export default [
    {
        timestamp: '2025-08-29T22:30:08.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.92437,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:08.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.5795, 111.767, 108.5795, 104.126375, 105.392, 105.2045, 108.5795, 109.938875, 104.313875, 103.563875,
            98.313875, 96.907625, 97.04825, 96.767, 95.73575, 95.688875, 96.017, 96.063875, 97.188875, 99.720125,
            101.782625, 101.36075, 100.142, 99.532625, 98.17325, 101.688875, 95.782625, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:09.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.22539,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:09.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.11075, 121.98575, 119.73575, 120.720125, 118.04825, 113.595125, 111.5795, 111.767, 108.532625,
            105.48575, 100.282625, 96.813875, 97.517, 97.3295, 96.251375, 96.720125, 96.392, 96.626375, 97.61075,
            99.907625, 101.501375, 102.251375, 100.001375, 99.720125, 98.4545, 102.5795, 96.11075, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:30.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.77971,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:30.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.688875, 122.782625, 120.767, 117.9545, 113.970125, 112.3295, 109.095125, 112.563875, 102.063875,
            100.376375, 99.5795, 97.7045, 97.3295, 97.79825, 96.392, 97.23575, 96.67325, 97.095125, 98.313875,
            100.282625, 102.251375, 101.970125, 100.095125, 99.67325, 98.36075, 102.438875, 96.907625, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:02.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.991005,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:02.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.73575, 116.642, 112.657625, 110.36075, 110.970125, 108.813875, 107.92325, 109.563875, 103.98575,
            100.845125, 99.48575, 96.626375, 96.67325, 96.5795, 95.73575, 96.9545, 95.501375, 96.438875, 97.376375,
            100.3295, 102.017, 101.4545, 100.142, 99.67325, 97.938875, 101.54825, 95.970125, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:28.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.95654,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:28.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.8295, 116.313875, 112.61075, 109.095125, 108.720125, 106.095125, 107.54825, 111.29825, 103.376375,
            100.282625, 100.751375, 105.017, 99.345125, 98.126375, 97.282625, 97.3295, 96.9545, 97.23575, 98.126375,
            100.751375, 101.54825, 102.626375, 100.23575, 99.48575, 98.407625, 102.157625, 96.626375, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:12.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.79164,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:12.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.92325, 121.845125, 119.73575, 117.345125, 114.017, 108.345125, 106.657625, 108.392, 104.267, 104.126375,
            101.36075, 100.095125, 98.970125, 100.04825, 96.767, 96.907625, 96.5795, 96.907625, 97.751375, 100.001375,
            101.501375, 102.626375, 100.142, 99.5795, 98.36075, 101.782625, 96.345125, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:07.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.87932,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:07.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 119.501375, 116.73575, 113.4545, 111.532625, 110.4545, 108.86075, 109.7045, 103.376375,
            101.032625, 99.11075, 97.188875, 96.720125, 96.251375, 95.4545, 95.267, 95.0795, 96.017, 97.095125,
            99.48575, 101.595125, 100.845125, 99.767, 99.2045, 98.032625, 101.36075, 95.688875, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:58.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.726654,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:58.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.017, 115.376375, 114.86075, 112.282625, 108.48575, 108.11075, 109.282625, 111.345125, 104.73575,
            100.42325, 99.017, 97.001375, 97.7045, 98.0795, 97.188875, 96.532625, 96.157625, 97.142, 97.61075, 99.67325,
            101.54825, 101.501375, 100.142, 99.48575, 98.220125, 102.11075, 96.157625, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:40.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.56082,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:40.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.376375, 118.98575, 115.79825, 112.657625, 109.7045, 107.407625, 107.267, 107.688875, 102.813875,
            99.67325, 98.501375, 98.36075, 99.063875, 98.17325, 96.907625, 97.42325, 95.782625, 97.095125, 97.563875,
            99.813875, 101.970125, 101.54825, 100.23575, 99.626375, 98.501375, 102.392, 96.767, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:18.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.036285,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:18.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.720125, 117.813875, 118.142, 119.220125, 114.251375, 107.313875, 106.3295, 106.751375, 102.017, 100.142,
            97.563875, 97.563875, 97.376375, 97.563875, 98.0795, 103.7045, 99.48575, 97.23575, 99.11075, 100.04825,
            102.532625, 102.29825, 100.376375, 99.48575, 98.0795, 102.11075, 96.626375, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:49.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.60541,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:49.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.92325, 114.157625, 113.407625, 109.845125, 108.5795, 106.79825, 106.517, 106.7045, 103.42325, 99.2045,
            99.48575, 98.876375, 96.063875, 97.142, 96.392, 96.67325, 95.688875, 96.813875, 97.470125, 99.9545,
            101.782625, 101.595125, 100.282625, 99.438875, 98.4545, 101.595125, 96.2045, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:18.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.43118,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:18.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.782625, 131.220125, 128.970125, 120.626375, 121.517, 116.36075, 114.48575, 116.501375, 112.845125,
            107.0795, 103.142, 100.517, 97.98575, 97.095125, 97.04825, 96.86075, 96.345125, 96.9545, 97.892, 99.907625,
            101.876375, 102.157625, 100.282625, 99.251375, 98.688875, 102.2045, 96.626375, 95.407625,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:19.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.98817,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:19.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.98575, 129.2045, 125.688875, 119.970125, 118.751375, 114.813875, 113.595125, 111.767, 106.7045,
            102.907625, 99.813875, 97.751375, 97.142, 96.626375, 96.392, 96.720125, 96.48575, 96.626375, 97.61075,
            99.9545, 101.970125, 101.970125, 100.282625, 99.392, 98.688875, 102.251375, 96.720125, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:11.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.86128,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:11.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.063875, 117.017, 114.2045, 116.595125, 114.063875, 107.36075, 108.392, 107.595125, 104.17325, 101.0795,
            100.04825, 97.79825, 97.42325, 96.345125, 96.438875, 96.157625, 96.532625, 96.767, 97.751375, 100.04825,
            101.595125, 101.032625, 99.67325, 99.345125, 98.0795, 101.688875, 95.92325, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:46.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.94655,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:46.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.142, 123.86075, 121.98575, 116.4545, 113.595125, 112.7045, 111.251375, 110.642, 105.720125, 103.282625,
            100.845125, 100.3295, 98.501375, 97.376375, 96.392, 96.532625, 95.970125, 96.392, 97.657625, 99.5795,
            101.688875, 101.688875, 99.907625, 99.438875, 98.267, 101.782625, 96.48575, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:09.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.56552,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:09.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.86075, 125.267, 124.04825, 121.282625, 116.501375, 112.095125, 110.970125, 112.657625, 104.970125,
            103.892, 100.7045, 97.892, 97.3295, 98.313875, 96.251375, 96.438875, 96.2045, 96.767, 97.470125, 100.282625,
            102.11075, 102.29825, 100.751375, 99.532625, 98.36075, 102.017, 96.11075, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:21.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.73634,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:21.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.376375, 124.79825, 123.29825, 120.626375, 117.251375, 116.73575, 111.626375, 113.032625, 105.157625,
            103.79825, 99.767, 100.61075, 98.126375, 97.376375, 98.0795, 97.282625, 96.767, 97.42325, 97.938875,
            100.3295, 102.063875, 102.626375, 99.907625, 99.29825, 98.407625, 101.92325, 96.626375, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:54.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.58458,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:54.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.54825, 111.67325, 108.157625, 105.251375, 105.767, 107.220125, 108.11075, 111.251375, 103.142, 100.3295,
            98.688875, 97.517, 96.157625, 96.157625, 95.782625, 95.313875, 95.313875, 95.876375, 97.142, 99.392,
            101.642, 101.4545, 100.188875, 99.392, 98.36075, 101.782625, 95.8295, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:19.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 144.28607,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:19.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            143.032625, 136.79825, 130.79825, 125.8295, 122.501375, 118.61075, 115.282625, 115.845125, 110.501375,
            107.407625, 103.892, 100.282625, 98.126375, 99.11075, 98.0795, 96.907625, 96.392, 96.67325, 98.313875,
            100.892, 101.970125, 102.67325, 100.04825, 99.29825, 98.782625, 103.001375, 96.626375, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:07.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.129974,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:07.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.032625, 104.17325, 102.48575, 105.67325, 106.845125, 105.86075, 105.345125, 106.938875, 102.9545,
            100.142, 99.767, 96.67325, 96.720125, 97.3295, 95.92325, 96.86075, 95.92325, 96.29825, 97.001375, 99.48575,
            101.595125, 101.782625, 100.23575, 99.532625, 98.313875, 101.92325, 96.48575, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:45.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.04445,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:45.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.8295, 121.79825, 115.938875, 110.595125, 109.376375, 107.17325, 105.9545, 109.7045, 103.23575,
            102.063875, 98.92325, 98.4545, 96.438875, 97.470125, 96.063875, 96.017, 96.392, 96.5795, 97.657625,
            100.001375, 101.782625, 101.595125, 100.23575, 99.67325, 98.267, 101.876375, 96.157625, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:38.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.74664,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:38.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.04825, 102.67325, 101.032625, 103.657625, 105.017, 103.938875, 106.376375, 107.126375, 103.142,
            101.782625, 98.92325, 100.42325, 99.532625, 98.126375, 97.23575, 96.67325, 95.595125, 96.813875, 97.42325,
            99.9545, 101.782625, 101.688875, 100.3295, 99.813875, 98.220125, 102.438875, 96.907625, 95.407625,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:06.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.467,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:06.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.42325, 121.23575, 117.9545, 117.392, 114.438875, 111.9545, 109.751375, 110.407625, 105.157625,
            103.470125, 99.11075, 97.282625, 96.345125, 96.720125, 95.17325, 95.36075, 95.267, 95.876375, 97.23575,
            99.2045, 101.642, 101.0795, 99.813875, 99.29825, 97.938875, 101.782625, 95.876375, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:41.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.21041,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:41.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.36075, 115.42325, 111.626375, 108.626375, 107.17325, 107.782625, 105.720125, 104.688875, 101.17325,
            99.345125, 98.032625, 98.501375, 98.782625, 98.92325, 97.188875, 97.142, 96.9545, 96.9545, 97.563875,
            100.142, 102.157625, 101.688875, 99.86075, 99.5795, 98.36075, 102.251375, 96.720125, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:32.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.82862,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:32.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.5795, 116.032625, 112.79825, 110.8295, 109.282625, 108.017, 108.813875, 112.001375, 103.845125,
            101.4545, 98.73575, 96.813875, 97.3295, 97.563875, 96.2045, 95.8295, 95.688875, 96.626375, 97.470125,
            99.67325, 102.251375, 102.017, 100.563875, 99.9545, 98.407625, 101.92325, 96.11075, 95.0795,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:05.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.1035,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:05.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.7045, 118.98575, 116.126375, 109.282625, 110.688875, 108.907625, 108.67325, 107.126375, 102.345125,
            99.2045, 97.657625, 97.188875, 96.67325, 96.626375, 96.157625, 95.36075, 95.54825, 96.11075, 97.188875,
            99.532625, 101.4545, 101.54825, 99.86075, 99.345125, 98.032625, 102.017, 96.017, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:20.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.99321,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:20.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.876375, 126.157625, 123.9545, 121.563875, 118.7045, 114.251375, 111.720125, 114.29825, 105.5795,
            102.345125, 101.501375, 98.688875, 96.907625, 96.67325, 96.48575, 96.2045, 95.876375, 96.86075, 97.61075,
            100.7045, 102.157625, 102.67325, 99.720125, 99.438875, 98.0795, 101.876375, 96.5795, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:11.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.46185,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:11.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.767, 121.845125, 118.751375, 118.3295, 116.032625, 112.845125, 112.657625, 110.501375, 104.970125,
            107.4545, 100.79825, 98.876375, 97.282625, 97.470125, 96.48575, 96.2045, 96.11075, 96.392, 97.61075,
            100.23575, 101.782625, 102.392, 100.142, 99.48575, 98.17325, 102.345125, 96.157625, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:31.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.26138,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:31.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.845125, 119.17325, 117.11075, 114.813875, 111.86075, 109.376375, 109.376375, 110.54825, 104.642,
            100.938875, 99.29825, 97.751375, 97.142, 96.5795, 96.48575, 96.345125, 96.48575, 96.86075, 98.126375,
            99.767, 102.11075, 101.73575, 100.563875, 99.720125, 98.54825, 103.001375, 97.001375, 95.4545,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:05.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.43086,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:05.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.79825, 124.376375, 119.688875, 117.48575, 116.642, 115.61075, 111.720125, 109.001375, 105.157625,
            103.61075, 98.970125, 97.61075, 98.73575, 97.892, 98.0795, 100.845125, 96.345125, 97.04825, 97.42325,
            100.188875, 101.642, 101.220125, 99.767, 99.29825, 98.032625, 101.17325, 96.345125, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:42.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.04995,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:42.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.720125, 111.438875, 105.9545, 106.79825, 107.970125, 107.36075, 108.251375, 109.282625, 105.813875,
            101.267, 98.73575, 98.313875, 97.79825, 96.813875, 96.5795, 96.767, 95.407625, 96.48575, 97.517, 99.392,
            102.2045, 101.8295, 100.04825, 99.438875, 97.892, 101.501375, 96.2045, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:12.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.422386,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:12.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            105.438875, 100.61075, 105.2045, 111.48575, 110.17325, 106.845125, 107.032625, 107.782625, 105.532625,
            103.751375, 101.0795, 99.907625, 98.688875, 98.73575, 97.095125, 96.67325, 96.67325, 97.282625, 97.61075,
            99.67325, 101.970125, 101.501375, 100.001375, 99.29825, 98.407625, 102.345125, 96.392, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:55.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.04713,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:55.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.3295, 130.517, 127.001375, 122.92325, 121.188875, 117.48575, 114.11075, 113.970125, 106.470125,
            103.563875, 101.126375, 98.92325, 97.892, 98.220125, 96.67325, 96.86075, 96.392, 96.67325, 97.79825,
            99.9545, 102.11075, 101.36075, 100.04825, 99.48575, 98.313875, 102.251375, 96.251375, 95.0795,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:53.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.249306,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:53.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.36075, 115.142, 109.892, 107.313875, 105.813875, 105.67325, 108.251375, 111.9545, 102.438875,
            101.407625, 99.2045, 97.938875, 97.001375, 95.688875, 96.29825, 96.017, 96.157625, 95.782625, 97.142,
            99.626375, 101.876375, 101.313875, 99.907625, 99.67325, 97.98575, 101.595125, 96.063875, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:00.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.47252,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:00.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.251375, 129.48575, 128.595125, 125.501375, 120.67325, 118.892, 115.517, 112.282625, 108.392, 103.892,
            101.126375, 99.67325, 97.61075, 96.86075, 96.813875, 96.5795, 95.92325, 96.251375, 97.188875, 100.04825,
            101.688875, 101.220125, 100.001375, 99.67325, 98.36075, 101.688875, 96.157625, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:22.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.68492,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:22.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.54825, 132.67325, 129.5795, 126.532625, 122.501375, 118.98575, 117.86075, 117.2045, 111.157625,
            106.79825, 102.532625, 100.751375, 97.98575, 97.98575, 97.142, 97.376375, 96.9545, 97.23575, 98.126375,
            100.845125, 102.157625, 102.5795, 100.3295, 99.5795, 98.92325, 102.532625, 96.720125, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:13.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.00751,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:13.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.7045, 119.267, 115.657625, 114.063875, 112.282625, 108.438875, 107.876375, 109.04825, 102.626375,
            100.42325, 101.54825, 106.188875, 100.61075, 97.095125, 96.392, 95.8295, 95.782625, 97.04825, 97.563875,
            100.23575, 101.73575, 102.345125, 100.142, 99.532625, 98.36075, 102.251375, 96.532625, 95.407625,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:51.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.14499,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:51.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.813875, 125.501375, 122.17325, 118.751375, 115.188875, 112.001375, 109.98575, 111.907625, 103.517,
            99.720125, 98.876375, 97.751375, 96.251375, 96.251375, 96.345125, 95.642, 95.36075, 96.626375, 97.517,
            100.001375, 101.782625, 101.642, 100.04825, 99.438875, 98.0795, 101.92325, 96.251375, 95.032625,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:17.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.96281,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:17.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.67325, 105.392, 103.42325, 105.532625, 106.376375, 105.438875, 107.876375, 113.501375, 102.29825,
            101.642, 101.313875, 99.86075, 97.188875, 97.095125, 96.438875, 96.767, 96.345125, 96.720125, 97.7045,
            99.813875, 101.688875, 102.345125, 100.517, 99.532625, 98.4545, 102.720125, 96.5795, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:14.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.00164,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:14.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.17325, 111.017, 109.188875, 111.392, 107.876375, 104.688875, 105.720125, 109.938875, 101.970125,
            101.688875, 104.92325, 108.017, 98.876375, 99.2045, 98.501375, 97.563875, 97.04825, 97.892, 98.126375,
            100.23575, 101.688875, 103.142, 100.04825, 99.345125, 99.063875, 102.532625, 97.42325, 95.642,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:52.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.580765,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:52.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.345125, 112.282625, 110.36075, 108.907625, 107.782625, 105.9545, 108.438875, 113.220125, 103.3295,
            101.782625, 99.720125, 97.563875, 96.392, 96.29825, 95.876375, 95.220125, 95.92325, 95.8295, 96.813875,
            99.5795, 101.54825, 101.17325, 99.720125, 99.392, 97.98575, 101.36075, 95.782625, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:44.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.58414,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:44.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.61075, 112.938875, 109.79825, 108.2045, 107.17325, 106.188875, 106.23575, 108.017, 101.688875, 99.392,
            97.938875, 97.7045, 96.48575, 96.9545, 96.86075, 96.720125, 96.017, 96.392, 97.3295, 99.48575, 101.970125,
            101.876375, 99.9545, 99.392, 98.17325, 101.8295, 96.48575, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:03.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.86159,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:03.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.017, 116.642, 112.61075, 110.0795, 106.892, 103.563875, 104.407625, 107.267, 101.220125, 101.642,
            99.438875, 97.142, 96.2045, 97.001375, 96.063875, 95.970125, 95.688875, 96.251375, 97.470125, 100.04825,
            101.688875, 101.407625, 100.095125, 99.767, 98.17325, 102.251375, 96.157625, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:27.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.71285,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:27.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.7045, 113.407625, 109.563875, 107.54825, 106.04825, 103.938875, 106.04825, 108.5795, 102.5795,
            101.595125, 102.157625, 100.61075, 98.782625, 98.126375, 97.188875, 97.23575, 96.48575, 97.04825, 98.313875,
            100.42325, 101.876375, 102.626375, 100.188875, 99.86075, 98.54825, 102.157625, 96.438875, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:16.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.93193,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:16.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.92325, 103.04825, 103.845125, 108.017, 108.157625, 104.688875, 107.501375, 110.688875, 103.657625,
            100.61075, 101.595125, 97.470125, 97.188875, 97.470125, 96.67325, 96.11075, 96.017, 96.5795, 97.563875,
            100.001375, 101.688875, 102.251375, 100.517, 99.67325, 98.4545, 102.532625, 96.157625, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:04.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.99672,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:04.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.04825, 128.4545, 121.751375, 116.73575, 114.48575, 112.3295, 110.4545, 109.845125, 105.532625,
            101.688875, 98.4545, 97.282625, 98.92325, 97.23575, 96.767, 96.67325, 96.2045, 97.095125, 97.845125,
            99.813875, 102.157625, 101.782625, 100.188875, 99.626375, 98.267, 102.063875, 96.48575, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:33.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.13232,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:33.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.017, 112.61075, 107.92325, 104.4545, 101.92325, 102.86075, 106.282625, 110.782625, 100.04825, 99.157625,
            98.688875, 97.938875, 98.501375, 97.751375, 96.11075, 96.5795, 96.345125, 96.86075, 97.61075, 99.9545,
            101.970125, 101.73575, 100.142, 99.767, 98.36075, 102.345125, 96.29825, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:34.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.56526,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:34.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.54825, 129.345125, 126.017, 123.157625, 120.345125, 117.063875, 113.220125, 112.282625, 106.188875,
            101.92325, 100.79825, 99.532625, 98.36075, 97.188875, 95.876375, 95.8295, 95.8295, 96.2045, 97.282625,
            99.86075, 102.67325, 102.063875, 100.376375, 99.86075, 98.501375, 102.767, 96.063875, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:01.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.05698,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:01.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.720125, 131.220125, 128.54825, 124.938875, 121.751375, 118.61075, 116.0795, 112.79825, 109.23575,
            105.438875, 101.876375, 98.220125, 97.376375, 96.392, 95.970125, 95.642, 95.4545, 96.67325, 97.517, 99.767,
            101.688875, 101.73575, 100.188875, 99.813875, 98.595125, 102.48575, 96.11075, 95.0795,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:15.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.894005,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:15.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 109.376375, 106.142, 104.970125, 106.563875, 105.11075, 106.23575, 109.892, 103.42325,
            101.501375, 100.376375, 97.23575, 97.517, 98.970125, 97.188875, 97.188875, 96.813875, 97.188875, 97.98575,
            100.04825, 101.8295, 102.767, 100.142, 99.5795, 98.970125, 102.345125, 96.767, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:59.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.25384,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:59.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.688875, 104.267, 102.438875, 106.142, 106.98575, 106.001375, 105.813875, 112.470125, 101.8295, 98.92325,
            99.157625, 96.9545, 97.61075, 97.470125, 97.3295, 96.813875, 97.095125, 96.9545, 97.7045, 100.095125,
            101.8295, 101.4545, 99.907625, 99.907625, 98.267, 101.73575, 96.157625, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:10.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.75255,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:10.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.657625, 129.438875, 122.92325, 119.54825, 118.657625, 114.813875, 112.563875, 113.220125, 106.188875,
            103.470125, 101.876375, 98.73575, 97.282625, 96.813875, 95.73575, 96.438875, 95.642, 96.017, 97.282625,
            100.142, 101.4545, 101.595125, 99.907625, 99.2045, 98.126375, 102.11075, 95.970125, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:17.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.808525,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:17.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.501375, 120.626375, 117.9545, 112.79825, 110.782625, 108.9545, 108.345125, 108.86075, 103.470125,
            100.61075, 97.657625, 96.48575, 97.845125, 97.42325, 95.73575, 95.92325, 95.876375, 96.29825, 97.563875,
            99.720125, 101.73575, 101.595125, 100.3295, 100.04825, 98.642, 103.517, 96.626375, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:56.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.91025,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:56.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.438875, 126.345125, 120.9545, 118.845125, 113.595125, 110.8295, 108.5795, 111.251375, 102.907625,
            104.4545, 99.5795, 99.86075, 99.532625, 99.48575, 96.907625, 97.04825, 96.9545, 96.67325, 97.282625,
            99.86075, 101.595125, 101.36075, 99.720125, 99.345125, 98.032625, 101.4545, 96.438875, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:29.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.93729,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:29.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.0795, 119.313875, 114.29825, 109.938875, 106.7045, 105.532625, 108.017, 112.142, 101.970125, 99.11075,
            101.73575, 103.657625, 98.267, 97.517, 97.282625, 96.345125, 96.29825, 96.67325, 97.79825, 99.907625,
            101.688875, 101.8295, 100.095125, 99.5795, 98.267, 101.92325, 96.48575, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:24.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.58218,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:24.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.063875, 118.845125, 114.438875, 111.345125, 108.5795, 106.3295, 106.751375, 111.532625, 102.345125,
            104.032625, 100.657625, 101.267, 99.2045, 99.063875, 97.23575, 97.3295, 96.813875, 97.42325, 97.657625,
            100.04825, 101.876375, 102.392, 100.282625, 99.813875, 98.73575, 102.11075, 96.532625, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:10.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.2676,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:10.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.517, 127.188875, 123.2045, 122.17325, 120.5795, 116.876375, 112.470125, 111.9545, 106.376375,
            105.157625, 101.313875, 98.501375, 98.0795, 97.001375, 96.48575, 96.157625, 96.29825, 96.813875, 97.42325,
            100.142, 102.017, 101.501375, 100.142, 99.48575, 97.845125, 101.4545, 96.345125, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:48.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.65955,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:48.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.267, 130.42325, 125.8295, 123.67325, 121.3295, 117.5795, 117.48575, 113.267, 109.42325, 105.11075,
            100.98575, 98.8295, 97.7045, 96.86075, 96.017, 95.313875, 95.595125, 96.251375, 97.563875, 99.813875,
            102.017, 101.688875, 99.9545, 99.720125, 98.407625, 102.157625, 96.157625, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:08.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.36102,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:08.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.79825, 121.892, 116.970125, 111.11075, 109.001375, 106.938875, 108.345125, 108.29825, 104.501375,
            100.657625, 99.29825, 97.751375, 97.188875, 96.907625, 95.73575, 95.970125, 95.642, 96.48575, 96.86075,
            100.095125, 101.595125, 101.36075, 99.767, 99.720125, 98.267, 101.595125, 96.2045, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:39.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.333244,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:39.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.92325, 102.063875, 100.376375, 103.23575, 104.0795, 104.313875, 105.813875, 106.892, 102.720125,
            101.267, 100.23575, 98.4545, 98.220125, 98.407625, 97.04825, 96.86075, 96.017, 96.67325, 97.938875,
            99.626375, 101.876375, 101.8295, 100.001375, 99.813875, 98.313875, 102.5795, 96.48575, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:50.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.72165,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:50.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.845125, 124.376375, 121.657625, 120.11075, 117.720125, 112.282625, 112.845125, 112.001375, 108.29825,
            102.532625, 99.345125, 97.79825, 97.04825, 97.376375, 96.5795, 96.2045, 95.970125, 96.626375, 97.657625,
            99.907625, 102.29825, 101.4545, 100.001375, 99.767, 98.36075, 101.970125, 96.157625, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:25.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.72658,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:25.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.813875, 128.0795, 126.720125, 126.392, 121.3295, 118.142, 114.86075, 112.7045, 107.36075, 104.36075,
            104.8295, 102.11075, 99.767, 99.2045, 97.892, 97.657625, 98.032625, 98.267, 98.54825, 101.36075, 102.251375,
            102.626375, 100.376375, 99.86075, 99.017, 102.251375, 97.001375, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:06.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.57341,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:06.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.501375, 125.8295, 123.720125, 120.11075, 118.04825, 115.04825, 112.3295, 109.98575, 106.892, 102.063875,
            99.251375, 97.42325, 96.907625, 97.001375, 95.92325, 96.626375, 96.720125, 97.282625, 97.188875, 100.142,
            102.157625, 101.407625, 99.9545, 99.67325, 98.267, 101.782625, 96.251375, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:02.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.23764,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:02.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.017, 123.438875, 121.188875, 119.970125, 115.04825, 111.813875, 109.42325, 109.142, 104.501375,
            100.657625, 98.73575, 96.157625, 96.767, 96.767, 95.595125, 95.595125, 95.126375, 96.017, 97.04825, 99.9545,
            101.595125, 101.407625, 100.04825, 99.67325, 98.17325, 101.595125, 95.876375, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:14.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.40179,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:14.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.11075, 117.720125, 114.251375, 110.92325, 109.142, 107.782625, 106.845125, 107.642, 104.220125,
            101.782625, 102.2045, 98.267, 97.04825, 97.23575, 96.907625, 96.907625, 96.86075, 97.001375, 97.98575,
            100.142, 101.8295, 101.642, 100.095125, 99.345125, 98.313875, 102.438875, 96.157625, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:37.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.706764,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:37.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.657625, 116.126375, 114.345125, 112.188875, 110.595125, 108.9545, 110.220125, 110.92325, 106.938875,
            104.313875, 101.0795, 98.92325, 98.782625, 97.282625, 97.376375, 96.86075, 95.876375, 97.23575, 97.563875,
            100.04825, 101.782625, 101.0795, 100.282625, 99.626375, 98.17325, 101.688875, 95.970125, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:13.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.15463,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:13.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.907625, 104.595125, 103.563875, 107.407625, 108.017, 105.907625, 106.845125, 107.501375, 104.8295,
            101.54825, 99.017, 96.9545, 97.42325, 97.42325, 96.67325, 96.345125, 96.251375, 96.907625, 98.0795,
            100.376375, 101.876375, 101.220125, 99.9545, 99.251375, 98.267, 102.86075, 96.67325, 95.36075,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:35.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.18304,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:35.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.392, 120.2045, 116.970125, 112.04825, 109.517, 108.720125, 107.642, 111.017, 102.720125, 102.11075,
            99.438875, 100.3295, 97.563875, 97.3295, 96.063875, 96.2045, 95.73575, 96.29825, 97.001375, 99.626375,
            101.688875, 101.126375, 99.720125, 99.251375, 97.892, 101.54825, 96.157625, 95.126375,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:15.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.53832,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:15.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.376375, 115.376375, 111.392, 108.438875, 105.67325, 106.142, 105.813875, 107.032625, 102.157625,
            101.36075, 99.438875, 96.907625, 97.3295, 96.67325, 95.642, 95.501375, 95.92325, 95.876375, 97.23575,
            99.813875, 101.970125, 101.4545, 100.188875, 99.720125, 98.501375, 102.626375, 96.532625, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:43.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.27583,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:43.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.063875, 107.126375, 103.563875, 103.04825, 103.001375, 103.563875, 104.501375, 108.626375, 104.595125,
            100.61075, 99.063875, 98.0795, 97.282625, 97.04825, 96.345125, 95.876375, 95.970125, 96.907625, 97.61075,
            99.767, 102.11075, 101.407625, 100.142, 99.532625, 98.4545, 102.48575, 96.2045, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:26.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.29337,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:26.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.345125, 120.813875, 116.876375, 112.61075, 110.220125, 108.532625, 108.67325, 110.4545, 104.407625,
            102.67325, 101.126375, 100.61075, 98.688875, 98.0795, 96.2045, 96.720125, 96.2045, 97.04825, 97.42325,
            100.095125, 101.73575, 102.29825, 100.376375, 99.626375, 98.267, 102.720125, 96.29825, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:23.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.79303,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:23.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.407625, 121.376375, 120.767, 116.970125, 114.907625, 113.220125, 110.407625, 113.54825, 103.517,
            101.17325, 101.032625, 98.595125, 97.376375, 96.9545, 96.5795, 96.29825, 96.392, 96.9545, 97.282625,
            100.3295, 101.595125, 102.157625, 100.04825, 99.29825, 98.4545, 102.063875, 96.626375, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:36.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.43982,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:36.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.017, 123.9545, 122.032625, 118.845125, 116.501375, 112.79825, 111.2045, 109.98575, 103.98575,
            102.813875, 99.767, 101.876375, 99.438875, 98.54825, 98.126375, 97.001375, 96.2045, 97.04825, 97.79825,
            99.86075, 102.017, 101.876375, 100.376375, 100.001375, 99.813875, 106.517, 97.892, 96.345125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:16.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.56347,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:16.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.36075, 115.79825, 112.657625, 109.98575, 109.282625, 107.876375, 108.157625, 107.642, 104.267, 101.267,
            104.407625, 100.376375, 97.845125, 96.86075, 96.532625, 96.017, 95.8295, 96.345125, 97.61075, 100.001375,
            102.063875, 101.688875, 100.61075, 99.720125, 98.36075, 102.017, 96.2045, 95.267,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:57.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.00374,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:57.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.782625, 129.345125, 126.29825, 124.376375, 122.4545, 119.407625, 118.7045, 117.813875, 113.8295,
            108.392, 106.001375, 103.42325, 99.767, 99.017, 97.7045, 96.5795, 96.48575, 96.392, 97.142, 100.001375,
            101.92325, 101.267, 99.907625, 99.532625, 98.032625, 101.595125, 96.392, 95.313875,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:47.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.08577,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:30:47.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.938875, 119.407625, 116.17325, 113.17325, 111.11075, 106.188875, 106.751375, 110.126375, 103.892,
            102.9545, 99.813875, 99.251375, 97.282625, 96.48575, 95.782625, 95.876375, 95.73575, 96.063875, 97.3295,
            99.67325, 101.970125, 101.595125, 99.813875, 99.438875, 98.032625, 101.4545, 95.970125, 95.17325,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:09.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.41986,
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:09.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.845125, 130.095125, 125.970125, 124.282625, 122.782625, 121.001375, 117.438875, 114.2045, 110.36075,
            106.845125, 103.23575, 99.86075, 96.907625, 96.720125, 96.11075, 96.063875, 95.73575, 96.86075, 97.517,
            99.9545, 101.92325, 101.0795, 99.767, 99.2045, 98.267, 102.11075, 96.2045, 95.220125,
        ],
        latitude: 37.4405733,
        longitude: -122.533416,
    },
    {
        timestamp: '2025-08-29T22:31:33.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.17969,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:33.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.98575, 119.4545, 116.0795, 113.313875, 112.188875, 108.720125, 108.063875, 109.892, 102.157625,
            100.42325, 99.767, 97.282625, 97.282625, 97.517, 96.626375, 96.345125, 97.142, 96.86075, 97.376375, 99.9545,
            101.876375, 101.876375, 100.095125, 99.251375, 98.267, 102.2045, 96.532625, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:09.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.86224,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:09.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.688875, 120.9545, 120.345125, 118.23575, 115.42325, 111.626375, 110.642, 113.407625, 104.17325,
            101.4545, 98.782625, 96.345125, 96.626375, 96.767, 95.54825, 95.642, 95.407625, 95.688875, 97.142, 99.5795,
            101.73575, 101.267, 99.9545, 99.251375, 98.032625, 101.876375, 95.970125, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:24.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.36412,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:24.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.157625, 113.407625, 111.251375, 107.876375, 108.29825, 107.220125, 107.970125, 109.188875, 104.595125,
            101.501375, 98.782625, 96.29825, 95.4545, 96.67325, 95.267, 95.36075, 95.267, 96.157625, 97.517, 99.813875,
            101.970125, 101.407625, 99.86075, 99.392, 98.267, 101.782625, 96.11075, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:00.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.88808,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:00.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.73575, 117.017, 114.017, 109.845125, 107.8295, 106.563875, 105.29825, 106.845125, 100.23575, 98.501375,
            98.501375, 98.8295, 97.79825, 97.938875, 96.48575, 97.001375, 96.907625, 97.7045, 98.267, 100.095125,
            102.438875, 102.251375, 99.907625, 99.438875, 98.126375, 101.73575, 96.720125, 95.407625,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:02.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.80551,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:02.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.04825, 105.5795, 104.73575, 108.11075, 105.532625, 106.79825, 105.29825, 105.907625, 101.970125,
            98.54825, 97.751375, 97.001375, 96.48575, 97.23575, 95.4545, 95.782625, 95.92325, 96.251375, 97.3295,
            99.720125, 102.063875, 101.642, 100.3295, 99.767, 98.54825, 102.157625, 96.392, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:26.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.4533,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:26.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.4545, 120.11075, 116.782625, 111.86075, 108.86075, 106.892, 106.845125, 108.2045, 100.188875, 99.48575,
            98.92325, 96.813875, 97.98575, 97.04825, 98.688875, 96.2045, 96.063875, 96.532625, 97.23575, 99.392,
            102.2045, 101.407625, 99.907625, 99.345125, 97.938875, 101.92325, 96.532625, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:50.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.73349,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:50.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.220125, 133.095125, 132.907625, 130.563875, 128.876375, 126.5795, 120.157625, 117.2045, 113.032625,
            111.29825, 106.751375, 101.54825, 98.688875, 97.23575, 96.2045, 95.501375, 95.54825, 96.345125, 97.657625,
            100.282625, 101.876375, 102.29825, 100.23575, 100.001375, 98.688875, 102.813875, 96.017, 95.0795,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:03.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.5308,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:03.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.845125, 112.563875, 109.23575, 104.92325, 105.813875, 106.42325, 106.470125, 108.626375, 101.8295,
            99.907625, 99.251375, 96.813875, 96.86075, 96.626375, 96.017, 96.532625, 95.73575, 96.345125, 97.42325,
            100.001375, 101.970125, 101.688875, 100.517, 99.532625, 98.407625, 102.017, 96.720125, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:20.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.36351,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:20.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.907625, 129.017, 125.4545, 121.376375, 120.251375, 117.767, 116.501375, 114.392, 109.61075, 106.563875,
            102.5795, 99.907625, 97.001375, 97.188875, 95.92325, 95.313875, 94.98575, 96.532625, 97.376375, 100.04825,
            101.970125, 101.8295, 100.04825, 99.48575, 97.98575, 101.642, 96.063875, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:43.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.83535,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:43.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.095125, 108.720125, 106.095125, 107.595125, 109.188875, 107.4545, 107.876375, 109.42325, 104.782625,
            101.220125, 99.720125, 96.9545, 96.720125, 97.188875, 97.001375, 95.313875, 95.970125, 96.626375, 97.282625,
            99.813875, 101.595125, 102.017, 100.188875, 99.5795, 98.54825, 101.876375, 96.2045, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:22.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.2473,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:22.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.23575, 125.4545, 119.4545, 115.376375, 113.73575, 110.4545, 110.4545, 111.720125, 105.29825, 101.267,
            98.782625, 96.907625, 96.767, 97.188875, 96.157625, 95.970125, 95.782625, 96.157625, 97.517, 99.5795,
            102.017, 101.595125, 100.376375, 99.48575, 98.032625, 101.970125, 96.157625, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:35.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.95424,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:35.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.095125, 123.907625, 121.517, 119.126375, 113.8295, 111.29825, 108.813875, 110.501375, 104.688875,
            100.42325, 99.157625, 97.142, 99.392, 98.8295, 97.188875, 97.517, 97.892, 97.892, 98.642, 100.517,
            102.157625, 102.438875, 100.3295, 99.438875, 98.595125, 103.04825, 97.376375, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:25.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.87627,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:25.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.032625, 118.938875, 115.845125, 111.626375, 108.626375, 106.98575, 106.188875, 106.751375, 102.017,
            99.9545, 98.970125, 96.86075, 96.11075, 97.282625, 96.345125, 96.626375, 95.73575, 96.532625, 97.563875,
            99.86075, 102.017, 101.54825, 100.23575, 99.67325, 98.407625, 101.8295, 96.392, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:49.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.11711,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:49.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.001375, 124.376375, 121.095125, 119.595125, 117.767, 114.251375, 110.782625, 111.720125, 105.86075,
            104.313875, 99.532625, 97.470125, 97.845125, 97.517, 96.767, 96.157625, 96.5795, 96.626375, 97.517,
            99.86075, 102.017, 102.392, 100.3295, 99.532625, 98.54825, 102.11075, 96.345125, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:01.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.90216,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:01.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.142, 109.61075, 105.907625, 103.98575, 104.92325, 104.970125, 104.970125, 106.3295, 102.86075,
            98.407625, 97.563875, 97.23575, 96.5795, 97.517, 95.595125, 95.92325, 95.876375, 96.251375, 97.282625,
            100.04825, 101.876375, 101.8295, 100.142, 99.392, 98.126375, 101.876375, 96.157625, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:23.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.35629,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:23.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.095125, 114.67325, 111.11075, 107.92325, 107.126375, 104.688875, 106.7045, 109.42325, 103.517,
            101.032625, 98.92325, 96.5795, 97.04825, 97.938875, 96.438875, 96.2045, 95.595125, 96.5795, 97.892,
            100.42325, 101.970125, 101.8295, 100.376375, 99.907625, 98.688875, 102.86075, 96.720125, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:11.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.40358,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:11.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.688875, 106.79825, 103.001375, 103.42325, 103.79825, 103.751375, 105.767, 111.251375, 99.86075, 98.642,
            96.907625, 97.3295, 97.517, 96.767, 95.407625, 96.063875, 95.0795, 96.251375, 97.563875, 99.67325,
            102.251375, 101.267, 100.42325, 99.86075, 98.313875, 102.392, 96.063875, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:53.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.09215,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:53.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.720125, 126.392, 120.67325, 116.36075, 114.532625, 114.157625, 110.4545, 111.251375, 106.845125,
            103.001375, 99.017, 96.626375, 97.376375, 97.563875, 96.11075, 96.67325, 96.157625, 96.392, 97.376375,
            100.142, 101.595125, 102.157625, 99.86075, 99.29825, 98.407625, 101.8295, 96.251375, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:36.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.8226,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:36.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.970125, 122.407625, 117.813875, 118.282625, 117.29825, 114.67325, 109.376375, 109.61075, 101.688875,
            101.688875, 99.5795, 97.142, 97.61075, 97.23575, 95.73575, 95.688875, 96.626375, 96.767, 97.42325,
            100.563875, 101.501375, 102.251375, 99.9545, 99.29825, 98.407625, 102.29825, 96.626375, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:27.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.09084,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:27.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.532625, 122.313875, 119.54825, 118.04825, 113.8295, 109.79825, 107.8295, 108.345125, 102.720125,
            99.532625, 99.345125, 97.04825, 97.470125, 97.657625, 96.86075, 96.67325, 96.345125, 97.42325, 97.517,
            99.907625, 102.2045, 101.54825, 99.767, 99.29825, 98.126375, 102.017, 96.67325, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:22.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.73141,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:22.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.86075, 120.9545, 117.438875, 111.67325, 113.595125, 108.767, 109.095125, 107.73575, 102.157625,
            101.17325, 98.970125, 98.0795, 97.3295, 96.813875, 106.751375, 102.251375, 96.29825, 96.9545, 98.032625,
            99.907625, 101.92325, 101.407625, 99.86075, 99.626375, 98.36075, 101.73575, 96.345125, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:42.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.70152,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:42.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.8295, 132.392, 128.595125, 125.501375, 123.813875, 119.220125, 117.720125, 115.751375, 110.92325,
            108.5795, 102.392, 99.392, 99.11075, 97.42325, 96.767, 95.970125, 95.501375, 97.42325, 96.9545, 100.04825,
            101.688875, 102.29825, 100.23575, 99.392, 98.36075, 102.251375, 96.157625, 95.0795,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:41.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.749985,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:41.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.73575, 116.407625, 113.0795, 110.17325, 107.501375, 105.9545, 105.9545, 107.032625, 102.907625, 99.767,
            99.29825, 97.98575, 98.032625, 98.126375, 98.642, 96.29825, 96.626375, 97.7045, 97.282625, 100.282625,
            101.501375, 102.2045, 100.142, 99.5795, 98.642, 102.438875, 96.626375, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:48.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.26664,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:48.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.04825, 117.9545, 115.376375, 113.126375, 110.782625, 107.17325, 108.29825, 109.61075, 103.61075,
            101.126375, 100.3295, 98.73575, 97.376375, 97.7045, 96.5795, 96.438875, 96.11075, 96.67325, 97.657625,
            99.9545, 102.017, 102.626375, 100.563875, 99.907625, 98.73575, 102.438875, 96.907625, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:05.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.69689,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:05.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.48575, 118.751375, 113.0795, 109.98575, 107.688875, 105.67325, 105.532625, 108.2045, 102.11075,
            100.095125, 99.5795, 97.001375, 96.9545, 97.23575, 97.79825, 97.563875, 97.751375, 97.657625, 97.7045,
            100.23575, 102.392, 102.392, 100.188875, 99.907625, 98.970125, 102.813875, 97.04825, 95.642,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:29.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.286446,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:29.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.98575, 106.98575, 105.157625, 106.42325, 106.7045, 105.345125, 107.36075, 107.782625, 102.438875,
            100.188875, 98.54825, 96.813875, 96.29825, 96.11075, 95.501375, 95.876375, 95.501375, 96.48575, 96.86075,
            99.48575, 101.54825, 101.220125, 100.142, 99.48575, 98.0795, 101.73575, 96.11075, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:32.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.33811,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:32.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.438875, 104.73575, 103.001375, 105.017, 106.282625, 105.157625, 104.688875, 106.517, 102.392, 99.438875,
            97.938875, 97.98575, 97.98575, 97.23575, 97.001375, 96.48575, 96.813875, 97.376375, 98.267, 100.376375,
            102.017, 101.782625, 100.282625, 99.626375, 98.73575, 102.392, 96.813875, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:55.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.58273,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:55.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.470125, 122.8295, 119.0795, 114.063875, 111.532625, 108.813875, 106.001375, 108.532625, 105.48575,
            102.720125, 98.4545, 96.813875, 97.3295, 97.751375, 96.11075, 97.001375, 95.54825, 96.392, 96.907625,
            100.282625, 101.4545, 102.063875, 99.813875, 99.626375, 98.126375, 101.54825, 96.29825, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:31.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.41669,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:31.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.892, 133.282625, 128.92325, 125.688875, 125.970125, 122.876375, 120.720125, 116.782625, 114.532625,
            112.79825, 105.626375, 103.7045, 100.376375, 98.126375, 97.3295, 98.407625, 97.001375, 96.9545, 97.7045,
            100.001375, 101.92325, 101.876375, 100.23575, 99.48575, 98.126375, 102.2045, 96.67325, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:59.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 147.17023,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:59.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.392, 140.17325, 139.282625, 135.157625, 130.517, 126.9545, 126.907625, 122.688875, 119.36075,
            115.845125, 112.751375, 108.5795, 105.5795, 101.220125, 97.517, 97.188875, 96.532625, 97.470125, 97.751375,
            100.470125, 102.2045, 101.8295, 100.23575, 99.907625, 98.970125, 103.04825, 96.48575, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:10.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.874306,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:10.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.29825, 107.54825, 102.907625, 103.892, 103.938875, 104.688875, 106.376375, 111.907625, 101.688875,
            100.095125, 97.61075, 97.095125, 97.001375, 96.017, 95.688875, 95.36075, 96.720125, 96.392, 97.7045,
            99.251375, 101.595125, 101.17325, 99.9545, 99.438875, 97.845125, 101.501375, 95.876375, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:34.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.43677,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:34.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.220125, 123.063875, 120.720125, 117.11075, 113.688875, 111.392, 108.251375, 107.4545, 102.392,
            101.54825, 100.892, 98.688875, 102.2045, 98.970125, 98.876375, 98.8295, 97.42325, 97.3295, 98.17325,
            101.313875, 101.970125, 102.251375, 100.282625, 99.907625, 98.642, 102.2045, 96.532625, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:16.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.4008,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:16.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.470125, 125.876375, 121.23575, 114.767, 114.11075, 110.17325, 109.470125, 109.23575, 105.392, 103.23575,
            101.220125, 97.61075, 97.23575, 97.98575, 96.438875, 96.438875, 95.642, 96.9545, 97.61075, 100.563875,
            102.29825, 101.782625, 100.188875, 99.5795, 98.407625, 102.626375, 96.626375, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:44.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.12422,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:44.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.86075, 131.92325, 127.42325, 121.892, 121.892, 119.642, 115.23575, 113.595125, 110.4545, 104.8295,
            102.392, 98.688875, 98.36075, 97.7045, 97.188875, 96.767, 96.86075, 97.04825, 97.938875, 100.470125,
            101.92325, 102.5795, 100.3295, 99.67325, 98.782625, 102.532625, 96.626375, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:21.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.92816,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:21.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.8295, 122.970125, 120.11075, 119.032625, 115.845125, 112.79825, 110.17325, 109.04825, 103.657625,
            100.7045, 99.2045, 97.04825, 97.517, 97.657625, 97.04825, 97.3295, 96.86075, 97.095125, 97.79825, 99.5795,
            102.48575, 101.73575, 100.188875, 99.5795, 98.267, 101.970125, 97.142, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:37.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.31815,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:37.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.5795, 105.157625, 102.48575, 105.251375, 107.313875, 106.188875, 107.126375, 108.29825, 103.282625,
            99.251375, 100.517, 105.017, 101.54825, 100.751375, 101.501375, 99.626375, 97.61075, 97.61075, 98.73575,
            101.032625, 101.688875, 102.48575, 100.095125, 99.345125, 98.313875, 102.2045, 96.438875, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:18.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.99693,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:18.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.376375, 136.517, 132.907625, 127.892, 124.892, 123.48575, 119.8295, 118.517, 114.626375, 111.813875,
            107.501375, 103.23575, 99.063875, 98.0795, 96.767, 96.907625, 96.063875, 96.720125, 97.282625, 100.751375,
            102.063875, 101.782625, 100.470125, 99.813875, 98.54825, 102.392, 97.3295, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:28.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.95723,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:28.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            104.642, 100.517, 101.970125, 104.313875, 106.142, 107.0795, 107.4545, 110.032625, 103.657625, 100.095125,
            98.220125, 97.095125, 96.157625, 96.063875, 95.4545, 96.532625, 96.063875, 96.251375, 97.142, 99.5795,
            101.73575, 101.220125, 100.3295, 99.720125, 98.642, 102.532625, 95.876375, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:30.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.79753,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:30.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.376375, 125.92325, 122.4545, 120.2045, 118.04825, 114.720125, 112.61075, 110.970125, 104.782625,
            100.517, 99.438875, 97.188875, 97.04825, 97.188875, 96.626375, 96.11075, 95.8295, 96.29825, 96.86075,
            99.813875, 101.8295, 101.876375, 100.095125, 99.720125, 98.17325, 101.970125, 96.345125, 95.407625,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:26.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.31394,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:26.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.29825, 117.11075, 112.892, 110.4545, 111.11075, 108.720125, 106.04825, 106.42325, 101.92325, 100.04825,
            98.17325, 96.392, 96.392, 97.938875, 96.11075, 95.4545, 95.642, 96.063875, 97.376375, 99.67325, 101.876375,
            101.501375, 100.04825, 99.532625, 97.938875, 101.782625, 96.2045, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:07.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.39718,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:07.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.876375, 114.017, 109.42325, 107.220125, 106.845125, 106.001375, 105.720125, 108.626375, 101.220125,
            100.142, 98.0795, 97.79825, 97.42325, 99.063875, 97.563875, 96.813875, 96.767, 97.42325, 97.79825,
            99.907625, 102.345125, 102.11075, 99.9545, 99.86075, 98.54825, 102.720125, 97.3295, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:33.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.21643,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:33.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.938875, 119.0795, 114.2045, 116.267, 113.876375, 109.3295, 109.23575, 107.8295, 104.407625, 100.657625,
            99.532625, 97.892, 96.767, 96.67325, 95.642, 96.345125, 95.970125, 96.345125, 97.470125, 99.86075,
            102.157625, 102.251375, 100.23575, 99.767, 98.73575, 102.11075, 96.345125, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:08.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.17456,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:08.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.767, 125.267, 122.782625, 117.767, 116.501375, 113.970125, 110.970125, 111.532625, 103.3295, 102.017,
            100.7045, 99.720125, 97.98575, 98.8295, 98.970125, 99.48575, 97.3295, 97.282625, 97.892, 99.813875,
            102.251375, 102.017, 100.188875, 99.626375, 98.313875, 102.063875, 96.67325, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:52.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.95956,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:52.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.813875, 122.313875, 117.157625, 113.501375, 110.220125, 107.4545, 106.282625, 108.157625, 101.595125,
            98.970125, 98.267, 97.23575, 97.282625, 98.220125, 96.9545, 96.438875, 96.017, 97.3295, 98.126375,
            100.470125, 102.063875, 102.9545, 100.563875, 100.001375, 99.063875, 103.001375, 96.767, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:25.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.25267,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:25.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.813875, 111.11075, 108.251375, 108.2045, 108.392, 108.11075, 107.0795, 110.220125, 103.98575, 100.517,
            99.345125, 97.001375, 98.970125, 97.142, 97.04825, 96.67325, 95.73575, 96.2045, 97.470125, 100.095125,
            102.063875, 101.36075, 100.001375, 99.438875, 98.501375, 102.5795, 96.29825, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:38.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.52432,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:38.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.595125, 108.345125, 104.501375, 105.345125, 106.282625, 105.345125, 105.907625, 108.157625, 102.813875,
            99.29825, 99.345125, 96.626375, 96.392, 96.5795, 96.48575, 95.876375, 96.251375, 96.86075, 97.563875,
            100.282625, 101.642, 102.5795, 100.470125, 99.626375, 98.782625, 102.86075, 96.48575, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:13.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.78351,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:13.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.54825, 124.23575, 120.063875, 115.98575, 113.032625, 109.845125, 108.438875, 109.517, 104.4545,
            101.17325, 98.501375, 96.532625, 96.626375, 96.438875, 96.2045, 95.595125, 95.407625, 96.2045, 97.657625,
            99.813875, 101.782625, 101.17325, 100.563875, 99.9545, 98.688875, 103.470125, 95.92325, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:23.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.05503,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:23.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.73575, 112.751375, 109.845125, 111.438875, 108.157625, 106.470125, 107.688875, 106.657625, 102.157625,
            102.017, 98.642, 97.23575, 96.907625, 96.345125, 96.48575, 96.063875, 96.11075, 96.720125, 97.188875,
            100.188875, 101.92325, 101.36075, 100.04825, 99.438875, 98.267, 101.595125, 96.5795, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:56.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.5461,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:56.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.907625, 115.892, 113.4545, 109.470125, 107.4545, 104.595125, 105.86075, 106.376375, 100.517, 98.782625,
            98.642, 98.642, 97.142, 97.563875, 96.48575, 96.063875, 96.11075, 96.9545, 97.845125, 100.7045, 101.92325,
            102.767, 100.376375, 99.532625, 98.267, 102.29825, 96.345125, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:31.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.07443,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:31.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.42325, 126.5795, 124.04825, 121.61075, 118.938875, 114.720125, 113.313875, 109.376375, 105.48575,
            100.845125, 99.813875, 97.938875, 107.782625, 100.517, 96.720125, 98.407625, 96.5795, 97.095125, 98.0795,
            100.376375, 101.970125, 102.017, 100.3295, 99.5795, 98.36075, 102.063875, 96.251375, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:28.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.30531,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:28.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.220125, 119.92325, 116.92325, 112.42325, 108.626375, 105.438875, 105.251375, 107.4545, 101.73575,
            98.782625, 98.17325, 97.845125, 106.3295, 97.188875, 96.2045, 96.392, 96.392, 96.720125, 97.7045,
            101.313875, 102.392, 101.92325, 100.095125, 99.720125, 98.36075, 102.063875, 96.392, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:06.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.268745,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:06.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.782625, 113.220125, 110.220125, 109.892, 106.376375, 105.438875, 105.813875, 106.517, 101.73575,
            98.688875, 97.79825, 97.04825, 97.142, 97.188875, 96.67325, 96.813875, 96.48575, 97.23575, 97.7045,
            100.04825, 102.2045, 101.73575, 100.095125, 99.392, 98.36075, 102.11075, 96.86075, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:39.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.28815,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:39.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.23575, 124.938875, 121.376375, 118.470125, 116.126375, 115.23575, 110.73575, 110.8295, 106.282625,
            101.876375, 99.251375, 97.563875, 97.282625, 97.23575, 95.782625, 96.392, 97.517, 96.86075, 97.563875,
            99.813875, 101.54825, 102.532625, 99.907625, 99.767, 98.8295, 102.29825, 97.04825, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:04.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.83766,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:04.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.657625, 112.001375, 108.626375, 109.001375, 108.532625, 106.98575, 108.438875, 110.8295, 104.267,
            101.36075, 99.11075, 96.48575, 96.345125, 96.438875, 96.017, 95.407625, 95.407625, 96.251375, 97.376375,
            99.67325, 101.92325, 101.313875, 100.001375, 99.626375, 98.032625, 101.876375, 96.626375, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:20.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.63151,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:20.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.36075, 112.23575, 107.73575, 105.813875, 106.04825, 104.267, 105.720125, 107.8295, 101.267, 100.751375,
            98.876375, 97.001375, 96.86075, 96.907625, 95.876375, 95.8295, 95.8295, 96.626375, 97.376375, 100.188875,
            101.970125, 101.970125, 100.3295, 99.5795, 98.36075, 102.392, 96.392, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:21.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.19771,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:21.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.98575, 109.001375, 105.345125, 102.767, 103.142, 103.376375, 106.188875, 109.563875, 100.938875,
            100.095125, 99.251375, 97.845125, 95.8295, 96.86075, 95.267, 95.73575, 95.595125, 96.11075, 97.282625,
            100.04825, 101.92325, 101.688875, 100.3295, 99.48575, 97.98575, 101.642, 96.11075, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:27.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.956184,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:27.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.67325, 103.04825, 103.470125, 106.61075, 107.313875, 105.67325, 106.282625, 106.3295, 102.29825,
            98.782625, 98.126375, 96.438875, 96.29825, 97.517, 96.392, 96.157625, 95.54825, 96.626375, 97.657625,
            99.532625, 102.251375, 101.8295, 100.188875, 99.67325, 98.0795, 101.92325, 96.063875, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:45.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.20739,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:45.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.376375, 116.642, 114.345125, 112.23575, 108.532625, 105.5795, 105.48575, 106.657625, 102.532625,
            101.407625, 98.4545, 98.220125, 97.61075, 97.3295, 97.001375, 95.876375, 96.29825, 96.626375, 97.376375,
            100.188875, 101.8295, 102.11075, 100.142, 99.5795, 98.407625, 102.157625, 96.157625, 95.126375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:56.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.2954,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:56.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.626375, 123.251375, 119.642, 114.017, 113.313875, 109.188875, 108.017, 108.251375, 103.470125,
            100.188875, 99.017, 98.782625, 97.79825, 98.595125, 96.813875, 96.67325, 96.720125, 96.813875, 98.0795,
            100.61075, 102.626375, 102.9545, 100.376375, 99.532625, 98.688875, 102.345125, 96.532625, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:54.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.76054,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:54.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.48575, 121.42325, 117.48575, 115.563875, 113.36075, 110.688875, 108.2045, 111.438875, 105.9545,
            101.220125, 98.407625, 96.438875, 96.767, 96.532625, 95.501375, 95.407625, 95.407625, 95.876375, 97.188875,
            99.9545, 101.501375, 102.345125, 100.23575, 99.251375, 97.938875, 102.063875, 96.157625, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:32.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.764786,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:32.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.7045, 116.0795, 111.86075, 108.392, 105.157625, 104.032625, 105.9545, 104.501375, 100.79825, 99.532625,
            97.845125, 96.5795, 95.501375, 96.157625, 95.970125, 95.642, 95.595125, 96.017, 97.142, 100.376375,
            101.8295, 101.267, 100.04825, 99.532625, 97.751375, 101.267, 96.157625, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:19.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.29787,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:19.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.251375, 119.0795, 115.751375, 113.782625, 112.282625, 109.04825, 110.4545, 111.86075, 105.48575,
            105.532625, 101.126375, 97.7045, 97.7045, 97.376375, 95.642, 95.876375, 95.688875, 95.970125, 97.282625,
            100.04825, 102.157625, 101.4545, 100.142, 99.813875, 98.17325, 101.8295, 96.29825, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:30.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.34462,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:30.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.751375, 121.79825, 120.86075, 115.98575, 114.720125, 109.3295, 109.61075, 108.2045, 104.595125,
            100.79825, 99.063875, 97.188875, 97.3295, 96.67325, 95.220125, 95.032625, 95.73575, 96.157625, 97.42325,
            99.907625, 102.063875, 101.688875, 100.188875, 99.720125, 98.267, 102.2045, 96.345125, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:57.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.393524,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:57.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.8295, 119.17325, 115.657625, 110.688875, 108.2045, 106.938875, 104.782625, 105.017, 102.2045, 99.2045,
            98.313875, 96.813875, 97.61075, 97.095125, 96.157625, 96.9545, 96.720125, 97.04825, 97.751375, 100.42325,
            101.8295, 102.67325, 100.42325, 99.5795, 98.782625, 102.48575, 96.5795, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:17.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.063644,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:17.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.188875, 119.220125, 117.2045, 114.86075, 112.282625, 109.751375, 112.657625, 110.54825, 105.813875,
            106.657625, 99.720125, 98.595125, 97.7045, 98.126375, 96.720125, 96.813875, 96.438875, 96.626375, 97.61075,
            100.470125, 102.251375, 101.970125, 100.04825, 99.720125, 98.407625, 102.48575, 96.720125, 95.313875,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:12.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.89854,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:12.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.7045, 118.98575, 117.2045, 112.657625, 110.595125, 106.79825, 106.001375, 108.5795, 102.626375,
            100.188875, 99.345125, 98.032625, 97.23575, 97.23575, 96.11075, 95.782625, 95.73575, 96.345125, 97.563875,
            100.001375, 102.017, 101.407625, 100.142, 99.907625, 98.36075, 101.92325, 96.392, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:29.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.71803,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:29.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.29825, 105.345125, 105.67325, 108.767, 108.532625, 107.267, 108.5795, 109.470125, 103.3295, 101.220125,
            98.782625, 97.7045, 97.470125, 97.751375, 97.188875, 96.345125, 96.48575, 96.813875, 97.517, 99.9545,
            102.11075, 101.782625, 100.095125, 99.767, 98.501375, 102.29825, 96.813875, 95.876375,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:47.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.14168,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:47.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.3295, 111.907625, 107.126375, 105.767, 106.845125, 104.73575, 105.86075, 109.470125, 102.017, 99.29825,
            99.67325, 96.5795, 97.095125, 97.98575, 97.376375, 96.907625, 96.11075, 96.86075, 97.657625, 100.001375,
            102.11075, 102.48575, 100.095125, 99.767, 98.54825, 102.29825, 96.438875, 95.17325,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:15.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.26839,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:15.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.813875, 129.438875, 125.36075, 121.3295, 118.845125, 115.23575, 112.001375, 111.5795, 105.251375,
            100.751375, 98.407625, 97.79825, 96.48575, 98.220125, 95.501375, 95.8295, 95.595125, 96.392, 97.42325,
            99.907625, 102.157625, 101.54825, 100.095125, 99.767, 98.642, 103.470125, 96.67325, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:24.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.17317,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:24.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.407625, 112.517, 109.282625, 110.8295, 107.688875, 104.4545, 106.470125, 109.3295, 102.86075, 100.04825,
            99.11075, 97.23575, 100.657625, 97.98575, 96.626375, 96.86075, 95.970125, 97.376375, 97.282625, 99.9545,
            101.782625, 101.876375, 100.001375, 99.5795, 98.54825, 102.157625, 96.48575, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:14.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.90886,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:14.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.063875, 123.063875, 119.970125, 117.29825, 113.36075, 111.2045, 109.04825, 110.313875, 103.42325,
            101.688875, 98.73575, 97.142, 96.67325, 96.720125, 96.11075, 96.67325, 96.063875, 96.767, 97.61075,
            100.376375, 101.642, 101.642, 100.517, 99.86075, 98.407625, 102.345125, 96.9545, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:58.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.80656,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:58.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.188875, 118.282625, 117.392, 115.61075, 112.657625, 109.892, 107.032625, 108.29825, 104.4545,
            101.501375, 99.67325, 97.938875, 96.86075, 96.9545, 96.532625, 96.626375, 96.392, 97.04825, 97.98575,
            99.9545, 102.063875, 101.73575, 100.23575, 99.813875, 98.220125, 102.251375, 96.063875, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:34.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.55655,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:32:34.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.626375, 129.345125, 126.157625, 124.845125, 123.767, 120.5795, 118.04825, 113.36075, 109.657625,
            106.376375, 102.063875, 99.67325, 98.54825, 97.142, 96.2045, 95.8295, 95.220125, 96.29825, 97.188875,
            99.626375, 101.501375, 102.017, 100.23575, 99.345125, 98.595125, 102.157625, 96.345125, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:40.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.21541,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:40.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.392, 114.907625, 111.29825, 109.938875, 109.7045, 106.563875, 106.892, 109.04825, 103.517, 101.54825,
            101.4545, 97.470125, 97.188875, 97.42325, 97.79825, 97.517, 100.142, 97.7045, 97.845125, 99.813875,
            101.36075, 102.11075, 100.04825, 99.532625, 98.36075, 102.251375, 96.626375, 95.267,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:46.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.677216,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:46.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.563875, 118.23575, 115.79825, 113.782625, 111.9545, 107.032625, 106.98575, 109.04825, 102.48575,
            98.8295, 98.642, 97.79825, 98.0795, 99.720125, 97.470125, 96.392, 96.720125, 97.470125, 97.282625,
            99.907625, 101.73575, 102.29825, 100.095125, 99.626375, 98.313875, 101.595125, 96.345125, 95.220125,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:51.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.537056,
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:31:51.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.095125, 106.517, 104.267, 102.626375, 103.23575, 103.751375, 105.48575, 106.657625, 102.345125,
            100.3295, 103.470125, 98.36075, 97.470125, 97.470125, 100.04825, 96.67325, 97.517, 95.970125, 97.657625,
            100.001375, 101.970125, 102.11075, 100.095125, 99.251375, 98.032625, 102.017, 96.11075, 95.36075,
        ],
        latitude: 37.4405792,
        longitude: -122.5334108,
    },
    {
        timestamp: '2025-08-29T22:33:08.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.32852,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:08.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.845125, 127.3295, 124.188875, 119.73575, 115.938875, 112.470125, 109.79825, 108.017, 102.48575,
            101.36075, 98.92325, 97.892, 97.751375, 97.188875, 95.54825, 96.063875, 95.782625, 96.532625, 97.517,
            99.813875, 102.063875, 101.688875, 100.282625, 99.907625, 98.407625, 101.92325, 96.532625, 95.36075,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:53.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.3047,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:53.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.29825, 115.142, 111.86075, 110.407625, 110.0795, 107.4545, 107.970125, 108.67325, 103.61075, 102.392,
            101.0795, 99.767, 98.73575, 96.626375, 96.063875, 95.595125, 95.595125, 96.157625, 97.61075, 99.532625,
            102.017, 101.688875, 100.23575, 99.532625, 98.267, 102.017, 96.392, 95.126375,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:58.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.52495,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:58.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.313875, 129.48575, 125.0795, 122.970125, 121.98575, 119.876375, 114.720125, 111.251375, 108.86075,
            105.29825, 102.767, 99.720125, 97.001375, 96.438875, 95.688875, 95.642, 95.267, 96.2045, 97.42325,
            99.813875, 102.017, 101.501375, 100.563875, 99.767, 98.0795, 102.29825, 96.157625, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:56.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.89114,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:56.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.11075, 116.54825, 111.29825, 107.92325, 107.92325, 105.392, 107.220125, 107.313875, 103.095125, 100.892,
            100.42325, 98.73575, 99.251375, 97.563875, 97.095125, 97.23575, 96.29825, 97.188875, 97.7045, 100.095125,
            102.2045, 101.8295, 100.657625, 99.767, 98.313875, 102.29825, 96.11075, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:50.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.435936,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:50.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 118.188875, 115.563875, 112.938875, 110.876375, 108.2045, 106.938875, 107.782625, 102.67325,
            101.267, 100.3295, 98.73575, 97.98575, 97.42325, 96.532625, 97.23575, 95.970125, 96.5795, 97.657625,
            99.813875, 102.392, 101.876375, 100.001375, 99.5795, 98.407625, 102.063875, 96.017, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:44.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.58905,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:44.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.782625, 129.11075, 125.54825, 121.657625, 119.73575, 117.5795, 114.813875, 113.17325, 109.845125,
            106.23575, 102.063875, 99.532625, 98.36075, 97.095125, 96.2045, 96.017, 95.642, 96.438875, 97.563875,
            100.376375, 102.11075, 101.595125, 100.095125, 99.532625, 98.501375, 102.2045, 96.29825, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:25.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.92615,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:25.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.2045, 110.54825, 104.595125, 101.876375, 105.392, 105.626375, 106.142, 105.438875, 102.157625, 99.29825,
            97.376375, 96.626375, 96.251375, 97.142, 96.11075, 96.2045, 95.642, 96.157625, 97.23575, 100.001375,
            102.017, 101.642, 100.142, 99.438875, 97.845125, 101.4545, 96.157625, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:54.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.72523,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:54.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.17325, 112.79825, 109.751375, 106.79825, 106.188875, 105.392, 105.063875, 106.42325, 102.86075,
            101.220125, 99.438875, 98.688875, 97.7045, 97.3295, 95.876375, 95.970125, 95.688875, 96.2045, 97.42325,
            99.86075, 102.157625, 102.063875, 100.657625, 99.626375, 98.267, 102.438875, 96.251375, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:31.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.64283,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:31.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.11075, 108.063875, 104.73575, 105.813875, 107.595125, 105.67325, 106.563875, 106.42325, 102.67325,
            98.595125, 99.157625, 97.657625, 96.813875, 96.48575, 95.970125, 95.407625, 95.501375, 95.970125, 97.376375,
            99.438875, 101.642, 101.501375, 100.3295, 99.48575, 98.17325, 102.48575, 96.157625, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:21.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.30502,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:21.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 125.876375, 121.938875, 120.11075, 121.04825, 116.17325, 112.845125, 110.220125, 105.5795,
            103.23575, 99.438875, 98.36075, 96.813875, 96.9545, 96.11075, 95.501375, 95.0795, 96.345125, 97.376375,
            99.813875, 102.063875, 101.4545, 100.23575, 99.813875, 98.36075, 102.532625, 96.48575, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:40.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.03162,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:40.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.845125, 113.032625, 111.438875, 110.688875, 107.642, 105.29825, 106.095125, 106.751375, 102.86075,
            102.29825, 99.86075, 98.36075, 98.4545, 98.032625, 96.438875, 96.2045, 96.11075, 96.251375, 97.61075,
            100.23575, 102.48575, 102.063875, 100.845125, 100.23575, 99.063875, 103.142, 96.5795, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:46.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.17639,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:46.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 123.48575, 119.782625, 116.0795, 113.782625, 112.7045, 109.751375, 106.98575, 102.86075,
            99.251375, 98.220125, 97.188875, 97.845125, 96.2045, 95.92325, 95.970125, 95.92325, 96.907625, 97.751375,
            100.282625, 102.2045, 101.876375, 100.142, 99.626375, 98.501375, 102.017, 96.438875, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:29.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.9885,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:29.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.04825, 120.9545, 118.376375, 114.720125, 111.86075, 109.282625, 110.688875, 109.23575, 104.220125,
            102.9545, 101.54825, 98.642, 97.42325, 96.345125, 95.876375, 95.501375, 95.595125, 96.2045, 97.142,
            99.813875, 101.92325, 101.313875, 100.04825, 99.532625, 97.892, 101.782625, 96.345125, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:17.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.17555,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:17.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.017, 120.626375, 118.095125, 114.345125, 111.813875, 109.23575, 107.876375, 105.251375, 101.501375,
            99.907625, 97.61075, 97.657625, 97.376375, 97.657625, 96.86075, 96.29825, 97.142, 98.126375, 98.36075,
            100.376375, 101.970125, 101.92325, 100.61075, 99.86075, 98.4545, 102.48575, 96.5795, 95.36075,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:42.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.20795,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:42.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.67325, 126.9545, 122.407625, 115.845125, 113.4545, 113.595125, 109.095125, 106.657625, 104.4545,
            101.17325, 99.2045, 98.782625, 97.563875, 97.376375, 95.407625, 95.642, 95.688875, 96.438875, 97.61075,
            99.813875, 102.017, 101.595125, 100.42325, 99.626375, 98.407625, 102.626375, 96.017, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:14.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.218765,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:14.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.48575, 115.42325, 115.04825, 115.001375, 112.751375, 108.063875, 107.313875, 106.98575, 103.517,
            100.938875, 99.86075, 98.595125, 97.142, 98.688875, 96.86075, 96.720125, 95.782625, 97.282625, 97.79825,
            100.142, 102.017, 101.642, 100.517, 99.626375, 98.220125, 102.29825, 96.9545, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:36.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.64727,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:36.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.517, 115.095125, 111.157625, 108.063875, 106.845125, 106.23575, 107.782625, 107.032625, 103.3295,
            100.001375, 99.5795, 97.657625, 97.7045, 97.095125, 95.313875, 95.73575, 95.126375, 96.392, 97.845125,
            100.42325, 102.017, 102.532625, 100.845125, 100.001375, 98.8295, 102.67325, 96.29825, 95.36075,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:35.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.92499,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:35.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.126375, 118.517, 118.282625, 115.563875, 112.282625, 109.142, 108.063875, 107.688875, 102.157625,
            99.251375, 97.845125, 96.9545, 96.392, 97.04825, 96.767, 96.157625, 95.688875, 96.86075, 97.3295, 100.3295,
            101.642, 102.5795, 100.23575, 99.392, 98.688875, 102.2045, 96.813875, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:27.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.15844,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:27.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.61075, 108.9545, 104.220125, 105.345125, 107.501375, 105.017, 105.9545, 105.720125, 101.8295,
            100.095125, 99.11075, 97.79825, 96.2045, 96.29825, 95.73575, 95.032625, 95.126375, 95.970125, 97.188875,
            99.907625, 101.688875, 101.407625, 100.142, 99.5795, 98.4545, 102.157625, 95.970125, 95.126375,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:38.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.824425,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:38.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.595125, 104.4545, 101.8295, 104.126375, 104.267, 105.2045, 106.142, 104.876375, 101.92325, 100.3295,
            99.29825, 98.501375, 97.657625, 97.142, 95.642, 95.267, 95.595125, 96.767, 97.7045, 100.04825, 101.595125,
            101.92325, 100.142, 99.67325, 98.407625, 102.532625, 95.876375, 95.0795,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:10.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.42279,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:10.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.92325, 131.8295, 127.845125, 123.392, 120.063875, 116.0795, 114.063875, 111.157625, 108.2045, 104.73575,
            101.407625, 98.642, 96.48575, 97.470125, 97.142, 96.532625, 96.157625, 96.907625, 97.517, 99.86075,
            102.438875, 101.407625, 100.42325, 99.9545, 98.501375, 102.813875, 96.392, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:02.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.1719,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:02.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.267, 122.17325, 119.17325, 117.29825, 114.11075, 111.48575, 107.0795, 107.970125, 103.657625,
            101.595125, 99.157625, 98.4545, 96.767, 96.063875, 95.688875, 95.595125, 95.220125, 96.438875, 97.142,
            99.813875, 102.063875, 101.54825, 100.188875, 99.251375, 97.892, 101.688875, 95.970125, 95.407625,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:33.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.83431,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:33.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.0795, 102.626375, 103.04825, 105.2045, 106.517, 107.36075, 107.595125, 105.720125, 102.157625,
            100.282625, 99.2045, 98.126375, 97.3295, 97.142, 97.04825, 96.720125, 95.4545, 96.438875, 97.376375,
            99.67325, 101.4545, 101.4545, 100.282625, 99.438875, 98.407625, 102.767, 96.11075, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:09.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.924255,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:09.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.73575, 114.48575, 111.532625, 110.970125, 109.517, 107.73575, 108.29825, 107.782625, 104.642, 102.5795,
            99.017, 97.61075, 97.376375, 98.501375, 97.470125, 97.095125, 95.92325, 97.282625, 97.79825, 100.04825,
            102.11075, 101.970125, 100.3295, 99.9545, 98.595125, 102.438875, 96.67325, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:23.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.23163,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:23.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.67325, 129.2045, 125.407625, 122.032625, 120.67325, 117.626375, 115.001375, 113.501375, 108.626375,
            105.251375, 102.2045, 99.2045, 97.751375, 97.282625, 95.92325, 96.5795, 96.251375, 96.532625, 97.470125,
            99.813875, 102.063875, 101.267, 100.095125, 99.626375, 98.407625, 102.345125, 96.29825, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:18.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.48233,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:18.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.142, 124.79825, 122.4545, 116.54825, 114.2045, 112.7045, 109.845125, 107.876375, 102.11075, 99.345125,
            98.782625, 97.7045, 96.438875, 97.282625, 96.251375, 96.5795, 95.688875, 96.251375, 97.04825, 99.907625,
            102.11075, 101.501375, 100.142, 99.532625, 98.220125, 101.782625, 96.2045, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:52.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.44843,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:52.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.845125, 127.282625, 123.157625, 120.67325, 121.376375, 116.0795, 111.9545, 109.188875, 106.563875,
            104.267, 101.688875, 99.251375, 99.063875, 97.001375, 96.532625, 95.970125, 95.313875, 96.11075, 97.376375,
            99.813875, 102.11075, 101.54825, 100.188875, 99.48575, 98.407625, 102.157625, 96.157625, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:39.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.08146,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:39.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.626375, 105.720125, 103.7045, 106.142, 106.79825, 105.251375, 107.0795, 108.767, 104.642, 100.98575,
            99.345125, 98.688875, 97.892, 97.23575, 96.86075, 95.92325, 96.438875, 96.48575, 97.470125, 100.001375,
            102.017, 101.54825, 100.657625, 100.188875, 98.73575, 102.5795, 96.438875, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:38.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.70006,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:38.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.2045, 111.48575, 107.407625, 106.3295, 107.73575, 106.3295, 107.220125, 108.438875, 104.876375,
            100.79825, 99.907625, 96.626375, 95.970125, 96.626375, 95.595125, 94.98575, 95.54825, 96.29825, 97.845125,
            99.86075, 101.876375, 102.345125, 100.470125, 100.470125, 98.782625, 102.9545, 96.345125, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:26.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.04642,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:26.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.657625, 108.86075, 103.892, 104.17325, 105.2045, 105.29825, 106.376375, 106.095125, 101.92325,
            99.720125, 99.11075, 97.517, 97.142, 96.017, 96.2045, 95.54825, 95.4545, 96.438875, 97.845125, 100.04825,
            102.063875, 101.17325, 100.282625, 99.438875, 97.98575, 101.4545, 96.2045, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:41.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.82212,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:41.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.407625, 117.063875, 114.11075, 111.392, 109.470125, 106.751375, 106.142, 106.42325, 102.67325,
            100.376375, 98.970125, 98.54825, 97.61075, 96.813875, 95.501375, 95.501375, 95.642, 96.251375, 97.7045,
            99.720125, 101.876375, 101.407625, 100.42325, 100.282625, 98.970125, 102.5795, 96.063875, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:15.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.0456,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:15.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 123.157625, 116.36075, 112.563875, 111.017, 109.470125, 109.282625, 106.42325, 103.3295,
            100.98575, 98.876375, 97.79825, 97.23575, 97.938875, 96.345125, 96.48575, 96.392, 96.392, 97.892, 99.813875,
            101.970125, 101.407625, 100.001375, 99.157625, 97.938875, 101.595125, 96.48575, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:43.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.264854,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:43.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.220125, 119.4545, 116.220125, 113.4545, 111.157625, 107.501375, 107.688875, 107.876375, 102.767,
            99.251375, 101.313875, 98.126375, 97.563875, 97.142, 96.67325, 96.48575, 95.970125, 96.67325, 97.7045,
            100.188875, 101.782625, 101.782625, 100.095125, 99.67325, 98.220125, 101.782625, 96.2045, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:13.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.91856,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:13.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.282625, 124.376375, 119.54825, 116.73575, 114.67325, 111.767, 109.282625, 107.782625, 104.220125,
            100.7045, 99.720125, 98.54825, 96.907625, 98.126375, 96.9545, 96.532625, 96.017, 96.67325, 97.61075,
            100.376375, 102.251375, 101.92325, 100.188875, 99.392, 97.938875, 101.73575, 96.720125, 95.36075,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:06.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.37171,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:06.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.17325, 119.501375, 116.73575, 114.5795, 112.517, 108.251375, 106.517, 107.126375, 102.907625, 99.345125,
            99.813875, 98.220125, 97.23575, 97.79825, 97.79825, 97.657625, 96.67325, 96.392, 98.032625, 99.9545,
            102.392, 101.642, 100.376375, 100.095125, 98.4545, 102.017, 96.720125, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:30.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.58614,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:30.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.595125, 123.813875, 122.54825, 121.142, 119.876375, 114.5795, 111.720125, 108.86075, 105.251375,
            100.892, 98.642, 97.845125, 97.3295, 97.282625, 95.8295, 96.063875, 95.970125, 95.970125, 97.563875,
            99.67325, 101.73575, 101.36075, 100.282625, 99.626375, 98.642, 102.626375, 96.017, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:57.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.82729,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:57.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.970125, 116.220125, 113.688875, 108.063875, 107.126375, 105.392, 105.392, 106.376375, 103.188875,
            103.095125, 99.29825, 97.751375, 97.657625, 96.532625, 96.48575, 95.501375, 95.4545, 96.532625, 97.04825,
            100.142, 102.063875, 101.4545, 100.142, 99.5795, 98.4545, 101.8295, 95.970125, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:49.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.57591,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:49.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.4545, 119.36075, 117.5795, 115.142, 110.54825, 106.470125, 107.595125, 106.938875, 103.470125, 102.2045,
            101.501375, 100.04825, 98.267, 97.188875, 96.438875, 96.251375, 95.407625, 96.11075, 97.188875, 99.67325,
            101.782625, 101.313875, 100.04825, 99.5795, 98.267, 102.157625, 96.11075, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:37.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.17422,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:37.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.001375, 115.142, 110.876375, 107.595125, 106.23575, 103.376375, 106.42325, 105.86075, 100.657625,
            99.907625, 99.2045, 97.23575, 96.67325, 96.813875, 96.017, 96.48575, 96.063875, 96.86075, 97.517, 100.517,
            101.782625, 102.626375, 100.376375, 99.813875, 98.501375, 102.392, 96.392, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:20.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.114044,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:20.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.907625, 114.86075, 111.48575, 106.23575, 107.54825, 105.67325, 105.438875, 105.532625, 101.501375,
            99.29825, 98.0795, 96.813875, 96.532625, 97.7045, 96.2045, 96.29825, 96.2045, 96.9545, 97.751375,
            100.188875, 102.11075, 101.782625, 100.376375, 99.767, 98.595125, 102.392, 96.392, 95.36075,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:37.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.35607,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:37.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.970125, 116.4545, 114.017, 109.938875, 109.282625, 106.04825, 105.907625, 105.11075, 101.782625,
            100.3295, 100.001375, 97.470125, 97.845125, 98.970125, 97.3295, 96.67325, 96.67325, 96.626375, 97.79825,
            100.3295, 102.017, 102.67325, 100.7045, 100.001375, 98.92325, 102.813875, 97.188875, 95.407625,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:48.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.82014,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:48.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.392, 121.282625, 119.876375, 116.220125, 111.345125, 110.642, 108.5795, 106.7045, 102.720125,
            100.001375, 98.595125, 96.86075, 97.23575, 96.720125, 95.17325, 95.54825, 95.642, 96.48575, 97.376375,
            100.04825, 101.876375, 101.126375, 99.907625, 99.5795, 98.267, 101.92325, 96.2045, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:34.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.7766,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:34.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.3295, 108.813875, 108.063875, 107.8295, 107.17325, 106.657625, 107.36075, 107.782625, 103.751375,
            101.17325, 99.767, 98.876375, 99.2045, 98.17325, 97.938875, 98.267, 96.720125, 97.04825, 97.938875,
            100.282625, 101.876375, 102.5795, 100.845125, 99.767, 98.642, 102.11075, 96.29825, 95.407625,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:12.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.21912,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:12.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.9545, 130.470125, 129.251375, 124.470125, 122.876375, 120.907625, 118.98575, 114.767, 110.688875,
            107.4545, 104.4545, 100.751375, 98.17325, 98.17325, 96.392, 95.970125, 96.157625, 96.767, 97.3295, 100.7045,
            102.251375, 101.54825, 100.23575, 99.67325, 98.313875, 102.345125, 96.5795, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:46.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.765495,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:46.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.095125, 111.438875, 107.970125, 103.563875, 106.04825, 106.142, 105.157625, 105.438875, 103.517,
            101.220125, 99.063875, 98.54825, 97.188875, 96.9545, 97.04825, 95.782625, 95.688875, 96.532625, 97.517,
            99.86075, 101.876375, 101.407625, 100.142, 99.86075, 98.4545, 102.2045, 96.345125, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:24.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.7848,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:24.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.54825, 124.001375, 120.063875, 116.36075, 114.9545, 111.392, 107.92325, 107.4545, 103.845125, 101.54825,
            99.48575, 97.7045, 96.86075, 96.157625, 95.501375, 96.017, 95.54825, 96.5795, 97.563875, 100.282625,
            102.157625, 101.782625, 100.42325, 99.392, 98.032625, 102.2045, 96.626375, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:22.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.619225,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:22.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.438875, 108.2045, 105.5795, 105.5795, 106.79825, 104.126375, 105.626375, 106.376375, 101.407625,
            100.282625, 99.2045, 97.657625, 96.438875, 96.907625, 96.017, 95.876375, 95.688875, 95.970125, 97.563875,
            99.86075, 101.92325, 101.501375, 100.282625, 99.48575, 98.17325, 101.92325, 96.11075, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:49.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.02261,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:49.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.0795, 120.392, 118.23575, 116.313875, 116.54825, 112.23575, 108.9545, 107.032625, 102.720125,
            100.470125, 101.4545, 99.767, 98.8295, 97.938875, 97.282625, 96.532625, 96.017, 96.438875, 97.751375,
            100.23575, 102.017, 101.4545, 100.188875, 99.9545, 98.4545, 102.626375, 96.392, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:45.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.08264,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:45.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.36075, 109.7045, 106.563875, 106.563875, 107.220125, 107.8295, 107.36075, 107.642, 103.845125, 101.4545,
            99.720125, 98.032625, 98.126375, 97.001375, 96.86075, 96.251375, 95.501375, 96.532625, 97.61075, 99.626375,
            102.2045, 101.688875, 99.9545, 99.29825, 98.407625, 101.73575, 96.11075, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:47.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.50912,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:47.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.7045, 105.767, 101.8295, 105.29825, 106.188875, 104.17325, 104.73575, 104.92325, 101.970125, 100.095125,
            97.563875, 96.907625, 97.095125, 96.48575, 95.642, 96.157625, 96.392, 96.767, 97.892, 100.188875,
            102.157625, 101.8295, 100.095125, 99.5795, 98.595125, 102.11075, 96.251375, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:51.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.81406,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:51.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.313875, 112.376375, 108.67325, 106.61075, 106.79825, 104.92325, 106.7045, 106.79825, 105.48575,
            102.2045, 101.4545, 99.9545, 98.407625, 97.04825, 96.48575, 95.4545, 95.92325, 96.767, 97.470125,
            100.001375, 101.8295, 101.4545, 100.142, 99.5795, 98.220125, 102.017, 96.157625, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:32.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 115.569244,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:32.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            106.61075, 101.688875, 99.532625, 103.04825, 104.688875, 103.282625, 104.970125, 104.0795, 101.8295,
            99.720125, 100.563875, 97.42325, 97.563875, 96.48575, 96.2045, 95.688875, 95.642, 96.157625, 97.892,
            99.813875, 101.73575, 101.407625, 100.61075, 99.813875, 98.220125, 102.11075, 95.970125, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:42.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.34604,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:42.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.54825, 125.54825, 122.032625, 119.54825, 115.282625, 115.61075, 113.36075, 109.282625, 106.3295,
            104.17325, 102.532625, 100.7045, 97.563875, 97.845125, 97.845125, 97.563875, 96.532625, 96.67325, 97.845125,
            99.907625, 102.48575, 101.876375, 100.657625, 100.001375, 98.688875, 102.532625, 96.626375, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:43.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.73157,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:43.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.11075, 129.2045, 124.7045, 121.563875, 120.2045, 115.376375, 113.54825, 110.970125, 106.7045,
            103.282625, 101.17325, 99.67325, 97.98575, 97.376375, 96.392, 96.2045, 95.54825, 96.626375, 97.517, 100.142,
            101.73575, 101.501375, 100.04825, 99.767, 98.595125, 102.48575, 96.720125, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:04.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.361626,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:04.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.313875, 115.938875, 113.220125, 110.032625, 107.032625, 104.688875, 105.392, 106.188875, 101.970125,
            99.5795, 97.938875, 97.79825, 97.517, 97.23575, 95.970125, 96.2045, 95.595125, 96.48575, 97.751375,
            100.04825, 102.438875, 102.063875, 100.61075, 100.095125, 98.36075, 102.29825, 96.251375, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:39.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.76659,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:39.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.017, 115.376375, 111.813875, 108.157625, 108.063875, 105.017, 106.3295, 104.17325, 101.126375,
            99.438875, 99.86075, 97.517, 96.813875, 96.2045, 97.42325, 95.126375, 95.688875, 96.907625, 97.79825,
            99.9545, 101.92325, 101.220125, 100.095125, 100.001375, 98.313875, 102.392, 96.11075, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:03.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.53779,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:03.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.4545, 114.86075, 113.126375, 109.3295, 106.376375, 104.501375, 106.470125, 104.782625, 100.563875,
            99.813875, 98.92325, 100.845125, 97.98575, 96.907625, 96.532625, 96.720125, 96.157625, 96.907625, 97.79825,
            100.095125, 101.876375, 101.267, 100.42325, 99.813875, 98.642, 102.345125, 96.5795, 95.36075,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:55.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.60854,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:55.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.407625, 115.845125, 112.845125, 111.392, 109.892, 107.267, 107.126375, 107.92325, 103.470125,
            100.563875, 98.4545, 97.188875, 97.188875, 97.61075, 96.813875, 95.92325, 95.220125, 96.532625, 97.188875,
            99.5795, 101.782625, 101.595125, 100.3295, 100.095125, 98.54825, 102.392, 95.92325, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:28.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 115.99707,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:28.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.73575, 101.4545, 100.376375, 104.92325, 104.595125, 104.032625, 104.0795, 106.142, 102.29825,
            100.376375, 100.142, 98.501375, 97.61075, 96.626375, 95.17325, 94.98575, 95.17325, 95.970125, 97.42325,
            99.767, 101.970125, 101.36075, 100.282625, 99.5795, 98.36075, 101.501375, 95.970125, 95.0795,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:41.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.15,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:41.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.095125, 108.86075, 105.29825, 106.657625, 106.095125, 105.813875, 107.126375, 106.751375, 102.48575,
            100.61075, 99.67325, 98.73575, 96.907625, 97.001375, 95.688875, 95.876375, 95.220125, 96.720125, 97.517,
            99.5795, 101.8295, 101.4545, 100.095125, 99.9545, 98.17325, 101.688875, 96.017, 95.126375,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:40.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.40138,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:40.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.938875, 108.29825, 104.220125, 107.032625, 105.813875, 105.813875, 106.3295, 106.142, 102.251375,
            100.282625, 99.813875, 98.407625, 97.751375, 97.282625, 95.642, 95.595125, 95.73575, 96.720125, 97.79825,
            100.470125, 102.345125, 101.876375, 100.188875, 100.04825, 98.73575, 102.48575, 96.017, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:00.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.42625,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:00.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.532625, 124.188875, 120.392, 116.642, 114.2045, 112.3295, 107.92325, 108.345125, 103.142, 99.767,
            97.938875, 97.04825, 96.251375, 96.29825, 96.017, 96.5795, 95.970125, 96.11075, 97.470125, 100.23575,
            102.438875, 101.876375, 100.23575, 99.438875, 98.032625, 101.688875, 96.345125, 95.313875,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:47.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.178795,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:47.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.657625, 117.626375, 113.501375, 108.67325, 108.063875, 106.470125, 106.282625, 105.392, 101.0795,
            99.532625, 100.095125, 99.157625, 97.376375, 97.3295, 96.29825, 96.345125, 96.157625, 96.48575, 97.42325,
            100.001375, 101.970125, 101.501375, 100.001375, 99.720125, 98.501375, 102.11075, 96.11075, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:07.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.39687,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:07.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.157625, 125.220125, 120.251375, 115.188875, 114.392, 111.2045, 109.845125, 105.345125, 103.470125,
            100.3295, 98.36075, 97.282625, 98.032625, 98.54825, 95.876375, 96.157625, 95.970125, 96.720125, 97.376375,
            99.720125, 101.970125, 101.36075, 100.23575, 99.767, 98.54825, 102.626375, 96.438875, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:19.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.76522,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:19.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.126375, 116.36075, 112.563875, 111.86075, 111.67325, 108.626375, 109.517, 109.470125, 105.813875,
            102.67325, 99.392, 98.407625, 97.845125, 98.501375, 97.095125, 96.345125, 96.345125, 96.392, 98.032625,
            100.42325, 102.017, 101.313875, 100.095125, 99.67325, 98.267, 101.876375, 96.48575, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:48.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.53375,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:48.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.720125, 126.720125, 123.2045, 120.345125, 119.688875, 116.0795, 112.470125, 110.17325, 106.23575,
            103.563875, 101.595125, 98.876375, 96.5795, 97.376375, 97.001375, 95.73575, 95.876375, 95.73575, 97.001375,
            99.767, 101.73575, 101.73575, 99.9545, 99.86075, 98.0795, 101.688875, 96.438875, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:36.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.1013,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:36.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.813875, 109.892, 109.751375, 110.313875, 109.563875, 106.892, 106.563875, 106.79825, 101.407625, 99.767,
            101.73575, 98.595125, 97.282625, 97.470125, 96.438875, 96.11075, 96.345125, 96.86075, 98.782625, 100.657625,
            102.626375, 102.5795, 100.563875, 100.04825, 99.017, 103.142, 97.3295, 95.4545,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:59.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.84856,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:32:59.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.095125, 124.04825, 120.907625, 117.251375, 114.67325, 112.563875, 109.282625, 107.126375, 103.7045,
            101.970125, 98.595125, 97.845125, 96.86075, 96.720125, 96.2045, 95.688875, 96.29825, 96.29825, 97.376375,
            100.3295, 102.017, 101.501375, 99.767, 99.251375, 97.79825, 101.54825, 96.48575, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:44.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.98145,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:44.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.17325, 130.001375, 127.3295, 124.188875, 120.157625, 117.392, 115.142, 111.767, 105.11075, 104.73575,
            101.73575, 100.892, 100.938875, 102.29825, 103.98575, 106.657625, 106.845125, 109.001375, 111.29825,
            112.563875, 111.157625, 114.29825, 116.970125, 116.54825, 126.29825, 134.220125, 110.0795, 109.23575,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:16.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.17793,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:16.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.688875, 120.767, 119.407625, 114.907625, 112.61075, 108.438875, 107.73575, 104.876375, 101.032625,
            98.642, 98.4545, 97.563875, 95.92325, 97.7045, 96.29825, 96.345125, 95.92325, 96.720125, 97.3295,
            100.095125, 101.688875, 101.642, 99.907625, 99.345125, 97.892, 101.313875, 95.970125, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:11.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.10956,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:11.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.29825, 127.657625, 125.36075, 124.61075, 122.92325, 119.220125, 113.0795, 110.501375, 105.626375,
            101.876375, 99.392, 97.751375, 96.2045, 97.563875, 96.86075, 96.48575, 95.970125, 96.767, 97.142, 99.813875,
            101.876375, 101.407625, 100.142, 99.48575, 97.892, 101.313875, 96.438875, 95.17325,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:42.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.26968,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:42.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.751375, 108.720125, 106.892, 106.23575, 106.892, 105.251375, 106.42325, 104.970125, 100.938875, 98.4545,
            99.438875, 99.11075, 97.751375, 97.095125, 95.407625, 96.2045, 95.8295, 96.532625, 97.751375, 99.9545,
            101.8295, 101.54825, 100.42325, 99.86075, 98.407625, 102.017, 96.2045, 95.267,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:01.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.19334,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:01.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.42325, 123.813875, 122.220125, 119.0795, 113.688875, 110.36075, 109.563875, 107.267, 103.7045,
            101.688875, 100.001375, 98.782625, 97.376375, 97.23575, 97.42325, 96.720125, 96.063875, 96.29825, 97.42325,
            99.9545, 101.782625, 101.220125, 99.907625, 99.345125, 98.032625, 102.2045, 96.345125, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:35.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.156624,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:35.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.563875, 117.9545, 113.267, 110.267, 107.595125, 105.48575, 105.9545, 105.2045, 101.595125, 99.813875,
            99.11075, 97.79825, 97.751375, 97.563875, 96.2045, 95.688875, 95.54825, 96.438875, 97.42325, 99.813875,
            101.782625, 101.92325, 100.142, 99.532625, 98.220125, 101.501375, 95.970125, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:45.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.88368,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:45.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.970125, 116.688875, 112.42325, 110.595125, 109.001375, 106.04825, 105.2045, 104.267, 101.8295,
            99.907625, 98.970125, 98.688875, 97.517, 97.3295, 96.720125, 96.2045, 95.970125, 96.438875, 97.563875,
            99.813875, 102.157625, 101.688875, 99.907625, 99.438875, 97.98575, 101.501375, 96.251375, 95.220125,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:05.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.82523,
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:33:05.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.3295, 120.9545, 115.79825, 111.813875, 110.876375, 108.2045, 106.845125, 106.376375, 102.345125,
            100.517, 99.392, 96.9545, 96.86075, 96.5795, 96.532625, 96.345125, 96.345125, 96.157625, 97.892, 99.9545,
            102.11075, 101.220125, 100.142, 99.86075, 98.4545, 102.063875, 96.29825, 95.36075,
        ],
        latitude: 37.4405775,
        longitude: -122.533398,
    },
    {
        timestamp: '2025-08-29T22:34:11.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.02637,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:11.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.813875, 113.782625, 111.532625, 109.095125, 107.92325, 105.767, 106.188875, 106.001375, 101.92325,
            99.86075, 98.54825, 97.845125, 97.001375, 96.767, 95.92325, 96.251375, 95.501375, 95.92325, 97.095125,
            99.813875, 102.063875, 101.688875, 100.001375, 99.67325, 98.313875, 101.688875, 96.157625, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:56.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.94273,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:56.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 119.54825, 116.970125, 112.517, 113.36075, 108.67325, 107.267, 105.767, 101.36075, 98.876375,
            98.8295, 97.517, 97.3295, 96.017, 95.54825, 97.751375, 95.876375, 96.2045, 97.61075, 100.142, 102.11075,
            101.17325, 100.282625, 99.767, 98.313875, 102.157625, 95.970125, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:50.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.827835,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:50.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.267, 113.876375, 110.267, 105.9545, 105.063875, 103.79825, 105.86075, 104.407625, 101.92325, 99.392,
            98.642, 98.501375, 97.42325, 97.3295, 95.595125, 95.876375, 95.595125, 96.48575, 97.3295, 99.907625,
            102.438875, 102.063875, 100.3295, 99.767, 98.595125, 102.345125, 96.532625, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:09.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.76941,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:09.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.42325, 115.23575, 114.251375, 110.92325, 103.892, 105.063875, 104.17325, 104.92325, 100.3295, 99.2045,
            98.782625, 97.938875, 97.282625, 96.720125, 95.876375, 95.0795, 95.688875, 96.532625, 97.470125, 100.095125,
            101.876375, 101.73575, 100.517, 99.67325, 98.313875, 102.48575, 95.970125, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:01.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.03549,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:01.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.86075, 121.61075, 119.0795, 115.095125, 113.688875, 109.04825, 107.54825, 105.9545, 102.29825, 99.5795,
            99.907625, 98.407625, 97.938875, 96.767, 96.626375, 95.220125, 95.36075, 96.345125, 97.3295, 100.04825,
            102.063875, 101.17325, 100.04825, 99.48575, 98.0795, 102.063875, 96.157625, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:54.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.93528,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:54.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.438875, 114.157625, 110.36075, 109.095125, 108.29825, 105.720125, 107.36075, 107.782625, 105.017,
            102.157625, 99.907625, 98.688875, 97.7045, 97.61075, 95.782625, 95.313875, 95.782625, 96.67325, 97.657625,
            100.001375, 101.92325, 101.595125, 100.42325, 100.142, 98.267, 102.017, 95.876375, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:40.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.19533,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:40.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.626375, 119.688875, 115.188875, 112.79825, 112.470125, 109.7045, 107.36075, 107.4545, 104.0795, 99.392,
            98.54825, 97.42325, 97.376375, 96.767, 95.642, 95.688875, 95.220125, 96.063875, 97.563875, 99.532625,
            102.157625, 101.54825, 100.470125, 100.04825, 98.267, 102.2045, 96.11075, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:32.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.481674,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:32.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.2045, 107.501375, 103.376375, 105.438875, 106.095125, 106.845125, 106.376375, 105.438875, 102.48575,
            99.063875, 97.657625, 96.48575, 96.907625, 96.813875, 96.251375, 96.017, 95.876375, 96.767, 97.61075,
            100.188875, 102.063875, 101.54825, 100.04825, 99.5795, 98.642, 102.392, 96.720125, 95.407625,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:42.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.09952,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:42.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.67325, 129.9545, 128.782625, 127.657625, 123.438875, 120.345125, 117.720125, 113.73575, 107.970125,
            104.4545, 100.517, 99.063875, 97.188875, 96.5795, 95.92325, 95.8295, 95.73575, 96.345125, 97.095125,
            100.282625, 102.017, 101.73575, 100.188875, 99.438875, 98.220125, 101.970125, 96.9545, 95.4545,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:27.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.75078,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:27.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.813875, 133.04825, 130.657625, 126.86075, 126.017, 118.892, 117.438875, 114.720125, 112.61075,
            110.688875, 105.392, 100.563875, 99.48575, 97.657625, 97.001375, 96.532625, 96.48575, 97.04825, 98.407625,
            100.79825, 102.392, 102.157625, 100.23575, 99.720125, 98.501375, 102.29825, 96.767, 95.407625,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:44.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.35889,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:44.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.220125, 128.8295, 127.142, 123.345125, 119.642, 116.313875, 113.220125, 109.98575, 105.767, 102.063875,
            99.907625, 97.3295, 96.720125, 96.2045, 94.98575, 95.407625, 95.267, 96.157625, 97.04825, 99.86075,
            101.92325, 101.36075, 99.813875, 99.11075, 97.657625, 101.267, 96.48575, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:43.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.23431,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:43.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.063875, 126.2045, 124.188875, 120.86075, 120.767, 116.782625, 115.188875, 112.001375, 109.7045,
            103.79825, 100.3295, 98.220125, 96.2045, 96.345125, 95.220125, 95.0795, 95.267, 96.251375, 97.470125,
            100.3295, 102.11075, 101.4545, 100.142, 99.392, 97.98575, 102.157625, 96.063875, 95.126375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:26.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 145.07277,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:26.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            143.032625, 137.0795, 134.17325, 131.92325, 131.0795, 128.688875, 125.36075, 123.67325, 119.876375,
            116.688875, 111.9545, 106.98575, 103.517, 100.79825, 97.3295, 96.9545, 96.86075, 96.392, 97.517, 100.470125,
            102.392, 101.92325, 100.23575, 99.86075, 98.407625, 102.2045, 96.5795, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:05.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.28291,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:05.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.11075, 113.876375, 109.04825, 105.392, 105.67325, 105.720125, 106.04825, 104.4545, 103.142, 99.907625,
            98.0795, 98.126375, 98.313875, 97.470125, 95.782625, 95.54825, 95.782625, 96.017, 97.04825, 99.86075,
            102.017, 101.782625, 100.142, 99.345125, 98.032625, 101.782625, 96.017, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:03.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.0127,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:03.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 122.876375, 118.376375, 120.29825, 116.220125, 111.86075, 110.267, 108.063875, 102.9545, 101.4545,
            101.54825, 98.267, 97.095125, 96.767, 95.642, 100.001375, 99.29825, 97.563875, 98.595125, 99.9545,
            102.063875, 101.313875, 100.142, 99.438875, 98.4545, 102.29825, 96.2045, 95.501375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:55.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.31264,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:55.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.642, 114.29825, 114.157625, 114.720125, 107.8295, 106.095125, 108.626375, 107.126375, 102.345125,
            100.142, 99.67325, 98.36075, 98.36075, 96.86075, 96.438875, 96.063875, 95.407625, 96.017, 97.517, 100.142,
            102.29825, 101.92325, 100.142, 99.5795, 98.4545, 102.48575, 96.29825, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:06.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.34744,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:06.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.813875, 116.73575, 111.86075, 108.5795, 107.17325, 104.876375, 106.79825, 106.001375, 101.688875,
            99.017, 97.751375, 97.845125, 96.438875, 95.642, 95.595125, 95.501375, 95.267, 96.392, 97.657625, 100.04825,
            102.063875, 100.98575, 100.142, 99.767, 98.220125, 101.782625, 96.11075, 95.407625,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:46.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.868454,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:46.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.54825, 117.720125, 113.17325, 111.11075, 107.313875, 106.751375, 106.79825, 105.813875, 102.345125,
            100.142, 98.032625, 96.86075, 97.04825, 96.2045, 96.251375, 95.595125, 95.782625, 96.392, 97.42325,
            100.188875, 101.8295, 101.501375, 100.095125, 99.48575, 98.267, 102.157625, 96.157625, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:02.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.67331,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:02.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.767, 117.67325, 113.126375, 110.36075, 108.720125, 106.42325, 107.0795, 107.407625, 104.501375,
            102.532625, 99.11075, 97.657625, 97.188875, 96.9545, 97.282625, 97.470125, 96.251375, 96.438875, 97.470125,
            100.04825, 102.2045, 101.688875, 100.3295, 99.907625, 98.407625, 102.063875, 96.251375, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:28.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.57464,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:28.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.98575, 106.517, 105.11075, 108.29825, 108.157625, 106.563875, 107.0795, 105.86075, 103.3295, 100.751375,
            99.438875, 97.657625, 97.42325, 97.563875, 96.157625, 96.438875, 96.11075, 96.626375, 98.0795, 100.42325,
            102.345125, 102.2045, 100.04825, 99.251375, 98.36075, 101.782625, 96.626375, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:57.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.22852,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:57.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 124.376375, 118.98575, 113.032625, 110.595125, 108.392, 106.751375, 104.73575, 101.73575,
            100.095125, 98.876375, 97.98575, 96.9545, 95.970125, 96.2045, 95.54825, 96.251375, 96.29825, 97.563875,
            99.86075, 102.11075, 101.73575, 100.563875, 99.767, 98.4545, 102.48575, 96.532625, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:52.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.7307,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:52.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.157625, 125.92325, 121.7045, 119.0795, 116.220125, 113.642, 109.61075, 107.688875, 103.563875,
            100.657625, 98.36075, 99.813875, 97.376375, 96.48575, 95.36075, 95.688875, 95.73575, 96.48575, 97.04825,
            99.9545, 101.876375, 101.688875, 100.42325, 99.67325, 98.407625, 102.29825, 95.92325, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:36.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.92659,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:36.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 114.532625, 110.876375, 108.29825, 107.220125, 104.8295, 105.532625, 105.813875, 102.438875,
            98.4545, 99.157625, 96.392, 96.017, 96.48575, 95.54825, 95.313875, 95.126375, 96.532625, 97.892, 99.86075,
            101.970125, 102.251375, 100.563875, 100.04825, 98.688875, 102.5795, 96.251375, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:17.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.93766,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:17.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.23575, 115.563875, 112.42325, 111.86075, 110.36075, 107.36075, 106.845125, 107.4545, 103.188875,
            100.3295, 101.595125, 99.86075, 98.688875, 97.23575, 97.04825, 96.392, 96.29825, 97.23575, 97.938875,
            100.23575, 102.29825, 101.970125, 100.517, 99.9545, 98.688875, 102.626375, 96.532625, 95.126375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:47.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.75005,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:47.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 127.517, 126.86075, 125.92325, 121.142, 117.9545, 115.23575, 111.767, 106.3295, 103.938875,
            102.11075, 98.92325, 97.3295, 96.626375, 95.688875, 95.595125, 96.017, 96.86075, 97.42325, 99.532625,
            101.92325, 101.407625, 100.095125, 99.345125, 97.98575, 102.626375, 96.017, 95.126375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:54.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.14183,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:54.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.767, 114.392, 110.4545, 108.532625, 108.017, 106.751375, 108.017, 107.970125, 104.313875, 101.0795,
            98.032625, 96.67325, 96.532625, 96.251375, 95.17325, 95.73575, 95.313875, 96.438875, 97.517, 100.3295,
            102.48575, 101.782625, 100.282625, 99.9545, 98.501375, 101.970125, 96.063875, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:49.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.08501,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:49.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.407625, 111.2045, 110.595125, 106.142, 105.017, 104.501375, 106.188875, 105.157625, 102.626375,
            98.36075, 100.188875, 98.73575, 97.188875, 96.2045, 94.98575, 95.126375, 95.032625, 96.157625, 97.563875,
            99.767, 101.876375, 101.688875, 100.142, 99.345125, 98.032625, 102.11075, 96.017, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:51.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.91687,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:51.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.001375, 121.142, 118.61075, 114.063875, 111.67325, 108.157625, 107.782625, 106.79825, 103.23575,
            101.220125, 98.595125, 97.98575, 97.98575, 96.86075, 97.188875, 98.0795, 96.438875, 96.813875, 97.563875,
            100.23575, 102.063875, 101.54825, 100.142, 100.001375, 98.688875, 101.73575, 96.532625, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:04.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.62776,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:04.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.470125, 124.61075, 122.407625, 118.095125, 114.86075, 110.407625, 108.86075, 106.845125, 101.267,
            98.8295, 98.54825, 97.142, 97.7045, 97.657625, 96.2045, 95.73575, 95.688875, 96.345125, 97.001375, 99.9545,
            101.92325, 101.782625, 99.813875, 99.29825, 97.845125, 101.36075, 96.2045, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:23.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.24463,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:23.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.0795, 105.626375, 103.04825, 106.142, 107.032625, 106.095125, 106.657625, 106.7045, 104.0795, 99.907625,
            99.720125, 98.126375, 98.220125, 98.0795, 96.063875, 95.970125, 95.876375, 96.438875, 97.751375, 99.767,
            102.11075, 102.157625, 100.517, 100.001375, 98.36075, 102.345125, 96.767, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:24.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.07388,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:24.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.126375, 114.11075, 111.345125, 108.86075, 107.313875, 106.095125, 104.73575, 104.782625, 100.938875,
            99.392, 98.642, 97.3295, 97.517, 96.720125, 96.11075, 96.11075, 96.767, 96.907625, 97.938875, 100.142,
            102.29825, 101.92325, 100.751375, 100.23575, 98.970125, 102.86075, 96.813875, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:20.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.608086,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:20.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.23575, 106.79825, 102.9545, 103.7045, 104.4545, 104.54825, 105.767, 104.595125, 102.626375, 100.470125,
            99.11075, 98.267, 98.17325, 97.23575, 96.11075, 96.11075, 96.345125, 96.9545, 97.79825, 100.23575, 102.2045,
            102.063875, 100.3295, 99.9545, 98.782625, 102.67325, 96.907625, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:00.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.38783,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:00.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.845125, 113.407625, 109.23575, 107.126375, 106.517, 103.938875, 104.220125, 102.67325, 99.532625,
            97.751375, 97.61075, 96.017, 96.438875, 96.157625, 95.4545, 95.782625, 94.938875, 96.2045, 97.282625,
            99.720125, 101.970125, 101.4545, 100.282625, 99.392, 98.220125, 101.782625, 96.251375, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:18.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.304955,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:18.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.907625, 103.845125, 103.04825, 106.188875, 107.17325, 107.0795, 105.438875, 107.267, 102.017,
            100.376375, 101.54825, 99.392, 98.313875, 97.517, 96.5795, 96.813875, 96.720125, 96.67325, 97.845125,
            99.767, 102.063875, 101.688875, 100.517, 99.813875, 98.73575, 102.767, 96.48575, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:35.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.51353,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:35.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            106.23575, 101.782625, 102.907625, 106.563875, 106.095125, 104.92325, 106.470125, 105.813875, 102.626375,
            100.751375, 98.970125, 97.001375, 96.720125, 96.813875, 95.220125, 95.267, 95.501375, 96.11075, 97.751375,
            100.04825, 102.157625, 102.48575, 100.7045, 100.04825, 98.688875, 102.48575, 96.29825, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:53.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.02347,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:53.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.4545, 119.032625, 117.11075, 115.7045, 113.313875, 110.0795, 106.517, 105.345125, 102.2045, 100.095125,
            97.517, 96.767, 96.5795, 97.04825, 96.251375, 96.251375, 95.73575, 96.532625, 97.42325, 100.142, 102.11075,
            101.313875, 100.3295, 99.907625, 98.501375, 102.2045, 96.29825, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:55.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.231316,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:55.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 109.04825, 103.095125, 104.54825, 106.142, 104.642, 105.438875, 105.626375, 101.267, 99.67325,
            97.892, 96.48575, 95.970125, 96.767, 95.782625, 95.73575, 95.8295, 96.48575, 97.7045, 99.907625, 102.157625,
            101.642, 100.42325, 100.04825, 98.313875, 102.29825, 96.251375, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:07.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.57803,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:07.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.392, 113.8295, 108.86075, 106.517, 107.407625, 105.017, 106.282625, 107.595125, 103.04825, 101.220125,
            98.4545, 96.9545, 96.2045, 95.876375, 95.688875, 95.17325, 94.7045, 96.2045, 97.095125, 100.42325,
            102.251375, 101.73575, 100.376375, 99.67325, 98.36075, 102.063875, 96.11075, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:38.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.22858,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:38.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.04825, 108.251375, 104.642, 106.095125, 107.267, 106.04825, 107.313875, 106.751375, 103.657625,
            100.79825, 99.392, 97.23575, 97.3295, 97.892, 96.29825, 96.11075, 100.282625, 96.626375, 97.79825,
            100.282625, 102.017, 101.501375, 100.3295, 99.907625, 98.876375, 102.813875, 96.29825, 95.126375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:51.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.59102,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:51.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.907625, 121.938875, 121.282625, 117.532625, 112.188875, 111.767, 110.313875, 108.2045, 105.063875,
            104.501375, 102.9545, 101.876375, 99.2045, 99.532625, 97.282625, 96.251375, 96.907625, 97.79825, 97.751375,
            100.142, 102.157625, 101.876375, 100.376375, 99.532625, 98.54825, 102.157625, 96.345125, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:57.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.82796,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:57.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.532625, 117.813875, 114.48575, 113.688875, 111.438875, 108.626375, 106.892, 105.157625, 102.813875,
            99.767, 98.032625, 97.188875, 95.782625, 96.157625, 95.220125, 95.73575, 95.54825, 95.970125, 97.470125,
            100.001375, 101.92325, 101.8295, 100.470125, 99.5795, 98.126375, 101.595125, 96.251375, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:03.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.9566,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:03.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.782625, 136.376375, 133.001375, 128.688875, 124.751375, 123.67325, 119.0795, 116.54825, 112.657625,
            108.813875, 106.3295, 102.5795, 99.813875, 97.7045, 97.001375, 96.063875, 95.970125, 97.23575, 97.751375,
            100.001375, 101.8295, 101.313875, 100.282625, 99.532625, 98.407625, 102.157625, 96.532625, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:19.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.51708,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:19.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.29825, 110.17325, 107.36075, 107.36075, 106.42325, 105.907625, 106.7045, 107.595125, 102.67325,
            100.095125, 100.282625, 98.54825, 98.313875, 98.032625, 97.79825, 97.282625, 97.98575, 98.032625, 98.595125,
            100.282625, 102.392, 102.063875, 100.42325, 99.67325, 98.782625, 102.48575, 97.23575, 95.501375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:39.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.13864,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:39.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.032625, 115.470125, 112.04825, 108.720125, 108.017, 107.501375, 107.8295, 106.657625, 104.0795,
            100.657625, 98.970125, 101.92325, 97.61075, 97.23575, 95.220125, 95.032625, 95.032625, 96.5795, 97.7045,
            99.86075, 101.970125, 101.501375, 99.9545, 99.720125, 98.4545, 102.48575, 95.970125, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:59.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.30457,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:59.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.86075, 128.970125, 125.970125, 122.688875, 118.563875, 115.751375, 111.767, 109.7045, 103.61075,
            101.642, 99.017, 96.9545, 96.532625, 95.8295, 95.267, 95.407625, 95.126375, 96.2045, 97.282625, 99.532625,
            101.876375, 101.688875, 100.23575, 99.67325, 98.126375, 102.063875, 95.970125, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:29.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.831184,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:29.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 117.767, 114.438875, 109.751375, 109.04825, 106.3295, 106.04825, 105.907625, 102.2045, 100.23575,
            99.017, 97.282625, 97.001375, 97.517, 95.8295, 95.595125, 96.017, 96.11075, 97.7045, 99.86075, 102.392,
            101.970125, 100.282625, 99.813875, 98.54825, 103.04825, 96.48575, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:01.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.46669,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:01.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.392, 127.23575, 124.517, 120.251375, 118.188875, 115.142, 112.563875, 109.61075, 105.86075, 101.313875,
            99.11075, 97.142, 96.9545, 96.532625, 95.92325, 95.595125, 95.642, 96.532625, 97.23575, 100.04825, 101.8295,
            101.73575, 100.142, 99.813875, 97.98575, 101.595125, 96.29825, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:45.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.43992,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:45.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.188875, 118.142, 116.0795, 113.970125, 112.845125, 108.063875, 105.907625, 104.501375, 101.0795,
            99.063875, 98.642, 97.751375, 97.61075, 97.001375, 95.501375, 95.313875, 95.267, 96.438875, 97.7045,
            99.813875, 101.782625, 101.4545, 100.095125, 99.5795, 97.892, 101.595125, 96.063875, 95.0795,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:21.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.88757,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:21.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.063875, 119.642, 116.595125, 114.063875, 111.532625, 109.42325, 106.142, 104.642, 100.892, 99.438875,
            100.04825, 98.267, 98.595125, 97.892, 97.7045, 97.142, 96.86075, 97.470125, 98.220125, 100.517, 102.29825,
            102.017, 100.3295, 99.9545, 98.54825, 102.11075, 96.720125, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:37.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.18848,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:37.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.3295, 109.470125, 110.73575, 109.23575, 106.7045, 106.470125, 107.501375, 108.907625, 103.751375,
            100.376375, 101.782625, 97.42325, 96.86075, 97.04825, 95.8295, 98.17325, 95.36075, 96.29825, 98.126375,
            100.142, 102.11075, 102.438875, 100.282625, 99.907625, 98.595125, 102.5795, 96.157625, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:00.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.30527,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:00.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.407625, 129.157625, 125.688875, 122.032625, 118.42325, 116.267, 112.61075, 108.9545, 105.86075,
            102.2045, 101.688875, 98.73575, 97.142, 98.126375, 95.501375, 96.345125, 96.813875, 97.095125, 97.845125,
            99.720125, 101.8295, 101.17325, 99.9545, 99.720125, 98.17325, 101.92325, 96.017, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:02.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.04688,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:02.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.126375, 104.4545, 103.095125, 108.48575, 110.688875, 106.142, 106.23575, 105.86075, 104.876375,
            99.720125, 99.017, 98.0795, 97.282625, 97.3295, 96.532625, 95.782625, 95.92325, 96.2045, 97.470125,
            100.282625, 101.970125, 101.501375, 100.04825, 99.67325, 98.0795, 102.063875, 96.017, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:13.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.62236,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:13.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.657625, 118.142, 114.86075, 113.032625, 111.157625, 108.345125, 108.017, 108.532625, 103.98575,
            100.376375, 100.7045, 98.876375, 97.892, 97.23575, 95.8295, 95.92325, 95.36075, 96.11075, 97.657625,
            99.86075, 101.876375, 101.595125, 100.563875, 99.9545, 98.36075, 102.157625, 95.876375, 95.126375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:34.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.08655,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:34.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.782625, 117.48575, 115.142, 109.42325, 107.501375, 105.907625, 106.98575, 106.282625, 102.392, 99.5795,
            97.98575, 96.48575, 96.157625, 95.876375, 95.407625, 96.017, 95.595125, 96.767, 97.470125, 100.188875,
            101.8295, 102.767, 100.282625, 99.767, 98.876375, 102.720125, 96.438875, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:58.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.509,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:58.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.001375, 131.220125, 128.92325, 126.9545, 124.7045, 119.73575, 118.095125, 114.9545, 107.876375,
            106.188875, 103.42325, 100.095125, 98.126375, 97.657625, 97.282625, 95.970125, 95.642, 96.345125, 97.845125,
            100.188875, 102.11075, 101.407625, 100.142, 99.251375, 97.751375, 101.407625, 96.345125, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:59.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.83834,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:59.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.86075, 109.938875, 107.36075, 106.563875, 108.29825, 106.892, 107.220125, 107.688875, 103.98575,
            100.751375, 100.563875, 97.938875, 97.282625, 97.001375, 95.501375, 95.642, 96.251375, 95.92325, 97.563875,
            100.095125, 102.157625, 101.501375, 100.23575, 99.5795, 98.0795, 101.876375, 96.017, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:41.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.81342,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:41.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.8295, 126.9545, 121.938875, 117.626375, 113.92325, 109.563875, 108.767, 106.470125, 103.3295, 99.86075,
            98.688875, 97.188875, 96.767, 96.532625, 94.938875, 95.17325, 95.126375, 96.345125, 97.61075, 100.188875,
            102.063875, 101.876375, 100.563875, 100.04825, 98.73575, 103.376375, 96.251375, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:10.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.24129,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:10.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.188875, 108.063875, 104.220125, 108.626375, 107.73575, 106.142, 106.470125, 105.813875, 103.376375,
            100.7045, 98.501375, 96.907625, 97.095125, 97.04825, 95.36075, 94.751375, 94.938875, 96.2045, 97.3295,
            99.5795, 101.876375, 101.126375, 100.3295, 99.767, 98.267, 102.11075, 96.251375, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:16.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.99195,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:16.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.282625, 113.220125, 107.782625, 104.688875, 104.688875, 103.517, 105.017, 104.407625, 100.79825,
            100.376375, 101.313875, 99.813875, 97.657625, 96.907625, 95.876375, 96.345125, 96.063875, 96.67325,
            97.61075, 100.376375, 102.48575, 101.54825, 100.142, 99.5795, 98.501375, 102.11075, 96.2045, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:50.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.80853,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:50.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.563875, 122.970125, 120.626375, 114.29825, 111.251375, 108.392, 108.017, 105.438875, 102.11075,
            99.532625, 97.938875, 97.188875, 97.376375, 96.720125, 96.67325, 95.54825, 95.501375, 96.345125, 97.61075,
            100.23575, 101.782625, 101.17325, 99.907625, 99.626375, 98.313875, 101.642, 96.251375, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:31.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.81116,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:31.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.220125, 111.017, 108.720125, 106.563875, 105.9545, 105.29825, 105.392, 104.17325, 102.532625, 99.157625,
            97.892, 97.282625, 97.282625, 96.11075, 95.688875, 95.73575, 95.92325, 96.813875, 97.938875, 99.907625,
            101.970125, 101.4545, 100.001375, 99.767, 98.220125, 101.970125, 96.29825, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:48.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.43803,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:48.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.0795, 123.157625, 121.142, 116.54825, 115.001375, 111.392, 110.501375, 108.48575, 105.48575, 101.126375,
            99.157625, 98.17325, 97.04825, 97.001375, 95.688875, 95.032625, 95.688875, 96.29825, 97.04825, 99.813875,
            101.73575, 101.54825, 99.67325, 99.11075, 97.892, 101.407625, 96.157625, 95.17325,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:12.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.50771,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:12.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.938875, 114.11075, 108.017, 106.517, 106.3295, 105.438875, 104.642, 104.782625, 101.267, 100.04825,
            100.04825, 98.595125, 101.126375, 98.032625, 97.79825, 96.48575, 96.2045, 96.5795, 97.845125, 100.142,
            101.970125, 101.688875, 100.517, 99.813875, 98.17325, 101.92325, 96.29825, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:14.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.64945,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:14.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.36075, 117.017, 111.626375, 110.313875, 109.892, 108.063875, 107.313875, 105.67325, 102.813875,
            100.3295, 100.563875, 99.67325, 97.563875, 96.86075, 96.720125, 96.67325, 96.063875, 97.42325, 98.17325,
            100.001375, 101.92325, 101.595125, 100.3295, 99.813875, 98.4545, 102.345125, 96.157625, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:08.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.73706,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:08.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.23575, 126.907625, 122.8295, 118.79825, 117.2045, 113.220125, 109.98575, 109.751375, 104.595125,
            101.688875, 97.751375, 97.42325, 98.501375, 97.892, 96.11075, 96.11075, 95.688875, 96.48575, 97.470125,
            100.04825, 102.251375, 102.017, 100.7045, 99.907625, 98.595125, 102.345125, 96.532625, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:53.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.25748,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:53.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.8295, 120.11075, 117.86075, 114.907625, 113.54825, 112.563875, 112.79825, 110.642, 106.657625,
            103.282625, 100.98575, 98.407625, 97.470125, 96.9545, 95.407625, 97.282625, 96.11075, 96.2045, 97.563875,
            99.9545, 101.8295, 101.220125, 100.001375, 99.626375, 98.126375, 101.876375, 96.251375, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:30.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.68542,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:30.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.282625, 114.767, 111.5795, 105.767, 107.4545, 105.67325, 106.42325, 103.938875, 102.2045, 99.767,
            97.657625, 96.48575, 96.345125, 97.282625, 96.2045, 95.92325, 96.11075, 97.001375, 97.23575, 100.095125,
            101.970125, 101.595125, 100.376375, 99.48575, 98.267, 101.782625, 96.392, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:22.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.95922,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:22.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.017, 106.376375, 105.532625, 109.188875, 108.48575, 107.8295, 108.813875, 109.23575, 104.92325, 101.642,
            101.73575, 100.3295, 98.4545, 98.032625, 97.7045, 96.86075, 96.5795, 97.142, 97.845125, 100.42325,
            101.92325, 101.8295, 100.563875, 99.9545, 98.54825, 102.345125, 96.9545, 95.4545,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:25.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.99107,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:25.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.92325, 125.032625, 122.8295, 119.54825, 119.54825, 116.876375, 113.313875, 112.376375, 106.142,
            103.938875, 100.376375, 99.2045, 98.876375, 97.470125, 97.42325, 96.5795, 96.345125, 97.98575, 98.4545,
            100.79825, 102.813875, 102.2045, 100.657625, 100.095125, 98.876375, 102.767, 97.001375, 95.36075,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:49.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.44415,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:49.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.36075, 130.04825, 123.86075, 121.376375, 117.532625, 116.688875, 113.267, 109.376375, 104.220125,
            101.032625, 99.017, 96.813875, 97.095125, 97.3295, 95.92325, 95.782625, 95.688875, 96.532625, 97.470125,
            100.282625, 102.29825, 101.92325, 100.61075, 99.813875, 98.501375, 102.626375, 96.29825, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:33.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.04908,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:33.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.407625, 106.751375, 105.017, 109.001375, 109.282625, 106.845125, 107.642, 107.688875, 103.79825,
            102.11075, 98.92325, 97.04825, 96.5795, 96.720125, 95.54825, 95.642, 95.92325, 96.2045, 97.563875,
            99.813875, 102.157625, 101.73575, 100.04825, 99.720125, 98.407625, 102.29825, 96.626375, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:56.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 144.9786,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:56.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.892, 138.720125, 135.2045, 126.767, 126.11075, 122.876375, 119.126375, 115.3295, 113.032625, 109.61075,
            107.220125, 102.2045, 99.017, 97.938875, 96.67325, 96.626375, 96.251375, 97.095125, 97.938875, 100.095125,
            101.876375, 101.688875, 100.142, 99.532625, 98.4545, 102.48575, 96.48575, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:15.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.7908,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:15.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.907625, 115.42325, 114.767, 111.438875, 108.438875, 105.907625, 105.720125, 107.220125, 101.688875,
            100.61075, 101.126375, 99.11075, 98.267, 97.563875, 96.251375, 95.782625, 96.11075, 96.720125, 97.517,
            100.188875, 102.251375, 101.8295, 100.3295, 99.767, 98.4545, 101.876375, 96.2045, 95.267,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:58.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.56309,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:58.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.438875, 117.67325, 114.438875, 111.720125, 108.532625, 106.98575, 107.267, 106.188875, 102.392,
            100.095125, 98.73575, 97.751375, 97.142, 97.3295, 95.642, 96.11075, 96.2045, 96.532625, 97.7045, 100.42325,
            101.92325, 101.782625, 100.095125, 99.345125, 98.032625, 102.063875, 96.532625, 95.313875,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:52.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.0004,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:33:52.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.251375, 122.92325, 120.392, 117.29825, 112.938875, 110.8295, 108.29825, 106.517, 102.11075, 98.407625,
            97.470125, 96.2045, 96.532625, 96.2045, 94.7045, 95.8295, 95.73575, 95.970125, 97.61075, 100.23575,
            102.157625, 101.642, 100.04825, 99.67325, 98.267, 101.782625, 96.157625, 95.126375,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:35.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.00073,
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:34:35.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.29825, 115.42325, 112.470125, 108.063875, 107.73575, 105.767, 104.970125, 104.032625, 102.11075,
            99.813875, 98.313875, 96.438875, 96.29825, 102.251375, 95.8295, 95.267, 97.001375, 96.392, 98.0795, 99.767,
            101.970125, 102.626375, 100.42325, 100.188875, 98.642, 103.095125, 96.392, 95.220125,
        ],
        latitude: 37.4405742,
        longitude: -122.5333845,
    },
    {
        timestamp: '2025-08-29T22:35:59.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.49141,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:59.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.095125, 112.470125, 109.188875, 105.626375, 105.86075, 105.157625, 103.23575, 106.188875, 102.157625,
            102.67325, 100.7045, 97.657625, 97.188875, 97.892, 95.73575, 95.92325, 96.063875, 109.938875, 108.063875,
            99.626375, 102.345125, 101.688875, 100.7045, 100.04825, 98.313875, 102.86075, 96.063875, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:56.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.3963,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:56.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.563875, 118.095125, 114.9545, 112.188875, 109.79825, 106.751375, 105.532625, 105.251375, 102.345125,
            99.392, 97.751375, 96.813875, 97.7045, 97.892, 96.767, 96.48575, 95.8295, 96.438875, 97.657625, 99.767,
            102.2045, 101.73575, 100.470125, 99.907625, 98.4545, 102.438875, 96.157625, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:25.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.7351,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:25.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.063875, 107.642, 104.501375, 106.42325, 106.938875, 106.98575, 106.142, 106.657625, 102.438875,
            101.8295, 99.86075, 97.7045, 97.79825, 97.282625, 96.626375, 96.813875, 96.11075, 96.5795, 98.032625,
            99.767, 102.157625, 101.688875, 100.376375, 99.626375, 98.220125, 102.2045, 96.063875, 95.126375,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:37.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.78201,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:37.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.063875, 125.688875, 122.876375, 120.392, 117.532625, 113.032625, 109.376375, 106.3295, 102.720125,
            99.720125, 98.0795, 96.907625, 97.188875, 97.04825, 96.11075, 96.017, 95.8295, 97.23575, 98.220125,
            100.563875, 101.970125, 102.392, 100.23575, 99.532625, 98.313875, 102.251375, 96.157625, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:15.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.8087,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:15.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.48575, 121.79825, 122.642, 118.61075, 114.345125, 114.11075, 112.04825, 109.938875, 106.376375,
            103.751375, 101.267, 102.907625, 100.938875, 99.626375, 100.98575, 98.220125, 97.79825, 97.142, 98.313875,
            100.563875, 102.29825, 101.92325, 99.86075, 99.5795, 98.4545, 101.8295, 96.532625, 95.501375,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:54.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.57476,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:54.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.2045, 118.938875, 113.8295, 111.392, 108.5795, 106.61075, 106.892, 106.142, 102.767, 100.04825,
            98.54825, 96.720125, 97.142, 97.001375, 96.29825, 97.04825, 95.970125, 96.9545, 101.407625, 102.251375,
            102.063875, 101.36075, 100.142, 99.345125, 98.032625, 101.782625, 96.157625, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:35.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.41397,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:35.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.86075, 129.67325, 124.845125, 123.29825, 118.79825, 116.642, 114.29825, 112.751375, 112.3295, 106.23575,
            101.36075, 106.095125, 99.11075, 101.126375, 101.642, 99.251375, 98.407625, 98.8295, 99.907625, 101.407625,
            102.017, 102.438875, 100.7045, 99.626375, 98.501375, 102.2045, 96.48575, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:17.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.92502,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:17.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 118.845125, 116.17325, 114.11075, 109.61075, 107.126375, 106.98575, 104.595125, 103.282625,
            102.29825, 99.813875, 107.92325, 112.470125, 101.4545, 101.73575, 100.001375, 98.36075, 97.470125,
            98.313875, 100.563875, 102.157625, 101.54825, 100.188875, 99.626375, 98.267, 101.970125, 96.29825, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:34.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.17589,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:34.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.126375, 125.595125, 122.407625, 120.29825, 118.23575, 113.501375, 111.157625, 109.751375, 106.845125,
            102.2045, 99.345125, 105.157625, 99.48575, 99.11075, 99.11075, 100.845125, 98.876375, 99.063875, 98.54825,
            100.751375, 101.876375, 102.67325, 100.42325, 99.29825, 98.407625, 101.876375, 96.767, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:13.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.03499,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:13.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.532625, 119.782625, 115.376375, 112.142, 109.751375, 107.642, 107.313875, 104.407625, 102.720125,
            99.2045, 98.642, 98.688875, 97.7045, 97.188875, 96.29825, 96.2045, 95.73575, 96.720125, 98.36075, 100.23575,
            102.29825, 101.782625, 100.095125, 99.392, 97.938875, 101.595125, 96.2045, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:09.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.22294,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:09.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.563875, 112.095125, 108.063875, 104.8295, 106.142, 106.892, 106.470125, 106.095125, 102.5795, 99.345125,
            99.67325, 99.017, 97.751375, 96.86075, 96.251375, 95.782625, 95.642, 96.29825, 97.751375, 100.095125,
            102.157625, 101.92325, 100.470125, 99.9545, 98.73575, 103.001375, 96.48575, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:09.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.37796,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:09.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.4545, 118.04825, 113.220125, 114.157625, 112.188875, 108.017, 107.92325, 107.54825, 102.5795, 99.67325,
            99.157625, 99.29825, 105.157625, 99.48575, 95.970125, 98.688875, 96.532625, 100.892, 104.4545, 100.282625,
            101.92325, 101.8295, 100.3295, 99.9545, 98.267, 102.063875, 95.970125, 95.0795,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:02.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.59055,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:02.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.595125, 115.657625, 111.767, 110.267, 107.267, 108.2045, 107.0795, 105.5795, 101.92325, 99.29825,
            99.29825, 99.67325, 98.0795, 97.188875, 96.67325, 95.688875, 95.642, 106.892, 102.11075, 101.642, 102.11075,
            102.063875, 100.3295, 99.626375, 98.4545, 102.2045, 96.438875, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:26.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.80583,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:26.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.92325, 117.67325, 114.345125, 110.92325, 109.845125, 108.767, 107.0795, 106.563875, 103.3295,
            100.657625, 98.54825, 97.563875, 96.767, 97.142, 95.688875, 96.29825, 95.267, 96.29825, 97.61075, 99.907625,
            101.970125, 101.782625, 100.470125, 99.532625, 98.313875, 102.532625, 96.532625, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:00.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.56266,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:00.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.92325, 116.032625, 110.407625, 106.938875, 107.032625, 105.626375, 105.9545, 106.188875, 100.98575,
            99.86075, 100.79825, 100.188875, 97.61075, 96.626375, 96.392, 95.501375, 95.032625, 96.626375, 100.98575,
            99.720125, 101.970125, 101.642, 100.188875, 99.48575, 97.845125, 101.73575, 95.970125, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:05.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.12982,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:05.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.563875, 127.657625, 123.2045, 119.36075, 116.4545, 114.48575, 110.4545, 108.251375, 104.642, 100.7045,
            99.063875, 98.642, 97.892, 98.688875, 97.001375, 96.157625, 95.4545, 96.11075, 97.3295, 100.001375, 102.017,
            101.36075, 99.9545, 99.29825, 97.79825, 101.313875, 95.876375, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:43.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.6114,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:43.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.04825, 113.032625, 111.86075, 109.376375, 107.8295, 106.470125, 106.095125, 105.626375, 103.282625,
            101.032625, 99.251375, 98.73575, 98.313875, 99.48575, 98.313875, 97.563875, 96.626375, 96.5795, 97.657625,
            100.001375, 101.970125, 101.92325, 100.42325, 100.04825, 98.4545, 102.48575, 96.251375, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:41.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.3455,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:41.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.2045, 114.392, 109.001375, 103.282625, 104.032625, 103.657625, 104.782625, 105.392, 101.54825, 101.267,
            98.8295, 98.8295, 98.313875, 98.688875, 97.3295, 97.095125, 96.438875, 96.907625, 97.751375, 99.767,
            102.251375, 101.782625, 100.42325, 100.142, 98.54825, 102.720125, 96.251375, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:01.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.39313,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:01.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.188875, 121.751375, 119.220125, 116.595125, 113.4545, 110.782625, 107.501375, 105.813875, 102.392,
            100.3295, 100.04825, 98.313875, 97.23575, 97.42325, 96.017, 95.313875, 98.970125, 108.017, 97.657625,
            100.142, 102.063875, 102.063875, 100.79825, 100.095125, 98.501375, 102.251375, 96.29825, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:27.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.34029,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:27.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.23575, 128.032625, 125.267, 120.48575, 118.04825, 118.563875, 116.782625, 113.0795, 109.001375,
            105.2045, 101.313875, 99.2045, 97.188875, 97.845125, 95.688875, 96.017, 95.36075, 96.392, 97.892, 100.42325,
            102.29825, 101.36075, 100.517, 99.9545, 98.0795, 101.970125, 96.11075, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:23.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.23346,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:23.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.876375, 116.8295, 114.438875, 110.642, 110.313875, 107.313875, 108.813875, 107.0795, 103.3295, 102.5795,
            106.938875, 99.29825, 98.0795, 98.4545, 96.48575, 99.251375, 96.48575, 97.42325, 98.642, 100.42325,
            102.251375, 101.970125, 100.188875, 99.438875, 98.220125, 101.782625, 96.392, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:03.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.88362,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:03.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.8295, 124.04825, 118.3295, 115.282625, 112.938875, 110.36075, 107.4545, 107.92325, 104.0795, 102.017,
            98.8295, 98.970125, 97.001375, 97.517, 96.251375, 96.345125, 95.876375, 96.626375, 104.220125, 101.501375,
            102.063875, 101.4545, 100.04825, 99.626375, 98.313875, 102.157625, 96.063875, 95.126375,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:10.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.682465,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:10.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.3295, 112.751375, 109.282625, 108.5795, 107.782625, 108.2045, 108.157625, 107.8295, 105.29825,
            101.92325, 100.42325, 98.73575, 97.563875, 96.813875, 95.8295, 95.642, 95.876375, 96.626375, 97.61075,
            100.517, 102.2045, 101.54825, 100.517, 99.86075, 98.501375, 102.251375, 96.345125, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:52.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.21799,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:52.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.04825, 119.032625, 115.04825, 111.392, 107.267, 107.032625, 104.970125, 104.4545, 100.23575, 98.220125,
            97.517, 95.970125, 96.626375, 96.2045, 95.595125, 95.313875, 95.876375, 96.67325, 97.751375, 99.767,
            102.063875, 101.267, 100.095125, 99.48575, 98.220125, 102.063875, 96.2045, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:16.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.69876,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:16.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.36075, 117.532625, 113.970125, 110.36075, 108.86075, 105.345125, 104.54825, 104.126375, 101.126375,
            119.4545, 125.220125, 97.892, 104.782625, 108.48575, 109.751375, 99.251375, 102.626375, 102.29825,
            105.907625, 101.0795, 102.017, 102.2045, 100.376375, 99.48575, 97.892, 101.4545, 96.438875, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:12.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.70709,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:12.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.470125, 135.5795, 132.251375, 124.657625, 122.782625, 119.688875, 116.92325, 112.657625, 108.720125,
            106.61075, 103.188875, 100.470125, 100.657625, 97.517, 96.813875, 95.8295, 95.970125, 96.813875, 97.657625,
            99.532625, 102.017, 101.595125, 100.095125, 99.392, 98.0795, 101.73575, 96.29825, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:38.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.585396,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:38.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.11075, 111.48575, 107.876375, 106.282625, 105.767, 108.157625, 106.142, 107.0795, 104.032625,
            100.282625, 99.626375, 98.032625, 98.782625, 98.220125, 97.98575, 99.438875, 97.470125, 97.751375,
            97.751375, 100.282625, 101.92325, 101.8295, 100.3295, 99.720125, 98.267, 102.017, 96.345125, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:58.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.05467,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:58.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.907625, 121.376375, 118.376375, 115.376375, 111.9545, 110.36075, 107.688875, 107.36075, 104.17325,
            102.438875, 102.392, 99.86075, 97.517, 98.36075, 96.251375, 99.251375, 98.4545, 109.563875, 108.063875,
            101.0795, 103.001375, 101.876375, 100.563875, 99.345125, 98.0795, 101.407625, 96.017, 95.126375,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:33.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.3264,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:33.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.92325, 120.063875, 118.845125, 115.42325, 114.532625, 110.782625, 110.267, 107.54825, 103.563875,
            100.23575, 99.48575, 99.67325, 103.61075, 97.751375, 97.376375, 96.9545, 97.42325, 96.9545, 97.563875,
            100.188875, 101.220125, 102.11075, 100.142, 99.157625, 98.267, 101.54825, 96.063875, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:31.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.5866,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:31.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.86075, 127.517, 126.720125, 125.17325, 121.23575, 119.17325, 117.907625, 112.892, 109.517, 104.407625,
            100.845125, 98.595125, 98.36075, 97.61075, 97.04825, 96.29825, 97.188875, 96.813875, 98.0795, 99.9545,
            102.438875, 101.688875, 100.282625, 99.813875, 98.36075, 102.392, 96.392, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:15.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.10292,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:15.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.79825, 119.0795, 114.157625, 110.0795, 109.3295, 108.5795, 107.313875, 108.626375, 103.7045, 115.282625,
            111.813875, 97.188875, 97.7045, 99.29825, 98.642, 98.220125, 98.032625, 97.751375, 99.251375, 100.142,
            102.157625, 101.688875, 100.3295, 99.626375, 98.0795, 101.73575, 96.251375, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:22.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.717476,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:22.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 115.892, 114.345125, 110.92325, 108.392, 106.142, 106.001375, 107.17325, 105.11075, 102.5795,
            99.720125, 99.2045, 98.8295, 97.79825, 97.845125, 97.7045, 96.392, 97.61075, 97.98575, 100.142, 102.157625,
            101.642, 100.23575, 99.626375, 98.0795, 101.595125, 96.2045, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:19.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.93024,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:19.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.032625, 126.9545, 126.2045, 121.892, 118.23575, 113.782625, 111.720125, 109.98575, 104.4545, 103.3295,
            100.61075, 99.392, 97.892, 98.4545, 96.438875, 97.892, 96.48575, 96.9545, 98.126375, 100.470125, 102.251375,
            101.501375, 99.813875, 99.392, 98.407625, 102.532625, 96.626375, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:17.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.68394,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:17.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.73575, 122.8295, 119.4545, 116.73575, 114.29825, 112.563875, 111.29825, 109.04825, 106.095125, 107.267,
            105.438875, 103.23575, 99.48575, 99.29825, 98.688875, 97.845125, 97.61075, 97.657625, 98.876375, 99.9545,
            102.392, 101.876375, 100.79825, 99.532625, 98.267, 102.11075, 96.438875, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:04.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.03638,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:04.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.001375, 115.3295, 114.251375, 112.563875, 110.126375, 106.61075, 107.36075, 107.970125, 105.9545,
            103.3295, 103.23575, 100.892, 99.063875, 97.845125, 96.767, 95.407625, 95.8295, 96.626375, 97.7045,
            100.42325, 102.2045, 101.8295, 99.86075, 99.345125, 97.845125, 101.54825, 96.157625, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:45.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.72714,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:45.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.688875, 124.98575, 123.2045, 122.313875, 119.876375, 115.282625, 113.313875, 110.54825, 107.73575,
            103.04825, 101.4545, 99.157625, 99.017, 99.626375, 98.54825, 98.0795, 97.42325, 98.313875, 98.595125,
            100.095125, 102.48575, 101.970125, 100.376375, 99.907625, 98.782625, 102.767, 97.188875, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:55.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.298294,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:55.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.67325, 111.157625, 106.892, 105.813875, 105.063875, 103.7045, 104.032625, 103.376375, 101.36075,
            99.720125, 97.79825, 97.517, 97.7045, 97.563875, 96.157625, 96.29825, 96.2045, 96.767, 98.0795, 100.095125,
            102.063875, 101.876375, 100.517, 100.001375, 98.595125, 102.532625, 96.251375, 95.126375,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:21.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.82841,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:21.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.54825, 121.188875, 116.313875, 112.938875, 110.313875, 109.095125, 108.9545, 107.92325, 104.595125,
            102.063875, 99.532625, 98.876375, 98.220125, 97.563875, 97.23575, 96.532625, 97.095125, 96.813875,
            97.751375, 99.907625, 101.8295, 101.501375, 100.001375, 99.392, 97.892, 101.54825, 95.970125, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:18.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.14703,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:18.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.470125, 124.79825, 120.251375, 116.876375, 113.92325, 109.376375, 107.501375, 107.032625, 104.92325,
            107.17325, 102.2045, 98.126375, 101.0795, 98.54825, 98.54825, 97.892, 98.688875, 96.86075, 99.251375,
            99.9545, 101.970125, 101.0795, 99.9545, 99.532625, 97.892, 101.688875, 96.017, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:49.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.73611,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:49.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.938875, 121.938875, 118.657625, 114.720125, 111.767, 109.98575, 110.267, 108.017, 103.470125, 99.063875,
            98.782625, 98.032625, 97.563875, 97.7045, 96.767, 97.282625, 97.23575, 97.517, 98.17325, 100.751375,
            102.532625, 101.595125, 100.142, 99.626375, 98.36075, 101.54825, 96.48575, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:14.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.7758,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:14.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.845125, 134.642, 131.220125, 126.813875, 124.517, 122.267, 119.876375, 115.61075, 112.142, 117.157625,
            111.392, 101.407625, 100.7045, 100.61075, 103.188875, 99.29825, 98.595125, 99.29825, 99.67325, 100.095125,
            102.251375, 101.782625, 100.04825, 99.251375, 97.98575, 101.54825, 96.438875, 95.501375,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:53.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.71975,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:53.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.892, 103.79825, 102.9545, 108.063875, 109.04825, 107.126375, 106.892, 107.642, 104.876375, 100.376375,
            98.595125, 95.407625, 97.001375, 97.470125, 97.23575, 96.48575, 105.017, 108.157625, 105.5795, 100.657625,
            102.532625, 101.642, 100.188875, 99.86075, 98.267, 102.017, 96.251375, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:11.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.67737,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:11.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.5795, 107.970125, 103.938875, 104.220125, 106.188875, 106.98575, 106.42325, 104.595125, 101.876375,
            99.532625, 99.438875, 98.267, 97.938875, 98.501375, 97.3295, 96.438875, 95.36075, 96.29825, 97.61075,
            100.376375, 102.48575, 101.73575, 100.470125, 99.67325, 98.313875, 102.532625, 95.92325, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:36.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.92874,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:36.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.67325, 124.42325, 121.98575, 119.688875, 116.267, 113.032625, 109.61075, 108.017, 106.142, 105.29825,
            99.86075, 103.376375, 100.42325, 99.813875, 98.8295, 98.36075, 96.626375, 97.470125, 98.595125, 100.61075,
            101.970125, 102.532625, 100.563875, 99.532625, 98.501375, 102.29825, 96.813875, 95.642,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:06.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.32561,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:06.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.720125, 112.04825, 112.563875, 115.61075, 109.188875, 107.126375, 108.720125, 105.907625, 102.392,
            99.813875, 98.032625, 97.657625, 97.376375, 97.142, 96.67325, 96.2045, 98.126375, 96.345125, 97.7045,
            99.9545, 101.92325, 101.36075, 100.001375, 99.532625, 98.126375, 102.11075, 96.392, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:44.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.35774,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:44.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.642, 119.17325, 115.42325, 112.282625, 108.392, 108.017, 106.376375, 107.4545, 103.04825, 101.73575,
            99.720125, 98.970125, 98.688875, 99.626375, 98.54825, 98.876375, 97.376375, 98.4545, 98.92325, 100.470125,
            102.251375, 101.970125, 100.282625, 99.86075, 98.407625, 102.2045, 97.04825, 95.501375,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:30.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.70193,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:30.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.9545, 106.142, 103.892, 105.67325, 107.126375, 105.251375, 106.282625, 106.282625, 102.67325,
            100.188875, 97.845125, 96.907625, 97.095125, 96.345125, 96.532625, 96.017, 95.36075, 96.157625, 97.42325,
            99.907625, 102.157625, 101.501375, 100.42325, 99.48575, 98.032625, 101.642, 96.11075, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:57.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.11921,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:57.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.095125, 118.61075, 113.8295, 110.92325, 109.04825, 107.220125, 106.751375, 107.73575, 104.220125,
            100.001375, 98.876375, 98.17325, 97.751375, 98.17325, 96.532625, 100.095125, 96.2045, 98.0795, 101.220125,
            100.001375, 101.92325, 101.73575, 100.23575, 99.48575, 98.220125, 102.29825, 96.345125, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:20.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.78525,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:20.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.407625, 121.751375, 116.688875, 112.376375, 111.438875, 107.407625, 106.095125, 106.517, 102.907625,
            99.532625, 98.8295, 99.017, 98.032625, 97.001375, 97.001375, 97.23575, 96.392, 96.813875, 97.892, 100.61075,
            101.876375, 101.4545, 100.282625, 99.345125, 98.17325, 101.92325, 96.392, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:50.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.23582,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:50.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.501375, 124.188875, 122.267, 119.032625, 115.142, 113.54825, 113.36075, 111.29825, 105.813875,
            103.095125, 99.907625, 97.79825, 96.438875, 97.3295, 96.063875, 95.92325, 96.720125, 96.626375, 98.032625,
            100.563875, 102.157625, 101.595125, 100.095125, 99.345125, 97.845125, 101.36075, 96.157625, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:13.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.58181,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:13.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.54825, 119.73575, 115.376375, 113.595125, 111.251375, 108.67325, 107.970125, 108.345125, 104.501375,
            100.79825, 110.36075, 97.892, 97.42325, 99.813875, 97.470125, 99.532625, 96.063875, 96.5795, 98.17325,
            100.470125, 102.11075, 101.688875, 100.42325, 99.29825, 97.892, 101.642, 96.251375, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:12.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.51299,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:12.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.251375, 125.595125, 120.720125, 115.095125, 113.54825, 107.92325, 105.86075, 105.813875, 102.017,
            99.438875, 98.17325, 97.98575, 96.813875, 97.845125, 97.282625, 96.48575, 95.642, 96.626375, 98.126375,
            100.001375, 102.2045, 101.595125, 100.517, 99.907625, 98.220125, 102.157625, 96.063875, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:10.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.58163,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:10.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.92325, 108.2045, 105.720125, 108.157625, 107.126375, 106.657625, 107.595125, 107.970125, 104.595125,
            101.73575, 100.04825, 99.67325, 111.345125, 97.892, 96.2045, 109.142, 95.970125, 105.392, 109.282625,
            100.42325, 102.438875, 101.876375, 100.517, 99.626375, 98.501375, 101.92325, 96.017, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:32.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.87701,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:32.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.126375, 131.8295, 128.313875, 121.845125, 120.017, 116.92325, 113.782625, 109.845125, 106.095125,
            103.7045, 100.3295, 99.5795, 102.813875, 98.267, 98.54825, 97.79825, 97.142, 97.657625, 98.220125, 100.142,
            102.392, 101.688875, 100.376375, 99.532625, 98.17325, 102.251375, 96.29825, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:11.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.89202,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:11.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.79825, 118.892, 116.4545, 112.42325, 112.23575, 107.876375, 106.657625, 105.86075, 102.813875,
            99.438875, 98.36075, 98.782625, 97.98575, 96.438875, 95.313875, 95.17325, 95.54825, 96.063875, 97.188875,
            100.001375, 101.92325, 101.501375, 100.282625, 99.907625, 98.313875, 102.626375, 95.876375, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:40.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.93969,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:40.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.0795, 118.470125, 115.845125, 112.7045, 109.001375, 108.9545, 107.92325, 107.126375, 103.42325,
            102.345125, 99.626375, 97.7045, 97.282625, 97.095125, 96.392, 96.438875, 95.970125, 96.251375, 97.42325,
            99.5795, 101.92325, 101.313875, 100.3295, 100.095125, 98.4545, 102.063875, 95.970125, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:05.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.6142,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:05.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.142, 122.642, 119.4545, 118.282625, 114.251375, 110.92325, 110.220125, 108.438875, 106.517, 100.98575,
            100.42325, 98.970125, 101.032625, 98.032625, 97.001375, 96.86075, 96.392, 96.720125, 97.938875, 100.23575,
            102.017, 101.642, 100.001375, 99.626375, 98.220125, 102.251375, 96.29825, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:08.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.94806,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:08.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.0795, 115.470125, 111.157625, 108.626375, 107.220125, 103.3295, 103.751375, 105.251375, 103.657625,
            101.970125, 100.42325, 99.017, 98.126375, 97.892, 96.438875, 96.2045, 96.017, 96.251375, 97.517, 99.86075,
            101.782625, 101.126375, 100.282625, 99.5795, 98.267, 101.970125, 96.345125, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:07.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.74913,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:07.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.017, 117.9545, 114.5795, 114.86075, 111.767, 108.345125, 108.392, 106.98575, 105.907625, 101.220125,
            102.48575, 99.767, 97.376375, 97.188875, 96.157625, 95.688875, 95.595125, 95.970125, 97.42325, 99.86075,
            101.73575, 101.782625, 100.095125, 99.720125, 98.4545, 101.688875, 95.92325, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:16.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.34209,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:16.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.267, 115.142, 112.04825, 109.657625, 106.7045, 106.001375, 106.98575, 106.001375, 102.67325, 100.42325,
            99.29825, 109.001375, 102.67325, 100.04825, 101.73575, 98.92325, 96.29825, 96.720125, 97.98575, 100.657625,
            102.532625, 101.782625, 100.04825, 99.438875, 98.220125, 101.642, 96.345125, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:24.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.11305,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:24.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.17325, 119.220125, 116.407625, 111.720125, 109.23575, 109.657625, 106.376375, 104.642, 103.282625,
            100.98575, 100.3295, 97.470125, 97.79825, 99.2045, 96.720125, 97.282625, 97.517, 97.892, 98.0795, 99.9545,
            102.2045, 101.73575, 100.282625, 99.5795, 98.126375, 101.73575, 96.017, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:28.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.38289,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:28.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.4545, 122.36075, 119.17325, 116.4545, 115.282625, 113.876375, 110.54825, 107.36075, 103.095125, 100.517,
            98.501375, 97.095125, 97.98575, 97.188875, 96.438875, 97.142, 96.720125, 97.751375, 98.17325, 100.61075,
            102.392, 101.54825, 100.04825, 99.392, 98.267, 102.29825, 96.48575, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:48.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.82384,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:48.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.782625, 126.907625, 121.79825, 118.892, 115.61075, 112.376375, 110.267, 108.767, 105.017, 100.751375,
            98.73575, 97.142, 97.892, 97.657625, 97.001375, 97.001375, 97.04825, 101.595125, 102.813875, 105.29825,
            102.29825, 101.8295, 100.376375, 99.907625, 98.501375, 102.5795, 96.438875, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:46.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.851555,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:46.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.813875, 111.813875, 108.2045, 105.626375, 105.29825, 105.813875, 107.220125, 106.7045, 103.845125,
            100.001375, 99.720125, 97.938875, 97.657625, 98.782625, 97.79825, 98.970125, 97.001375, 97.095125,
            98.407625, 100.04825, 102.157625, 101.782625, 100.376375, 99.5795, 98.313875, 102.063875, 96.2045, 95.0795,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:29.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.04406,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:29.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.938875, 115.657625, 111.345125, 108.86075, 107.688875, 106.517, 107.0795, 107.267, 104.17325, 100.98575,
            98.688875, 97.095125, 97.657625, 97.282625, 97.001375, 97.001375, 96.5795, 97.23575, 97.938875, 100.517,
            102.626375, 101.92325, 100.3295, 99.813875, 98.407625, 102.29825, 96.345125, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:42.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.02184,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:42.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.720125, 113.0795, 108.5795, 108.86075, 107.595125, 106.7045, 109.3295, 107.92325, 103.42325, 101.36075,
            100.376375, 99.626375, 100.001375, 99.86075, 98.92325, 99.438875, 97.98575, 98.4545, 98.92325, 100.470125,
            102.720125, 102.626375, 100.7045, 100.282625, 98.876375, 103.04825, 97.517, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:51.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.93054,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:51.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.845125, 114.392, 111.9545, 107.17325, 106.42325, 106.470125, 105.9545, 104.876375, 100.938875, 99.67325,
            97.98575, 96.767, 96.017, 96.251375, 95.595125, 95.36075, 96.251375, 96.345125, 97.517, 100.04825, 102.2045,
            101.642, 100.095125, 99.063875, 98.0795, 101.8295, 96.017, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:14.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.34955,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:14.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.392, 109.657625, 105.063875, 107.36075, 106.98575, 105.67325, 106.845125, 106.7045, 104.501375,
            100.751375, 99.11075, 99.438875, 98.17325, 97.142, 96.5795, 95.595125, 95.688875, 96.157625, 97.42325,
            100.04825, 101.54825, 101.407625, 100.095125, 99.392, 97.98575, 101.220125, 95.970125, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:04.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.12578,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:04.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.376375, 124.42325, 120.251375, 118.892, 115.563875, 109.892, 110.0795, 107.032625, 104.876375,
            101.032625, 100.001375, 99.9545, 98.782625, 97.7045, 96.532625, 96.720125, 97.470125, 98.267, 97.845125,
            100.517, 102.29825, 101.642, 100.04825, 99.626375, 98.17325, 101.782625, 96.48575, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:08.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.14638,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:08.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.313875, 119.4545, 114.626375, 112.657625, 109.376375, 107.126375, 107.126375, 106.845125, 103.23575,
            100.79825, 100.188875, 101.032625, 98.032625, 96.67325, 96.86075, 95.876375, 95.73575, 96.345125, 97.61075,
            100.61075, 102.11075, 101.876375, 100.61075, 100.188875, 98.782625, 102.86075, 96.5795, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:18.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.63423,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:18.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.5795, 131.36075, 125.4545, 120.532625, 118.001375, 114.392, 112.657625, 108.157625, 109.470125,
            105.532625, 103.04825, 103.938875, 105.345125, 98.73575, 100.04825, 100.470125, 97.517, 97.517, 98.032625,
            100.470125, 102.2045, 101.4545, 100.001375, 99.48575, 98.36075, 102.5795, 96.251375, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:28.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.81364,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:28.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.720125, 121.42325, 117.9545, 114.5795, 112.79825, 111.157625, 109.282625, 105.392, 102.29825, 101.267,
            98.782625, 98.36075, 97.892, 97.751375, 96.532625, 96.29825, 96.392, 97.095125, 98.032625, 100.61075,
            102.29825, 101.595125, 100.04825, 99.345125, 98.126375, 101.4545, 96.2045, 95.032625,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:06.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.258736,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:06.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.92325, 117.907625, 112.657625, 111.767, 110.267, 108.29825, 106.657625, 105.251375, 102.438875,
            100.3295, 99.532625, 100.470125, 98.313875, 97.23575, 96.9545, 96.017, 96.438875, 104.642, 97.7045,
            100.23575, 102.157625, 102.392, 100.142, 99.5795, 97.98575, 101.876375, 96.532625, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:07.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.74283,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:07.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.970125, 101.688875, 100.892, 102.9545, 103.98575, 103.845125, 106.7045, 104.970125, 100.42325,
            99.626375, 98.267, 99.2045, 98.54825, 97.282625, 96.48575, 95.4545, 95.642, 100.892, 108.48575, 100.517,
            102.392, 101.688875, 100.188875, 99.67325, 98.220125, 102.11075, 95.876375, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:39.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.00212,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:39.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.98575, 109.845125, 105.626375, 108.11075, 108.2045, 107.407625, 106.61075, 106.282625, 103.517,
            101.313875, 99.48575, 97.751375, 99.251375, 99.392, 98.501375, 98.0795, 97.095125, 97.657625, 98.4545,
            100.04825, 102.438875, 101.92325, 100.142, 100.188875, 98.642, 102.48575, 96.67325, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:47.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.5674,
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:35:47.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.142, 122.642, 119.92325, 116.782625, 113.126375, 109.938875, 108.438875, 104.92325, 102.2045, 99.67325,
            97.23575, 98.126375, 97.61075, 98.17325, 97.001375, 96.251375, 96.345125, 96.532625, 98.032625, 100.095125,
            102.626375, 102.11075, 100.376375, 99.907625, 98.407625, 102.392, 96.438875, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5333793,
    },
    {
        timestamp: '2025-08-29T22:36:41.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.26762,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:41.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.251375, 116.126375, 112.892, 110.126375, 107.782625, 105.48575, 106.04825, 106.3295, 110.8295,
            104.126375, 100.23575, 100.892, 104.8295, 102.11075, 97.563875, 99.345125, 102.767, 100.3295, 99.29825,
            100.563875, 102.017, 101.595125, 100.470125, 100.095125, 98.4545, 102.2045, 96.11075, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:54.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.02907,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:54.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.54825, 118.563875, 112.517, 110.032625, 108.626375, 106.98575, 107.970125, 123.813875, 117.157625,
            103.517, 110.970125, 101.4545, 100.61075, 98.8295, 96.907625, 97.657625, 96.907625, 96.67325, 97.7045,
            100.095125, 102.29825, 101.501375, 100.23575, 99.907625, 98.267, 102.251375, 96.11075, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:47.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.41138,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:47.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.376375, 111.9545, 108.5795, 108.345125, 107.642, 106.751375, 107.876375, 105.251375, 104.8295,
            100.938875, 100.845125, 99.67325, 97.892, 98.688875, 96.9545, 97.001375, 96.5795, 97.04825, 98.17325,
            100.42325, 102.438875, 102.157625, 100.470125, 99.345125, 98.220125, 101.782625, 96.67325, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:56.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.8056,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:56.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.73575, 129.813875, 127.42325, 121.42325, 117.813875, 115.470125, 114.86075, 112.04825, 109.188875,
            104.267, 101.220125, 98.126375, 97.001375, 98.267, 96.392, 96.063875, 96.063875, 96.438875, 97.517, 99.9545,
            101.970125, 101.126375, 100.142, 99.626375, 98.407625, 102.11075, 96.063875, 95.0795,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:02.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.00645,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:02.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.407625, 127.892, 125.17325, 119.4545, 116.876375, 113.36075, 109.3295, 106.23575, 103.563875, 99.392,
            98.782625, 97.42325, 97.61075, 97.142, 96.017, 96.392, 96.157625, 96.626375, 97.79825, 100.095125,
            102.157625, 101.642, 100.095125, 99.720125, 98.032625, 101.876375, 96.29825, 95.407625,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:49.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.53537,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:49.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.282625, 112.61075, 110.8295, 106.376375, 106.79825, 106.001375, 104.876375, 109.470125, 119.17325,
            101.970125, 100.563875, 101.36075, 98.0795, 99.157625, 99.157625, 102.017, 104.0795, 96.767, 98.267,
            100.376375, 101.92325, 101.642, 100.04825, 99.017, 97.938875, 101.313875, 96.251375, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:11.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.00247,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:11.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.938875, 118.470125, 114.063875, 111.29825, 111.345125, 109.001375, 109.657625, 112.98575, 109.470125,
            102.86075, 102.5795, 99.251375, 99.392, 100.3295, 103.376375, 100.61075, 96.720125, 97.470125, 97.892,
            100.001375, 102.345125, 101.407625, 100.470125, 99.86075, 98.220125, 102.345125, 96.2045, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:03.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.18968,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:03.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.36075, 122.407625, 119.595125, 114.5795, 112.376375, 111.392, 108.532625, 108.626375, 106.79825,
            99.438875, 99.11075, 97.470125, 96.5795, 98.313875, 97.79825, 96.9545, 95.970125, 96.67325, 98.313875,
            99.813875, 102.063875, 101.595125, 100.142, 99.5795, 97.98575, 101.8295, 96.29825, 95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:13.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.7367,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:13.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.563875, 118.98575, 115.61075, 112.142, 112.095125, 107.970125, 105.251375, 106.376375, 103.142,
            100.282625, 98.970125, 97.095125, 97.892, 105.438875, 96.813875, 96.48575, 102.532625, 97.001375, 102.5795,
            100.517, 102.813875, 102.063875, 100.7045, 100.142, 98.501375, 102.29825, 96.251375, 95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:58.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.94107,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:58.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.04825, 129.767, 127.563875, 125.501375, 121.98575, 118.095125, 118.23575, 111.9545, 106.657625,
            103.61075, 100.188875, 97.79825, 96.907625, 97.282625, 97.23575, 96.251375, 95.876375, 96.11075, 97.657625,
            100.04825, 102.11075, 101.782625, 100.3295, 99.5795, 98.032625, 101.36075, 96.67325, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:43.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.33897,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:43.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.42325, 117.86075, 115.517, 111.48575, 109.188875, 108.392, 106.142, 106.04825, 103.142, 101.92325,
            100.3295, 99.907625, 99.2045, 98.688875, 97.095125, 96.86075, 96.345125, 96.720125, 97.751375, 100.282625,
            102.017, 101.782625, 100.7045, 99.9545, 98.688875, 102.5795, 96.157625, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:19.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.89144,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:19.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.8295, 105.063875, 103.3295, 104.876375, 103.938875, 103.938875, 104.876375, 103.657625, 100.61075,
            98.595125, 99.157625, 104.313875, 97.001375, 97.892, 96.907625, 97.04825, 95.8295, 96.67325, 97.7045,
            99.907625, 101.876375, 101.595125, 100.470125, 99.67325, 98.126375, 102.2045, 95.92325, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:00.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.44933,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:00.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.595125, 108.907625, 108.392, 108.345125, 109.657625, 107.501375, 109.282625, 109.04825, 118.892,
            102.907625, 106.376375, 101.73575, 97.892, 98.782625, 99.017, 98.782625, 97.001375, 99.063875, 98.73575,
            100.42325, 102.626375, 101.73575, 100.657625, 99.767, 98.407625, 102.48575, 96.11075, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:12.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.92337,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:12.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 115.001375, 110.876375, 107.688875, 108.2045, 105.345125, 105.767, 107.220125, 104.032625,
            101.595125, 99.813875, 102.063875, 98.267, 105.29825, 98.267, 101.313875, 112.517, 99.767, 100.7045,
            102.907625, 103.095125, 101.642, 101.126375, 100.282625, 98.501375, 102.392, 96.251375, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:07.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.8606,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:07.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.23575, 119.54825, 113.36075, 110.4545, 108.767, 107.126375, 106.095125, 110.595125, 118.188875, 100.142,
            103.001375, 102.251375, 100.470125, 104.595125, 102.626375, 100.3295, 99.29825, 98.267, 98.782625,
            100.470125, 102.017, 102.017, 100.3295, 99.626375, 97.938875, 101.782625, 96.251375, 95.126375,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:59.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.21867,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:59.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.438875, 125.92325, 124.095125, 121.188875, 116.126375, 114.251375, 112.188875, 111.720125, 128.126375,
            112.282625, 103.42325, 108.392, 99.2045, 104.595125, 102.251375, 100.42325, 99.345125, 100.142, 98.267,
            100.61075, 102.345125, 101.688875, 100.376375, 99.438875, 98.17325, 101.4545, 96.063875, 95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:22.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.75397,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:22.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.79825, 116.92325, 115.3295, 110.595125, 108.720125, 108.251375, 106.892, 108.720125, 105.157625,
            107.126375, 102.907625, 97.376375, 97.61075, 97.3295, 97.657625, 96.907625, 97.282625, 97.142, 98.032625,
            99.720125, 102.5795, 101.970125, 100.563875, 100.04825, 98.642, 104.032625, 100.3295, 97.7045,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:23.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.49037,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:23.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.220125, 125.17325, 123.29825, 122.970125, 119.92325, 114.157625, 112.470125, 108.48575, 105.392,
            102.017, 99.017, 99.063875, 97.095125, 97.563875, 97.3295, 96.532625, 96.251375, 96.86075, 97.892,
            100.04825, 101.92325, 101.54825, 100.470125, 99.251375, 98.220125, 102.438875, 96.48575, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:20.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.69427,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:20.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.751375, 110.54825, 106.892, 106.376375, 106.23575, 106.376375, 105.720125, 105.720125, 103.23575,
            99.29825, 102.907625, 102.532625, 97.657625, 97.751375, 96.532625, 96.29825, 95.595125, 96.392, 97.7045,
            99.9545, 102.063875, 101.407625, 100.188875, 99.5795, 98.17325, 101.876375, 96.157625, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:33.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.49117,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:33.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.2045, 108.063875, 104.595125, 104.642, 105.345125, 106.095125, 105.907625, 115.3295, 120.626375,
            103.79825, 105.48575, 101.407625, 98.4545, 100.61075, 100.563875, 101.313875, 100.001375, 98.0795,
            98.313875, 100.188875, 101.876375, 102.48575, 100.42325, 100.095125, 98.876375, 102.813875, 95.92325,
            95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:01.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.63146,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:01.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.345125, 111.017, 112.188875, 107.0795, 108.251375, 107.4545, 106.470125, 105.251375, 103.142,
            100.001375, 106.61075, 100.3295, 108.017, 100.282625, 97.517, 107.92325, 97.23575, 98.876375, 100.517,
            100.282625, 101.92325, 101.36075, 100.517, 99.720125, 97.79825, 101.407625, 96.29825, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:14.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.45581,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:14.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.3295, 107.876375, 105.67325, 105.67325, 104.267, 107.501375, 114.48575, 105.29825, 101.501375,
            101.876375, 99.063875, 97.563875, 97.657625, 98.970125, 99.720125, 96.063875, 96.48575, 96.67325, 97.892,
            99.86075, 102.345125, 101.407625, 100.3295, 99.720125, 98.4545, 102.438875, 96.017, 95.126375,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:04.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.9521,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:04.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 121.657625, 119.782625, 116.876375, 113.032625, 109.61075, 107.782625, 107.642, 113.688875,
            101.36075, 101.313875, 100.892, 102.67325, 99.907625, 98.688875, 101.92325, 97.517, 97.845125, 98.595125,
            100.7045, 102.532625, 102.11075, 100.563875, 99.813875, 98.313875, 102.063875, 96.392, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:21.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.29198,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:21.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.392, 117.157625, 113.688875, 117.251375, 118.98575, 108.813875, 107.4545, 113.876375, 114.626375,
            104.595125, 104.126375, 100.142, 102.392, 104.501375, 110.0795, 109.142, 103.845125, 101.595125, 100.3295,
            99.907625, 102.11075, 101.595125, 100.095125, 99.48575, 98.36075, 102.063875, 96.48575, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:20.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.96371,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:20.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.095125, 112.751375, 111.532625, 110.642, 110.36075, 108.67325, 107.032625, 106.98575, 103.42325,
            101.501375, 98.92325, 98.92325, 98.0795, 98.501375, 97.61075, 98.688875, 96.720125, 97.657625, 98.407625,
            100.095125, 102.29825, 102.2045, 100.517, 99.9545, 98.8295, 103.142, 96.767, 95.407625,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:17.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.97804,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:17.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.2045, 109.845125, 107.0795, 105.67325, 107.267, 106.282625, 107.0795, 106.938875, 102.48575, 100.282625,
            99.438875, 105.29825, 103.04825, 98.313875, 103.376375, 104.313875, 103.7045, 106.095125, 102.532625,
            102.2045, 104.36075, 102.626375, 101.0795, 100.095125, 98.642, 102.29825, 96.767, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:37.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.851,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:37.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.407625, 107.54825, 106.282625, 106.001375, 106.657625, 105.29825, 105.345125, 106.001375, 114.626375,
            100.7045, 100.7045, 99.157625, 96.251375, 97.938875, 97.188875, 96.813875, 95.8295, 96.392, 98.126375,
            99.907625, 101.73575, 102.392, 100.282625, 99.67325, 98.54825, 103.04825, 96.157625, 94.98575,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:24.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.37996,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:24.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.657625, 117.017, 117.29825, 115.61075, 111.392, 107.595125, 105.438875, 107.73575, 112.845125,
            124.98575, 111.2045, 105.5795, 101.126375, 100.657625, 104.032625, 102.720125, 102.157625, 103.095125,
            102.345125, 100.657625, 102.2045, 101.501375, 100.376375, 99.767, 98.313875, 101.970125, 96.345125,
            95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:57.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.77924,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:57.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.688875, 118.04825, 112.282625, 108.9545, 107.126375, 105.48575, 106.188875, 106.3295, 122.17325,
            117.720125, 114.86075, 109.282625, 102.11075, 99.626375, 99.626375, 98.313875, 97.938875, 97.61075,
            98.782625, 100.42325, 102.063875, 101.595125, 100.376375, 99.626375, 98.220125, 102.392, 96.626375, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:25.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 145.79938,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:25.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            143.688875, 139.095125, 135.767, 130.7045, 127.61075, 125.220125, 125.876375, 121.23575, 118.3295,
            115.23575, 110.595125, 106.23575, 102.767, 100.23575, 101.407625, 98.970125, 97.563875, 97.095125,
            98.126375, 99.907625, 101.8295, 101.782625, 100.282625, 99.438875, 98.313875, 102.9545, 96.720125,
            95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:15.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.98898,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:15.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.157625, 120.392, 116.126375, 116.4545, 114.063875, 110.92325, 119.642, 108.907625, 103.845125, 102.392,
            99.532625, 99.017, 102.017, 105.532625, 111.813875, 104.688875, 107.313875, 99.063875, 100.751375,
            101.407625, 103.3295, 101.92325, 100.7045, 100.001375, 98.313875, 102.767, 96.392, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:48.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.86836,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:48.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.04825, 104.642, 102.063875, 104.595125, 106.61075, 106.142, 106.376375, 111.157625, 120.86075,
            104.970125, 103.79825, 104.407625, 98.595125, 101.126375, 99.29825, 98.782625, 97.142, 96.86075, 97.3295,
            100.04825, 102.017, 101.4545, 100.142, 99.2045, 98.17325, 101.407625, 96.2045, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:26.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.97557,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:26.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.563875, 105.48575, 104.267, 112.282625, 118.3295, 109.3295, 108.626375, 116.8295, 105.813875, 104.267,
            102.392, 99.017, 101.970125, 103.001375, 104.032625, 105.5795, 104.970125, 100.001375, 101.782625,
            101.032625, 102.767, 102.345125, 100.61075, 99.392, 98.126375, 101.501375, 96.626375, 95.126375,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:45.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.65353,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:45.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.470125, 132.017, 127.376375, 124.23575, 122.876375, 118.79825, 113.36075, 111.907625, 115.188875,
            108.626375, 106.938875, 105.157625, 97.7045, 98.595125, 97.42325, 98.220125, 99.720125, 97.7045, 97.657625,
            99.9545, 102.157625, 101.642, 100.657625, 99.767, 98.688875, 102.626375, 96.157625, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:38.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.14119,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:38.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.376375, 110.73575, 106.470125, 107.4545, 107.407625, 106.282625, 106.563875, 106.04825, 103.657625,
            100.3295, 105.251375, 107.407625, 101.4545, 99.626375, 96.907625, 98.36075, 100.04825, 100.845125,
            100.188875, 100.3295, 101.92325, 101.970125, 100.42325, 99.438875, 98.642, 102.86075, 96.532625, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:22.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.98705,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:22.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.48575, 134.8295, 131.220125, 128.0795, 125.595125, 121.7045, 120.532625, 117.29825, 115.657625,
            118.376375, 105.017, 101.17325, 102.11075, 101.032625, 97.751375, 98.17325, 104.220125, 101.0795, 100.517,
            100.845125, 102.2045, 101.92325, 100.3295, 99.767, 98.73575, 102.67325, 96.345125, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:27.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.09757,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:27.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.0795, 109.98575, 109.188875, 108.2045, 105.767, 105.345125, 105.2045, 105.532625, 104.0795, 104.595125,
            102.720125, 99.907625, 99.720125, 99.29825, 98.782625, 98.4545, 97.845125, 97.892, 98.4545, 100.3295,
            102.392, 101.782625, 100.3295, 99.392, 98.501375, 101.8295, 96.720125, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:28.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.39518,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:28.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.8295, 110.501375, 106.517, 106.563875, 107.032625, 106.61075, 107.36075, 107.501375, 103.98575,
            103.657625, 100.376375, 98.126375, 98.17325, 98.126375, 97.98575, 98.688875, 96.9545, 97.04825, 98.126375,
            99.767, 101.970125, 101.54825, 100.188875, 99.345125, 98.313875, 103.42325, 96.392, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:27.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.624146,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:27.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.095125, 111.438875, 107.8295, 105.720125, 106.470125, 108.813875, 113.220125, 105.813875, 101.4545,
            100.04825, 101.032625, 100.001375, 97.938875, 101.4545, 98.970125, 101.54825, 100.142, 99.251375, 99.345125,
            100.188875, 101.8295, 101.54825, 100.095125, 99.392, 97.892, 101.4545, 95.970125, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:15.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.6514,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:15.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.8295, 111.063875, 108.907625, 107.407625, 110.595125, 108.86075, 107.032625, 107.688875, 104.220125,
            102.017, 98.73575, 96.5795, 98.126375, 109.142, 97.282625, 96.907625, 110.501375, 99.813875, 98.8295,
            103.282625, 105.813875, 102.017, 101.73575, 101.4545, 98.501375, 102.5795, 95.92325, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:22.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.23604,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:22.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.470125, 127.79825, 123.813875, 119.126375, 119.032625, 116.4545, 114.86075, 110.8295, 106.42325,
            106.845125, 102.29825, 99.29825, 97.61075, 98.54825, 96.345125, 95.876375, 96.2045, 96.5795, 97.470125,
            99.86075, 101.688875, 101.595125, 100.23575, 99.29825, 97.892, 101.407625, 95.8295, 95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:25.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.88937,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:25.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.532625, 124.845125, 121.61075, 120.017, 115.79825, 114.29825, 110.407625, 107.36075, 107.220125,
            104.92325, 102.48575, 102.9545, 98.595125, 98.970125, 98.595125, 98.501375, 97.188875, 97.42325, 97.79825,
            99.9545, 101.92325, 100.98575, 99.9545, 99.251375, 97.938875, 101.782625, 96.017, 95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:32.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.90315,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:32.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.845125, 109.61075, 107.876375, 108.86075, 108.532625, 107.407625, 106.376375, 106.892, 118.657625,
            102.2045, 99.767, 99.11075, 98.267, 99.438875, 98.642, 98.642, 97.517, 96.532625, 97.657625, 99.813875,
            102.29825, 101.8295, 100.3295, 100.282625, 98.36075, 102.345125, 95.970125, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:26.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.21571,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:26.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.751375, 121.3295, 116.267, 111.86075, 110.36075, 108.67325, 107.4545, 106.3295, 103.563875, 102.767,
            99.251375, 98.17325, 96.813875, 97.938875, 97.142, 97.470125, 96.017, 96.813875, 97.7045, 100.001375,
            101.688875, 100.98575, 99.767, 98.876375, 97.657625, 100.98575, 95.970125, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:34.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.69751,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:34.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.5795, 114.67325, 112.751375, 111.767, 110.595125, 108.29825, 107.688875, 109.23575, 106.001375,
            102.720125, 99.86075, 98.688875, 100.470125, 103.938875, 97.79825, 96.720125, 100.42325, 97.188875, 97.892,
            99.767, 101.92325, 102.626375, 100.61075, 99.813875, 98.54825, 102.86075, 96.345125, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:21.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.15968,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:21.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.267, 119.688875, 117.11075, 112.470125, 110.267, 108.345125, 106.892, 105.2045, 103.61075, 120.813875,
            119.92325, 116.0795, 107.220125, 103.751375, 110.0795, 107.0795, 103.3295, 102.251375, 102.017, 101.0795,
            102.5795, 101.8295, 100.517, 100.142, 98.501375, 102.251375, 96.11075, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:31.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.78731,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:31.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.720125, 117.67325, 113.407625, 111.251375, 110.407625, 109.23575, 107.642, 108.2045, 103.7045,
            101.54825, 100.3295, 99.251375, 97.845125, 97.42325, 96.67325, 96.11075, 95.8295, 96.67325, 97.470125,
            99.67325, 101.970125, 101.595125, 100.142, 99.438875, 98.17325, 101.876375, 96.67325, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:10.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.05323,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:10.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.407625, 111.345125, 108.67325, 104.54825, 106.938875, 105.626375, 105.9545, 105.813875, 103.892,
            99.67325, 99.48575, 98.17325, 96.720125, 98.032625, 96.9545, 96.767, 95.595125, 96.017, 97.23575, 99.720125,
            102.251375, 101.642, 100.376375, 99.5795, 98.220125, 101.876375, 95.970125, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:51.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.86699,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:51.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.157625, 114.48575, 111.11075, 109.095125, 108.11075, 107.032625, 107.54825, 107.032625, 102.813875,
            100.188875, 103.938875, 98.688875, 97.61075, 99.438875, 97.04825, 96.438875, 96.720125, 96.345125, 97.142,
            99.67325, 101.54825, 101.126375, 99.9545, 99.438875, 98.220125, 101.782625, 96.017, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:16.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.37371,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:16.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.032625, 102.11075, 101.92325, 103.79825, 104.220125, 105.67325, 108.626375, 104.73575, 100.845125,
            99.017, 97.657625, 96.532625, 97.095125, 98.970125, 97.7045, 96.813875, 96.9545, 96.345125, 97.563875,
            99.86075, 102.017, 101.36075, 100.23575, 99.767, 98.36075, 102.720125, 96.2045, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:29.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.00777,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:29.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.688875, 115.938875, 113.92325, 112.79825, 110.73575, 107.0795, 107.92325, 108.48575, 105.063875,
            101.54825, 99.532625, 97.563875, 96.86075, 97.470125, 97.142, 96.392, 95.642, 96.9545, 97.282625, 99.767,
            101.876375, 101.267, 99.9545, 99.345125, 97.845125, 101.36075, 95.970125, 95.126375,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:31.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.599014,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:31.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.157625, 117.157625, 114.532625, 111.532625, 109.142, 107.36075, 106.563875, 105.813875, 109.751375,
            108.5795, 105.11075, 101.54825, 102.063875, 98.220125, 96.67325, 96.907625, 96.29825, 97.001375, 97.892,
            100.04825, 102.251375, 101.73575, 100.517, 100.188875, 98.54825, 106.61075, 101.0795, 96.67325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:24.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.52225,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:24.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.79825, 127.42325, 124.657625, 121.892, 118.892, 115.470125, 112.142, 110.688875, 109.938875, 104.970125,
            101.36075, 99.813875, 98.36075, 98.0795, 97.892, 96.345125, 97.79825, 97.7045, 98.17325, 100.470125,
            102.11075, 101.36075, 100.142, 99.392, 98.0795, 101.36075, 96.251375, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:23.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.16627,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:23.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.845125, 117.626375, 113.73575, 109.98575, 108.48575, 107.642, 105.67325, 106.470125, 115.095125,
            111.063875, 114.2045, 112.470125, 98.17325, 100.23575, 98.220125, 97.376375, 97.470125, 98.267, 98.970125,
            100.517, 102.157625, 101.73575, 100.142, 99.29825, 97.938875, 101.876375, 96.251375, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:28.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.792564,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:28.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.2045, 110.267, 107.0795, 107.36075, 107.688875, 106.79825, 109.751375, 122.595125, 103.98575, 99.767,
            106.23575, 99.29825, 98.642, 99.907625, 100.657625, 102.5795, 101.267, 101.267, 101.267, 100.563875,
            102.017, 101.17325, 99.86075, 99.251375, 97.98575, 101.642, 96.2045, 95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:55.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.27977,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:55.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.251375, 122.970125, 119.0795, 119.8295, 117.813875, 113.220125, 110.36075, 110.501375, 106.563875,
            103.23575, 101.220125, 99.67325, 97.892, 97.751375, 97.517, 96.626375, 96.2045, 97.001375, 98.0795,
            100.188875, 102.017, 101.782625, 100.42325, 100.04825, 98.501375, 102.532625, 97.001375, 95.407625,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:52.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.15431,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:52.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.001375, 117.907625, 113.501375, 111.532625, 113.126375, 111.438875, 107.688875, 107.17325, 103.142,
            100.657625, 98.8295, 98.36075, 97.61075, 97.98575, 96.392, 96.86075, 96.438875, 96.5795, 97.563875, 99.9545,
            102.2045, 101.501375, 100.001375, 99.532625, 98.0795, 102.063875, 96.532625, 95.501375,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:06.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.28728,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:06.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.157625, 125.0795, 119.267, 115.23575, 110.688875, 108.767, 108.11075, 105.5795, 104.73575, 100.845125,
            99.063875, 99.345125, 97.657625, 97.7045, 97.376375, 96.29825, 96.345125, 96.767, 97.657625, 99.9545,
            102.345125, 102.017, 100.563875, 99.767, 98.54825, 102.157625, 96.017, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:30.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.713684,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:30.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.157625, 107.876375, 103.563875, 104.73575, 105.017, 105.345125, 105.767, 106.282625, 117.438875,
            113.501375, 115.470125, 107.313875, 101.36075, 99.157625, 98.267, 101.876375, 101.4545, 98.407625,
            99.063875, 99.813875, 101.876375, 101.73575, 100.282625, 99.626375, 98.032625, 102.063875, 96.251375,
            95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:53.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.842545,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:53.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.5795, 112.563875, 107.970125, 106.23575, 105.813875, 106.001375, 106.657625, 107.4545, 101.54825,
            99.11075, 100.563875, 98.267, 98.313875, 98.876375, 96.392, 96.767, 96.532625, 96.438875, 97.61075, 100.142,
            102.29825, 102.017, 100.470125, 99.813875, 98.501375, 102.767, 96.2045, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:18.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.056,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:18.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.688875, 120.438875, 117.67325, 113.876375, 109.61075, 107.407625, 105.063875, 105.063875, 101.0795,
            99.11075, 98.126375, 104.501375, 110.032625, 98.407625, 99.251375, 105.67325, 106.79825, 110.126375,
            106.001375, 102.67325, 105.767, 104.313875, 102.2045, 100.282625, 98.267, 101.782625, 96.29825, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:19.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.39772,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:19.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.376375, 127.892, 128.032625, 123.29825, 119.8295, 115.751375, 114.29825, 111.48575, 107.267, 103.376375,
            100.938875, 98.595125, 97.938875, 98.0795, 97.095125, 96.345125, 96.626375, 96.9545, 97.79825, 99.86075,
            102.251375, 101.876375, 100.3295, 99.5795, 98.54825, 102.345125, 96.532625, 95.407625,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:29.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.36392,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:29.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.8295, 123.5795, 121.095125, 120.67325, 117.532625, 114.5795, 111.345125, 109.001375, 107.17325,
            100.98575, 100.001375, 99.017, 98.126375, 99.251375, 101.8295, 101.73575, 101.126375, 100.61075, 98.73575,
            100.188875, 101.876375, 101.642, 100.095125, 99.29825, 97.892, 101.8295, 96.532625, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:39.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.07223,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:39.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.345125, 108.251375, 105.86075, 106.517, 107.501375, 105.767, 107.17325, 107.267, 104.501375, 102.017,
            100.376375, 97.79825, 96.9545, 97.3295, 96.392, 96.813875, 95.501375, 96.5795, 97.657625, 100.001375,
            102.157625, 101.688875, 100.095125, 99.9545, 98.126375, 102.063875, 96.251375, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:42.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.9168,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:42.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.142, 126.9545, 124.001375, 121.79825, 118.142, 113.407625, 111.813875, 110.126375, 105.720125,
            101.36075, 104.73575, 105.67325, 104.642, 98.267, 97.3295, 97.376375, 102.48575, 98.92325, 98.782625,
            100.376375, 102.345125, 101.92325, 100.657625, 100.188875, 98.54825, 102.48575, 96.251375, 95.407625,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:44.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.1119,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:44.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.517, 130.3295, 126.532625, 122.032625, 120.345125, 118.845125, 113.642, 112.79825, 116.501375,
            110.876375, 103.04825, 101.688875, 98.313875, 99.345125, 98.407625, 97.3295, 96.86075, 96.767, 97.79825,
            99.626375, 102.063875, 101.876375, 100.42325, 100.142, 98.688875, 102.48575, 96.438875, 95.220125,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:35.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.24138,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:35.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.4545, 119.032625, 115.23575, 112.563875, 109.98575, 107.73575, 108.11075, 108.157625, 103.282625,
            100.7045, 100.7045, 100.42325, 98.970125, 98.54825, 96.345125, 96.438875, 95.54825, 96.2045, 97.7045,
            99.438875, 101.407625, 102.11075, 100.376375, 99.86075, 98.220125, 102.251375, 95.876375, 95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:36.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.037285,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:36.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.54825, 114.5795, 107.0795, 105.9545, 106.845125, 106.42325, 105.11075, 107.0795, 118.188875, 101.0795,
            101.407625, 101.407625, 99.29825, 99.532625, 98.267, 98.92325, 96.11075, 96.813875, 97.79825, 100.142,
            101.688875, 102.063875, 100.376375, 99.438875, 98.220125, 102.2045, 96.345125, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:50.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.28432,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:50.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.79825, 117.9545, 115.845125, 113.73575, 111.813875, 109.470125, 108.11075, 107.688875, 105.438875,
            101.8295, 106.001375, 102.438875, 99.2045, 100.79825, 96.626375, 97.188875, 99.626375, 97.79825, 99.017,
            100.282625, 102.2045, 101.688875, 100.282625, 99.907625, 98.407625, 102.11075, 96.532625, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:05.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.49797,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:05.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.8295, 126.29825, 121.3295, 117.11075, 115.188875, 111.813875, 109.938875, 108.626375, 104.642,
            101.36075, 100.563875, 103.095125, 105.438875, 106.282625, 97.98575, 106.001375, 104.782625, 99.532625,
            99.67325, 101.0795, 102.9545, 101.782625, 100.892, 99.907625, 98.36075, 102.392, 96.157625, 95.36075,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:40.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.29831,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:40.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.813875, 110.267, 110.17325, 109.938875, 106.001375, 106.3295, 105.532625, 109.23575, 115.517, 100.98575,
            101.73575, 102.2045, 97.095125, 98.595125, 98.17325, 98.501375, 96.9545, 97.142, 97.892, 99.720125,
            101.876375, 101.220125, 100.376375, 99.907625, 98.313875, 102.67325, 96.157625, 95.267,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:32.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.71428,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:32.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.001375, 117.5795, 113.92325, 115.517, 115.845125, 110.8295, 108.063875, 108.438875, 106.79825,
            102.251375, 102.063875, 100.845125, 100.001375, 102.157625, 107.126375, 107.0795, 103.001375, 100.61075,
            101.642, 101.126375, 102.532625, 101.876375, 100.376375, 99.532625, 98.17325, 102.2045, 96.5795, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:46.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.04427,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:36:46.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.813875, 125.782625, 121.3295, 115.7045, 112.938875, 110.17325, 109.282625, 106.470125, 104.313875,
            101.73575, 101.970125, 106.751375, 108.720125, 98.8295, 97.23575, 98.688875, 100.61075, 98.407625,
            99.251375, 101.8295, 101.8295, 101.501375, 99.767, 98.876375, 97.42325, 100.892, 96.251375, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:08.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.1261,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:08.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.063875, 123.5795, 120.532625, 117.67325, 115.282625, 111.11075, 109.001375, 108.345125, 104.17325,
            101.782625, 101.73575, 104.970125, 99.017, 105.626375, 97.751375, 99.157625, 102.251375, 103.61075,
            98.407625, 100.563875, 102.532625, 101.54825, 101.407625, 100.282625, 97.938875, 101.595125, 96.017,
            95.17325,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:09.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.88608,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:09.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.98575, 121.188875, 119.0795, 117.907625, 115.282625, 108.251375, 106.095125, 104.4545, 101.17325,
            101.0795, 99.626375, 100.98575, 100.42325, 105.48575, 96.11075, 100.23575, 101.0795, 99.67325, 98.032625,
            99.813875, 102.2045, 102.157625, 102.2045, 100.751375, 98.032625, 101.876375, 96.29825, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:30.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.22601,
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:37:30.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.2045, 130.470125, 126.86075, 121.79825, 119.782625, 117.017, 113.8295, 110.8295, 107.126375, 101.4545,
            100.938875, 100.23575, 98.54825, 99.017, 102.157625, 105.767, 102.720125, 105.392, 101.032625, 100.563875,
            102.9545, 102.063875, 100.892, 100.142, 98.0795, 101.501375, 96.2045, 95.313875,
        ],
        latitude: 37.4405803,
        longitude: -122.5333735,
    },
    {
        timestamp: '2025-08-29T22:38:12.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 115.6467,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:12.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.688875, 101.92325, 100.751375, 104.0795, 105.157625, 102.392, 103.3295, 103.376375, 100.563875,
            98.407625, 98.267, 98.17325, 98.595125, 97.470125, 96.720125, 96.11075, 96.438875, 96.626375, 97.938875,
            99.9545, 102.017, 101.876375, 100.61075, 99.5795, 98.501375, 102.29825, 96.157625, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:54.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.318306,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:54.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.61075, 115.376375, 111.9545, 111.67325, 117.11075, 111.67325, 111.532625, 110.8295, 107.92325,
            105.720125, 101.407625, 100.23575, 100.001375, 103.98575, 106.7045, 104.782625, 102.907625, 101.54825,
            100.470125, 100.892, 102.813875, 101.8295, 100.7045, 99.813875, 98.595125, 102.29825, 96.345125, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:52.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.0939,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:52.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 117.063875, 113.595125, 111.063875, 108.157625, 105.157625, 105.813875, 107.688875, 103.563875,
            100.001375, 102.017, 99.157625, 96.86075, 97.42325, 96.86075, 95.8295, 96.532625, 96.9545, 97.751375,
            100.142, 102.2045, 101.36075, 100.095125, 99.345125, 97.657625, 101.54825, 96.11075, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:42.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.59557,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:42.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.42325, 121.42325, 118.845125, 117.5795, 115.142, 109.61075, 111.2045, 109.657625, 104.782625, 101.8295,
            100.3295, 100.282625, 99.392, 100.42325, 98.407625, 97.98575, 97.657625, 98.032625, 98.267, 100.42325,
            102.251375, 102.345125, 100.23575, 99.67325, 98.595125, 102.157625, 97.61075, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:24.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.93239,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:24.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.376375, 108.532625, 103.98575, 103.517, 106.751375, 105.86075, 104.8295, 105.720125, 101.313875,
            98.782625, 98.642, 98.17325, 97.657625, 97.04825, 96.767, 96.157625, 95.688875, 97.142, 98.313875, 99.767,
            102.2045, 101.642, 100.657625, 99.86075, 98.407625, 102.438875, 96.532625, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:02.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.05726,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:02.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 117.67325, 114.5795, 109.79825, 110.688875, 108.438875, 109.095125, 110.0795, 115.563875,
            117.438875, 101.501375, 108.5795, 103.470125, 108.063875, 102.2045, 102.813875, 105.157625, 98.36075,
            98.032625, 99.813875, 102.157625, 101.595125, 100.142, 99.29825, 97.7045, 101.267, 96.29825, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:37.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.560265,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:37.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 122.032625, 122.501375, 115.79825, 111.2045, 110.4545, 108.907625, 107.313875, 105.017,
            101.876375, 101.220125, 99.5795, 99.532625, 98.407625, 101.032625, 100.001375, 99.67325, 99.157625, 98.642,
            100.188875, 102.017, 102.438875, 100.376375, 99.438875, 98.642, 102.063875, 96.86075, 95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:34.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.197876,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:34.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.188875, 118.61075, 114.720125, 111.438875, 108.626375, 106.563875, 105.907625, 104.92325, 102.907625,
            99.392, 99.813875, 99.2045, 98.17325, 98.17325, 97.7045, 97.188875, 97.04825, 97.7045, 98.36075, 100.517,
            102.11075, 103.142, 100.845125, 99.907625, 98.73575, 102.720125, 96.813875, 95.54825,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:13.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.20948,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:13.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.11075, 105.67325, 103.517, 104.4545, 107.4545, 107.595125, 108.392, 110.0795, 108.907625, 105.907625,
            103.61075, 104.032625, 105.626375, 99.5795, 97.98575, 95.688875, 96.11075, 97.188875, 97.845125, 99.9545,
            102.392, 102.11075, 100.61075, 99.907625, 98.313875, 102.48575, 96.392, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:43.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.10499,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:43.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.79825, 110.8295, 107.267, 107.73575, 107.595125, 104.688875, 106.61075, 106.79825, 103.470125, 109.3295,
            110.8295, 106.470125, 105.5795, 105.720125, 101.407625, 100.657625, 99.438875, 99.251375, 99.345125,
            100.42325, 102.626375, 102.157625, 100.23575, 99.626375, 98.4545, 102.29825, 96.48575, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:32.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.65526,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:32.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.517, 109.282625, 107.688875, 106.657625, 104.501375, 109.095125, 106.470125, 105.157625, 101.73575,
            99.813875, 100.23575, 99.017, 99.48575, 98.17325, 98.4545, 99.438875, 98.220125, 97.892, 99.251375,
            100.79825, 102.2045, 102.017, 100.42325, 99.720125, 98.4545, 101.92325, 96.67325, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:36.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.42679,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:36.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.11075, 124.376375, 121.376375, 117.86075, 115.79825, 111.438875, 110.4545, 109.23575, 106.470125,
            103.188875, 102.626375, 101.4545, 98.8295, 100.42325, 102.11075, 103.61075, 102.11075, 101.032625, 101.267,
            101.595125, 102.29825, 102.86075, 100.517, 99.907625, 98.688875, 102.5795, 96.9545, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:18.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.64339,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:18.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.532625, 112.04825, 110.220125, 104.8295, 104.782625, 103.79825, 105.86075, 104.782625, 101.36075,
            99.813875, 99.063875, 98.36075, 98.970125, 98.4545, 96.438875, 96.532625, 96.720125, 97.42325, 98.782625,
            100.23575, 102.11075, 101.876375, 100.23575, 99.86075, 98.4545, 102.392, 96.532625, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:11.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.52909,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:11.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.845125, 107.313875, 107.970125, 104.970125, 109.376375, 110.0795, 110.4545, 110.8295, 105.9545,
            102.532625, 100.3295, 98.688875, 98.782625, 98.220125, 100.938875, 99.67325, 99.345125, 98.54825, 98.73575,
            100.23575, 102.063875, 101.876375, 100.517, 99.767, 98.688875, 102.907625, 96.626375, 95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:47.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.93153,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:47.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.86075, 127.376375, 125.313875, 121.845125, 118.79825, 112.751375, 112.188875, 109.938875, 104.92325,
            102.29825, 101.126375, 99.017, 98.0795, 98.220125, 97.001375, 96.392, 96.767, 96.5795, 98.032625, 100.3295,
            102.017, 101.876375, 100.142, 99.767, 98.36075, 102.11075, 96.532625, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:53.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.343124,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:53.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.845125, 116.032625, 114.11075, 109.095125, 108.813875, 108.767, 105.813875, 104.92325, 102.251375,
            101.032625, 99.813875, 99.345125, 97.845125, 100.517, 102.157625, 101.17325, 101.688875, 101.17325,
            100.095125, 100.42325, 102.157625, 101.220125, 100.095125, 99.29825, 98.267, 103.3295, 96.813875, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:50.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.19005,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:50.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.392, 128.126375, 126.532625, 124.23575, 118.845125, 117.29825, 114.67325, 111.720125, 106.42325,
            102.017, 100.938875, 99.11075, 98.688875, 102.29825, 104.876375, 103.845125, 103.61075, 99.063875,
            100.42325, 100.470125, 102.392, 101.782625, 100.7045, 99.813875, 98.267, 102.11075, 96.626375, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:25.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.04209,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:25.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.782625, 102.157625, 99.86075, 102.11075, 104.54825, 104.54825, 106.282625, 105.063875, 103.188875,
            100.142, 98.970125, 97.376375, 96.86075, 98.4545, 97.282625, 96.2045, 96.29825, 96.9545, 97.79825, 99.392,
            101.782625, 101.220125, 100.001375, 99.720125, 98.407625, 102.063875, 96.157625, 95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:08.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.15663,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:08.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.17325, 107.688875, 106.3295, 108.392, 109.282625, 107.36075, 107.688875, 107.8295, 104.642, 102.017,
            99.11075, 99.017, 97.845125, 97.095125, 95.970125, 96.017, 95.970125, 96.720125, 97.517, 99.813875,
            102.063875, 101.73575, 100.3295, 99.67325, 98.313875, 102.251375, 96.392, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:33.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.29247,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:33.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.5795, 120.907625, 114.813875, 111.86075, 111.532625, 106.845125, 108.2045, 103.845125, 102.017,
            100.938875, 100.04825, 99.767, 99.5795, 99.392, 101.0795, 99.9545, 100.142, 99.5795, 99.907625, 101.595125,
            102.813875, 102.86075, 100.79825, 100.282625, 99.157625, 103.04825, 96.813875, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:41.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.07428,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:41.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.8295, 113.313875, 109.04825, 104.595125, 106.001375, 105.48575, 105.532625, 103.938875, 101.267,
            100.188875, 99.626375, 100.751375, 98.876375, 100.001375, 100.376375, 99.017, 96.907625, 96.767, 97.7045,
            100.470125, 102.438875, 102.11075, 100.376375, 99.626375, 98.220125, 101.8295, 96.251375, 95.126375,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:07.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.10922,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:07.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 115.938875, 115.79825, 113.17325, 107.876375, 111.907625, 111.2045, 115.095125, 104.73575,
            104.4545, 100.142, 99.392, 99.5795, 99.29825, 104.642, 99.438875, 101.501375, 98.688875, 98.407625,
            100.095125, 102.017, 101.220125, 99.86075, 99.5795, 98.126375, 101.642, 96.157625, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:46.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.54852,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:46.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.3295, 116.220125, 114.86075, 114.767, 112.282625, 106.3295, 107.595125, 104.970125, 101.126375,
            98.220125, 98.4545, 98.17325, 98.267, 98.0795, 96.48575, 96.9545, 95.92325, 96.907625, 97.892, 100.282625,
            102.11075, 101.970125, 100.23575, 99.438875, 98.4545, 102.67325, 96.626375, 95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:41.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.13446,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:41.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.3295, 123.720125, 122.17325, 119.92325, 114.2045, 109.095125, 105.2045, 103.892, 100.3295, 99.86075,
            98.54825, 97.7045, 98.407625, 98.36075, 96.5795, 96.9545, 96.67325, 97.563875, 97.61075, 100.04825,
            102.29825, 101.73575, 100.095125, 99.767, 98.267, 103.142, 96.626375, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:21.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.5915,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:21.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.36075, 116.407625, 113.267, 109.7045, 108.767, 107.032625, 107.220125, 107.642, 102.86075, 100.095125,
            98.0795, 98.782625, 99.392, 98.36075, 96.907625, 96.86075, 96.2045, 97.938875, 98.876375, 100.282625,
            101.92325, 101.73575, 100.095125, 99.532625, 98.17325, 101.73575, 96.5795, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:42.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.31735,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:42.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.517, 103.79825, 102.86075, 107.54825, 108.9545, 108.767, 108.345125, 109.23575, 105.063875, 102.86075,
            103.751375, 110.595125, 102.063875, 103.142, 100.98575, 99.157625, 98.126375, 97.98575, 97.98575, 99.720125,
            102.11075, 101.688875, 100.42325, 99.626375, 98.54825, 102.345125, 96.29825, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:39.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.82994,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:39.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.251375, 118.98575, 115.845125, 112.61075, 111.017, 109.282625, 107.501375, 105.48575, 103.188875,
            100.938875, 99.392, 98.17325, 99.017, 99.767, 98.595125, 97.188875, 97.142, 97.282625, 98.36075, 100.751375,
            102.063875, 101.688875, 100.095125, 99.438875, 98.17325, 102.017, 96.532625, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:48.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.938,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:48.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.845125, 125.73575, 122.782625, 118.657625, 116.642, 113.4545, 110.970125, 110.220125, 107.220125,
            103.892, 100.470125, 99.767, 97.188875, 97.79825, 97.095125, 96.438875, 96.29825, 97.095125, 97.98575,
            100.23575, 102.438875, 101.54825, 100.188875, 99.5795, 98.407625, 102.907625, 96.29825, 95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:57.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.9064,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:57.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.392, 125.032625, 122.8295, 118.188875, 116.407625, 113.642, 110.313875, 108.5795, 104.73575, 102.5795,
            100.04825, 99.2045, 99.29825, 98.126375, 97.845125, 96.9545, 96.251375, 97.095125, 97.751375, 100.3295,
            102.532625, 102.063875, 100.42325, 99.813875, 98.4545, 102.48575, 96.438875, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:45.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.98018,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:45.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.17325, 131.220125, 128.782625, 124.657625, 121.657625, 118.892, 115.845125, 113.642, 109.845125,
            107.688875, 102.813875, 99.626375, 98.642, 98.970125, 98.032625, 98.032625, 97.188875, 97.892, 98.36075,
            100.845125, 103.095125, 102.532625, 100.61075, 100.04825, 98.642, 102.626375, 97.001375, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:37.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.428024,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:37.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.4545, 114.438875, 110.876375, 108.2045, 106.79825, 107.267, 108.438875, 106.142, 102.532625, 100.001375,
            100.3295, 99.392, 99.907625, 98.313875, 97.04825, 96.392, 97.095125, 97.563875, 98.0795, 100.23575,
            102.063875, 102.626375, 100.61075, 99.86075, 98.501375, 102.29825, 96.392, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:23.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.69295,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:23.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.470125, 115.61075, 111.48575, 107.267, 108.157625, 105.626375, 107.642, 106.142, 103.3295, 100.845125,
            97.7045, 98.126375, 98.220125, 98.267, 97.188875, 96.720125, 96.345125, 97.938875, 97.845125, 99.86075,
            102.2045, 101.782625, 100.188875, 99.720125, 98.267, 102.2045, 96.392, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:20.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.22492,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:20.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.438875, 116.782625, 113.17325, 107.688875, 106.3295, 105.532625, 106.04825, 106.938875, 104.267,
            102.157625, 99.5795, 99.767, 99.813875, 99.626375, 98.4545, 97.23575, 96.720125, 98.642, 99.157625,
            100.188875, 101.970125, 102.2045, 100.517, 99.9545, 98.782625, 102.720125, 96.67325, 95.54825,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:44.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.48268,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:44.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.751375, 108.392, 104.267, 105.532625, 106.23575, 105.67325, 105.017, 103.892, 101.970125, 100.188875,
            100.001375, 99.813875, 100.282625, 101.642, 99.438875, 99.907625, 99.29825, 99.2045, 99.2045, 101.407625,
            103.376375, 103.282625, 100.892, 99.767, 99.67325, 104.267, 100.23575, 97.04825,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:51.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.92548,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:51.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.98575, 123.392, 118.376375, 111.813875, 110.92325, 109.657625, 107.92325, 106.845125, 102.48575,
            100.282625, 100.751375, 99.017, 98.220125, 98.313875, 97.001375, 96.720125, 96.345125, 96.67325, 97.845125,
            100.095125, 102.29825, 101.970125, 100.892, 99.720125, 98.92325, 103.845125, 96.438875, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:31.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.62844,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:31.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.282625, 108.626375, 106.001375, 106.517, 107.032625, 106.142, 108.017, 108.438875, 105.157625,
            100.657625, 99.017, 98.54825, 98.595125, 98.126375, 97.23575, 96.86075, 96.438875, 98.17325, 98.54825,
            100.095125, 102.345125, 102.2045, 100.470125, 99.9545, 98.313875, 102.2045, 96.767, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:09.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.699715,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:09.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.063875, 106.98575, 104.267, 106.04825, 107.0795, 106.470125, 107.267, 106.751375, 103.470125,
            101.313875, 98.642, 98.782625, 97.892, 96.9545, 95.54825, 95.970125, 95.36075, 96.251375, 97.61075,
            99.438875, 102.11075, 101.595125, 100.282625, 99.767, 98.220125, 102.29825, 96.017, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:22.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.28255,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:22.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.095125, 108.063875, 104.407625, 106.98575, 108.017, 107.8295, 105.86075, 105.438875, 101.501375,
            99.438875, 99.063875, 97.845125, 98.501375, 98.54825, 97.470125, 97.001375, 97.095125, 98.267, 98.876375,
            100.470125, 102.720125, 102.67325, 100.563875, 99.9545, 98.688875, 102.5795, 97.23575, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:01.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.63496,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:01.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.54825, 129.626375, 126.532625, 122.876375, 119.501375, 114.720125, 113.782625, 112.282625, 107.501375,
            106.42325, 103.42325, 108.813875, 102.67325, 104.220125, 99.345125, 99.438875, 98.642, 97.563875, 98.126375,
            100.04825, 102.157625, 101.73575, 99.907625, 99.251375, 97.98575, 101.4545, 96.626375, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:33.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.755104,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:33.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.532625, 118.3295, 123.532625, 120.813875, 110.782625, 111.767, 110.0795, 106.517, 104.92325, 101.73575,
            101.17325, 100.892, 99.2045, 101.688875, 104.8295, 100.001375, 101.688875, 100.517, 101.032625, 101.0795,
            102.157625, 102.48575, 100.42325, 99.86075, 98.8295, 102.392, 96.532625, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:17.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.98111,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:17.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.251375, 109.470125, 108.67325, 107.126375, 105.813875, 106.517, 108.11075, 108.532625, 107.54825,
            104.595125, 101.313875, 102.438875, 104.782625, 102.11075, 101.36075, 98.313875, 97.282625, 97.751375,
            98.970125, 100.282625, 102.392, 101.8295, 100.61075, 99.767, 98.4545, 101.782625, 96.251375, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:34.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.88646,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:34.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.92325, 124.095125, 122.876375, 122.4545, 117.767, 115.563875, 111.251375, 108.9545, 104.501375,
            101.8295, 101.501375, 99.67325, 98.0795, 97.7045, 96.767, 96.67325, 96.767, 97.142, 97.7045, 99.767,
            101.595125, 102.532625, 100.3295, 99.67325, 98.688875, 102.5795, 96.157625, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:47.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.7775,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:47.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.67325, 111.345125, 107.267, 105.9545, 105.767, 105.345125, 105.392, 107.4545, 102.532625, 100.282625,
            99.767, 99.251375, 99.532625, 99.67325, 99.29825, 98.8295, 98.267, 98.73575, 98.970125, 100.657625,
            103.23575, 103.23575, 100.563875, 99.907625, 98.8295, 103.79825, 98.126375, 95.54825,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:08.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.747635,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:08.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.782625, 107.17325, 105.017, 106.845125, 107.501375, 107.595125, 105.438875, 107.595125, 101.313875,
            100.751375, 99.48575, 98.642, 98.4545, 97.751375, 98.126375, 97.23575, 97.7045, 97.188875, 98.313875,
            99.48575, 102.157625, 101.73575, 100.095125, 99.29825, 98.17325, 101.642, 96.251375, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:38.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.10637,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:38.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.7045, 127.282625, 123.251375, 117.29825, 114.86075, 112.7045, 110.92325, 109.98575, 105.720125,
            101.92325, 99.720125, 99.5795, 99.86075, 99.9545, 98.407625, 97.470125, 97.142, 97.98575, 98.54825,
            100.282625, 102.29825, 102.767, 100.517, 99.86075, 98.970125, 102.767, 96.720125, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:14.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.52648,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:14.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.9545, 105.345125, 102.017, 106.7045, 107.407625, 106.7045, 107.92325, 110.407625, 108.907625,
            107.126375, 103.79825, 105.392, 106.892, 101.782625, 99.2045, 95.642, 96.11075, 97.282625, 97.845125,
            99.767, 102.017, 101.267, 100.142, 99.67325, 98.313875, 102.345125, 96.063875, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:40.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.14967,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:40.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.282625, 118.42325, 114.438875, 109.563875, 109.61075, 106.04825, 105.86075, 105.345125, 103.142,
            100.282625, 98.407625, 98.032625, 97.938875, 98.688875, 97.001375, 96.767, 95.642, 96.813875, 97.938875,
            100.282625, 102.157625, 101.501375, 100.3295, 99.48575, 98.220125, 101.407625, 96.157625, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:06.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.71501,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:06.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.92325, 118.938875, 116.501375, 113.8295, 111.813875, 109.188875, 107.54825, 107.0795, 102.11075,
            100.188875, 99.720125, 99.720125, 98.54825, 98.4545, 101.595125, 97.282625, 96.86075, 96.813875, 97.61075,
            100.470125, 101.970125, 101.642, 100.3295, 99.29825, 97.938875, 101.501375, 96.017, 95.126375,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:30.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.37126,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:30.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.8295, 129.9545, 128.501375, 126.67325, 121.142, 117.29825, 115.376375, 111.017, 108.532625, 104.0795,
            101.126375, 99.813875, 98.595125, 98.688875, 97.517, 96.813875, 96.392, 97.98575, 98.688875, 100.095125,
            102.063875, 101.54825, 100.188875, 99.345125, 98.17325, 101.595125, 96.813875, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:45.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.63351,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:45.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.438875, 117.48575, 116.313875, 113.688875, 110.267, 106.845125, 105.5795, 102.813875, 107.313875,
            126.29825, 119.642, 107.407625, 107.313875, 102.438875, 101.970125, 102.2045, 104.36075, 99.5795, 98.688875,
            101.220125, 102.767, 102.11075, 100.61075, 99.907625, 98.501375, 103.282625, 97.938875, 97.3295,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:49.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.4068,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:49.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.438875, 116.17325, 117.11075, 117.017, 110.407625, 109.517, 108.29825, 111.2045, 105.48575, 101.501375,
            99.626375, 98.92325, 98.4545, 103.282625, 107.92325, 102.86075, 105.720125, 100.892, 101.0795, 101.313875,
            102.5795, 101.73575, 100.3295, 99.5795, 98.36075, 101.73575, 96.063875, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:15.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.76509,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:15.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.392, 125.782625, 122.267, 115.42325, 112.517, 110.54825, 110.0795, 106.563875, 103.845125, 101.4545,
            99.29825, 97.61075, 97.845125, 97.470125, 96.9545, 96.48575, 96.767, 97.79825, 98.126375, 100.23575,
            102.11075, 101.688875, 100.517, 99.86075, 98.595125, 103.42325, 96.438875, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:19.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.67863,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:19.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.720125, 110.688875, 107.220125, 106.001375, 107.36075, 106.42325, 105.907625, 106.142, 102.907625,
            100.42325, 98.92325, 99.392, 99.345125, 98.970125, 98.0795, 96.48575, 96.67325, 97.7045, 98.595125,
            99.813875, 101.970125, 101.595125, 100.376375, 99.907625, 98.54825, 103.3295, 96.5795, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:46.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.66449,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:46.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 116.407625, 112.517, 107.36075, 108.251375, 107.688875, 106.3295, 104.8295, 103.657625,
            111.86075, 114.9545, 108.11075, 100.845125, 100.470125, 98.73575, 99.063875, 100.79825, 99.157625, 99.9545,
            100.376375, 101.876375, 101.688875, 100.3295, 99.720125, 98.126375, 102.017, 96.157625, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:40.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.68504,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:40.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 110.54825, 107.220125, 104.17325, 104.73575, 104.73575, 106.188875, 105.392, 102.017,
            100.751375, 100.751375, 98.407625, 99.063875, 99.29825, 99.48575, 97.095125, 97.79825, 97.470125, 98.54825,
            100.42325, 102.48575, 102.11075, 100.470125, 99.720125, 98.407625, 101.92325, 96.720125, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:59.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.89862,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:59.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.79825, 131.17325, 128.501375, 126.48575, 123.907625, 121.095125, 118.892, 114.2045, 110.501375,
            107.032625, 103.845125, 101.267, 99.813875, 99.532625, 97.657625, 97.376375, 96.157625, 96.5795, 98.032625,
            99.67325, 102.2045, 101.501375, 100.563875, 99.767, 98.0795, 102.251375, 96.251375, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:55.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.72749,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:55.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.220125, 109.095125, 105.251375, 107.313875, 106.23575, 104.642, 106.470125, 105.5795, 103.98575,
            101.688875, 98.642, 98.688875, 97.845125, 98.313875, 98.688875, 99.720125, 98.54825, 97.657625, 98.595125,
            100.04825, 102.157625, 101.8295, 100.517, 99.720125, 98.595125, 102.626375, 96.48575, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:05.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.32767,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:05.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.86075, 131.782625, 129.29825, 123.5795, 122.313875, 118.79825, 117.251375, 114.345125, 111.063875,
            107.782625, 103.563875, 100.001375, 98.501375, 97.79825, 96.9545, 97.04825, 96.5795, 96.720125, 98.032625,
            99.767, 102.2045, 101.595125, 100.470125, 99.48575, 98.73575, 103.517, 96.720125, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:36.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.46855,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:36.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.17325, 119.688875, 117.5795, 112.095125, 112.376375, 108.5795, 108.626375, 106.563875, 105.29825,
            102.767, 101.126375, 103.282625, 103.001375, 100.61075, 99.157625, 98.4545, 97.188875, 98.0795, 98.876375,
            100.98575, 102.532625, 102.67325, 100.845125, 100.42325, 99.392, 103.095125, 97.188875, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:28.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.43271,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:28.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.3295, 127.845125, 124.98575, 123.11075, 119.876375, 117.5795, 114.345125, 109.7045, 105.251375,
            102.532625, 100.095125, 98.313875, 98.595125, 99.9545, 99.767, 97.938875, 97.23575, 97.7045, 98.782625,
            100.61075, 102.157625, 101.876375, 100.23575, 99.48575, 98.220125, 101.970125, 96.48575, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:39.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.25432,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:39.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.907625, 114.29825, 110.73575, 107.782625, 109.142, 109.563875, 106.79825, 105.11075, 102.392,
            100.001375, 100.42325, 100.470125, 98.126375, 98.267, 97.3295, 95.8295, 97.188875, 96.813875, 97.657625,
            100.23575, 102.392, 101.688875, 100.42325, 99.720125, 98.501375, 102.29825, 96.532625, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:26.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.41331,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:26.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 118.751375, 115.563875, 112.3295, 111.720125, 109.892, 108.29825, 109.3295, 105.392, 100.42325,
            98.782625, 98.17325, 97.61075, 98.970125, 98.36075, 97.3295, 97.42325, 98.17325, 99.017, 100.376375,
            102.67325, 102.5795, 100.751375, 99.720125, 99.157625, 103.23575, 97.001375, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:16.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.94063,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:16.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.79825, 122.36075, 119.36075, 116.4545, 113.032625, 110.407625, 110.407625, 108.67325, 108.2045,
            105.67325, 103.3295, 104.595125, 106.142, 100.04825, 99.29825, 97.23575, 96.251375, 97.142, 98.032625,
            99.813875, 101.876375, 101.407625, 100.001375, 99.392, 98.0795, 101.313875, 96.29825, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:43.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.40013,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:43.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.376375, 112.892, 109.001375, 106.61075, 106.563875, 106.3295, 105.813875, 106.892, 103.845125,
            101.876375, 99.11075, 99.720125, 98.595125, 98.8295, 97.61075, 97.42325, 96.48575, 96.9545, 98.220125,
            100.657625, 102.345125, 102.2045, 100.376375, 99.767, 98.407625, 102.251375, 96.67325, 95.54825,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:03.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.56214,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:03.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.86075, 106.42325, 103.42325, 105.345125, 105.063875, 104.73575, 106.23575, 109.938875, 120.345125,
            119.501375, 101.876375, 109.61075, 103.001375, 109.7045, 104.782625, 103.188875, 105.907625, 102.626375,
            98.876375, 100.42325, 102.532625, 102.017, 100.188875, 99.251375, 97.938875, 101.782625, 96.157625,
            95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:29.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.57495,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:29.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.92325, 125.313875, 120.5795, 120.767, 118.938875, 114.532625, 111.251375, 109.376375, 103.142, 101.4545,
            99.11075, 97.61075, 98.36075, 98.8295, 96.767, 97.095125, 96.532625, 98.407625, 98.267, 100.04825,
            102.29825, 101.782625, 100.188875, 99.438875, 98.313875, 102.063875, 96.532625, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:27.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.25261,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:27.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.251375, 127.79825, 122.032625, 114.9545, 113.970125, 111.9545, 110.220125, 107.220125, 104.92325,
            100.845125, 99.29825, 98.73575, 97.7045, 97.892, 97.3295, 97.282625, 96.9545, 97.517, 98.4545, 100.376375,
            102.157625, 101.54825, 100.42325, 99.29825, 98.032625, 101.876375, 96.813875, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:44.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.551056,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:44.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.563875, 108.532625, 105.67325, 106.7045, 107.876375, 108.251375, 108.11075, 106.376375, 103.517,
            116.970125, 118.61075, 105.626375, 106.188875, 105.29825, 103.7045, 100.98575, 101.032625, 98.876375,
            98.501375, 100.23575, 102.157625, 101.595125, 100.517, 99.67325, 98.36075, 101.92325, 96.2045, 95.0795,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:38.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.19979,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:38.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.532625, 116.36075, 111.67325, 109.095125, 109.563875, 107.688875, 105.626375, 104.92325, 101.220125,
            100.188875, 101.126375, 99.813875, 97.892, 98.36075, 97.3295, 96.532625, 96.157625, 96.626375, 97.751375,
            99.813875, 101.92325, 102.251375, 100.563875, 99.813875, 98.36075, 102.2045, 96.29825, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:04.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.94828,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:04.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.095125, 109.04825, 107.36075, 108.9545, 108.438875, 106.892, 108.11075, 108.2045, 105.720125,
            103.376375, 100.095125, 98.782625, 98.595125, 98.0795, 97.3295, 96.438875, 96.48575, 97.42325, 97.42325,
            99.626375, 101.73575, 101.4545, 100.188875, 99.2045, 97.892, 101.876375, 96.392, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:56.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.64817,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:56.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.563875, 112.7045, 108.9545, 108.392, 108.767, 106.517, 107.501375, 107.4545, 103.657625, 100.657625,
            99.29825, 99.063875, 97.517, 97.61075, 96.48575, 96.626375, 96.532625, 97.142, 97.563875, 99.813875,
            102.157625, 101.4545, 100.001375, 99.626375, 98.313875, 102.11075, 96.29825, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:10.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.93459,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:10.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.938875, 110.501375, 108.626375, 104.36075, 106.517, 106.188875, 107.92325, 107.0795, 102.157625,
            99.720125, 98.501375, 99.157625, 98.642, 97.892, 97.79825, 97.79825, 97.23575, 97.845125, 98.0795,
            100.282625, 102.251375, 102.017, 100.282625, 99.626375, 98.4545, 102.5795, 96.5795, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:35.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.93686,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:35.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 125.73575, 125.688875, 122.36075, 117.720125, 117.48575, 114.063875, 108.48575, 105.532625,
            104.17325, 102.9545, 99.345125, 97.892, 98.876375, 97.3295, 97.095125, 96.392, 97.04825, 97.7045, 99.907625,
            102.017, 102.5795, 100.282625, 99.626375, 98.501375, 102.11075, 96.67325, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:35.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.09446,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:35.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.001375, 118.001375, 114.5795, 113.313875, 109.563875, 105.813875, 105.438875, 106.657625, 102.9545,
            100.98575, 100.61075, 101.220125, 101.313875, 99.767, 98.0795, 97.892, 97.282625, 98.4545, 98.688875,
            100.3295, 102.11075, 102.813875, 100.470125, 99.813875, 98.73575, 102.67325, 96.720125, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:58.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.69775,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:37:58.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.251375, 107.4545, 105.813875, 105.720125, 106.376375, 106.001375, 107.54825, 103.657625, 102.626375,
            99.626375, 99.29825, 99.2045, 98.642, 98.407625, 97.095125, 96.5795, 96.157625, 96.907625, 98.17325,
            100.142, 102.2045, 101.970125, 100.470125, 99.86075, 98.782625, 102.48575, 96.345125, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:00.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.78294,
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:38:00.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.17325, 125.267, 120.720125, 116.126375, 115.282625, 112.142, 111.438875, 107.0795, 103.938875,
            100.657625, 101.501375, 105.9545, 100.23575, 100.470125, 98.220125, 97.751375, 97.42325, 97.188875, 97.892,
            100.3295, 102.251375, 101.92325, 100.282625, 99.392, 98.4545, 101.782625, 96.5795, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5333738,
    },
    {
        timestamp: '2025-08-29T22:39:36.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.85117,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:36.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.4545, 124.751375, 120.5795, 115.282625, 114.438875, 112.188875, 110.54825, 107.36075, 104.876375,
            101.92325, 100.470125, 100.61075, 100.04825, 99.017, 97.095125, 97.376375, 97.282625, 98.032625, 98.688875,
            101.267, 102.29825, 102.67325, 100.98575, 100.142, 98.92325, 102.9545, 96.907625, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:57.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.390396,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:57.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.8295, 106.142, 104.0795, 107.0795, 107.782625, 106.79825, 108.017, 107.595125, 103.657625, 102.29825,
            103.7045, 102.907625, 99.86075, 100.001375, 98.032625, 97.892, 97.470125, 96.626375, 97.892, 100.04825,
            102.251375, 101.407625, 100.282625, 99.720125, 98.36075, 102.11075, 95.8295, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:58.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.04858,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:58.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.470125, 102.48575, 102.345125, 105.438875, 104.73575, 103.98575, 107.54825, 105.907625, 101.642,
            100.142, 101.970125, 101.54825, 99.48575, 99.9545, 97.79825, 97.751375, 96.813875, 96.907625, 98.0795,
            99.86075, 102.438875, 101.595125, 100.61075, 100.04825, 98.595125, 102.532625, 96.2045, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:49.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.77113,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:49.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.782625, 126.2045, 123.626375, 118.7045, 118.04825, 115.282625, 113.876375, 109.001375, 106.3295,
            103.892, 100.79825, 99.392, 98.876375, 99.907625, 98.313875, 97.657625, 97.282625, 97.61075, 98.36075,
            100.142, 102.29825, 102.11075, 100.61075, 100.04825, 98.642, 102.720125, 96.438875, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:19.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.65486,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:19.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.438875, 105.392, 103.3295, 104.642, 106.563875, 106.188875, 105.67325, 107.4545, 103.142, 100.517,
            98.782625, 97.61075, 97.282625, 97.7045, 97.3295, 97.095125, 96.5795, 97.563875, 97.79825, 99.86075,
            102.5795, 102.11075, 100.282625, 99.86075, 98.313875, 102.157625, 96.48575, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:26.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.98173,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:26.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.813875, 115.04825, 111.017, 105.48575, 105.67325, 105.48575, 105.29825, 103.61075, 102.392, 98.595125,
            98.17325, 97.563875, 97.142, 98.36075, 96.907625, 96.48575, 96.532625, 97.001375, 97.98575, 100.095125,
            102.251375, 101.8295, 100.657625, 99.813875, 98.73575, 102.392, 96.392, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:40.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.4188,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:40.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.392, 127.001375, 124.095125, 119.267, 119.54825, 115.751375, 112.42325, 109.657625, 105.48575,
            102.29825, 100.845125, 100.470125, 110.92325, 98.36075, 98.36075, 103.3295, 97.142, 97.04825, 98.032625,
            100.376375, 102.345125, 101.688875, 100.282625, 99.813875, 98.17325, 102.392, 96.345125, 95.126375,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:22.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.03579,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:22.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.407625, 110.220125, 107.032625, 105.767, 106.657625, 105.345125, 108.438875, 107.36075, 102.9545,
            100.892, 98.36075, 98.54825, 97.79825, 98.54825, 96.392, 96.767, 95.876375, 97.095125, 97.938875,
            100.095125, 102.11075, 101.876375, 100.188875, 99.157625, 98.17325, 101.642, 96.251375, 95.126375,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:40:01.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.12808,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:40:01.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.4545, 124.751375, 122.0795, 119.126375, 117.017, 113.267, 111.29825, 109.657625, 104.4545, 101.782625,
            100.61075, 101.407625, 98.782625, 100.376375, 97.79825, 97.23575, 96.767, 97.282625, 97.845125, 100.23575,
            102.392, 102.157625, 100.563875, 99.813875, 98.4545, 102.157625, 96.48575, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:55.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.814644,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:55.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.767, 117.2045, 116.0795, 111.063875, 108.67325, 105.29825, 106.095125, 104.73575, 102.86075, 100.517,
            100.282625, 103.282625, 99.626375, 98.642, 97.845125, 97.61075, 97.563875, 97.142, 98.17325, 100.376375,
            102.392, 101.642, 100.001375, 99.29825, 97.892, 101.4545, 96.251375, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:09.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.86934,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:09.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.501375, 109.98575, 107.970125, 105.907625, 104.92325, 105.017, 106.98575, 105.767, 101.54825, 99.157625,
            99.017, 98.313875, 98.4545, 99.11075, 96.813875, 98.782625, 98.220125, 97.095125, 98.313875, 100.7045,
            101.688875, 101.688875, 100.142, 99.532625, 97.938875, 101.407625, 96.438875, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:58.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.91847,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:58.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.376375, 126.392, 124.3295, 118.376375, 113.4545, 113.782625, 112.3295, 109.470125, 106.3295, 102.345125,
            99.9545, 99.29825, 98.0795, 98.688875, 96.438875, 96.48575, 95.970125, 96.345125, 97.470125, 99.907625,
            101.782625, 101.642, 100.04825, 99.251375, 98.0795, 101.501375, 96.29825, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:39.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.01657,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:39.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.438875, 129.720125, 125.876375, 118.188875, 117.29825, 114.11075, 113.36075, 112.470125, 107.8295,
            102.48575, 101.407625, 100.282625, 99.017, 97.23575, 96.392, 96.11075, 95.8295, 96.9545, 97.938875,
            100.188875, 102.063875, 101.782625, 100.563875, 99.626375, 98.17325, 102.2045, 96.345125, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:20.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.09268,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:20.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.517, 131.17325, 125.642, 120.720125, 118.23575, 116.17325, 113.92325, 110.8295, 105.813875, 103.563875,
            100.563875, 99.48575, 98.313875, 98.782625, 97.657625, 97.04825, 96.813875, 97.657625, 98.313875, 99.767,
            102.251375, 102.11075, 100.517, 99.720125, 98.267, 101.970125, 96.251375, 95.17325,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:04.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.78011,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:04.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.767, 117.720125, 114.063875, 111.438875, 109.892, 106.892, 106.751375, 106.001375, 103.188875,
            99.720125, 98.267, 98.782625, 99.11075, 98.8295, 97.282625, 97.938875, 97.42325, 97.42325, 98.36075,
            100.42325, 102.392, 101.54825, 100.563875, 99.67325, 98.407625, 102.157625, 96.626375, 95.407625,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:37.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.79193,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:37.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.86075, 133.79825, 130.188875, 126.017, 123.907625, 120.720125, 115.657625, 114.438875, 111.11075,
            107.032625, 104.126375, 101.8295, 102.2045, 98.970125, 97.845125, 98.0795, 96.767, 97.23575, 98.54825,
            100.61075, 102.017, 102.48575, 100.376375, 99.392, 98.313875, 102.532625, 96.157625, 95.0795,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:50.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.25185,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:50.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.8295, 134.595125, 130.001375, 125.642, 123.11075, 120.48575, 117.907625, 115.3295, 109.751375, 105.9545,
            102.2045, 100.095125, 99.48575, 98.876375, 96.392, 97.79825, 97.095125, 97.376375, 97.7045, 99.720125,
            102.017, 101.73575, 100.282625, 99.438875, 98.54825, 104.0795, 96.720125, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:59.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.4838,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:59.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.98575, 115.470125, 113.36075, 110.126375, 110.876375, 111.767, 108.532625, 105.11075, 102.9545,
            100.79825, 97.98575, 98.407625, 97.845125, 99.67325, 97.04825, 97.095125, 96.2045, 97.04825, 97.7045,
            100.376375, 102.345125, 101.92325, 100.23575, 99.532625, 98.313875, 102.063875, 96.626375, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:21.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.81941,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:21.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.157625, 114.438875, 112.563875, 109.938875, 106.23575, 106.79825, 105.907625, 104.54825, 101.407625,
            100.142, 98.595125, 96.720125, 97.79825, 97.938875, 96.720125, 96.720125, 96.67325, 97.04825, 97.61075,
            99.67325, 101.73575, 101.642, 100.188875, 99.626375, 98.407625, 102.157625, 96.438875, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:24.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.40454,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:24.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.98575, 128.970125, 127.845125, 124.188875, 119.8295, 115.7045, 115.517, 111.345125, 106.845125,
            102.9545, 101.782625, 98.407625, 98.267, 99.626375, 97.7045, 97.517, 97.001375, 97.61075, 98.407625,
            100.61075, 102.251375, 101.970125, 100.3295, 99.438875, 98.642, 102.767, 97.188875, 95.4545,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:05.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.47104,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:05.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.657625, 133.845125, 130.142, 126.392, 125.501375, 124.938875, 121.282625, 117.017, 112.751375,
            108.438875, 103.23575, 101.032625, 99.438875, 98.876375, 97.3295, 97.095125, 97.98575, 102.392, 98.54825,
            100.42325, 102.2045, 101.8295, 100.657625, 100.188875, 99.2045, 103.42325, 96.767, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:38.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.286514,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:38.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.626375, 114.5795, 113.0795, 108.813875, 108.2045, 108.438875, 106.657625, 106.563875, 103.563875,
            100.23575, 99.9545, 99.86075, 99.157625, 97.376375, 96.5795, 96.29825, 95.876375, 96.813875, 97.79825,
            100.42325, 101.876375, 102.157625, 100.517, 99.67325, 98.17325, 101.73575, 96.017, 95.17325,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:45.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.70977,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:45.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.626375, 116.54825, 114.626375, 108.67325, 107.313875, 106.938875, 105.767, 107.126375, 104.642,
            99.532625, 98.501375, 97.657625, 98.688875, 97.7045, 97.001375, 96.907625, 96.67325, 97.001375, 97.657625,
            100.517, 102.29825, 101.642, 100.470125, 99.9545, 98.501375, 102.532625, 96.157625, 95.4545,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:18.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.11916,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:18.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.17325, 117.907625, 116.220125, 112.563875, 107.73575, 105.813875, 107.0795, 106.04825, 103.938875,
            101.313875, 99.626375, 98.54825, 98.4545, 98.876375, 97.517, 97.892, 97.001375, 97.376375, 97.98575,
            100.7045, 102.532625, 102.11075, 100.23575, 99.626375, 98.407625, 102.157625, 96.532625, 95.595125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:59.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.00331,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:59.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.17325, 106.23575, 102.907625, 105.251375, 105.813875, 106.657625, 107.73575, 106.517, 103.563875,
            100.79825, 100.517, 117.2045, 118.98575, 100.7045, 99.626375, 99.392, 99.392, 97.282625, 98.407625, 99.5795,
            102.11075, 101.54825, 100.517, 100.04825, 98.4545, 102.157625, 95.92325, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:29.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.42369,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:29.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.61075, 131.36075, 123.438875, 121.517, 118.938875, 113.54825, 111.532625, 111.438875, 105.67325,
            101.970125, 100.563875, 97.938875, 101.642, 98.407625, 96.720125, 99.11075, 96.345125, 97.001375, 97.845125,
            99.626375, 102.157625, 101.54825, 100.470125, 99.67325, 98.501375, 104.54825, 96.720125, 95.407625,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:28.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.56914,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:28.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.48575, 119.032625, 118.470125, 114.86075, 110.642, 107.92325, 107.126375, 107.17325, 103.188875,
            100.470125, 98.73575, 97.42325, 103.7045, 98.876375, 100.095125, 103.001375, 96.907625, 97.845125,
            98.313875, 99.907625, 101.970125, 101.782625, 100.142, 99.48575, 98.36075, 102.345125, 96.532625, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:11.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.06903,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:11.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.04825, 108.2045, 104.92325, 104.688875, 105.438875, 105.67325, 106.3295, 107.54825, 102.813875,
            101.126375, 99.29825, 98.313875, 98.0795, 99.2045, 97.79825, 97.657625, 96.626375, 97.751375, 98.313875,
            100.42325, 102.720125, 102.251375, 100.470125, 99.626375, 98.220125, 101.92325, 97.001375, 95.501375,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:15.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.01133,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:15.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.720125, 112.751375, 110.126375, 108.532625, 105.345125, 104.313875, 105.626375, 103.892, 102.2045,
            100.42325, 99.9545, 100.282625, 98.032625, 98.17325, 97.142, 97.282625, 96.86075, 98.407625, 98.642,
            100.3295, 102.392, 101.642, 100.470125, 100.04825, 98.501375, 102.11075, 96.251375, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:51.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.94241,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:51.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.157625, 128.688875, 125.688875, 123.813875, 122.54825, 118.470125, 114.063875, 112.23575, 108.2045,
            103.095125, 100.23575, 98.595125, 98.92325, 98.407625, 97.04825, 97.657625, 97.23575, 97.470125, 98.17325,
            100.188875, 102.11075, 101.595125, 100.23575, 99.29825, 97.845125, 101.876375, 96.532625, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:57.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.73856,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:57.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.892, 120.813875, 118.845125, 114.67325, 112.04825, 111.157625, 107.688875, 106.98575, 103.282625,
            101.73575, 99.11075, 99.29825, 99.813875, 100.42325, 98.501375, 97.095125, 97.188875, 96.9545, 98.220125,
            100.282625, 102.157625, 101.595125, 100.282625, 99.48575, 97.938875, 101.313875, 96.2045, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:54.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.34161,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:54.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 124.04825, 120.813875, 116.970125, 112.001375, 109.938875, 109.42325, 107.642, 104.032625,
            100.563875, 99.017, 97.751375, 98.0795, 98.782625, 96.9545, 97.845125, 97.001375, 97.42325, 97.98575,
            100.188875, 102.29825, 101.688875, 100.188875, 99.5795, 98.36075, 102.11075, 96.345125, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:46.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.5219,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:46.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.73575, 104.36075, 101.595125, 103.517, 105.345125, 106.517, 107.0795, 107.876375, 103.563875, 100.04825,
            98.407625, 98.36075, 98.595125, 98.36075, 100.142, 97.188875, 97.142, 97.282625, 98.0795, 99.9545, 102.392,
            102.11075, 100.7045, 100.04825, 98.595125, 102.48575, 96.2045, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:16.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.4067,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:16.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.4545, 119.0795, 115.938875, 110.688875, 107.876375, 107.782625, 104.36075, 105.251375, 100.563875,
            100.79825, 98.642, 98.407625, 106.23575, 99.532625, 96.2045, 98.92325, 98.032625, 97.79825, 98.36075,
            99.9545, 102.157625, 101.36075, 100.376375, 99.813875, 98.4545, 102.345125, 96.157625, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:06.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.76161,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:06.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.720125, 130.98575, 124.98575, 123.345125, 120.626375, 118.23575, 112.657625, 110.17325, 107.267,
            102.532625, 100.095125, 97.98575, 98.0795, 98.17325, 96.720125, 96.345125, 96.2045, 96.67325, 97.845125,
            100.142, 102.157625, 101.54825, 100.142, 99.345125, 98.126375, 101.595125, 96.438875, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:52.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 147.4406,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:52.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            145.3295, 140.595125, 137.4545, 133.001375, 129.813875, 127.470125, 126.345125, 122.782625, 119.92325,
            116.267, 113.313875, 108.907625, 105.063875, 102.345125, 100.142, 98.126375, 97.42325, 97.42325, 98.782625,
            100.23575, 102.392, 101.970125, 100.3295, 99.767, 98.313875, 102.86075, 96.532625, 95.17325,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:55.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.06066,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:55.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.92325, 110.8295, 107.595125, 108.063875, 107.4545, 107.126375, 109.42325, 114.438875, 113.0795,
            103.23575, 101.92325, 102.157625, 100.470125, 98.8295, 98.267, 99.063875, 98.782625, 97.142, 98.267,
            100.001375, 102.251375, 101.501375, 100.282625, 99.48575, 98.17325, 102.017, 95.92325, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:23.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.37874,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:23.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.063875, 133.3295, 129.813875, 127.517, 125.032625, 124.751375, 120.251375, 118.3295, 113.688875,
            108.5795, 105.9545, 102.2045, 99.813875, 99.251375, 98.220125, 98.407625, 98.36075, 97.7045, 98.501375,
            100.142, 102.626375, 101.876375, 100.657625, 99.532625, 98.501375, 102.11075, 96.67325, 95.407625,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:32.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.969444,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:32.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.938875, 119.36075, 116.126375, 112.7045, 109.845125, 106.376375, 104.8295, 106.61075, 102.720125,
            100.23575, 100.282625, 98.36075, 98.220125, 99.017, 97.142, 96.67325, 96.11075, 97.61075, 98.17325,
            100.095125, 102.157625, 102.251375, 100.470125, 100.142, 98.501375, 101.970125, 96.392, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:54.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.787926,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:54.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.392, 103.563875, 101.267, 105.5795, 106.470125, 106.001375, 105.9545, 106.517, 102.532625, 100.61075,
            99.017, 97.376375, 99.063875, 102.29825, 102.438875, 98.8295, 98.407625, 99.9545, 101.73575, 101.8295,
            102.345125, 101.782625, 100.7045, 99.86075, 98.126375, 101.642, 96.2045, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:48.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.47694,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:48.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.345125, 117.2045, 114.345125, 111.2045, 109.892, 107.17325, 106.04825, 107.642, 103.98575, 100.282625,
            98.0795, 99.392, 98.501375, 99.017, 97.938875, 97.517, 97.3295, 97.517, 97.892, 100.188875, 102.532625,
            102.063875, 100.282625, 99.5795, 98.4545, 102.48575, 96.532625, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:10.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.06053,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:10.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.79825, 119.688875, 116.313875, 113.595125, 110.54825, 108.532625, 107.220125, 106.376375, 102.767,
            100.61075, 98.92325, 97.98575, 98.688875, 98.595125, 97.376375, 97.3295, 98.782625, 100.001375, 100.376375,
            100.42325, 102.29825, 102.2045, 100.282625, 99.907625, 98.4545, 102.157625, 96.626375, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:53.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.65271,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:53.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.532625, 124.938875, 121.142, 113.36075, 111.67325, 110.126375, 110.782625, 108.5795, 103.23575,
            102.11075, 100.376375, 98.220125, 98.8295, 98.501375, 98.0795, 97.470125, 97.657625, 97.7045, 97.98575,
            100.04825, 101.876375, 101.313875, 100.376375, 99.5795, 98.313875, 103.142, 96.67325, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:12.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.80089,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:12.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 125.0795, 120.67325, 119.4545, 118.563875, 112.517, 109.188875, 108.29825, 102.392, 100.892,
            98.970125, 97.61075, 99.063875, 98.501375, 98.17325, 98.313875, 97.42325, 97.845125, 99.345125, 100.42325,
            102.813875, 102.29825, 100.517, 100.001375, 98.501375, 102.345125, 96.720125, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:31.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.99164,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:31.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.282625, 121.376375, 117.017, 112.845125, 111.063875, 108.720125, 106.751375, 105.907625, 102.11075,
            99.29825, 99.345125, 101.92325, 105.767, 98.595125, 96.9545, 102.9545, 96.11075, 96.5795, 97.79825,
            100.3295, 102.251375, 101.73575, 100.04825, 99.29825, 97.845125, 101.501375, 96.157625, 95.17325,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:56.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.63929,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:56.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.642, 116.501375, 112.845125, 108.017, 106.470125, 105.251375, 107.501375, 106.282625, 102.2045,
            101.313875, 99.767, 99.345125, 99.48575, 99.67325, 98.17325, 97.42325, 97.001375, 97.79825, 98.8295,
            100.7045, 102.345125, 101.73575, 100.470125, 99.9545, 98.54825, 102.251375, 96.2045, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:42.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.37833,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:42.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.42325, 126.11075, 124.142, 123.2045, 119.54825, 115.751375, 115.282625, 111.720125, 106.23575,
            102.532625, 100.98575, 99.251375, 98.642, 98.54825, 96.720125, 97.7045, 96.720125, 97.095125, 97.892,
            99.9545, 102.11075, 101.688875, 100.23575, 99.626375, 97.98575, 101.501375, 96.67325, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:56.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.33776,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:56.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 115.04825, 112.892, 108.720125, 106.98575, 105.345125, 107.970125, 105.767, 102.532625,
            103.04825, 101.782625, 103.938875, 100.376375, 100.188875, 97.563875, 97.845125, 97.470125, 96.532625,
            97.7045, 99.626375, 101.92325, 101.313875, 100.376375, 99.67325, 98.36075, 101.970125, 96.157625, 95.126375,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:49.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.65262,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:49.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 125.032625, 121.095125, 116.782625, 115.188875, 113.0795, 111.017, 108.017, 105.438875,
            101.501375, 98.8295, 97.517, 97.938875, 99.720125, 97.095125, 97.751375, 96.86075, 97.04825, 98.126375,
            100.282625, 102.11075, 101.313875, 100.42325, 99.813875, 98.4545, 102.2045, 96.438875, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:35.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.05361,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:35.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.157625, 107.92325, 104.0795, 101.220125, 103.04825, 104.876375, 103.98575, 103.42325, 100.3295,
            99.29825, 100.282625, 99.2045, 99.063875, 98.36075, 96.29825, 96.157625, 95.8295, 96.767, 98.267, 100.42325,
            102.392, 102.907625, 100.7045, 99.9545, 98.54825, 102.720125, 95.970125, 95.17325,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:50.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.75275,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:50.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.3295, 128.36075, 126.345125, 123.017, 121.7045, 119.4545, 118.04825, 111.626375, 110.267, 106.61075,
            103.142, 102.2045, 99.907625, 99.345125, 97.3295, 97.517, 97.142, 97.376375, 98.032625, 100.61075,
            102.438875, 102.438875, 100.42325, 99.907625, 98.92325, 103.095125, 96.86075, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:02.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.22714,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:02.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.532625, 135.720125, 132.063875, 126.67325, 127.61075, 123.67325, 119.126375, 116.407625, 113.642,
            108.813875, 105.392, 102.67325, 100.563875, 100.42325, 100.001375, 97.892, 97.001375, 98.36075, 98.501375,
            101.126375, 101.73575, 101.313875, 100.04825, 99.48575, 98.126375, 101.970125, 96.345125, 95.0795,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:47.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.70283,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:47.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.61075, 114.9545, 111.29825, 109.04825, 106.3295, 105.345125, 106.657625, 104.876375, 101.220125,
            99.532625, 99.438875, 106.04825, 97.517, 99.532625, 97.938875, 97.42325, 98.688875, 97.001375, 98.032625,
            99.813875, 102.29825, 101.8295, 100.79825, 99.9545, 98.642, 102.907625, 96.063875, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:30.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.79094,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:30.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.532625, 127.001375, 125.407625, 123.345125, 119.595125, 115.095125, 110.501375, 106.3295, 103.376375,
            100.282625, 101.032625, 98.501375, 97.376375, 99.5795, 97.657625, 97.376375, 96.392, 97.517, 98.032625,
            100.001375, 102.29825, 101.36075, 100.001375, 99.67325, 97.98575, 101.73575, 96.157625, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:01.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.24448,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:01.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.142, 129.9545, 125.92325, 126.67325, 123.767, 124.282625, 120.017, 117.29825, 113.8295, 108.438875,
            108.157625, 102.251375, 101.92325, 101.126375, 98.876375, 98.0795, 97.845125, 97.98575, 98.595125, 100.517,
            102.392, 101.8295, 100.61075, 100.282625, 98.54825, 103.095125, 96.67325, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:48.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.01558,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:48.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.7045, 113.92325, 110.0795, 110.220125, 107.407625, 106.79825, 106.938875, 106.61075, 101.876375,
            100.892, 100.938875, 103.23575, 97.657625, 97.376375, 97.142, 97.563875, 96.86075, 97.23575, 97.79825,
            99.86075, 102.345125, 102.063875, 100.657625, 100.001375, 98.54825, 102.438875, 96.438875, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:17.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.14507,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:17.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.767, 131.313875, 128.220125, 125.267, 124.001375, 119.17325, 113.407625, 112.142, 108.2045, 103.98575,
            100.142, 98.54825, 98.782625, 99.392, 97.7045, 97.470125, 96.86075, 97.938875, 98.267, 100.23575, 102.392,
            102.345125, 100.42325, 99.813875, 98.595125, 102.345125, 96.67325, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:07.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.974915,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:07.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.0795, 119.54825, 115.095125, 111.392, 108.5795, 106.7045, 107.407625, 106.142, 101.782625, 100.61075,
            97.98575, 98.73575, 99.017, 99.767, 97.61075, 97.892, 97.563875, 98.267, 98.501375, 100.79825, 102.251375,
            102.017, 100.657625, 99.392, 98.642, 101.782625, 96.813875, 95.4545,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:52.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.55293,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:52.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.188875, 129.532625, 124.23575, 120.9545, 119.970125, 118.98575, 114.017, 111.907625, 108.9545,
            102.626375, 102.11075, 99.48575, 99.48575, 98.54825, 97.282625, 97.892, 96.626375, 97.892, 98.595125,
            100.751375, 102.720125, 102.532625, 100.7045, 100.23575, 98.595125, 102.907625, 97.095125, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:51.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.4376,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:51.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.54825, 126.2045, 126.345125, 124.79825, 119.4545, 115.001375, 116.4545, 111.532625, 105.9545,
            102.532625, 100.142, 99.438875, 98.642, 99.9545, 97.79825, 96.626375, 96.017, 97.04825, 98.0795, 100.23575,
            102.392, 102.017, 100.376375, 99.67325, 98.220125, 101.970125, 96.438875, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:44.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.26272,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:44.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.001375, 109.095125, 106.657625, 107.126375, 105.345125, 104.92325, 106.517, 105.907625, 102.251375,
            100.376375, 99.392, 98.970125, 98.876375, 101.8295, 97.517, 97.563875, 99.11075, 97.188875, 98.73575,
            100.7045, 102.767, 101.970125, 100.376375, 99.720125, 98.54825, 102.5795, 96.48575, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:53.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.4631,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:53.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.907625, 120.251375, 115.657625, 112.7045, 109.7045, 106.04825, 107.407625, 108.11075, 103.001375,
            100.001375, 99.2045, 98.8295, 98.8295, 100.751375, 103.845125, 100.517, 101.8295, 100.470125, 103.376375,
            102.11075, 102.48575, 101.782625, 100.3295, 99.48575, 98.0795, 101.4545, 96.157625, 95.36075,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:00.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.734474,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:00.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.92325, 111.2045, 107.970125, 107.267, 108.11075, 107.032625, 108.157625, 107.4545, 104.36075, 101.8295,
            98.970125, 98.8295, 99.907625, 101.220125, 97.751375, 97.7045, 96.720125, 97.142, 98.688875, 100.98575,
            102.532625, 102.157625, 100.23575, 99.5795, 98.313875, 102.157625, 96.29825, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:13.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.369865,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:13.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.36075, 119.642, 116.73575, 112.79825, 109.188875, 106.751375, 106.470125, 107.032625, 103.001375,
            100.188875, 99.29825, 98.4545, 105.67325, 98.54825, 96.86075, 98.17325, 96.392, 97.563875, 98.267,
            100.04825, 102.063875, 101.876375, 100.42325, 99.9545, 98.642, 102.438875, 96.251375, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:14.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.34485,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:14.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.532625, 120.9545, 115.845125, 112.095125, 111.67325, 109.095125, 109.376375, 105.9545, 102.532625,
            99.9545, 98.970125, 98.313875, 97.751375, 98.267, 97.79825, 97.517, 97.142, 97.3295, 98.407625, 100.376375,
            102.345125, 102.29825, 100.61075, 100.23575, 98.782625, 102.392, 96.626375, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:55.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.632935,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:38:55.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.5795, 106.98575, 104.407625, 105.720125, 104.501375, 104.54825, 107.267, 106.42325, 102.438875,
            99.907625, 97.42325, 98.220125, 98.73575, 98.595125, 97.188875, 97.095125, 96.907625, 97.42325, 98.220125,
            100.517, 102.2045, 101.73575, 100.282625, 99.626375, 98.313875, 101.92325, 96.251375, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:08.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.47849,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:08.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.392, 130.845125, 124.98575, 123.767, 119.8295, 115.7045, 113.032625, 111.907625, 107.595125, 104.595125,
            102.157625, 99.720125, 99.720125, 99.86075, 98.032625, 97.938875, 98.220125, 97.23575, 97.98575, 100.563875,
            102.48575, 101.8295, 100.3295, 99.5795, 98.267, 102.438875, 96.67325, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:43.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.81801,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:43.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.86075, 123.9545, 121.095125, 119.0795, 115.188875, 112.845125, 110.970125, 107.876375, 104.126375,
            101.267, 99.532625, 99.532625, 98.595125, 105.626375, 96.392, 98.17325, 99.720125, 98.595125, 97.98575,
            100.04825, 102.251375, 101.36075, 100.282625, 99.532625, 98.126375, 101.54825, 96.2045, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:41.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.30705,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:41.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.54825, 121.751375, 117.29825, 119.92325, 112.79825, 109.470125, 108.251375, 106.04825, 101.73575,
            99.5795, 98.54825, 98.220125, 100.892, 98.17325, 96.5795, 97.517, 96.063875, 96.813875, 97.79825, 100.23575,
            101.782625, 101.4545, 100.04825, 99.438875, 98.267, 102.438875, 96.2045, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:33.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.06576,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:33.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.938875, 115.517, 112.04825, 109.98575, 107.407625, 106.657625, 105.86075, 107.73575, 102.11075,
            99.532625, 99.907625, 98.54825, 98.92325, 98.688875, 96.767, 96.392, 96.017, 97.42325, 97.79825, 99.532625,
            101.73575, 101.970125, 100.142, 99.5795, 98.407625, 102.157625, 96.29825, 95.220125,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:34.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.255646,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:34.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.48575, 115.845125, 112.563875, 107.688875, 108.157625, 105.48575, 106.282625, 106.142, 103.001375,
            101.267, 100.61075, 99.29825, 99.063875, 98.54825, 96.392, 97.095125, 96.017, 97.04825, 97.7045, 100.23575,
            102.063875, 102.532625, 100.3295, 99.767, 98.688875, 102.392, 96.2045, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:01.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.01462,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:01.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.970125, 120.29825, 117.345125, 113.876375, 110.642, 108.532625, 109.001375, 108.29825, 103.563875,
            100.3295, 98.595125, 98.8295, 99.29825, 100.3295, 97.79825, 97.001375, 96.392, 97.282625, 97.892,
            100.188875, 101.92325, 101.4545, 100.23575, 99.392, 98.126375, 102.29825, 96.251375, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:25.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.53877,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:25.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.907625, 113.4545, 111.251375, 108.063875, 107.126375, 106.517, 105.532625, 104.4545, 100.657625, 99.767,
            97.98575, 97.42325, 105.157625, 105.251375, 97.657625, 97.938875, 100.23575, 98.032625, 98.126375,
            100.376375, 102.532625, 101.73575, 100.3295, 99.67325, 98.0795, 101.876375, 96.813875, 95.267,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:03.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.16606,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:03.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.86075, 129.345125, 124.001375, 119.54825, 117.5795, 114.767, 114.767, 109.892, 107.36075, 103.095125,
            99.5795, 99.86075, 99.626375, 99.767, 97.892, 96.907625, 96.813875, 97.04825, 97.938875, 100.657625,
            102.251375, 102.017, 100.188875, 99.5795, 98.220125, 102.063875, 96.438875, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:27.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.69703,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:39:27.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.5795, 112.3295, 108.9545, 105.626375, 105.67325, 104.73575, 105.157625, 105.767, 103.095125, 99.438875,
            98.36075, 97.188875, 97.845125, 98.0795, 97.282625, 97.3295, 97.142, 97.845125, 98.0795, 100.188875,
            102.157625, 102.251375, 100.470125, 99.767, 98.407625, 102.157625, 96.767, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:40:00.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.81577,
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:40:00.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.92325, 125.36075, 120.9545, 119.595125, 118.095125, 113.17325, 110.595125, 108.345125, 107.54825,
            109.845125, 112.282625, 114.11075, 103.001375, 103.79825, 101.4545, 99.063875, 99.392, 97.79825, 98.0795,
            100.04825, 101.782625, 101.407625, 100.61075, 99.86075, 98.501375, 102.017, 96.11075, 95.313875,
        ],
        latitude: 37.4405833,
        longitude: -122.5333728,
    },
    {
        timestamp: '2025-08-29T22:40:38.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.15552,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:38.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.720125, 122.73575, 118.3295, 115.79825, 112.376375, 108.626375, 107.688875, 106.04825, 103.98575,
            99.438875, 99.29825, 101.876375, 110.8295, 98.595125, 102.11075, 103.23575, 100.282625, 105.157625,
            103.095125, 100.79825, 102.532625, 102.345125, 100.42325, 99.67325, 98.782625, 102.907625, 96.48575,
            95.17325,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:22.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.10815,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:22.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.157625, 133.3295, 126.9545, 122.4545, 121.376375, 120.767, 117.392, 114.11075, 110.407625, 105.67325,
            102.063875, 98.36075, 99.345125, 99.392, 97.23575, 98.54825, 97.751375, 98.0795, 98.17325, 100.3295,
            102.5795, 102.2045, 100.563875, 100.001375, 98.54825, 103.517, 96.907625, 95.17325,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:26.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.80444,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:26.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.157625, 131.17325, 129.392, 125.17325, 121.142, 116.688875, 115.376375, 107.782625, 109.282625,
            104.782625, 101.407625, 98.36075, 98.4545, 99.017, 96.813875, 97.79825, 97.095125, 97.892, 98.4545, 99.9545,
            101.92325, 101.73575, 100.3295, 99.392, 98.126375, 101.4545, 96.345125, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:12.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.06277,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:12.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.220125, 128.267, 125.4545, 122.54825, 119.970125, 115.892, 111.86075, 111.67325, 106.98575, 105.86075,
            100.845125, 100.04825, 99.2045, 100.095125, 98.267, 98.642, 97.7045, 97.845125, 98.92325, 100.7045,
            102.67325, 102.017, 100.42325, 100.142, 98.73575, 102.5795, 96.907625, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:11.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.278,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:11.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.04825, 136.376375, 135.157625, 127.188875, 122.876375, 122.17325, 119.17325, 115.376375, 112.23575,
            110.54825, 122.595125, 103.42325, 103.98575, 110.17325, 98.8295, 105.9545, 103.98575, 101.595125,
            100.657625, 101.220125, 102.29825, 101.73575, 100.470125, 99.48575, 98.642, 102.11075, 96.767, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:16.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.74889,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:16.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 127.001375, 125.220125, 121.42325, 120.67325, 114.48575, 113.688875, 118.61075, 106.938875,
            103.845125, 108.532625, 101.032625, 99.9545, 101.501375, 98.032625, 98.126375, 97.42325, 98.267, 98.0795,
            99.9545, 102.392, 101.92325, 100.282625, 99.9545, 98.54825, 101.970125, 96.017, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:34.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.300125,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:34.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.688875, 111.5795, 107.17325, 105.157625, 105.9545, 105.157625, 106.095125, 105.11075, 102.48575,
            101.73575, 99.720125, 101.642, 102.157625, 101.970125, 98.92325, 99.345125, 98.595125, 98.876375, 99.86075,
            100.095125, 101.8295, 102.5795, 100.657625, 100.42325, 98.782625, 102.813875, 96.767, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:16.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.435555,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:16.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.86075, 121.188875, 119.407625, 114.626375, 111.017, 109.282625, 108.157625, 111.532625, 103.188875,
            105.017, 101.407625, 97.657625, 98.313875, 99.11075, 97.42325, 97.61075, 97.23575, 97.61075, 98.36075,
            100.657625, 102.345125, 102.157625, 100.282625, 99.813875, 98.17325, 101.73575, 96.813875, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:09.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.21199,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:09.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.563875, 111.67325, 109.470125, 107.267, 106.7045, 106.657625, 107.220125, 108.2045, 103.188875,
            101.595125, 117.813875, 127.095125, 119.220125, 104.032625, 112.751375, 103.657625, 111.626375, 103.892,
            100.7045, 100.751375, 102.720125, 102.2045, 100.79825, 100.282625, 98.73575, 102.907625, 96.29825,
            95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:44.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.17233,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:44.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.642, 129.5795, 128.220125, 125.642, 122.73575, 119.73575, 114.626375, 113.54825, 108.720125, 107.126375,
            102.813875, 101.267, 100.142, 99.345125, 98.8295, 98.782625, 98.4545, 99.48575, 98.407625, 100.517, 102.392,
            102.29825, 100.3295, 99.48575, 98.36075, 101.970125, 96.438875, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:37.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.02337,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:37.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.5795, 110.8295, 107.032625, 106.517, 105.626375, 105.392, 107.4545, 106.892, 110.4545, 101.313875,
            100.657625, 99.48575, 99.813875, 100.3295, 98.501375, 97.79825, 97.095125, 101.688875, 98.876375, 99.67325,
            101.970125, 102.626375, 100.3295, 99.67325, 98.407625, 102.345125, 96.063875, 95.126375,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:14.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.842636,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:14.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.220125, 113.220125, 108.48575, 106.563875, 105.767, 105.29825, 106.517, 106.517, 104.0795, 100.23575,
            100.095125, 100.892, 100.563875, 100.188875, 98.688875, 98.126375, 97.376375, 98.126375, 99.017, 100.845125,
            101.970125, 101.501375, 100.3295, 99.48575, 98.36075, 101.73575, 96.720125, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:04.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.70417,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:04.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 117.251375, 114.2045, 109.001375, 108.9545, 109.23575, 109.79825, 108.438875, 105.063875,
            111.907625, 106.563875, 104.0795, 100.563875, 101.8295, 98.36075, 97.657625, 97.3295, 97.42325, 98.4545,
            100.23575, 102.2045, 101.501375, 100.7045, 99.5795, 98.501375, 102.251375, 96.2045, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:31.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.51509,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:31.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.595125, 119.126375, 115.563875, 114.48575, 112.61075, 108.438875, 106.001375, 106.751375, 102.017,
            99.392, 97.845125, 103.3295, 104.4545, 99.532625, 97.282625, 97.892, 98.688875, 97.938875, 98.36075,
            100.563875, 102.345125, 102.063875, 100.376375, 100.001375, 98.36075, 102.29825, 96.438875, 95.17325,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:48.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.32076,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:48.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.0795, 104.4545, 104.54825, 104.267, 105.063875, 105.063875, 119.73575, 116.313875, 102.5795, 121.3295,
            112.517, 107.876375, 101.17325, 101.0795, 99.2045, 100.470125, 100.04825, 98.92325, 98.970125, 100.845125,
            102.29825, 101.73575, 100.188875, 100.001375, 99.345125, 102.67325, 96.438875, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:05.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.69043,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:05.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.5795, 121.04825, 117.9545, 114.48575, 110.73575, 110.220125, 109.563875, 111.5795, 107.970125,
            121.751375, 113.73575, 106.142, 104.8295, 104.17325, 101.970125, 105.345125, 105.9545, 102.11075,
            101.501375, 103.42325, 103.3295, 101.8295, 100.61075, 100.04825, 98.73575, 102.438875, 96.345125, 95.4545,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:02.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.776566,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:02.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.470125, 103.98575, 99.5795, 103.7045, 106.42325, 107.970125, 106.7045, 118.98575, 121.42325, 113.032625,
            108.48575, 108.392, 103.04825, 102.157625, 98.8295, 101.876375, 98.501375, 99.2045, 99.67325, 100.7045,
            102.532625, 101.73575, 100.657625, 100.001375, 98.73575, 102.67325, 96.29825, 95.126375,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:23.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.9912,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:23.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.36075, 127.938875, 124.79825, 121.3295, 119.642, 117.2045, 110.876375, 108.063875, 105.29825,
            101.688875, 99.48575, 98.313875, 98.17325, 100.095125, 97.751375, 97.751375, 97.7045, 98.032625, 98.17325,
            100.142, 102.251375, 102.11075, 100.470125, 99.532625, 98.407625, 101.595125, 96.532625, 95.407625,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:45.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.869576,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:45.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.563875, 118.095125, 114.251375, 111.626375, 110.0795, 107.267, 106.188875, 112.79825, 112.845125,
            111.626375, 104.0795, 103.001375, 99.907625, 102.157625, 100.095125, 102.29825, 98.642, 99.48575, 98.642,
            100.3295, 102.532625, 101.782625, 100.376375, 99.532625, 98.36075, 103.188875, 96.5795, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:02.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.74158,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:02.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.063875, 119.642, 115.517, 111.907625, 109.845125, 108.251375, 107.36075, 107.0795, 103.3295, 101.642,
            101.267, 100.845125, 99.532625, 100.470125, 98.782625, 97.61075, 96.86075, 97.23575, 98.267, 100.751375,
            102.2045, 101.36075, 100.188875, 99.67325, 98.4545, 101.92325, 96.2045, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:36.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.26312,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:36.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.392, 128.36075, 128.126375, 124.188875, 119.313875, 118.7045, 114.9545, 113.54825, 115.095125,
            105.063875, 101.407625, 99.392, 100.04825, 98.642, 97.845125, 98.126375, 96.86075, 97.517, 99.017, 100.3295,
            102.017, 102.5795, 100.79825, 100.23575, 98.970125, 102.767, 96.5795, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:30.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.8262,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:30.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.23575, 126.5795, 122.17325, 119.688875, 116.267, 112.751375, 108.86075, 120.67325, 111.251375, 103.7045,
            105.626375, 97.938875, 98.595125, 100.188875, 97.470125, 97.845125, 97.376375, 97.04825, 97.98575,
            100.376375, 101.8295, 101.126375, 99.86075, 99.392, 97.751375, 101.407625, 96.11075, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:21.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.933624,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:21.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.032625, 114.48575, 110.4545, 107.876375, 108.063875, 106.095125, 107.501375, 107.032625, 103.79825,
            99.907625, 98.782625, 104.54825, 97.98575, 98.688875, 97.282625, 97.657625, 97.142, 98.17325, 98.501375,
            100.142, 102.251375, 101.688875, 100.470125, 100.142, 98.73575, 103.04825, 96.392, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:57.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.24773,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:57.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 122.0795, 118.938875, 118.188875, 115.470125, 113.267, 109.42325, 107.970125, 103.892,
            100.938875, 99.907625, 115.7045, 103.376375, 100.7045, 110.313875, 99.017, 105.438875, 104.501375,
            104.220125, 102.5795, 103.376375, 102.345125, 100.892, 99.720125, 98.73575, 102.48575, 96.5795, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:42.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.36069,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:42.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.188875, 125.36075, 120.907625, 120.017, 117.345125, 112.7045, 110.17325, 109.188875, 104.126375,
            100.188875, 100.3295, 99.29825, 98.970125, 99.5795, 96.86075, 97.282625, 97.04825, 97.7045, 98.17325,
            100.282625, 102.11075, 101.54825, 99.9545, 99.345125, 98.032625, 101.501375, 96.438875, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:18.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.157974,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:18.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.79825, 108.532625, 104.73575, 102.907625, 104.970125, 104.970125, 104.970125, 104.688875, 101.54825,
            99.392, 99.626375, 98.970125, 98.970125, 99.720125, 98.267, 98.642, 97.98575, 98.407625, 99.157625,
            100.42325, 102.67325, 102.345125, 100.7045, 100.42325, 98.970125, 103.095125, 97.376375, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:27.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.95842,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:27.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.7045, 123.063875, 118.657625, 117.2045, 112.657625, 110.73575, 109.98575, 107.595125, 103.3295,
            100.657625, 99.907625, 97.892, 98.782625, 99.720125, 96.345125, 97.845125, 98.126375, 98.267, 98.782625,
            100.563875, 102.29825, 101.782625, 100.563875, 99.5795, 98.126375, 102.345125, 96.438875, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:07.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.89498,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:07.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.892, 114.48575, 109.188875, 107.36075, 107.8295, 104.876375, 107.220125, 106.23575, 104.220125,
            107.782625, 104.126375, 98.73575, 104.4545, 99.626375, 97.563875, 98.970125, 97.23575, 98.0795, 98.92325,
            102.063875, 102.813875, 102.345125, 100.751375, 100.23575, 98.92325, 103.23575, 96.48575, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:43.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.18657,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:43.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.86075, 125.032625, 122.126375, 119.267, 115.892, 114.86075, 113.73575, 108.251375, 105.29825,
            102.063875, 99.48575, 99.86075, 98.92325, 99.157625, 96.813875, 97.001375, 96.5795, 97.282625, 98.267,
            100.23575, 102.29825, 101.36075, 100.095125, 99.251375, 98.126375, 101.73575, 96.29825, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:40.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.95013,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:40.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.892, 122.267, 119.313875, 115.938875, 114.48575, 112.79825, 108.626375, 106.188875, 103.001375,
            100.845125, 99.017, 99.2045, 103.376375, 98.595125, 97.23575, 98.126375, 98.267, 98.17325, 99.813875,
            100.470125, 102.626375, 102.063875, 100.845125, 99.767, 98.642, 102.67325, 97.095125, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:47.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.208084,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:47.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.876375, 113.313875, 107.8295, 107.36075, 108.345125, 106.188875, 107.8295, 109.61075, 103.188875,
            106.142, 114.438875, 102.626375, 100.563875, 101.688875, 100.188875, 99.438875, 99.67325, 101.313875,
            99.345125, 100.282625, 102.157625, 101.73575, 100.42325, 100.04825, 98.54825, 102.251375, 96.29825,
            95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:13.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.56404,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:13.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.907625, 110.54825, 106.42325, 103.845125, 104.313875, 105.157625, 105.2045, 107.313875, 101.73575,
            101.313875, 100.42325, 99.48575, 100.142, 99.157625, 99.017, 97.79825, 96.767, 97.938875, 98.220125,
            100.23575, 102.2045, 101.688875, 100.517, 99.907625, 98.54825, 102.017, 96.626375, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:15.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.92607,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:15.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.517, 132.29825, 128.8295, 127.188875, 122.688875, 119.0795, 114.392, 112.938875, 107.642, 105.5795,
            103.3295, 100.282625, 98.8295, 98.92325, 97.470125, 97.095125, 96.9545, 97.095125, 98.17325, 100.095125,
            102.251375, 101.782625, 100.42325, 99.720125, 97.938875, 102.2045, 96.767, 95.407625,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:10.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.23724,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:10.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 125.92325, 122.970125, 119.4545, 117.063875, 115.657625, 112.657625, 109.517, 106.095125,
            104.54825, 105.017, 102.720125, 103.751375, 100.04825, 97.3295, 97.470125, 97.61075, 98.0795, 99.251375,
            103.04825, 102.767, 102.157625, 100.751375, 100.23575, 98.688875, 102.532625, 96.392, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:03.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.14484,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:03.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.313875, 119.73575, 111.11075, 106.3295, 105.67325, 105.5795, 103.938875, 103.517, 100.938875, 99.9545,
            100.517, 102.392, 99.345125, 100.7045, 98.0795, 98.313875, 97.563875, 97.79825, 98.4545, 100.282625,
            101.8295, 101.73575, 100.142, 99.720125, 98.54825, 102.626375, 96.29825, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:13.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.98002,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:13.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.2045, 119.267, 115.845125, 114.157625, 111.86075, 106.61075, 106.23575, 111.438875, 103.42325,
            105.48575, 102.063875, 98.73575, 99.2045, 100.23575, 99.063875, 97.938875, 99.251375, 98.032625, 98.54825,
            100.376375, 102.67325, 102.720125, 100.517, 99.767, 98.407625, 102.48575, 96.767, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:41.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.2276,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:41.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.532625, 128.8295, 126.017, 123.438875, 121.98575, 117.720125, 117.063875, 111.907625, 108.157625,
            104.313875, 100.282625, 99.5795, 108.626375, 98.595125, 96.907625, 101.92325, 98.501375, 106.095125, 99.767,
            100.98575, 102.767, 102.438875, 100.563875, 99.626375, 98.73575, 105.251375, 97.470125, 95.642,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:01.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.14118,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:01.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.313875, 110.267, 108.157625, 106.657625, 104.970125, 103.751375, 105.251375, 114.767, 107.220125,
            102.157625, 99.720125, 99.767, 102.720125, 103.42325, 97.470125, 100.095125, 97.517, 98.73575, 99.29825,
            101.876375, 102.48575, 101.782625, 100.42325, 99.9545, 98.501375, 102.11075, 96.2045, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:24.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.32567,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:24.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.92325, 125.642, 120.67325, 117.251375, 113.501375, 108.392, 107.54825, 106.188875, 102.532625,
            98.782625, 97.892, 97.845125, 98.126375, 99.438875, 96.813875, 97.282625, 97.142, 98.313875, 98.36075,
            100.470125, 102.2045, 102.063875, 100.657625, 100.001375, 98.54825, 102.11075, 96.5795, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:48.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.05919,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:48.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.032625, 128.782625, 125.032625, 120.907625, 119.8295, 117.767, 115.79825, 109.563875, 105.9545,
            118.938875, 103.657625, 106.188875, 101.54825, 100.142, 98.220125, 98.970125, 98.032625, 98.313875,
            98.92325, 100.657625, 102.392, 102.017, 100.23575, 99.813875, 98.4545, 102.2045, 97.04825, 95.4545,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:32.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.903496,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:32.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.3295, 115.98575, 113.267, 110.407625, 108.11075, 106.001375, 106.845125, 106.42325, 101.782625,
            100.3295, 99.392, 97.188875, 99.392, 100.470125, 97.61075, 97.563875, 97.188875, 97.79825, 98.17325,
            100.142, 102.345125, 101.782625, 100.23575, 99.86075, 98.407625, 102.2045, 96.29825, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:19.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.80873,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:19.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.267, 109.376375, 106.7045, 105.5795, 104.54825, 104.54825, 106.79825, 105.67325, 106.79825, 97.98575,
            100.751375, 99.157625, 99.438875, 100.001375, 98.220125, 97.376375, 97.751375, 98.36075, 98.73575, 100.3295,
            102.157625, 101.92325, 100.3295, 99.9545, 98.54825, 102.5795, 96.720125, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:14.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.4243,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:14.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.92325, 137.73575, 134.407625, 125.92325, 124.095125, 121.61075, 117.626375, 115.845125, 111.532625,
            109.04825, 105.017, 107.032625, 102.438875, 100.751375, 98.4545, 98.267, 100.892, 97.61075, 98.126375,
            100.282625, 102.017, 101.36075, 100.23575, 99.720125, 98.4545, 102.251375, 96.2045, 95.17325,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:33.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.56738,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:33.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.938875, 108.767, 104.73575, 106.517, 109.470125, 108.67325, 108.017, 120.438875, 107.8295, 110.642,
            107.313875, 100.23575, 100.23575, 100.04825, 97.3295, 98.642, 98.36075, 98.220125, 99.157625, 100.42325,
            102.532625, 102.157625, 100.845125, 100.095125, 98.876375, 103.04825, 96.345125, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:06.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.87914,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:06.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.376375, 105.626375, 101.92325, 103.845125, 105.017, 105.2045, 107.595125, 106.98575, 103.376375,
            100.142, 99.48575, 98.595125, 99.626375, 98.8295, 98.126375, 97.751375, 96.767, 97.282625, 98.313875,
            100.376375, 102.345125, 102.157625, 100.376375, 99.907625, 98.54825, 102.438875, 96.48575, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:51.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.872894,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:51.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.04825, 111.67325, 109.61075, 105.67325, 104.8295, 104.642, 106.376375, 104.313875, 101.126375, 99.767,
            99.626375, 100.42325, 97.98575, 98.220125, 97.376375, 96.813875, 97.563875, 97.04825, 98.267, 100.282625,
            102.532625, 102.063875, 100.42325, 99.907625, 98.4545, 102.11075, 95.970125, 95.17325,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:20.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.673225,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:20.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.392, 114.29825, 110.501375, 106.517, 104.032625, 102.907625, 105.251375, 105.5795, 101.688875, 98.8295,
            98.54825, 103.42325, 98.92325, 100.04825, 99.392, 101.407625, 100.23575, 98.313875, 98.8295, 100.517,
            102.392, 101.970125, 100.563875, 100.23575, 98.36075, 102.532625, 96.251375, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:09.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.59746,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:09.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.42325, 119.4545, 115.657625, 112.282625, 109.001375, 106.892, 106.517, 106.04825, 100.563875, 99.48575,
            98.407625, 96.86075, 98.267, 99.48575, 97.42325, 97.42325, 96.5795, 97.282625, 98.032625, 99.720125,
            102.11075, 101.73575, 100.282625, 99.67325, 98.54825, 102.157625, 96.345125, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:54.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.2658,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:54.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.767, 115.142, 109.657625, 108.345125, 109.142, 107.0795, 109.376375, 108.720125, 104.17325, 100.376375,
            100.095125, 99.251375, 98.8295, 99.157625, 97.04825, 97.095125, 96.9545, 97.04825, 98.126375, 99.9545,
            102.438875, 102.251375, 101.126375, 100.142, 98.642, 102.767, 96.11075, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:25.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.66914,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:25.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.48575, 131.54825, 126.345125, 122.267, 119.17325, 115.61075, 113.8295, 111.626375, 106.938875,
            105.063875, 100.892, 98.0795, 99.438875, 98.876375, 96.720125, 97.657625, 97.142, 97.751375, 98.501375,
            100.42325, 102.438875, 101.876375, 100.42325, 99.67325, 98.642, 103.095125, 96.767, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:29.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.96907,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:29.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.126375, 135.9545, 134.36075, 130.79825, 129.48575, 125.595125, 121.376375, 121.376375, 117.813875,
            114.626375, 109.7045, 106.04825, 102.907625, 102.11075, 98.4545, 97.79825, 97.142, 97.7045, 98.220125,
            100.657625, 102.392, 101.970125, 100.282625, 99.532625, 98.313875, 103.04825, 96.48575, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:35.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.93048,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:35.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.29825, 115.04825, 111.29825, 111.2045, 108.11075, 106.376375, 106.282625, 106.188875, 102.392,
            99.813875, 98.267, 97.845125, 98.782625, 103.04825, 96.5795, 96.9545, 97.517, 97.7045, 99.86075, 100.001375,
            101.8295, 102.48575, 100.42325, 99.86075, 98.782625, 102.813875, 96.251375, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:00.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.8623,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:00.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 124.657625, 124.98575, 125.595125, 118.845125, 116.782625, 112.79825, 111.813875, 106.751375,
            103.23575, 100.79825, 98.876375, 99.532625, 99.813875, 96.907625, 96.907625, 97.23575, 97.42325, 98.54825,
            100.376375, 102.157625, 101.782625, 100.517, 99.5795, 98.126375, 101.8295, 96.251375, 95.126375,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:05.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.58422,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:05.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.642, 116.407625, 112.7045, 109.563875, 107.17325, 105.063875, 104.220125, 105.157625, 102.063875,
            100.001375, 99.29825, 98.407625, 98.407625, 99.532625, 97.7045, 96.9545, 97.001375, 97.470125, 98.54825,
            100.188875, 102.251375, 101.92325, 100.282625, 99.626375, 98.313875, 101.876375, 96.29825, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:06.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.3401,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:06.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.157625, 124.470125, 121.142, 118.23575, 123.5795, 118.98575, 113.4545, 111.767, 105.907625, 116.407625,
            105.532625, 102.48575, 100.517, 102.251375, 98.8295, 98.4545, 98.032625, 98.970125, 98.0795, 100.376375,
            102.532625, 102.017, 100.61075, 100.04825, 98.688875, 102.767, 96.392, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:08.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.82986,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:08.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.876375, 125.407625, 123.813875, 119.032625, 113.313875, 113.126375, 111.29825, 109.563875, 103.892,
            101.0795, 99.720125, 97.892, 98.407625, 98.595125, 97.61075, 97.282625, 96.532625, 97.751375, 98.313875,
            100.42325, 102.532625, 101.642, 100.376375, 99.907625, 98.501375, 102.86075, 96.86075, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:49.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.8449,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:49.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.438875, 113.876375, 110.313875, 109.04825, 107.501375, 106.23575, 107.4545, 106.563875, 102.9545,
            101.313875, 99.720125, 100.42325, 98.4545, 98.4545, 96.392, 96.5795, 96.5795, 97.001375, 98.407625,
            100.376375, 102.392, 102.063875, 100.23575, 99.86075, 98.407625, 101.876375, 96.345125, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:28.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.22511,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:28.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 123.907625, 120.063875, 115.188875, 112.892, 110.876375, 108.907625, 108.767, 104.595125,
            100.79825, 98.595125, 98.36075, 98.8295, 99.813875, 97.61075, 98.220125, 97.04825, 97.7045, 98.501375,
            100.188875, 102.29825, 102.157625, 100.23575, 99.532625, 98.36075, 102.017, 96.67325, 95.4545,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:11.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.85286,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:11.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.688875, 120.157625, 117.2045, 114.2045, 111.438875, 110.220125, 107.876375, 108.017, 104.220125,
            101.4545, 99.813875, 98.36075, 99.063875, 99.813875, 97.751375, 97.938875, 97.142, 97.938875, 98.73575,
            100.376375, 102.345125, 101.688875, 100.188875, 99.67325, 98.36075, 102.11075, 96.29825, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:56.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.2816,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:56.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.29825, 129.251375, 127.376375, 124.7045, 121.938875, 117.9545, 112.938875, 110.220125, 106.142,
            103.04825, 101.126375, 106.61075, 98.92325, 100.001375, 102.29825, 97.23575, 99.157625, 97.3295, 100.23575,
            100.42325, 102.5795, 101.876375, 100.563875, 99.626375, 97.98575, 102.11075, 96.5795, 95.267,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:50.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.941765,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:50.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.892, 112.095125, 108.67325, 109.095125, 108.251375, 107.032625, 107.595125, 109.470125, 104.313875,
            102.48575, 100.470125, 100.376375, 99.157625, 99.063875, 97.23575, 97.23575, 96.907625, 97.751375, 98.36075,
            100.563875, 102.48575, 102.063875, 100.3295, 100.04825, 98.4545, 102.2045, 96.29825, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:17.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.64372,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:17.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.86075, 117.11075, 112.188875, 108.907625, 108.438875, 107.876375, 107.8295, 106.23575, 103.23575,
            99.720125, 103.563875, 103.188875, 99.11075, 102.626375, 99.720125, 99.29825, 100.845125, 98.4545, 98.642,
            100.42325, 102.720125, 101.782625, 100.188875, 99.67325, 98.595125, 102.813875, 96.5795, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:04.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.15203,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:04.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.392, 111.392, 107.595125, 107.220125, 107.642, 106.001375, 107.595125, 107.4545, 103.563875, 115.376375,
            100.470125, 102.063875, 106.42325, 102.907625, 98.688875, 101.73575, 103.470125, 99.251375, 99.532625,
            104.220125, 102.532625, 101.782625, 100.470125, 100.3295, 98.595125, 102.438875, 96.251375, 95.17325,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:07.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.88409,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:07.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.782625, 109.376375, 106.095125, 105.29825, 104.407625, 104.8295, 105.86075, 107.313875, 102.626375,
            100.3295, 98.4545, 97.751375, 98.17325, 99.11075, 99.251375, 97.61075, 97.001375, 97.142, 98.267, 100.23575,
            102.251375, 101.92325, 100.282625, 99.907625, 98.595125, 102.67325, 96.907625, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:08.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.70002,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:08.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.67325, 104.876375, 102.532625, 104.267, 104.595125, 105.251375, 107.595125, 107.0795, 103.845125,
            100.376375, 99.532625, 98.313875, 99.5795, 99.532625, 97.938875, 97.751375, 97.517, 98.032625, 98.0795,
            99.813875, 102.11075, 101.501375, 100.470125, 100.142, 98.73575, 102.907625, 96.251375, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:15.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.2484,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:15.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.407625, 123.767, 121.61075, 118.282625, 115.517, 112.79825, 109.563875, 120.11075, 104.595125,
            100.001375, 101.501375, 98.73575, 101.876375, 99.86075, 98.54825, 98.970125, 98.407625, 99.2045, 99.157625,
            100.7045, 102.9545, 102.67325, 100.7045, 100.001375, 98.970125, 103.188875, 97.657625, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:10.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.88887,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:10.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.42325, 130.3295, 125.73575, 119.782625, 119.267, 117.626375, 113.267, 112.751375, 108.532625, 105.11075,
            102.626375, 101.54825, 101.595125, 102.11075, 98.8295, 98.501375, 97.376375, 98.126375, 98.4545, 100.188875,
            102.438875, 102.48575, 100.79825, 100.3295, 98.782625, 103.188875, 97.095125, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:03.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.512665,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:03.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.392, 104.0795, 102.9545, 105.438875, 106.61075, 104.17325, 103.61075, 107.782625, 108.907625,
            103.188875, 100.938875, 100.001375, 98.313875, 99.345125, 98.0795, 97.001375, 96.67325, 97.892, 98.267,
            100.142, 102.392, 101.876375, 100.3295, 99.720125, 98.54825, 102.11075, 96.251375, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:58.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.271835,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:58.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.063875, 116.267, 114.29825, 112.188875, 110.876375, 107.36075, 106.98575, 106.751375, 102.29825,
            100.001375, 100.188875, 100.7045, 101.4545, 100.845125, 99.29825, 98.17325, 100.61075, 98.782625, 98.876375,
            100.188875, 102.392, 101.73575, 100.470125, 99.67325, 98.407625, 101.688875, 96.29825, 95.36075,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:53.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.27775,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:53.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.751375, 115.42325, 110.36075, 108.11075, 108.017, 105.11075, 104.970125, 104.8295, 100.657625, 99.86075,
            105.11075, 112.657625, 98.032625, 99.2045, 106.563875, 97.001375, 103.61075, 101.642, 106.563875,
            103.657625, 103.376375, 101.970125, 101.54825, 99.86075, 98.313875, 102.251375, 95.8295, 95.220125,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:39.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.34328,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:39.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.11075, 130.3295, 126.251375, 124.657625, 122.595125, 120.345125, 116.36075, 112.61075, 112.188875,
            105.438875, 102.017, 99.251375, 99.11075, 97.845125, 95.876375, 96.532625, 95.92325, 97.79825, 98.876375,
            100.04825, 102.251375, 101.595125, 100.3295, 99.5795, 98.407625, 102.063875, 96.345125, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:52.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.485886,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:52.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.220125, 109.751375, 106.563875, 105.48575, 105.157625, 103.376375, 106.563875, 105.438875, 101.267,
            100.095125, 99.392, 115.376375, 98.313875, 98.407625, 109.001375, 97.376375, 100.376375, 100.282625,
            107.220125, 105.392, 103.42325, 101.73575, 101.36075, 100.04825, 98.54825, 102.720125, 96.438875, 95.407625,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:59.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.61354,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:59.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.142, 129.9545, 125.54825, 121.04825, 119.8295, 115.61075, 112.095125, 110.17325, 107.032625, 103.892,
            100.845125, 100.23575, 98.688875, 99.813875, 97.938875, 96.813875, 97.282625, 98.0795, 98.688875,
            100.657625, 102.438875, 101.688875, 100.42325, 99.767, 98.54825, 102.438875, 96.29825, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:12.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.3427,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:41:12.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.04825, 120.767, 117.157625, 114.813875, 112.282625, 109.938875, 106.657625, 106.470125, 109.23575,
            119.688875, 122.92325, 101.17325, 109.001375, 106.657625, 103.938875, 106.61075, 105.9545, 102.720125,
            102.720125, 101.595125, 102.9545, 102.626375, 100.892, 99.67325, 99.5795, 103.563875, 99.017, 95.782625,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:46.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.2374,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:46.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.345125, 126.532625, 123.626375, 120.907625, 118.095125, 114.157625, 110.876375, 109.61075, 106.61075,
            101.92325, 100.23575, 98.54825, 99.2045, 98.36075, 96.9545, 97.23575, 96.9545, 97.845125, 99.017, 100.3295,
            102.2045, 101.54825, 100.188875, 99.626375, 98.126375, 101.54825, 96.29825, 95.407625,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:55.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.53282,
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:40:55.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.157625, 128.73575, 123.720125, 119.73575, 117.720125, 113.970125, 114.017, 110.92325, 106.142,
            103.42325, 101.36075, 100.376375, 98.313875, 99.5795, 96.907625, 97.142, 97.470125, 97.188875, 98.4545,
            99.907625, 102.5795, 101.8295, 100.751375, 99.813875, 98.4545, 102.392, 96.438875, 95.313875,
        ],
        latitude: 37.4405837,
        longitude: -122.533377,
    },
    {
        timestamp: '2025-08-29T22:42:13.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.16669,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:13.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.470125, 134.032625, 130.23575, 124.23575, 121.892, 120.157625, 117.29825, 113.0795, 109.938875, 108.017,
            106.142, 106.7045, 104.0795, 101.407625, 101.36075, 103.42325, 104.8295, 98.36075, 99.017, 101.0795,
            102.063875, 101.501375, 100.23575, 99.392, 98.032625, 102.11075, 96.626375, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:24.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.44687,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:24.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.017, 108.063875, 106.142, 105.017, 106.142, 104.36075, 106.470125, 109.42325, 103.563875, 101.8295,
            100.845125, 114.720125, 99.720125, 101.407625, 103.42325, 98.0795, 98.54825, 101.36075, 98.688875,
            100.095125, 101.970125, 101.595125, 100.188875, 99.626375, 98.267, 102.392, 96.720125, 95.688875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:25.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.13631,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:25.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.063875, 115.657625, 112.517, 110.8295, 108.626375, 107.73575, 109.98575, 109.470125, 105.767,
            103.470125, 104.313875, 100.188875, 99.251375, 100.98575, 102.29825, 97.142, 97.470125, 97.3295, 98.36075,
            100.095125, 102.720125, 101.595125, 100.3295, 99.67325, 98.126375, 101.595125, 96.11075, 95.4545,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:24.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.15406,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:24.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.04825, 113.17325, 110.595125, 107.642, 107.267, 106.142, 107.220125, 107.92325, 103.845125, 101.595125,
            110.642, 105.626375, 115.61075, 108.29825, 99.2045, 107.36075, 102.11075, 104.313875, 100.61075, 100.751375,
            102.438875, 101.688875, 100.892, 100.001375, 98.54825, 102.626375, 96.251375, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:36.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.163605,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:36.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.751375, 113.0795, 110.126375, 106.79825, 111.532625, 109.892, 105.5795, 107.032625, 103.657625,
            100.845125, 101.267, 99.157625, 98.688875, 99.767, 97.282625, 99.720125, 97.7045, 98.267, 99.67325,
            100.98575, 102.251375, 102.626375, 100.61075, 100.23575, 98.92325, 102.86075, 96.392, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:08.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.38568,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:08.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.345125, 122.642, 119.17325, 119.032625, 115.517, 109.892, 109.23575, 108.626375, 110.782625, 102.67325,
            99.063875, 99.157625, 98.36075, 99.86075, 98.642, 98.407625, 97.470125, 97.142, 98.032625, 99.86075,
            102.157625, 101.8295, 100.517, 99.767, 98.36075, 102.251375, 96.157625, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:40.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.06274,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:40.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.438875, 135.345125, 131.267, 126.392, 124.845125, 125.54825, 122.032625, 121.7045, 118.938875, 115.3295,
            110.220125, 106.001375, 102.438875, 101.595125, 99.767, 99.063875, 98.126375, 98.4545, 99.5795, 100.61075,
            102.767, 102.063875, 100.657625, 100.42325, 99.017, 103.751375, 96.86075, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:37.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.4877,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:37.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.9545, 125.4545, 122.17325, 118.7045, 115.845125, 111.626375, 109.42325, 109.095125, 120.017, 107.8295,
            100.470125, 99.29825, 99.157625, 99.48575, 98.313875, 98.782625, 97.517, 98.17325, 98.36075, 100.845125,
            102.063875, 102.48575, 100.517, 100.095125, 98.782625, 102.67325, 96.251375, 95.17325,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:56.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.60953,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:56.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.720125, 111.813875, 107.92325, 105.48575, 105.86075, 105.392, 104.73575, 104.4545, 101.8295, 100.563875,
            99.438875, 97.282625, 97.98575, 99.017, 97.98575, 98.126375, 96.532625, 97.001375, 98.17325, 100.142,
            102.2045, 101.4545, 100.282625, 100.095125, 98.267, 102.813875, 96.11075, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:28.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 148.30074,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:28.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.86075, 142.282625, 141.767, 135.017, 128.92325, 126.767, 125.876375, 120.157625, 117.9545, 115.142,
            112.282625, 109.04825, 103.376375, 102.017, 100.23575, 99.720125, 98.54825, 98.54825, 99.29825, 100.892,
            102.5795, 102.392, 100.563875, 99.813875, 98.688875, 102.86075, 96.532625, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:22.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.3021,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:22.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.23575, 118.892, 116.595125, 116.970125, 116.220125, 110.501375, 109.79825, 109.563875, 107.267,
            103.657625, 104.032625, 103.470125, 99.813875, 99.11075, 100.470125, 97.751375, 98.642, 98.36075, 98.782625,
            100.470125, 102.017, 101.876375, 100.376375, 99.813875, 98.501375, 102.2045, 96.157625, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:32.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.65218,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:32.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.42325, 121.845125, 119.92325, 117.345125, 114.017, 110.501375, 107.8295, 105.11075, 103.79825,
            100.282625, 98.4545, 99.157625, 100.3295, 99.9545, 97.892, 97.3295, 97.095125, 97.845125, 98.642, 100.98575,
            102.392, 101.8295, 99.86075, 99.2045, 98.313875, 101.73575, 96.626375, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:19.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.8982,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:19.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.001375, 125.36075, 122.220125, 121.657625, 120.438875, 117.345125, 119.032625, 111.29825, 107.54825,
            103.376375, 107.595125, 103.001375, 100.98575, 102.2045, 102.67325, 98.642, 100.23575, 99.532625, 99.48575,
            100.7045, 102.532625, 101.4545, 100.517, 100.04825, 98.407625, 101.92325, 96.532625, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:18.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.63905,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:18.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.095125, 123.11075, 120.907625, 113.782625, 112.001375, 108.907625, 108.67325, 108.063875, 103.001375,
            100.657625, 100.001375, 98.313875, 98.782625, 99.063875, 97.892, 97.142, 96.5795, 97.563875, 98.220125,
            100.470125, 102.345125, 101.501375, 100.42325, 99.907625, 98.4545, 102.438875, 96.2045, 95.17325,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:35.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.42943,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:35.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.095125, 119.642, 113.407625, 108.767, 108.11075, 107.407625, 108.626375, 108.157625, 104.4545,
            99.626375, 99.626375, 101.876375, 111.48575, 99.767, 98.313875, 97.7045, 100.376375, 103.517, 100.470125,
            100.61075, 102.532625, 102.720125, 100.42325, 99.813875, 98.642, 102.2045, 96.063875, 95.126375,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:31.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.32283,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:31.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.9545, 114.2045, 110.126375, 108.017, 105.157625, 103.095125, 104.267, 104.032625, 102.251375, 100.3295,
            101.36075, 99.438875, 118.282625, 99.2045, 97.282625, 107.501375, 97.657625, 103.61075, 99.626375,
            100.23575, 102.48575, 101.73575, 100.376375, 99.29825, 98.126375, 102.29825, 96.29825, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:29.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.32018,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:29.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.92325, 120.9545, 116.501375, 115.3295, 116.220125, 111.063875, 109.79825, 109.282625, 104.0795,
            100.98575, 99.5795, 98.642, 98.92325, 99.720125, 97.61075, 96.86075, 97.23575, 96.907625, 98.032625,
            100.23575, 102.626375, 102.063875, 100.79825, 100.188875, 98.688875, 102.767, 96.392, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:54.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.01017,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:54.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.642, 115.517, 111.2045, 111.392, 110.126375, 107.36075, 108.251375, 109.282625, 108.2045, 105.251375,
            110.782625, 104.970125, 98.501375, 100.61075, 97.79825, 98.032625, 97.79825, 97.938875, 98.126375,
            100.376375, 102.29825, 102.017, 100.657625, 100.095125, 98.313875, 102.251375, 96.251375, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:07.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.376945,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:07.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.876375, 117.29825, 114.2045, 110.407625, 108.532625, 106.845125, 109.563875, 108.720125, 105.345125,
            106.470125, 105.438875, 105.438875, 101.17325, 102.532625, 100.04825, 99.157625, 97.657625, 97.7045,
            98.73575, 100.657625, 102.2045, 101.595125, 100.517, 100.001375, 98.782625, 102.626375, 96.767, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:16.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.4817,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:16.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.782625, 125.970125, 122.782625, 117.2045, 114.720125, 110.595125, 109.095125, 109.23575, 104.54825,
            101.688875, 99.767, 98.501375, 98.267, 109.095125, 97.79825, 96.9545, 96.813875, 97.001375, 98.126375,
            100.517, 102.063875, 101.73575, 100.04825, 99.5795, 98.032625, 101.54825, 96.2045, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:27.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.11113,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:27.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.782625, 115.376375, 112.657625, 108.626375, 106.563875, 105.063875, 105.86075, 104.970125, 101.73575,
            100.001375, 98.8295, 109.3295, 108.438875, 99.29825, 100.001375, 100.845125, 98.501375, 101.501375,
            101.8295, 100.61075, 102.157625, 101.8295, 100.142, 99.48575, 98.267, 101.73575, 95.876375, 95.0795,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:15.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.70716,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:15.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.7045, 117.251375, 114.29825, 109.657625, 110.595125, 106.7045, 110.54825, 118.517, 109.142, 108.532625,
            104.876375, 103.142, 99.67325, 102.29825, 102.157625, 98.876375, 97.938875, 97.42325, 97.7045, 100.657625,
            101.92325, 101.595125, 100.3295, 99.532625, 98.126375, 101.501375, 96.438875, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:20.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.93095,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:20.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.188875, 122.970125, 120.29825, 117.063875, 115.563875, 110.782625, 113.17325, 108.345125, 103.42325,
            107.595125, 103.7045, 104.8295, 100.845125, 101.0795, 99.626375, 98.407625, 98.595125, 99.345125, 98.782625,
            100.376375, 102.017, 102.11075, 100.563875, 99.720125, 98.032625, 101.73575, 96.251375, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:45.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.32245,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:45.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.54825, 125.595125, 122.407625, 118.938875, 116.970125, 112.7045, 111.157625, 107.688875, 103.470125,
            100.23575, 98.782625, 97.142, 98.36075, 97.42325, 97.517, 97.376375, 97.04825, 97.42325, 98.126375,
            100.282625, 102.251375, 101.73575, 100.376375, 99.86075, 98.782625, 102.67325, 96.532625, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:05.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.30667,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:05.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.92325, 120.67325, 115.892, 113.92325, 111.48575, 108.2045, 109.98575, 107.313875, 122.17325, 117.720125,
            102.345125, 103.3295, 98.970125, 102.626375, 101.407625, 100.282625, 98.220125, 98.0795, 98.0795, 100.61075,
            102.626375, 101.970125, 100.42325, 99.67325, 98.36075, 102.5795, 97.470125, 95.54825,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:28.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.829185,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:28.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.0795, 108.438875, 105.532625, 111.157625, 115.188875, 108.48575, 107.0795, 108.345125, 103.376375,
            101.267, 101.92325, 111.017, 99.5795, 99.532625, 105.063875, 100.61075, 100.42325, 100.470125, 100.188875,
            99.720125, 102.11075, 101.36075, 100.470125, 99.67325, 98.220125, 102.29825, 95.970125, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:41.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.803085,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:41.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.0795, 120.438875, 119.36075, 116.407625, 112.095125, 111.67325, 110.92325, 108.48575, 103.3295,
            100.188875, 101.126375, 99.907625, 106.751375, 100.376375, 100.04825, 100.892, 100.142, 101.782625,
            99.532625, 100.845125, 102.48575, 102.11075, 100.23575, 99.86075, 98.36075, 101.782625, 96.157625, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:31.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.92868,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:31.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.032625, 128.92325, 121.563875, 119.73575, 118.095125, 114.5795, 110.17325, 109.517, 104.407625,
            102.9545, 105.48575, 100.938875, 101.407625, 100.892, 98.595125, 99.5795, 98.313875, 99.907625, 100.98575,
            101.0795, 102.29825, 102.017, 100.3295, 99.67325, 98.36075, 103.04825, 96.532625, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:09.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.3081,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:09.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.907625, 135.48575, 131.126375, 127.001375, 123.157625, 121.61075, 119.17325, 116.8295, 115.470125,
            114.626375, 106.142, 102.532625, 100.188875, 102.063875, 101.642, 101.032625, 98.642, 97.657625, 98.36075,
            100.657625, 102.438875, 101.92325, 100.751375, 100.095125, 98.501375, 102.626375, 96.438875, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:48.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.33132,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:48.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 114.2045, 111.767, 110.032625, 109.23575, 108.532625, 109.98575, 117.767, 107.0795, 114.063875,
            113.267, 102.392, 102.9545, 101.970125, 99.720125, 98.407625, 97.563875, 98.126375, 98.8295, 100.563875,
            102.438875, 101.970125, 100.282625, 99.532625, 98.407625, 102.063875, 96.532625, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:10.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.70494,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:10.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.751375, 124.3295, 121.517, 119.688875, 119.595125, 113.0795, 112.470125, 107.73575, 106.845125,
            103.845125, 103.657625, 103.563875, 106.282625, 105.438875, 101.407625, 100.892, 101.782625, 99.392,
            99.48575, 100.470125, 101.782625, 101.876375, 100.04825, 99.392, 97.892, 101.782625, 96.438875, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:21.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.911026,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:21.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.126375, 105.813875, 103.845125, 106.657625, 108.5795, 108.2045, 108.907625, 107.220125, 103.470125,
            100.845125, 100.376375, 98.688875, 99.29825, 100.001375, 98.220125, 97.376375, 96.767, 97.3295, 97.892,
            100.23575, 101.970125, 101.595125, 100.751375, 99.720125, 98.36075, 102.86075, 96.29825, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:11.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.75204,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:11.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.220125, 111.86075, 106.517, 106.517, 105.157625, 104.126375, 107.032625, 105.626375, 103.79825,
            102.11075, 103.892, 101.970125, 99.48575, 107.54825, 97.61075, 98.0795, 97.79825, 98.032625, 98.36075,
            100.563875, 102.438875, 101.73575, 100.470125, 99.86075, 98.0795, 102.017, 96.438875, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:22.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.0067,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:22.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.813875, 105.626375, 103.3295, 102.5795, 104.876375, 105.345125, 105.907625, 104.642, 100.61075, 99.2045,
            99.767, 105.2045, 102.67325, 99.2045, 99.720125, 106.751375, 97.376375, 101.17325, 100.001375, 100.470125,
            101.876375, 101.73575, 100.892, 99.9545, 98.407625, 102.532625, 96.438875, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:39.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.94923,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:39.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.376375, 103.282625, 103.61075, 106.938875, 106.282625, 104.595125, 113.782625, 112.98575, 108.063875,
            104.73575, 102.907625, 100.470125, 101.876375, 101.407625, 98.0795, 99.86075, 98.92325, 99.86075, 100.61075,
            100.61075, 102.345125, 101.92325, 100.657625, 100.001375, 98.782625, 102.86075, 96.157625, 95.17325,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:46.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.92598,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:46.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.095125, 117.11075, 115.3295, 109.657625, 107.4545, 106.42325, 107.267, 107.688875, 103.517, 100.657625,
            98.595125, 98.876375, 98.313875, 98.032625, 96.86075, 97.142, 96.392, 97.470125, 98.54825, 100.282625,
            102.29825, 102.157625, 100.892, 100.095125, 98.501375, 102.157625, 96.2045, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:30.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.37011,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:30.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.313875, 108.767, 106.282625, 103.79825, 105.626375, 106.095125, 105.48575, 111.626375, 121.3295,
            102.438875, 100.001375, 102.813875, 99.813875, 100.04825, 100.61075, 98.267, 97.42325, 98.267, 98.8295,
            101.032625, 102.532625, 102.345125, 100.3295, 99.720125, 98.126375, 101.407625, 96.345125, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:03.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.10637,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:03.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.563875, 121.095125, 114.86075, 113.313875, 111.017, 107.313875, 110.126375, 108.11075, 106.282625,
            102.720125, 102.017, 102.11075, 104.970125, 100.376375, 97.61075, 100.42325, 99.5795, 98.642, 98.36075,
            100.751375, 102.392, 102.017, 100.517, 99.532625, 98.36075, 103.42325, 96.626375, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:29.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.331,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:29.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.376375, 122.92325, 120.017, 116.313875, 115.3295, 112.42325, 110.970125, 110.0795, 119.642, 107.501375,
            100.938875, 102.29825, 101.0795, 101.876375, 100.751375, 100.23575, 99.157625, 98.8295, 99.251375,
            101.970125, 102.9545, 103.001375, 100.517, 100.23575, 98.642, 102.157625, 97.376375, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:47.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.44511,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:47.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.48575, 124.23575, 116.220125, 112.142, 109.563875, 109.04825, 108.438875, 109.142, 108.48575, 116.267,
            112.142, 99.345125, 100.61075, 101.501375, 98.407625, 98.407625, 97.42325, 97.938875, 99.392, 100.470125,
            102.438875, 101.595125, 100.657625, 99.907625, 98.595125, 102.67325, 96.532625, 95.17325,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:02.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.63112,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:02.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.438875, 134.36075, 129.2045, 124.845125, 122.73575, 121.42325, 118.563875, 116.032625, 117.438875,
            111.720125, 104.782625, 102.392, 101.876375, 101.8295, 102.29825, 101.92325, 101.782625, 98.54825, 99.67325,
            100.657625, 102.345125, 101.8295, 100.845125, 99.720125, 98.36075, 102.251375, 96.392, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:06.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.69827,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:06.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.751375, 122.36075, 121.98575, 120.532625, 118.23575, 113.642, 111.532625, 107.313875, 105.345125,
            101.595125, 102.11075, 101.0795, 104.17325, 102.438875, 98.595125, 99.157625, 99.017, 98.126375, 99.5795,
            100.142, 102.392, 101.688875, 100.751375, 99.9545, 98.595125, 102.9545, 96.767, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:19.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.715485,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:19.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.157625, 109.001375, 106.3295, 106.188875, 107.032625, 106.98575, 109.657625, 109.79825, 106.04825,
            103.001375, 100.42325, 99.767, 99.11075, 98.54825, 97.845125, 97.751375, 98.313875, 97.470125, 98.17325,
            100.42325, 102.29825, 101.688875, 100.61075, 99.813875, 98.407625, 102.67325, 96.063875, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:53.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.8551,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:53.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.157625, 119.36075, 115.61075, 111.907625, 110.595125, 107.92325, 107.313875, 107.313875, 127.42325,
            118.095125, 101.92325, 102.9545, 101.876375, 100.23575, 102.813875, 101.595125, 99.11075, 99.017, 98.970125,
            100.79825, 102.345125, 101.595125, 100.282625, 99.626375, 98.267, 101.73575, 96.063875, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:42.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.248825,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:42.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.23575, 111.532625, 106.938875, 108.67325, 109.517, 108.392, 112.282625, 112.98575, 116.313875, 106.7045,
            101.54825, 100.845125, 99.017, 99.67325, 100.892, 99.532625, 98.0795, 97.98575, 98.8295, 100.517,
            102.251375, 101.8295, 100.517, 99.813875, 98.4545, 102.017, 96.2045, 95.4545,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:33.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.923904,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:33.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.23575, 113.501375, 110.642, 109.04825, 108.345125, 106.23575, 108.532625, 110.220125, 125.970125,
            103.657625, 100.001375, 100.751375, 99.5795, 102.11075, 102.251375, 99.438875, 98.36075, 98.126375, 98.267,
            100.376375, 102.251375, 102.063875, 100.23575, 99.532625, 98.126375, 102.063875, 96.626375, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:14.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.25049,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:14.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.8295, 124.845125, 120.720125, 119.267, 115.3295, 110.220125, 108.626375, 110.220125, 102.907625,
            101.126375, 100.563875, 99.813875, 99.720125, 100.42325, 98.501375, 97.23575, 97.23575, 97.892, 98.032625,
            100.751375, 102.345125, 101.876375, 100.3295, 99.392, 98.36075, 101.782625, 96.251375, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:51.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.26698,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:51.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.92325, 132.157625, 132.017, 128.0795, 121.563875, 120.2045, 118.188875, 113.0795, 120.017, 117.345125,
            116.36075, 109.61075, 103.282625, 100.23575, 98.970125, 98.876375, 99.2045, 98.407625, 98.407625, 100.23575,
            102.48575, 101.54825, 100.470125, 99.86075, 98.407625, 101.92325, 96.48575, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:49.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.0875,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:49.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.157625, 126.626375, 123.767, 120.017, 116.92325, 114.767, 110.688875, 109.23575, 106.188875, 102.5795,
            100.79825, 99.063875, 98.595125, 98.876375, 97.095125, 97.282625, 97.188875, 97.657625, 98.0795, 100.142,
            102.5795, 101.92325, 100.42325, 100.001375, 98.54825, 102.157625, 96.251375, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:50.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.871216,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:50.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.470125, 115.79825, 111.626375, 109.61075, 107.970125, 106.376375, 104.970125, 106.001375, 108.907625,
            99.251375, 99.86075, 99.11075, 99.11075, 98.313875, 97.657625, 97.470125, 97.095125, 97.61075, 97.845125,
            99.9545, 102.157625, 101.92325, 100.61075, 99.767, 98.407625, 102.2045, 96.345125, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:52.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.36113,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:52.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.642, 130.142, 128.73575, 126.626375, 122.17325, 117.626375, 114.767, 112.142, 106.751375, 102.251375,
            102.907625, 100.04825, 99.29825, 99.48575, 99.2045, 98.313875, 98.54825, 98.126375, 98.642, 100.376375,
            102.438875, 101.970125, 100.657625, 99.9545, 98.688875, 102.626375, 96.5795, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:55.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.45841,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:55.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.470125, 113.501375, 109.376375, 106.282625, 104.970125, 104.876375, 106.42325, 110.4545, 102.86075,
            99.86075, 105.5795, 103.7045, 100.938875, 99.251375, 97.938875, 98.54825, 98.501375, 99.86075, 99.48575,
            100.751375, 102.392, 101.73575, 100.517, 99.813875, 98.407625, 102.157625, 96.29825, 95.220125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:23.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.3369,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:23.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.970125, 122.267, 116.92325, 111.720125, 110.92325, 107.970125, 106.470125, 107.267, 103.376375,
            107.220125, 107.501375, 105.438875, 99.720125, 99.29825, 97.282625, 97.61075, 96.48575, 97.563875, 97.98575,
            100.23575, 102.29825, 101.92325, 100.61075, 99.813875, 98.501375, 102.392, 96.345125, 95.17325,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:12.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 144.27298,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:12.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.470125, 137.73575, 132.86075, 127.470125, 125.313875, 121.845125, 119.313875, 114.9545, 113.0795,
            107.501375, 104.73575, 101.8295, 104.92325, 105.5795, 98.970125, 98.876375, 97.61075, 97.892, 97.845125,
            100.04825, 102.063875, 101.642, 100.517, 100.142, 98.54825, 102.626375, 96.392, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:20.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.9021,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:20.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.4545, 118.376375, 113.782625, 109.001375, 107.17325, 105.063875, 106.23575, 107.36075, 103.095125,
            102.063875, 100.845125, 101.313875, 99.251375, 99.345125, 97.7045, 97.517, 96.5795, 97.095125, 97.657625,
            99.907625, 102.2045, 101.782625, 100.7045, 100.188875, 98.595125, 102.2045, 96.67325, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:18.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.10054,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:18.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.17325, 116.36075, 112.938875, 110.73575, 108.9545, 112.563875, 117.345125, 106.751375, 109.751375,
            116.36075, 108.720125, 103.657625, 102.11075, 104.17325, 103.42325, 101.4545, 100.04825, 99.9545, 99.767,
            100.42325, 101.970125, 101.688875, 100.517, 100.142, 98.54825, 102.438875, 96.345125, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:26.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.42293,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:26.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.657625, 115.61075, 112.79825, 108.767, 106.79825, 103.892, 104.4545, 110.642, 114.767, 125.36075,
            121.470125, 119.876375, 105.345125, 102.9545, 104.54825, 103.938875, 102.67325, 107.92325, 105.813875,
            103.04825, 102.5795, 102.251375, 100.7045, 100.095125, 98.407625, 102.251375, 96.392, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:17.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.75813,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:17.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.92325, 116.595125, 111.767, 109.79825, 108.2045, 105.907625, 110.126375, 108.48575, 101.407625,
            117.813875, 104.501375, 104.54825, 98.8295, 99.720125, 99.157625, 98.501375, 99.532625, 97.98575, 98.17325,
            100.188875, 102.017, 101.782625, 100.188875, 99.9545, 98.595125, 102.626375, 96.345125, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:41.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.28035,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:41.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.626375, 132.438875, 129.767, 124.470125, 122.36075, 119.73575, 115.095125, 112.563875, 116.17325,
            113.032625, 103.23575, 100.517, 100.095125, 100.282625, 99.392, 99.767, 98.4545, 98.126375, 98.642,
            100.938875, 102.2045, 101.36075, 100.23575, 99.626375, 98.73575, 103.095125, 96.438875, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:57.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.532906,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:57.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.642, 109.657625, 105.392, 107.126375, 106.845125, 105.2045, 105.813875, 106.517, 118.79825, 106.79825,
            101.220125, 100.095125, 99.438875, 101.126375, 99.67325, 99.063875, 97.517, 97.751375, 98.8295, 100.42325,
            102.48575, 101.970125, 100.42325, 100.001375, 98.501375, 102.767, 96.29825, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:58.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.04613,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:58.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.892, 109.517, 106.42325, 106.282625, 106.79825, 104.313875, 107.032625, 108.29825, 105.48575, 101.73575,
            100.188875, 101.0795, 98.220125, 99.907625, 100.98575, 102.813875, 100.23575, 99.2045, 100.61075,
            100.563875, 102.5795, 101.970125, 100.7045, 99.907625, 98.595125, 103.001375, 96.157625, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:30.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.08777,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:30.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.063875, 129.438875, 126.907625, 124.42325, 119.642, 117.767, 114.626375, 112.892, 108.532625, 104.36075,
            108.532625, 101.0795, 113.73575, 100.751375, 98.4545, 104.8295, 96.626375, 99.67325, 99.5795, 100.095125,
            102.063875, 101.4545, 100.282625, 99.720125, 98.267, 102.48575, 96.157625, 95.126375,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:27.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.27487,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:27.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.8295, 115.892, 110.876375, 113.126375, 112.282625, 110.267, 109.142, 109.282625, 108.438875, 107.36075,
            102.017, 100.563875, 99.063875, 99.532625, 98.876375, 96.813875, 97.376375, 97.563875, 98.032625, 99.5795,
            102.11075, 101.54825, 100.282625, 99.907625, 98.407625, 102.767, 96.2045, 95.126375,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:44.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.45764,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:44.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.626375, 117.813875, 114.11075, 117.392, 114.626375, 105.813875, 105.67325, 108.5795, 102.907625,
            100.470125, 98.688875, 98.267, 108.2045, 102.9545, 97.79825, 97.61075, 97.563875, 99.063875, 99.767,
            101.17325, 102.720125, 101.8295, 100.657625, 100.095125, 98.92325, 103.095125, 96.392, 95.407625,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:00.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.87704,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:00.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.42325, 116.642, 112.282625, 108.345125, 106.001375, 106.42325, 106.04825, 107.595125, 106.04825,
            101.501375, 99.017, 98.17325, 98.782625, 99.157625, 98.73575, 99.67325, 97.938875, 97.751375, 98.032625,
            100.001375, 102.438875, 102.157625, 100.7045, 99.813875, 98.73575, 102.9545, 96.5795, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:38.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.671524,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:38.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.392, 117.2045, 112.095125, 111.2045, 110.501375, 108.11075, 109.98575, 111.063875, 110.032625,
            102.813875, 100.095125, 98.36075, 100.282625, 98.313875, 97.79825, 99.063875, 97.517, 98.220125, 98.92325,
            100.23575, 102.017, 102.2045, 100.188875, 99.813875, 98.501375, 102.438875, 96.063875, 95.17325,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:04.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.1423,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:04.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.095125, 124.892, 122.4545, 116.970125, 114.11075, 112.79825, 110.220125, 107.267, 104.876375, 100.892,
            100.79825, 98.126375, 99.063875, 99.251375, 97.79825, 98.782625, 97.79825, 97.938875, 98.220125, 100.657625,
            102.063875, 101.688875, 100.282625, 99.5795, 98.642, 102.438875, 97.376375, 95.595125,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:26.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.31093,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:26.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.3295, 121.23575, 118.61075, 116.220125, 114.017, 110.501375, 106.892, 107.36075, 102.813875, 99.720125,
            99.532625, 99.67325, 99.29825, 99.48575, 97.470125, 99.251375, 97.23575, 97.001375, 97.751375, 100.04825,
            102.48575, 101.54825, 100.142, 99.438875, 98.0795, 101.595125, 96.063875, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:21.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.602,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:21.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.7045, 132.9545, 131.54825, 129.907625, 125.642, 123.11075, 119.54825, 115.04825, 111.907625, 107.126375,
            107.4545, 103.751375, 100.657625, 100.517, 98.8295, 98.54825, 98.032625, 97.938875, 98.126375, 100.142,
            102.063875, 101.407625, 100.563875, 100.04825, 98.54825, 102.438875, 96.438875, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:17.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.70004,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:17.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.782625, 114.5795, 111.017, 105.9545, 105.9545, 105.438875, 105.720125, 110.36075, 101.782625,
            100.657625, 106.61075, 99.532625, 100.938875, 101.313875, 98.36075, 98.501375, 97.657625, 98.0795,
            99.251375, 100.23575, 102.48575, 101.595125, 100.282625, 99.86075, 98.126375, 102.67325, 96.251375, 95.267,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:59.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.67389,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:59.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.563875, 118.7045, 113.267, 112.04825, 110.642, 108.392, 110.0795, 111.11075, 106.23575, 102.251375,
            101.501375, 99.532625, 102.063875, 99.532625, 99.29825, 99.86075, 100.001375, 99.438875, 102.813875,
            101.642, 102.345125, 101.688875, 100.095125, 99.532625, 98.032625, 101.970125, 96.29825, 95.4545,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:01.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.42535,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:01.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 117.67325, 113.501375, 113.876375, 112.188875, 109.42325, 108.063875, 107.73575, 121.001375,
            111.907625, 101.876375, 101.642, 99.063875, 102.2045, 98.876375, 101.595125, 98.313875, 98.032625,
            98.501375, 100.3295, 102.532625, 102.063875, 100.938875, 99.907625, 98.313875, 102.767, 96.438875, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:34.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.44295,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:34.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.142, 121.938875, 118.751375, 114.2045, 111.532625, 109.470125, 107.876375, 107.92325, 117.157625,
            100.845125, 99.345125, 98.92325, 99.063875, 99.392, 97.563875, 97.142, 97.845125, 97.3295, 98.126375,
            100.142, 102.157625, 102.29825, 100.23575, 99.720125, 98.501375, 101.782625, 96.29825, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:25.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.08577,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:25.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.392, 119.595125, 116.501375, 111.67325, 108.48575, 106.98575, 106.563875, 109.23575, 111.813875,
            101.4545, 99.720125, 99.48575, 99.9545, 99.157625, 97.001375, 96.9545, 96.907625, 97.751375, 98.126375,
            100.142, 102.392, 101.595125, 100.3295, 99.907625, 98.17325, 102.438875, 96.017, 95.36075,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:43.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.01219,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:41:43.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.345125, 111.11075, 107.595125, 114.345125, 115.563875, 106.188875, 106.470125, 112.001375, 124.98575,
            108.345125, 101.876375, 101.54825, 100.657625, 101.267, 99.532625, 100.470125, 99.48575, 98.4545, 98.688875,
            100.98575, 102.720125, 102.2045, 100.376375, 99.813875, 98.642, 102.626375, 96.48575, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:23.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.57216,
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:42:23.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.688875, 126.251375, 119.73575, 116.220125, 116.407625, 112.845125, 109.845125, 108.2045, 104.4545,
            100.470125, 99.720125, 101.407625, 107.642, 100.376375, 98.267, 101.970125, 98.782625, 98.642, 99.063875,
            100.563875, 102.157625, 101.642, 100.470125, 99.251375, 98.126375, 101.92325, 96.5795, 95.313875,
        ],
        latitude: 37.4405808,
        longitude: -122.5333888,
    },
    {
        timestamp: '2025-08-29T22:43:21.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.65779,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:21.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.626375, 120.720125, 118.61075, 115.095125, 110.970125, 109.095125, 108.5795, 106.3295, 102.345125,
            102.2045, 99.9545, 99.5795, 97.892, 98.032625, 97.892, 97.3295, 97.470125, 97.751375, 97.98575, 100.188875,
            102.392, 102.2045, 100.7045, 99.907625, 98.407625, 102.157625, 96.2045, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:58.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.46887,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:58.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.9545, 122.17325, 120.9545, 118.001375, 115.61075, 111.017, 109.517, 107.688875, 106.04825, 104.407625,
            111.813875, 119.501375, 118.7045, 101.642, 101.92325, 100.001375, 98.36075, 99.251375, 98.4545, 100.7045,
            102.438875, 102.017, 100.563875, 100.142, 98.54825, 102.5795, 96.157625, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:51.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.75516,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:51.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.48575, 117.67325, 115.517, 110.782625, 111.532625, 108.345125, 105.438875, 105.626375, 102.157625,
            101.126375, 100.3295, 98.688875, 98.501375, 99.157625, 98.688875, 97.657625, 97.79825, 97.938875, 98.126375,
            100.3295, 102.11075, 101.782625, 100.61075, 99.5795, 98.4545, 101.92325, 96.67325, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:01.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.74467,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:01.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.4545, 123.345125, 120.720125, 117.345125, 115.23575, 112.470125, 110.688875, 109.04825, 104.54825,
            103.376375, 103.7045, 106.001375, 104.688875, 99.813875, 98.54825, 97.98575, 96.626375, 97.892, 97.938875,
            100.095125, 101.970125, 101.642, 100.3295, 99.9545, 98.032625, 101.92325, 96.017, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:05.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.96204,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:05.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.36075, 127.98575, 124.142, 120.907625, 118.282625, 117.5795, 115.04825, 112.188875, 107.267, 104.92325,
            105.67325, 106.563875, 103.282625, 100.657625, 98.36075, 97.142, 96.9545, 97.001375, 97.938875, 100.188875,
            102.017, 101.970125, 100.282625, 99.67325, 98.126375, 102.532625, 96.063875, 95.17325,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:49.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.94923,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:49.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.438875, 127.7045, 125.73575, 123.48575, 118.751375, 116.0795, 113.0795, 112.751375, 108.767, 103.3295,
            102.720125, 100.751375, 101.54825, 103.98575, 97.892, 99.720125, 98.407625, 97.892, 98.595125, 100.3295,
            102.392, 102.392, 100.79825, 99.532625, 98.54825, 102.29825, 96.907625, 95.642,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:27.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.45687,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:27.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.970125, 106.938875, 104.92325, 105.767, 109.282625, 106.7045, 104.267, 112.892, 109.7045, 105.29825,
            105.5795, 105.626375, 103.001375, 100.845125, 101.8295, 101.220125, 99.29825, 99.720125, 98.73575,
            101.17325, 102.5795, 102.063875, 100.7045, 100.04825, 98.8295, 102.767, 97.142, 95.4545,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:44.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.22746,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:44.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.61075, 118.7045, 116.501375, 116.0795, 112.845125, 108.48575, 109.42325, 108.251375, 105.48575,
            129.251375, 124.845125, 101.267, 107.17325, 108.392, 99.29825, 100.470125, 101.220125, 103.23575,
            101.032625, 100.142, 101.970125, 101.688875, 100.095125, 99.345125, 98.220125, 102.767, 96.767, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:46.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.90002,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:46.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.095125, 106.517, 103.7045, 104.688875, 105.438875, 106.282625, 106.892, 104.36075, 102.720125,
            101.220125, 100.79825, 102.907625, 99.392, 99.907625, 98.642, 97.04825, 96.86075, 96.86075, 98.0795,
            100.188875, 102.29825, 101.782625, 100.3295, 99.720125, 98.36075, 101.970125, 96.063875, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:56.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.36215,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:56.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.095125, 112.04825, 109.376375, 107.970125, 109.04825, 111.438875, 112.563875, 105.9545, 103.188875,
            108.48575, 104.4545, 108.157625, 100.001375, 99.29825, 98.642, 97.751375, 97.3295, 97.751375, 98.267,
            100.3295, 102.626375, 101.8295, 100.517, 99.5795, 98.220125, 101.8295, 96.251375, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:52.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.49255,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:52.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.720125, 119.126375, 116.501375, 113.4545, 116.407625, 119.0795, 106.188875, 108.86075, 112.04825,
            108.29825, 101.642, 101.0795, 100.001375, 99.67325, 100.42325, 99.438875, 98.876375, 97.42325, 98.032625,
            99.86075, 101.970125, 101.92325, 100.23575, 100.001375, 98.36075, 102.438875, 96.532625, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:15.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.24401,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:15.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.688875, 113.126375, 108.345125, 108.017, 109.470125, 108.251375, 107.782625, 108.063875, 108.251375,
            123.251375, 113.54825, 100.938875, 105.813875, 101.782625, 104.4545, 100.61075, 101.267, 103.517, 100.42325,
            100.892, 102.29825, 101.8295, 100.42325, 100.001375, 98.73575, 103.7045, 96.626375, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:12.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.02248,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:12.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.04825, 121.188875, 118.7045, 114.251375, 112.188875, 108.532625, 107.220125, 105.86075, 102.345125,
            101.032625, 102.11075, 103.751375, 105.5795, 101.0795, 98.876375, 99.251375, 100.61075, 98.54825, 99.813875,
            100.563875, 102.48575, 102.345125, 100.79825, 99.907625, 98.501375, 102.907625, 96.29825, 95.126375,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:40.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.46118,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:40.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 126.11075, 123.2045, 121.892, 118.23575, 115.282625, 112.282625, 111.720125, 108.907625,
            106.188875, 106.23575, 100.563875, 99.438875, 100.845125, 98.92325, 98.220125, 97.3295, 97.7045, 98.267,
            100.095125, 102.67325, 101.92325, 100.7045, 100.188875, 98.501375, 102.063875, 96.251375, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:33.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.34856,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:33.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.438875, 121.79825, 121.23575, 117.11075, 114.438875, 111.29825, 109.517, 107.970125, 104.126375,
            101.4545, 99.67325, 99.532625, 109.3295, 99.251375, 97.892, 97.892, 96.392, 97.095125, 98.032625, 100.3295,
            102.157625, 102.2045, 100.563875, 100.3295, 98.876375, 102.86075, 96.67325, 95.4545,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:16.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.75605,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:16.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.001375, 114.9545, 112.7045, 108.9545, 108.67325, 105.907625, 104.970125, 105.907625, 103.001375,
            103.42325, 104.407625, 107.688875, 106.61075, 100.563875, 97.61075, 101.126375, 101.36075, 102.86075,
            100.142, 100.892, 102.767, 102.017, 100.657625, 99.907625, 98.92325, 103.470125, 96.813875, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:37.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.64514,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:37.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.267, 126.017, 124.79825, 120.767, 116.8295, 113.642, 113.92325, 109.142, 108.017, 113.220125, 103.98575,
            100.517, 103.79825, 101.0795, 100.142, 99.532625, 98.126375, 103.3295, 99.157625, 100.61075, 102.392,
            102.813875, 100.938875, 99.907625, 98.73575, 103.376375, 97.04825, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:17.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.08728,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:17.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.8295, 124.376375, 122.126375, 113.876375, 111.438875, 110.970125, 107.876375, 107.782625, 104.220125,
            104.032625, 100.845125, 97.892, 98.36075, 98.876375, 98.220125, 97.517, 96.720125, 97.095125, 98.4545,
            100.001375, 102.345125, 101.782625, 100.470125, 99.813875, 98.36075, 101.8295, 96.48575, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:20.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.2966,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:20.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.3295, 108.86075, 105.720125, 103.845125, 105.251375, 103.282625, 103.61075, 105.251375, 101.8295,
            102.29825, 100.61075, 100.892, 101.595125, 99.251375, 100.095125, 99.813875, 100.42325, 105.907625,
            100.23575, 100.282625, 102.48575, 101.876375, 100.61075, 99.720125, 98.54825, 103.142, 96.5795, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:04.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.55696,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:04.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.54825, 127.282625, 126.532625, 123.392, 120.626375, 116.8295, 113.220125, 110.126375, 104.407625,
            106.04825, 103.938875, 106.282625, 102.392, 101.54825, 98.501375, 97.61075, 97.42325, 97.845125, 98.313875,
            100.188875, 102.2045, 101.595125, 100.095125, 99.532625, 98.54825, 102.017, 96.532625, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:30.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.502144,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:30.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 119.032625, 115.376375, 112.938875, 109.517, 105.907625, 105.345125, 106.04825, 102.438875,
            99.767, 103.001375, 103.938875, 99.251375, 99.392, 97.188875, 98.032625, 97.517, 97.79825, 97.98575,
            99.720125, 102.392, 101.8295, 100.517, 99.86075, 98.407625, 102.5795, 96.48575, 95.4545,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:34.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.37575,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:34.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.017, 127.751375, 124.657625, 119.8295, 116.876375, 114.017, 111.063875, 117.251375, 107.17325,
            103.79825, 100.7045, 98.970125, 99.813875, 99.9545, 98.220125, 97.23575, 97.04825, 96.813875, 97.79825,
            100.282625, 101.688875, 102.438875, 100.517, 99.720125, 98.267, 102.11075, 96.2045, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:27.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.206116,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:27.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.892, 119.92325, 117.48575, 112.845125, 110.267, 107.595125, 106.563875, 105.86075, 102.063875,
            100.61075, 100.188875, 99.48575, 98.313875, 98.407625, 97.892, 97.892, 97.188875, 97.751375, 97.938875,
            100.282625, 102.532625, 101.970125, 100.657625, 99.767, 98.407625, 102.29825, 96.532625, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:45.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 144.86559,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:45.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            143.267, 136.61075, 131.782625, 129.48575, 130.517, 128.0795, 125.0795, 123.5795, 118.61075, 114.813875,
            111.438875, 109.3295, 106.001375, 101.36075, 98.4545, 97.98575, 99.2045, 97.470125, 98.4545, 100.657625,
            101.970125, 101.970125, 100.3295, 99.5795, 98.4545, 103.188875, 96.67325, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:36.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.54433,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:36.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.67325, 124.188875, 121.282625, 116.501375, 111.9545, 109.282625, 108.86075, 106.3295, 103.563875,
            101.8295, 100.845125, 99.532625, 102.813875, 101.032625, 98.4545, 97.563875, 97.470125, 97.938875,
            98.501375, 100.3295, 101.876375, 102.5795, 100.563875, 99.813875, 98.642, 102.2045, 96.48575, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:40.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.741875,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:40.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.267, 118.79825, 114.9545, 114.11075, 112.095125, 108.2045, 106.79825, 106.7045, 102.626375, 101.0795,
            102.720125, 108.48575, 107.407625, 98.4545, 101.313875, 102.532625, 105.251375, 105.5795, 103.751375,
            101.8295, 102.907625, 102.532625, 100.845125, 100.001375, 98.4545, 102.29825, 96.626375, 95.54825,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:42.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.949234,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:42.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.892, 106.282625, 103.7045, 104.876375, 106.001375, 105.438875, 105.907625, 107.782625, 103.657625,
            100.142, 101.032625, 125.17325, 123.48575, 100.79825, 104.876375, 102.532625, 104.688875, 98.92325, 98.8295,
            100.001375, 102.251375, 101.8295, 100.563875, 100.142, 98.876375, 102.29825, 97.04825, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:31.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.06056,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:31.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.876375, 117.017, 113.267, 109.938875, 107.73575, 105.720125, 106.563875, 107.126375, 109.23575,
            118.42325, 108.251375, 104.36075, 102.813875, 103.845125, 104.970125, 103.376375, 99.9545, 98.17325,
            98.36075, 100.376375, 102.532625, 102.251375, 100.376375, 99.813875, 98.220125, 102.11075, 96.392,
            95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:57.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.132645,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:57.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.5795, 108.9545, 105.2045, 106.7045, 107.032625, 105.392, 105.9545, 105.86075, 104.032625, 100.42325,
            102.86075, 102.907625, 120.86075, 100.095125, 99.29825, 101.8295, 97.563875, 100.61075, 98.220125,
            100.657625, 102.251375, 102.063875, 100.42325, 99.767, 98.4545, 102.157625, 96.438875, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:00.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.90345,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:00.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.907625, 113.8295, 108.86075, 104.688875, 105.767, 103.751375, 105.251375, 104.4545, 111.907625,
            113.92325, 103.470125, 105.626375, 111.813875, 102.017, 98.313875, 98.313875, 98.17325, 97.751375,
            98.313875, 99.86075, 102.48575, 101.642, 100.23575, 99.86075, 98.267, 101.970125, 96.251375, 95.126375,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:02.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.66318,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:02.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.688875, 118.282625, 114.063875, 109.98575, 108.063875, 107.313875, 106.376375, 106.657625, 110.970125,
            122.126375, 116.407625, 107.313875, 103.04825, 101.407625, 99.2045, 99.86075, 98.501375, 97.142, 97.563875,
            100.095125, 102.017, 101.595125, 100.42325, 99.67325, 98.126375, 102.157625, 96.063875, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:11.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.941925,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:11.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.001375, 113.4545, 110.36075, 109.188875, 110.595125, 110.642, 111.063875, 109.892, 109.23575, 122.54825,
            115.42325, 100.7045, 103.095125, 100.563875, 102.345125, 98.267, 98.8295, 101.73575, 99.11075, 100.845125,
            102.532625, 101.92325, 100.79825, 99.813875, 98.4545, 102.392, 96.2045, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:03.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.44269,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:03.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.67325, 118.7045, 112.001375, 111.251375, 109.282625, 107.126375, 105.5795, 105.392, 102.907625,
            130.188875, 119.595125, 106.892, 106.095125, 101.595125, 101.032625, 105.813875, 99.532625, 99.2045,
            100.04825, 100.938875, 102.67325, 102.157625, 100.470125, 99.720125, 98.267, 103.04825, 96.5795, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:48.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.79408,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:48.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.938875, 123.251375, 115.657625, 111.9545, 110.0795, 106.563875, 124.61075, 115.001375, 103.188875,
            111.063875, 113.501375, 105.063875, 101.92325, 101.642, 105.29825, 102.438875, 102.345125, 100.892,
            99.532625, 100.517, 102.11075, 101.876375, 100.845125, 99.907625, 98.313875, 102.438875, 96.5795, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:28.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.87999,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:28.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.86075, 112.142, 109.23575, 107.4545, 109.657625, 111.063875, 109.563875, 109.42325, 105.626375,
            102.532625, 101.501375, 100.376375, 99.063875, 98.92325, 98.54825, 98.267, 97.98575, 97.42325, 98.4545,
            100.42325, 102.48575, 102.392, 100.751375, 99.86075, 98.595125, 102.626375, 96.5795, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:42.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.782295,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:42.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.017, 116.92325, 112.04825, 109.517, 106.79825, 106.3295, 104.688875, 104.54825, 102.5795, 120.86075,
            114.907625, 104.0795, 105.017, 105.907625, 108.063875, 104.595125, 102.626375, 99.392, 99.251375, 100.42325,
            102.5795, 102.017, 100.751375, 100.095125, 98.8295, 102.5795, 97.095125, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:35.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.51585,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:35.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.751375, 122.8295, 116.267, 111.532625, 108.438875, 107.876375, 106.845125, 105.5795, 103.7045,
            123.48575, 118.188875, 104.8295, 106.142, 106.470125, 107.595125, 105.813875, 102.767, 99.392, 99.157625,
            100.892, 102.2045, 102.720125, 100.095125, 99.5795, 98.4545, 102.11075, 96.532625, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:38.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.1456,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:38.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.017, 132.67325, 129.532625, 127.142, 125.4545, 122.0795, 119.688875, 115.188875, 110.17325, 117.5795,
            110.501375, 102.5795, 101.4545, 102.626375, 105.67325, 101.36075, 98.407625, 97.98575, 98.595125,
            100.845125, 102.251375, 102.157625, 100.657625, 100.188875, 98.688875, 102.9545, 98.126375, 95.54825,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:38.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.6841,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:38.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.907625, 131.970125, 128.595125, 125.17325, 124.001375, 122.267, 121.517, 115.79825, 121.751375,
            119.0795, 108.907625, 104.313875, 102.063875, 100.3295, 105.767, 99.438875, 99.813875, 104.126375, 99.392,
            100.282625, 102.11075, 101.876375, 100.657625, 99.9545, 98.36075, 102.345125, 96.345125, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:06.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.20056,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:06.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.48575, 126.626375, 122.92325, 118.79825, 116.595125, 114.48575, 113.407625, 109.376375, 105.48575,
            103.142, 101.4545, 102.063875, 99.86075, 99.345125, 98.267, 97.42325, 97.142, 97.3295, 97.563875,
            100.001375, 102.017, 101.688875, 99.9545, 99.2045, 98.032625, 101.73575, 96.67325, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:24.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.97761,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:24.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.54825, 121.04825, 117.2045, 113.595125, 112.095125, 109.142, 107.876375, 108.532625, 103.23575,
            101.73575, 101.126375, 99.907625, 105.063875, 102.626375, 98.595125, 104.36075, 100.142, 102.251375,
            99.29825, 100.657625, 102.767, 102.392, 100.188875, 99.86075, 98.688875, 103.23575, 97.7045, 95.782625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:23.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.37336,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:23.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.251375, 118.42325, 115.376375, 111.767, 108.813875, 107.876375, 109.282625, 109.61075, 115.892, 111.017,
            103.657625, 99.532625, 100.892, 101.642, 99.5795, 100.188875, 99.813875, 98.17325, 99.907625, 100.938875,
            102.767, 102.11075, 100.79825, 100.095125, 98.595125, 102.11075, 96.392, 94.98575,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:53.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.83148,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:53.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.032625, 106.61075, 103.7045, 104.032625, 105.157625, 111.9545, 112.98575, 105.438875, 103.376375,
            102.48575, 102.767, 104.782625, 100.98575, 100.23575, 99.157625, 98.313875, 98.032625, 97.892, 98.0795,
            100.282625, 102.157625, 101.970125, 100.563875, 99.813875, 98.36075, 102.720125, 96.5795, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:19.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.51428,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:19.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.157625, 108.251375, 104.4545, 104.313875, 105.11075, 104.688875, 105.11075, 105.9545, 104.876375,
            121.188875, 110.54825, 99.532625, 101.407625, 102.29825, 101.595125, 104.17325, 101.642, 100.751375,
            106.42325, 101.126375, 103.470125, 102.532625, 100.563875, 100.04825, 98.782625, 104.501375, 97.845125,
            95.92325,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:18.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.643974,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:18.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.392, 106.845125, 105.251375, 106.04825, 107.970125, 106.563875, 109.23575, 109.142, 106.79825,
            123.48575, 117.67325, 103.04825, 104.267, 106.142, 106.095125, 101.782625, 100.376375, 100.095125,
            99.251375, 100.282625, 102.251375, 101.782625, 100.61075, 99.86075, 98.220125, 102.5795, 96.251375,
            95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:41.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.54113,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:41.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.126375, 118.470125, 116.595125, 115.79825, 114.907625, 109.04825, 107.876375, 107.595125, 103.657625,
            101.0795, 99.907625, 109.3295, 99.67325, 99.11075, 110.032625, 97.563875, 97.61075, 98.313875, 98.36075,
            100.282625, 102.532625, 102.063875, 100.563875, 100.04825, 98.688875, 102.251375, 96.29825, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:35.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.5516,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:35.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.376375, 120.251375, 118.470125, 116.782625, 114.532625, 111.626375, 111.86075, 116.36075, 106.517,
            107.595125, 102.813875, 100.23575, 100.04825, 102.2045, 98.876375, 97.98575, 97.23575, 97.751375, 98.267,
            100.7045, 101.92325, 102.813875, 100.892, 100.095125, 98.970125, 103.563875, 96.86075, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:32.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.71167,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:32.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.657625, 114.907625, 111.720125, 109.61075, 106.892, 104.36075, 105.251375, 105.86075, 101.876375,
            99.5795, 99.48575, 97.23575, 102.9545, 99.11075, 97.282625, 96.86075, 96.438875, 97.42325, 98.0795,
            100.04825, 102.5795, 101.73575, 100.657625, 99.626375, 98.595125, 102.017, 96.345125, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:22.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.38671,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:22.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.470125, 110.642, 107.8295, 106.657625, 106.7045, 104.92325, 106.188875, 109.42325, 118.563875,
            107.220125, 102.720125, 101.126375, 98.595125, 100.095125, 99.532625, 100.095125, 97.3295, 97.517, 97.79825,
            99.907625, 102.345125, 101.407625, 100.376375, 100.095125, 98.4545, 102.29825, 96.345125, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:08.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.44795,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:08.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.376375, 111.9545, 109.3295, 108.532625, 107.0795, 104.92325, 107.407625, 108.345125, 102.5795,
            101.126375, 101.970125, 99.720125, 99.11075, 98.782625, 97.095125, 97.470125, 96.11075, 96.626375,
            98.032625, 100.282625, 102.157625, 101.782625, 100.142, 99.532625, 98.267, 101.73575, 96.2045, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:39.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.33394,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:39.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.532625, 112.3295, 108.251375, 107.17325, 108.11075, 106.657625, 106.001375, 106.517, 107.220125,
            120.626375, 112.095125, 102.345125, 105.67325, 106.470125, 106.563875, 102.438875, 101.595125, 100.282625,
            99.438875, 100.751375, 102.67325, 101.970125, 100.23575, 99.626375, 98.0795, 101.876375, 96.251375, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:47.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.01018,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:47.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.86075, 102.5795, 103.3295, 105.767, 106.751375, 105.5795, 106.188875, 105.438875, 102.48575, 100.282625,
            100.04825, 98.876375, 99.11075, 99.813875, 97.188875, 97.04825, 96.813875, 97.095125, 97.98575, 100.04825,
            102.438875, 102.29825, 100.61075, 100.095125, 98.4545, 102.2045, 96.29825, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:32.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 146.15952,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:32.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            145.282625, 137.642, 129.9545, 124.98575, 122.4545, 119.642, 116.220125, 112.98575, 110.36075, 112.98575,
            103.845125, 102.438875, 103.42325, 108.11075, 114.251375, 103.3295, 105.251375, 111.11075, 105.907625,
            102.345125, 103.188875, 102.626375, 100.98575, 100.42325, 99.2045, 105.345125, 99.48575, 96.9545,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:14.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.725624,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:14.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.657625, 112.61075, 109.751375, 107.313875, 106.845125, 105.157625, 106.282625, 107.267, 104.17325,
            120.86075, 124.79825, 112.142, 105.86075, 105.532625, 106.142, 102.48575, 99.720125, 98.36075, 99.017,
            100.23575, 102.157625, 101.8295, 100.188875, 99.720125, 98.54825, 102.86075, 96.438875, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:41.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.76471,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:41.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.9545, 124.188875, 119.876375, 116.8295, 116.688875, 112.751375, 110.032625, 108.67325, 105.017,
            101.54825, 100.188875, 100.04825, 100.845125, 98.407625, 97.563875, 98.54825, 99.29825, 98.501375, 97.517,
            99.767, 102.251375, 101.876375, 100.376375, 99.767, 98.126375, 101.73575, 96.017, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:43.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.14706,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:43.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 123.907625, 119.73575, 115.188875, 113.782625, 110.782625, 109.845125, 108.907625, 106.001375,
            117.157625, 109.98575, 101.407625, 102.720125, 100.001375, 103.3295, 102.86075, 103.892, 98.407625,
            97.938875, 99.67325, 101.92325, 101.407625, 100.095125, 99.48575, 98.0795, 101.970125, 95.92325, 95.220125,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:45.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.14005,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:45.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.2045, 120.767, 116.126375, 113.876375, 112.001375, 109.376375, 105.345125, 105.2045, 102.626375,
            101.970125, 99.86075, 99.157625, 99.11075, 98.782625, 97.938875, 97.282625, 97.61075, 97.3295, 97.657625,
            100.095125, 101.8295, 101.407625, 99.907625, 99.5795, 98.313875, 101.73575, 96.157625, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:54.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.12328,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:54.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.7045, 120.11075, 113.92325, 108.345125, 108.157625, 110.17325, 108.251375, 108.11075, 106.095125,
            106.376375, 115.7045, 105.017, 99.5795, 98.782625, 98.688875, 99.5795, 97.470125, 98.642, 98.267,
            100.095125, 102.11075, 101.876375, 100.470125, 99.767, 98.54825, 102.345125, 96.767, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:13.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.06601,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:13.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.376375, 121.095125, 117.48575, 114.345125, 111.48575, 107.267, 106.42325, 106.42325, 103.563875,
            102.2045, 100.845125, 99.438875, 98.642, 99.392, 97.98575, 97.04825, 97.001375, 97.563875, 97.7045,
            99.720125, 102.157625, 101.782625, 100.657625, 99.9545, 98.407625, 102.251375, 96.392, 95.407625,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:33.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.56525,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:33.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.938875, 127.938875, 127.142, 124.095125, 120.67325, 115.470125, 112.751375, 108.720125, 105.438875,
            101.92325, 100.892, 105.48575, 110.73575, 99.626375, 99.813875, 106.7045, 101.126375, 104.36075, 102.438875,
            101.73575, 102.767, 102.86075, 100.751375, 99.720125, 98.73575, 102.345125, 96.392, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:29.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.98849,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:29.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.017, 116.267, 112.517, 109.751375, 106.23575, 105.29825, 105.9545, 105.063875, 101.595125, 99.813875,
            103.657625, 109.61075, 100.517, 99.532625, 98.220125, 100.563875, 98.8295, 100.517, 98.73575, 100.751375,
            102.9545, 102.11075, 100.79825, 100.095125, 98.73575, 102.626375, 96.532625, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:25.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.43292,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:25.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.61075, 128.0795, 124.892, 120.438875, 117.392, 114.86075, 112.61075, 110.032625, 105.907625, 102.48575,
            100.282625, 99.767, 98.92325, 99.345125, 97.845125, 97.188875, 97.04825, 97.188875, 98.267, 100.23575,
            102.2045, 102.11075, 100.23575, 99.626375, 98.36075, 102.438875, 96.626375, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:37.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.08177,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:37.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.267, 123.813875, 123.29825, 122.407625, 122.688875, 117.017, 114.017, 111.29825, 110.73575, 105.438875,
            105.11075, 101.73575, 102.017, 104.0795, 100.470125, 99.438875, 100.657625, 102.392, 100.470125, 100.845125,
            102.48575, 102.86075, 100.142, 99.767, 98.501375, 103.376375, 96.9545, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:07.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.29901,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:07.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.126375, 124.938875, 122.642, 119.642, 115.892, 119.8295, 118.3295, 110.595125, 108.29825, 107.642,
            110.407625, 101.73575, 100.142, 100.376375, 98.36075, 97.42325, 97.23575, 97.188875, 97.98575, 100.3295,
            102.2045, 101.595125, 100.42325, 99.5795, 98.126375, 101.8295, 96.251375, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:36.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.98528,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:36.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.9545, 128.8295, 127.98575, 126.11075, 120.67325, 114.813875, 109.7045, 108.438875, 103.517, 106.04825,
            101.782625, 99.5795, 98.642, 102.2045, 99.438875, 103.04825, 100.142, 101.0795, 102.907625, 101.032625,
            102.86075, 102.86075, 100.657625, 99.86075, 98.267, 102.29825, 96.907625, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:09.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.61661,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:09.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.73575, 114.86075, 112.095125, 107.501375, 106.517, 105.626375, 105.720125, 106.79825, 103.04825,
            101.595125, 101.782625, 100.657625, 99.626375, 99.251375, 97.657625, 97.751375, 96.626375, 97.517, 97.61075,
            100.001375, 101.92325, 101.36075, 100.04825, 99.48575, 98.17325, 101.92325, 96.29825, 95.17325,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:55.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.60045,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:55.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.79825, 122.642, 118.563875, 114.063875, 112.376375, 116.8295, 121.3295, 106.563875, 104.73575,
            113.126375, 105.345125, 112.376375, 102.2045, 99.063875, 99.720125, 98.36075, 97.23575, 98.4545, 97.98575,
            100.188875, 102.157625, 101.688875, 100.188875, 99.48575, 97.892, 101.54825, 96.11075, 95.313875,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:50.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.3552,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:50.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.8295, 127.845125, 124.657625, 122.501375, 118.938875, 117.767, 113.4545, 112.376375, 107.4545, 103.142,
            100.188875, 99.813875, 98.4545, 99.438875, 97.892, 97.095125, 96.907625, 96.9545, 98.220125, 100.04825,
            102.392, 101.501375, 100.23575, 99.67325, 98.36075, 102.251375, 96.48575, 95.17325,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:34.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.40317,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:34.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.032625, 123.5795, 120.48575, 116.688875, 114.157625, 110.642, 109.657625, 108.017, 103.751375,
            101.782625, 98.73575, 98.688875, 102.251375, 99.345125, 98.17325, 97.845125, 97.23575, 97.751375, 98.032625,
            100.142, 102.11075, 102.86075, 100.98575, 100.001375, 99.29825, 103.79825, 96.720125, 95.501375,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:10.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.60437,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:10.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.095125, 116.782625, 113.126375, 109.095125, 105.907625, 104.595125, 103.938875, 106.470125, 109.517,
            126.2045, 117.5795, 102.2045, 103.376375, 102.720125, 106.892, 100.657625, 98.220125, 99.438875, 98.36075,
            100.04825, 101.970125, 101.36075, 100.3295, 99.626375, 98.267, 101.970125, 96.063875, 95.4545,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:59.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.63348,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:59.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.626375, 107.17325, 105.813875, 106.517, 107.36075, 106.751375, 107.313875, 108.017, 113.73575,
            129.532625, 122.126375, 104.126375, 107.032625, 99.9545, 99.438875, 100.04825, 99.5795, 97.376375, 97.892,
            100.188875, 102.157625, 101.92325, 100.23575, 100.001375, 98.642, 102.86075, 96.251375, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:26.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 116.28821,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:26.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            106.376375, 102.392, 102.157625, 103.42325, 104.688875, 105.157625, 104.4545, 106.3295, 102.532625,
            101.313875, 101.970125, 100.282625, 99.157625, 99.29825, 97.657625, 97.3295, 97.095125, 97.23575, 97.845125,
            100.42325, 101.8295, 101.54825, 100.23575, 99.438875, 98.17325, 102.2045, 96.345125, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:44.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.1177,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:44.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.04825, 133.563875, 130.282625, 129.157625, 125.267, 122.876375, 120.2045, 115.79825, 112.188875,
            108.345125, 105.29825, 107.17325, 107.54825, 101.501375, 101.032625, 102.063875, 108.29825, 105.67325,
            105.2045, 103.001375, 102.67325, 102.813875, 100.517, 99.907625, 98.36075, 103.142, 97.42325, 95.54825,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:34.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.84763,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:43:34.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.438875, 125.688875, 121.657625, 118.188875, 115.3295, 112.751375, 110.032625, 106.79825, 104.0795,
            105.345125, 100.42325, 98.782625, 98.54825, 98.407625, 97.04825, 97.657625, 96.907625, 96.907625, 98.0795,
            100.470125, 101.92325, 102.29825, 100.142, 99.438875, 98.0795, 101.595125, 96.157625, 95.267,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:43.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.58952,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:43.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.9545, 123.392, 118.517, 112.42325, 111.5795, 108.720125, 109.3295, 109.61075, 105.48575, 103.563875,
            115.04825, 114.157625, 110.407625, 112.188875, 99.063875, 100.3295, 100.001375, 100.142, 98.688875,
            100.282625, 102.251375, 101.73575, 100.142, 100.04825, 98.642, 103.188875, 96.48575, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:39.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.57474,
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        timestamp: '2025-08-29T22:42:39.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.48575, 120.720125, 117.907625, 114.48575, 111.438875, 109.845125, 107.54825, 107.126375, 106.79825,
            107.267, 108.67325, 99.251375, 100.095125, 101.313875, 98.688875, 97.751375, 96.9545, 97.001375, 97.517,
            99.907625, 101.876375, 101.688875, 100.42325, 99.86075, 98.36075, 101.970125, 96.345125, 95.36075,
        ],
        latitude: 37.4405755,
        longitude: -122.533388,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.50649065836552, 117.81476467971763, 115.55269839857874, 114.17369483985983, 112.57038078292027,
                111.20333229537573, 111.62576334519783, 112.5791107651267, 107.56370818505529, 104.2301895017811,
                103.2454808718878, 101.9352606761582, 100.17742037366698, 99.00632384341779, 97.9384301601437,
                98.6219822064071, 99.26655516014381, 99.1425004448413, 99.42413967971676, 101.11475355872038,
                103.03985364768846, 102.71011610320446, 101.19821663701221, 100.3375627224214, 98.73458229537505,
                102.54786076512615, 96.23830782918273, 95.25649065836416,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.01481249999999, 102.49793749999999, 101.681375, 103.61075, 103.8179375, 103.1148125, 104.8295,
                105.6929375, 100.7710625, 98.118875, 97.41575, 96.4116875, 95.688875, 95.313875, 94.5366875, 94.657625,
                95.032625, 95.782625, 97.142, 99.5795, 101.688875, 101.407625, 100.23575, 99.48575, 98.0054375,
                101.407625, 95.73575, 95.0795,
            ],
            '25th_percentile': [
                117.67325, 111.626375, 109.517, 109.188875, 108.4154375, 107.876375, 108.626375, 109.845125, 104.642,
                101.126375, 100.188875, 98.8295, 97.892, 97.42325, 96.063875, 96.251375, 96.532625, 97.001375, 97.892,
                100.095125, 102.157625, 101.876375, 100.7045, 99.9779375, 98.407625, 102.11075, 96.063875, 95.17325,
            ],
            '50th_percentile': [
                123.767, 117.67325, 115.282625, 113.92325, 111.626375, 110.595125, 111.345125, 112.563875, 107.73575,
                103.845125, 103.095125, 101.876375, 100.001375, 98.54825, 97.282625, 97.376375, 97.7045, 97.98575,
                98.501375, 100.42325, 102.438875, 102.157625, 100.892, 100.142, 98.642, 102.438875, 96.157625, 95.267,
            ],
            '75th_percentile': [
                129.48575, 124.0248125, 121.23575, 117.9779375, 115.845125, 113.6654375, 114.1341875, 115.1185625,
                110.126375, 106.751375, 105.86075, 104.313875, 101.876375, 100.0716875, 99.157625, 99.767, 101.2435625,
                100.3998125, 99.9545, 101.267, 102.907625, 102.720125, 101.313875, 100.470125, 98.876375, 102.86075,
                96.392, 95.313875,
            ],
            '99th_percentile': [
                140.1535625, 135.46887500000003, 132.87106250000002, 129.6685625, 127.72231250000002,
                125.17606250000001, 122.336375, 121.04825, 116.76575000000001, 115.61825, 112.17200000000001,
                109.87231249999999, 107.73575, 106.40356249999999, 105.5673125, 108.88793749999999, 108.4266875,
                107.24731249999999, 106.59106249999999, 107.0673125, 108.74731249999999, 108.212, 104.66918749999999,
                102.86075, 100.563875, 104.76293749999999, 97.3295, 95.52856249999999,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.42733082440034,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.68711443662231, 118.83362632042493, 115.73101848591774, 113.49565316901625, 112.00043970070632,
                109.92875176056539, 109.19470686619916, 108.71610871479068, 105.37587984155107, 103.17869674295939,
                101.49383758802972, 100.12637500000149, 99.52437235915636, 99.03796170774791, 97.99906426056474,
                97.84385959507179, 97.42820158450839, 97.78383538732531, 98.43865492957887, 100.30160607394518,
                102.18716945422699, 101.86008978873402, 100.35761399648041, 99.72601188380432, 98.41351188380425,
                102.28961223591713, 96.44008538732525, 95.31354489436744,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.75965624999999, 102.13465624999999, 101.43434375, 103.04825, 103.96278124999999, 103.376375,
                104.05653124999999, 103.75325, 100.3773125, 98.4545, 97.563875, 96.41590624999999, 96.04090624999999,
                96.04090624999999, 95.220125, 95.10340624999999, 95.0795, 95.92325, 97.001375, 99.46278124999999,
                101.501375, 101.10340624999999, 99.767, 99.157625, 97.79825, 101.29090624999999, 95.876375, 95.0795,
            ],
            '25th_percentile': [
                118.73965625, 113.06778125, 109.64590625, 108.05215625, 107.407625, 106.142, 106.376375, 106.376375,
                102.626375, 100.23575, 99.09903125, 97.892, 97.517, 97.3295, 96.438875, 96.29825, 96.017, 96.626375,
                97.61075, 99.9545, 101.970125, 101.54825, 100.142, 99.532625, 98.17325, 101.876375, 96.157625,
                95.220125,
            ],
            '50th_percentile': [
                124.563875, 118.7748125, 115.3998125, 112.3060625, 110.595125, 108.3216875, 107.92325, 107.92325,
                103.98575, 101.4545, 100.1654375, 99.0404375, 98.501375, 98.54825, 97.282625, 97.142, 96.767, 97.188875,
                98.032625, 100.188875, 102.157625, 101.782625, 100.3295, 99.67325, 98.36075, 102.2045, 96.345125,
                95.267,
            ],
            '75th_percentile': [
                130.43496875, 124.80996875, 121.52871875, 118.62246875, 115.80996875, 112.751375, 110.8060625,
                110.220125, 106.38809375, 103.79825, 101.970125, 100.938875, 99.96621875, 99.907625, 98.54825,
                98.46621875, 97.79825, 98.032625, 98.595125, 100.470125, 102.345125, 102.063875, 100.517, 99.907625,
                98.54825, 102.532625, 96.5795, 95.36075,
            ],
            '99th_percentile': [
                142.67684375, 136.9360625, 133.57559375, 129.31840625, 126.84575000000001, 125.07668749999999,
                121.44528125, 120.948875, 121.16215625, 123.36621875, 119.61809375, 114.43325, 112.74575, 108.202625,
                109.368875, 106.82028125, 105.93059375, 106.48559375, 105.9535625, 103.02434375, 103.35246875, 102.9545,
                101.10246875, 100.3754375, 99.18059375, 104.05559375, 97.91496875, 95.8285625,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.93836835916969,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        timestamp: '2025-08-29T22:43:50.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.52167,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:50.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.4545, 129.532625, 130.517, 126.813875, 120.67325, 120.438875, 118.142, 115.04825, 110.54825, 107.54825,
            103.376375, 100.892, 98.73575, 99.157625, 97.751375, 96.438875, 96.2045, 96.720125, 97.98575, 100.188875,
            102.157625, 101.688875, 100.001375, 99.392, 98.0795, 101.501375, 96.251375, 95.220125,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:44:00.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.40423,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:44:00.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.4545, 116.267, 114.157625, 112.470125, 110.876375, 112.095125, 113.73575, 108.767, 106.188875,
            101.782625, 100.563875, 98.8295, 102.345125, 104.407625, 101.970125, 99.907625, 97.3295, 97.04825,
            97.845125, 99.813875, 102.2045, 101.36075, 100.61075, 99.813875, 98.17325, 102.345125, 95.970125, 95.313875,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:53.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.79251,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:53.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.813875, 112.3295, 109.3295, 108.48575, 110.0795, 108.767, 108.48575, 109.376375, 106.095125, 101.92325,
            100.563875, 99.5795, 113.032625, 110.595125, 101.267, 106.892, 105.345125, 101.4545, 105.767, 101.54825,
            102.345125, 101.595125, 100.751375, 99.438875, 98.267, 101.688875, 96.11075, 95.267,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:52.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.420074,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:52.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.751375, 117.5795, 113.688875, 109.7045, 108.5795, 107.73575, 104.313875, 108.392, 107.0795, 101.92325,
            102.017, 101.313875, 102.48575, 102.532625, 101.501375, 103.095125, 97.7045, 97.79825, 98.17325, 100.188875,
            102.29825, 101.642, 100.04825, 99.11075, 97.98575, 101.126375, 95.970125, 95.267,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:51.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.3484,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:51.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.267, 119.4545, 117.438875, 113.407625, 110.220125, 108.626375, 104.501375, 105.251375, 101.17325,
            101.595125, 98.876375, 97.61075, 98.032625, 99.017, 97.657625, 98.313875, 96.9545, 96.5795, 97.563875,
            100.42325, 102.063875, 101.876375, 100.282625, 99.345125, 97.79825, 101.36075, 96.345125, 95.220125,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:55.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.763504,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:55.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.67325, 120.017, 117.2045, 115.845125, 112.61075, 109.376375, 105.532625, 105.720125, 101.313875,
            100.001375, 99.11075, 96.767, 98.126375, 98.54825, 97.7045, 97.095125, 96.67325, 96.532625, 97.845125,
            99.67325, 101.970125, 101.501375, 100.001375, 98.876375, 97.938875, 101.267, 96.626375, 95.36075,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:48.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.90373,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:48.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.98575, 134.876375, 130.892, 125.642, 124.938875, 124.517, 119.313875, 119.032625, 115.142, 112.563875,
            109.23575, 103.517, 102.767, 104.220125, 111.907625, 108.813875, 105.392, 102.532625, 101.267, 101.782625,
            102.767, 102.017, 100.04825, 99.626375, 98.267, 102.626375, 97.376375, 95.73575,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:49.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.43174,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:49.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 116.876375, 114.11075, 111.48575, 110.73575, 110.54825, 106.98575, 107.642, 104.782625,
            101.4545, 100.657625, 99.017, 98.970125, 99.392, 98.4545, 98.17325, 97.61075, 97.188875, 98.501375,
            99.86075, 102.532625, 101.92325, 100.282625, 99.767, 98.220125, 101.8295, 96.767, 95.36075,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:54.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.17673,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:54.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.36075, 125.782625, 117.626375, 115.142, 113.642, 110.8295, 109.3295, 109.517, 103.3295, 101.642,
            99.48575, 102.2045, 111.67325, 100.04825, 97.751375, 105.907625, 99.67325, 99.532625, 105.438875, 102.2045,
            102.345125, 103.095125, 100.61075, 99.392, 98.313875, 101.970125, 96.5795, 95.36075,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:47.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.15027,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:47.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.92325, 125.688875, 123.67325, 120.392, 117.48575, 115.3295, 113.501375, 111.345125, 105.017, 101.8295,
            98.8295, 98.688875, 99.48575, 98.782625, 100.563875, 101.970125, 97.563875, 97.001375, 98.407625,
            100.188875, 102.157625, 101.54825, 99.86075, 99.345125, 97.845125, 101.501375, 96.438875, 95.313875,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:57.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.28317,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:57.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.751375, 119.73575, 117.345125, 114.063875, 110.36075, 106.142, 104.970125, 105.626375, 102.2045,
            99.438875, 100.61075, 103.845125, 111.29825, 101.688875, 103.98575, 103.001375, 101.642, 103.563875,
            101.876375, 101.688875, 102.720125, 102.11075, 100.376375, 99.392, 98.032625, 101.782625, 96.438875, 95.267,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:56.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.78088,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:56.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.095125, 105.626375, 104.73575, 103.142, 104.17325, 105.29825, 108.438875, 104.73575, 102.345125,
            100.657625, 99.345125, 98.032625, 100.3295, 100.79825, 100.095125, 98.032625, 96.86075, 96.9545, 97.563875,
            100.23575, 102.157625, 101.642, 100.563875, 99.67325, 98.17325, 102.11075, 96.345125, 95.313875,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:59.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.48547,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:59.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.61075, 116.92325, 114.251375, 110.73575, 110.73575, 108.11075, 106.61075, 108.532625, 104.688875,
            100.23575, 99.48575, 97.188875, 98.36075, 98.8295, 97.095125, 97.001375, 96.29825, 96.813875, 97.938875,
            100.001375, 102.017, 101.688875, 100.188875, 99.532625, 98.0795, 101.73575, 95.876375, 95.126375,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:46.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.26445,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:46.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.188875, 127.938875, 124.938875, 121.517, 119.595125, 118.142, 111.392, 109.3295, 106.657625, 103.282625,
            100.657625, 98.220125, 97.938875, 99.017, 97.938875, 97.751375, 97.517, 97.188875, 98.407625, 100.938875,
            102.11075, 101.876375, 100.23575, 99.67325, 98.220125, 101.970125, 96.86075, 95.4545,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:58.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.70094,
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T22:43:58.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.720125, 116.92325, 113.54825, 110.032625, 107.17325, 104.876375, 105.532625, 106.376375, 101.642,
            100.001375, 98.92325, 98.970125, 111.11075, 99.532625, 97.7045, 102.67325, 97.470125, 104.126375, 105.767,
            102.767, 103.3295, 102.29825, 100.517, 99.9545, 98.17325, 101.688875, 96.157625, 95.36075,
        ],
        latitude: 37.4405778,
        longitude: -122.5333863,
    },
    {
        timestamp: '2025-08-29T23:00:19.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.53414,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:19.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.313875, 115.04825, 112.282625, 107.8295, 106.3295, 105.813875, 107.54825, 106.79825, 105.345125,
            102.720125, 104.407625, 105.86075, 109.3295, 102.5795, 101.642, 101.688875, 100.7045, 99.9545, 101.220125,
            101.688875, 103.001375, 103.563875, 100.61075, 99.767, 98.501375, 103.001375, 97.376375, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:08.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.00645,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:08.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.188875, 106.98575, 105.2045, 106.938875, 106.470125, 105.5795, 105.813875, 106.657625, 119.501375,
            115.657625, 103.517, 102.86075, 101.73575, 106.04825, 103.23575, 103.142, 100.517, 99.720125, 99.907625,
            101.032625, 102.86075, 102.720125, 100.563875, 99.720125, 98.8295, 102.907625, 96.720125, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:50.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.19441,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:50.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.892, 104.4545, 105.767, 106.79825, 108.532625, 108.5795, 109.282625, 108.438875, 104.032625, 104.595125,
            103.470125, 102.720125, 102.86075, 103.3295, 103.42325, 102.720125, 102.11075, 101.642, 99.86075, 100.61075,
            103.142, 102.438875, 100.892, 100.188875, 98.54825, 102.345125, 96.532625, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:21.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.17166,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:21.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.86075, 132.532625, 131.17325, 130.61075, 127.98575, 124.282625, 120.345125, 118.938875, 114.063875,
            111.626375, 107.688875, 104.688875, 101.032625, 101.8295, 100.42325, 100.23575, 100.282625, 99.720125,
            99.9545, 101.407625, 103.42325, 102.392, 101.0795, 99.86075, 98.782625, 102.813875, 96.29825, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:16.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.6853,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:16.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.23575, 123.017, 118.79825, 115.7045, 113.92325, 112.095125, 108.767, 109.7045, 106.23575, 111.5795,
            103.7045, 104.407625, 102.9545, 104.407625, 101.642, 102.813875, 101.688875, 99.767, 99.86075, 101.54825,
            103.04825, 103.563875, 101.17325, 100.23575, 99.2045, 103.376375, 97.892, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:59.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.02332,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:59.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 124.282625, 122.876375, 118.79825, 117.813875, 115.892, 113.407625, 112.188875, 108.720125,
            104.876375, 104.126375, 102.720125, 103.7045, 103.3295, 102.9545, 103.517, 102.67325, 100.845125,
            100.188875, 101.73575, 103.42325, 102.626375, 100.751375, 100.04825, 98.73575, 102.86075, 97.001375,
            95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:27.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.53722,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:27.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.11075, 120.5795, 117.48575, 114.11075, 110.220125, 107.407625, 115.23575, 107.4545, 105.157625,
            113.032625, 106.61075, 104.782625, 103.61075, 104.782625, 103.282625, 102.767, 101.876375, 101.032625,
            100.563875, 101.501375, 102.2045, 102.813875, 101.032625, 99.720125, 98.36075, 102.251375, 96.392, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:23.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.07681,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:23.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.157625, 129.017, 126.063875, 124.282625, 121.7045, 119.032625, 115.751375, 111.767, 115.095125,
            105.532625, 110.73575, 104.032625, 103.3295, 104.407625, 103.42325, 102.2045, 100.98575, 99.345125,
            99.532625, 101.36075, 102.157625, 102.86075, 100.42325, 99.29825, 97.98575, 101.8295, 96.5795, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:22.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.53506,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:22.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.267, 126.9545, 121.142, 118.001375, 119.54825, 116.407625, 112.657625, 114.438875, 105.67325, 106.42325,
            103.751375, 102.86075, 103.61075, 106.376375, 102.907625, 102.29825, 100.79825, 99.48575, 100.282625,
            101.688875, 102.438875, 103.282625, 100.42325, 99.438875, 98.407625, 102.532625, 97.095125, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:18.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.53928,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:18.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.267, 117.86075, 116.313875, 112.095125, 110.313875, 107.407625, 107.782625, 105.157625, 105.251375,
            111.063875, 103.657625, 105.251375, 106.938875, 102.86075, 101.4545, 100.3295, 99.29825, 98.782625, 99.392,
            100.845125, 102.017, 103.23575, 100.3295, 99.813875, 98.4545, 102.48575, 96.813875, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:19.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.02393,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:19.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.095125, 129.67325, 127.892, 122.970125, 119.595125, 116.407625, 115.095125, 111.86075, 109.095125,
            105.438875, 102.813875, 102.157625, 103.751375, 105.813875, 102.063875, 103.04825, 102.392, 101.8295,
            100.470125, 101.92325, 103.3295, 102.392, 100.563875, 99.767, 98.220125, 102.157625, 96.29825, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:02.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.64539,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:02.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.67325, 127.61075, 123.67325, 120.29825, 115.938875, 113.73575, 112.376375, 109.517, 106.142, 104.17325,
            102.9545, 103.79825, 112.938875, 102.392, 104.032625, 107.313875, 102.5795, 103.61075, 101.970125,
            103.001375, 103.470125, 103.001375, 100.3295, 99.9545, 98.642, 102.251375, 96.5795, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:49.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.24817,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:49.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.642, 111.532625, 109.142, 108.017, 106.282625, 108.813875, 113.220125, 107.126375, 108.251375,
            110.032625, 111.48575, 103.188875, 103.517, 103.98575, 102.813875, 101.8295, 101.782625, 99.532625, 99.9545,
            100.7045, 103.001375, 102.532625, 100.751375, 99.67325, 98.4545, 102.626375, 96.2045, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:55.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.522194,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:55.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.345125, 104.876375, 105.29825, 107.501375, 108.157625, 109.376375, 110.595125, 109.188875, 106.095125,
            103.892, 103.3295, 106.845125, 109.095125, 105.392, 106.470125, 105.813875, 105.345125, 102.813875,
            101.92325, 102.9545, 103.563875, 103.095125, 101.126375, 100.23575, 98.36075, 102.532625, 96.063875,
            95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:21.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.71219,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:21.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.017, 132.251375, 128.970125, 123.907625, 121.001375, 118.938875, 116.688875, 112.7045, 108.626375,
            107.595125, 105.720125, 104.36075, 102.9545, 102.720125, 102.907625, 101.54825, 100.470125, 99.720125,
            100.3295, 101.501375, 103.001375, 103.470125, 100.188875, 99.392, 98.36075, 102.5795, 97.3295, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:46.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.30864,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:46.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.42325, 112.42325, 110.0795, 110.17325, 108.907625, 108.626375, 110.126375, 108.017, 105.438875,
            103.095125, 102.67325, 102.48575, 102.017, 102.626375, 103.001375, 102.5795, 101.642, 99.392, 99.532625,
            101.36075, 103.188875, 103.188875, 100.98575, 100.376375, 98.688875, 102.626375, 96.532625, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:40.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.04106,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:40.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.73575, 126.86075, 124.42325, 121.376375, 117.626375, 114.48575, 111.67325, 109.470125, 106.563875,
            104.313875, 104.876375, 105.532625, 103.282625, 103.188875, 101.54825, 100.98575, 100.98575, 101.032625,
            100.282625, 101.0795, 103.001375, 103.001375, 101.267, 99.907625, 98.407625, 102.720125, 96.532625, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:03.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.26764,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:03.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.17325, 129.29825, 125.92325, 120.813875, 119.595125, 116.782625, 117.907625, 112.376375, 109.470125,
            105.017, 104.267, 102.392, 102.392, 102.86075, 101.688875, 103.470125, 103.001375, 100.657625, 100.3295,
            101.17325, 103.42325, 102.907625, 100.98575, 100.376375, 99.017, 103.3295, 97.23575, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:51.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.80202,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:51.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.54825, 117.907625, 116.8295, 114.157625, 111.251375, 108.5795, 108.5795, 105.767, 104.17325, 102.345125,
            102.67325, 103.282625, 102.251375, 102.907625, 103.470125, 103.79825, 104.4545, 101.92325, 100.188875,
            101.17325, 103.376375, 102.392, 100.61075, 100.3295, 98.8295, 103.04825, 96.813875, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:04.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.10738,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:04.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 124.095125, 122.54825, 119.267, 114.813875, 110.8295, 110.642, 107.220125, 105.063875, 120.2045,
            114.67325, 103.7045, 103.892, 105.017, 104.313875, 105.063875, 102.5795, 100.188875, 100.657625, 101.4545,
            102.813875, 102.251375, 100.517, 100.095125, 98.313875, 102.11075, 96.29825, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:13.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.61314,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:13.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.438875, 120.720125, 118.188875, 114.813875, 112.892, 109.188875, 108.11075, 107.36075, 106.095125,
            105.251375, 102.48575, 104.126375, 101.54825, 103.001375, 102.392, 102.720125, 101.73575, 100.657625,
            100.142, 101.407625, 102.720125, 101.8295, 100.188875, 99.438875, 98.407625, 102.063875, 96.438875,
            95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:27.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.83409,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:27.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.7045, 119.876375, 114.11075, 111.86075, 113.032625, 108.157625, 118.657625, 128.0795, 107.501375,
            106.517, 111.626375, 103.3295, 106.938875, 103.892, 105.017, 104.313875, 102.5795, 102.251375, 100.61075,
            101.407625, 103.001375, 102.157625, 100.7045, 99.907625, 98.642, 102.2045, 96.392, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:58.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.4696,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:58.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.392, 123.392, 120.532625, 117.532625, 115.98575, 113.220125, 111.720125, 113.267, 125.313875, 115.04825,
            105.720125, 106.79825, 103.79825, 106.188875, 106.98575, 104.642, 104.642, 102.29825, 100.938875, 102.017,
            103.42325, 102.532625, 100.42325, 100.142, 98.54825, 102.29825, 96.813875, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:15.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.49337,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:15.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.688875, 115.892, 114.392, 112.376375, 109.7045, 108.063875, 107.92325, 109.845125, 105.626375, 106.892,
            108.907625, 110.54825, 105.626375, 104.36075, 104.73575, 104.54825, 102.017, 99.532625, 99.907625,
            101.032625, 102.345125, 102.720125, 100.470125, 99.48575, 98.36075, 102.29825, 96.2045, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:29.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.84149,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:29.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.642, 127.23575, 124.188875, 115.751375, 112.845125, 112.79825, 110.595125, 110.970125, 106.376375,
            104.313875, 104.220125, 103.04825, 101.54825, 102.2045, 115.61075, 105.626375, 102.392, 100.751375,
            101.688875, 103.095125, 103.79825, 102.626375, 100.98575, 99.67325, 98.782625, 102.29825, 97.142, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:56.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.13761,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:56.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.267, 104.4545, 106.282625, 107.0795, 106.095125, 106.001375, 106.376375, 107.73575, 103.7045,
            102.345125, 101.36075, 104.407625, 103.142, 102.720125, 102.063875, 102.9545, 102.48575, 100.095125,
            99.9545, 100.845125, 102.9545, 101.782625, 100.3295, 99.86075, 98.4545, 102.11075, 96.251375, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:29.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.71576,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:29.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 118.657625, 115.79825, 111.392, 109.7045, 108.017, 107.782625, 106.845125, 104.220125, 104.313875,
            103.751375, 103.79825, 103.04825, 103.470125, 102.86075, 103.3295, 103.23575, 100.7045, 101.642, 101.126375,
            103.04825, 103.517, 101.267, 100.376375, 99.017, 102.9545, 97.001375, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:38.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.73698,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:38.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 124.376375, 120.720125, 118.517, 116.595125, 113.0795, 110.54825, 107.876375, 105.251375,
            103.563875, 104.73575, 107.876375, 113.0795, 105.157625, 106.142, 111.48575, 105.67325, 103.376375, 103.517,
            103.376375, 103.188875, 103.188875, 100.98575, 99.86075, 98.0795, 102.813875, 97.470125, 96.017,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:57.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.40561,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:57.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.9545, 123.11075, 119.501375, 114.720125, 110.92325, 109.376375, 107.17325, 107.17325, 104.407625,
            106.188875, 104.407625, 104.313875, 103.563875, 103.04825, 102.907625, 103.751375, 103.61075, 101.642,
            101.032625, 101.595125, 103.376375, 102.9545, 100.845125, 100.3295, 99.017, 103.142, 97.3295, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:18.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.87553,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:18.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.720125, 116.4545, 113.876375, 109.79825, 108.48575, 106.892, 106.79825, 106.751375, 105.063875,
            104.032625, 103.095125, 102.5795, 102.345125, 111.907625, 102.532625, 105.720125, 104.970125, 102.767,
            102.767, 101.92325, 103.98575, 103.142, 101.688875, 100.001375, 98.688875, 103.657625, 96.67325, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:31.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.28711,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:31.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.11075, 112.142, 109.7045, 107.8295, 106.657625, 106.23575, 107.220125, 106.563875, 103.3295, 104.4545,
            103.282625, 117.67325, 102.813875, 103.188875, 113.595125, 101.92325, 101.54825, 101.782625, 104.407625,
            102.017, 103.188875, 103.3295, 101.313875, 100.23575, 98.688875, 102.67325, 96.438875, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:28.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.7616,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:28.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.7045, 134.595125, 131.501375, 127.517, 124.517, 121.61075, 118.517, 118.7045, 114.626375, 109.98575,
            108.67325, 104.595125, 102.720125, 112.563875, 120.813875, 103.376375, 106.751375, 107.4545, 110.876375,
            103.657625, 104.642, 103.751375, 102.67325, 100.563875, 98.876375, 103.095125, 97.001375, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:25.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.1617,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:25.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.782625, 116.8295, 113.8295, 111.345125, 109.282625, 107.36075, 110.126375, 110.4545, 104.4545,
            116.501375, 114.438875, 103.517, 103.657625, 104.220125, 104.17325, 103.563875, 102.438875, 101.032625,
            100.98575, 101.73575, 102.392, 103.142, 100.517, 99.532625, 98.642, 102.2045, 96.532625, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:12.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 148.78537,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:12.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            146.595125, 142.470125, 139.892, 130.61075, 127.095125, 125.313875, 122.126375, 120.157625, 118.282625,
            120.29825, 110.970125, 107.17325, 107.501375, 112.42325, 109.517, 107.0795, 108.48575, 102.86075, 107.267,
            106.376375, 104.642, 103.563875, 101.126375, 100.188875, 98.782625, 104.36075, 97.42325, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:44.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.15587,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:44.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.313875, 112.938875, 112.23575, 113.688875, 113.267, 111.017, 110.36075, 112.892, 106.79825, 111.67325,
            106.095125, 105.438875, 104.407625, 103.282625, 103.79825, 103.188875, 101.73575, 100.04825, 99.532625,
            101.267, 103.3295, 103.376375, 101.4545, 99.9545, 98.36075, 102.017, 97.001375, 95.4545,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:20.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.00558,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:20.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.642, 126.767, 124.61075, 120.9545, 118.3295, 115.142, 112.7045, 110.595125, 107.220125, 105.251375,
            104.407625, 104.36075, 103.3295, 103.282625, 102.720125, 100.98575, 101.126375, 100.001375, 100.282625,
            101.54825, 102.813875, 103.3295, 100.892, 99.86075, 98.688875, 102.767, 97.142, 95.54825,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:26.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.87265,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:26.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.142, 124.3295, 123.813875, 122.876375, 118.470125, 116.36075, 113.313875, 114.438875, 109.23575,
            106.938875, 103.938875, 103.04825, 100.61075, 100.42325, 100.095125, 100.892, 100.61075, 100.3295, 100.142,
            101.36075, 103.563875, 102.532625, 100.142, 99.67325, 98.126375, 101.970125, 96.626375, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:11.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.62314,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:11.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.8295, 127.892, 124.282625, 119.501375, 117.157625, 114.9545, 112.7045, 111.017, 112.938875, 125.8295,
            115.095125, 104.313875, 105.29825, 104.92325, 104.92325, 105.907625, 103.938875, 101.595125, 101.642,
            101.970125, 103.3295, 102.48575, 100.892, 100.095125, 98.595125, 102.86075, 96.29825, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:47.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.30553,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:47.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.9545, 120.157625, 116.54825, 115.001375, 111.907625, 112.23575, 124.04825, 108.9545, 106.61075,
            116.970125, 109.938875, 108.48575, 103.470125, 105.017, 108.017, 105.157625, 103.845125, 101.4545, 100.3295,
            101.73575, 103.376375, 103.04825, 100.7045, 99.9545, 98.876375, 102.392, 96.392, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:53.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.42625,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:53.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 123.9545, 118.98575, 116.54825, 113.73575, 111.29825, 109.517, 106.892, 109.04825, 107.501375,
            103.61075, 102.392, 104.92325, 104.220125, 102.86075, 104.032625, 104.17325, 100.845125, 99.626375,
            100.751375, 102.5795, 101.876375, 100.188875, 99.907625, 98.267, 102.063875, 96.720125, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:39.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.37589,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:39.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.688875, 123.345125, 121.3295, 117.907625, 116.313875, 113.267, 110.126375, 108.813875, 104.782625,
            103.470125, 102.907625, 113.688875, 114.767, 103.751375, 115.563875, 112.938875, 103.3295, 104.032625,
            104.782625, 102.720125, 103.61075, 102.767, 101.36075, 99.720125, 98.267, 102.345125, 96.29825, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:52.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.94351,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:52.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.251375, 120.532625, 119.267, 116.36075, 114.345125, 110.92325, 108.907625, 108.2045, 105.86075,
            103.42325, 102.720125, 102.626375, 126.720125, 103.470125, 104.126375, 112.517, 107.4545, 107.642,
            101.407625, 102.767, 103.3295, 102.5795, 100.79825, 99.907625, 98.313875, 101.876375, 96.29825, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:20.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.09534,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:20.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.970125, 127.001375, 124.376375, 119.876375, 116.17325, 113.36075, 111.438875, 111.251375, 106.04825,
            105.5795, 102.907625, 103.04825, 101.126375, 102.438875, 101.595125, 101.17325, 100.282625, 99.767,
            100.282625, 101.688875, 103.095125, 102.2045, 100.282625, 99.86075, 98.313875, 102.063875, 96.345125,
            95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:24.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.77524,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:24.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.892, 127.892, 125.220125, 121.42325, 120.11075, 118.517, 114.063875, 110.8295, 106.517, 104.876375,
            104.501375, 103.79825, 101.126375, 101.642, 100.3295, 101.313875, 101.782625, 100.04825, 100.23575,
            101.4545, 103.376375, 102.017, 100.563875, 99.720125, 98.501375, 102.29825, 96.2045, 95.126375,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:33.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.10281,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:33.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.188875, 129.720125, 127.23575, 126.11075, 122.4545, 120.5795, 118.142, 114.9545, 109.282625, 106.001375,
            105.5795, 104.782625, 104.407625, 103.282625, 103.04825, 102.29825, 101.220125, 99.86075, 99.532625,
            101.688875, 102.48575, 101.782625, 100.095125, 99.767, 98.642, 102.2045, 97.04825, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:17.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.03268,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:17.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.595125, 119.782625, 117.251375, 116.17325, 112.61075, 109.376375, 109.845125, 108.438875, 115.3295,
            129.626375, 108.767, 106.095125, 105.2045, 106.79825, 109.188875, 105.907625, 102.392, 100.470125,
            100.938875, 102.392, 103.61075, 104.17325, 100.892, 100.188875, 99.9545, 103.61075, 98.876375, 95.642,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:36.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.00141,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:36.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.73575, 114.907625, 115.001375, 114.251375, 110.54825, 108.86075, 109.04825, 106.282625, 104.642,
            103.42325, 105.392, 113.782625, 115.938875, 104.8295, 106.845125, 106.42325, 103.61075, 100.517, 103.657625,
            102.48575, 103.563875, 104.220125, 100.892, 100.04825, 98.267, 102.11075, 96.2045, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:34.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.78276,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:34.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.438875, 114.67325, 115.04825, 112.7045, 108.157625, 106.79825, 105.5795, 105.48575, 103.04825,
            102.86075, 103.376375, 104.267, 103.282625, 102.392, 102.813875, 102.767, 101.0795, 99.48575, 100.001375,
            101.595125, 102.67325, 102.532625, 100.517, 99.767, 98.4545, 101.92325, 96.767, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:25.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.78372,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:25.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.142, 127.61075, 125.267, 124.282625, 124.001375, 119.220125, 114.5795, 114.438875, 111.345125, 119.4545,
            113.313875, 103.98575, 105.29825, 105.2045, 103.470125, 103.376375, 103.98575, 102.813875, 100.79825,
            102.2045, 103.23575, 102.767, 100.938875, 99.626375, 98.0795, 102.48575, 96.720125, 95.407625,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:22.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.70496,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:22.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.3295, 127.845125, 125.782625, 121.938875, 118.79825, 119.876375, 115.892, 117.9545, 119.782625,
            113.54825, 106.282625, 105.532625, 102.157625, 104.970125, 102.392, 101.8295, 101.313875, 101.4545,
            100.470125, 102.11075, 103.7045, 102.5795, 101.0795, 99.720125, 98.595125, 102.9545, 96.5795, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:28.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.76082,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:28.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.938875, 124.657625, 121.79825, 118.517, 116.595125, 112.282625, 112.095125, 112.04825, 107.17325,
            105.251375, 105.017, 104.54825, 102.29825, 103.188875, 102.907625, 102.9545, 103.142, 100.892, 101.4545,
            101.220125, 102.438875, 103.23575, 100.892, 99.67325, 98.688875, 102.29825, 96.907625, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:41.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.60376,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:41.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.267, 127.751375, 122.73575, 118.7045, 115.517, 113.313875, 110.407625, 108.86075, 104.032625,
            103.282625, 102.9545, 102.720125, 103.142, 102.626375, 101.688875, 102.017, 101.688875, 100.42325, 99.2045,
            101.17325, 103.001375, 102.532625, 100.892, 99.392, 98.267, 102.2045, 96.767, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:37.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.21983,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:37.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.345125, 133.845125, 132.157625, 130.188875, 128.36075, 124.938875, 121.470125, 118.98575, 115.142,
            111.438875, 107.92325, 106.376375, 104.17325, 105.2045, 103.892, 103.845125, 101.0795, 101.970125,
            100.470125, 101.501375, 102.813875, 102.626375, 101.0795, 100.23575, 98.73575, 102.5795, 96.67325,
            95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:42.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.99422,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:42.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.392, 132.48575, 128.267, 124.657625, 121.79825, 119.4545, 116.220125, 112.7045, 109.98575, 107.0795,
            106.142, 105.48575, 103.3295, 103.7045, 102.392, 102.532625, 102.157625, 99.9545, 99.720125, 101.54825,
            102.5795, 102.11075, 100.376375, 100.563875, 98.876375, 103.892, 96.813875, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:13.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.35585,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:13.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.626375, 131.688875, 128.501375, 127.563875, 124.001375, 119.220125, 115.845125, 113.92325, 107.032625,
            105.29825, 102.532625, 102.345125, 106.23575, 103.657625, 102.063875, 103.61075, 102.251375, 102.813875,
            102.86075, 107.0795, 104.595125, 102.86075, 100.892, 99.86075, 98.688875, 102.48575, 96.720125, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:16.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.753174,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:16.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.73575, 113.36075, 110.407625, 109.376375, 107.8295, 107.4545, 106.61075, 107.17325, 106.517, 103.892,
            102.907625, 101.970125, 102.5795, 102.2045, 101.970125, 103.04825, 102.48575, 101.126375, 100.892,
            101.313875, 102.9545, 102.157625, 100.188875, 99.392, 97.98575, 101.8295, 96.48575, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:09.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.238884,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:09.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.3295, 114.907625, 112.470125, 109.563875, 106.563875, 108.29825, 107.73575, 105.767, 103.376375,
            103.188875, 103.376375, 108.48575, 112.845125, 114.017, 101.876375, 114.251375, 108.157625, 106.04825,
            108.11075, 105.48575, 106.517, 103.938875, 101.267, 100.42325, 99.11075, 102.907625, 96.29825, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:45.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.12549,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:45.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.220125, 105.9545, 105.67325, 106.001375, 106.23575, 106.470125, 107.8295, 109.845125, 116.220125,
            103.657625, 107.0795, 102.2045, 103.892, 102.2045, 102.67325, 102.48575, 101.220125, 98.92325, 98.73575,
            101.032625, 103.42325, 103.188875, 100.938875, 99.86075, 98.73575, 102.5795, 96.11075, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:07.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.698166,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:07.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.251375, 105.2045, 105.251375, 107.688875, 107.17325, 108.86075, 106.79825, 105.251375, 103.517,
            103.3295, 102.67325, 101.92325, 101.126375, 102.392, 101.267, 101.36075, 100.3295, 99.392, 100.79825,
            100.657625, 103.04825, 102.626375, 100.845125, 100.095125, 98.595125, 102.392, 96.392, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:06.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.21261,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:06.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.11075, 110.970125, 107.313875, 104.54825, 107.313875, 109.001375, 108.5795, 106.79825, 104.17325,
            103.04825, 102.86075, 100.845125, 108.9545, 102.86075, 101.642, 101.54825, 100.79825, 101.032625, 100.98575,
            100.938875, 102.9545, 102.063875, 100.7045, 100.376375, 98.782625, 102.813875, 96.48575, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:20.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.79558,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:20.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.188875, 129.063875, 129.345125, 127.7045, 123.11075, 119.876375, 116.782625, 115.751375, 113.4545,
            107.220125, 105.2045, 103.751375, 102.626375, 103.142, 103.23575, 101.782625, 101.0795, 99.48575, 99.720125,
            101.0795, 102.626375, 103.188875, 100.938875, 99.767, 98.688875, 103.142, 97.095125, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:01.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.24236,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:01.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.876375, 124.001375, 122.126375, 117.67325, 114.017, 110.688875, 110.595125, 108.86075, 105.48575,
            103.3295, 102.813875, 100.845125, 101.688875, 102.251375, 102.392, 103.61075, 103.282625, 100.751375,
            99.907625, 100.892, 102.532625, 102.532625, 100.188875, 99.767, 98.313875, 101.73575, 96.720125, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:43.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.66211,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:43.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.220125, 134.782625, 132.907625, 130.7045, 129.86075, 125.54825, 123.5795, 120.438875, 116.407625,
            117.345125, 109.517, 106.470125, 105.29825, 104.313875, 102.67325, 102.813875, 102.345125, 100.001375,
            99.907625, 101.54825, 103.188875, 103.188875, 100.938875, 99.813875, 98.688875, 102.438875, 96.813875,
            95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:26.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.89513,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:26.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.73575, 120.2045, 115.470125, 114.2045, 112.657625, 112.751375, 124.751375, 107.0795, 108.2045,
            124.470125, 107.642, 108.48575, 104.970125, 112.376375, 106.98575, 104.313875, 104.17325, 103.892,
            104.407625, 101.642, 103.142, 103.470125, 100.563875, 99.907625, 98.782625, 103.188875, 97.001375,
            95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:48.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.40332,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:48.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.751375, 125.642, 124.751375, 122.501375, 118.7045, 118.23575, 126.438875, 110.876375, 107.501375,
            119.220125, 107.782625, 105.767, 105.157625, 106.845125, 107.17325, 104.876375, 104.17325, 101.17325,
            100.095125, 101.0795, 102.67325, 102.29825, 100.657625, 100.23575, 98.876375, 102.86075, 96.392, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:35.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.19208,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:35.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.17325, 109.470125, 106.470125, 109.751375, 108.438875, 108.345125, 109.751375, 107.4545, 106.095125,
            103.376375, 104.4545, 111.438875, 107.032625, 103.04825, 112.845125, 103.42325, 102.438875, 108.157625,
            101.595125, 102.2045, 103.001375, 103.470125, 100.938875, 100.142, 98.501375, 102.5795, 96.438875, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:15.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.07631,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:15.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.657625, 124.657625, 122.92325, 121.282625, 117.767, 113.782625, 112.845125, 112.79825, 106.563875,
            105.9545, 102.86075, 103.095125, 110.688875, 117.438875, 103.845125, 109.282625, 108.720125, 108.345125,
            105.29825, 104.970125, 105.157625, 103.79825, 101.36075, 99.907625, 98.501375, 102.29825, 96.2045, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:00.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.16742,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:00.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.720125, 124.98575, 120.907625, 120.9545, 116.8295, 112.7045, 112.095125, 110.17325, 112.42325, 115.142,
            105.48575, 102.907625, 104.032625, 105.720125, 104.126375, 104.032625, 104.267, 101.4545, 100.42325,
            101.407625, 103.142, 102.626375, 100.517, 99.907625, 99.017, 103.376375, 97.3295, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:30.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.20948,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:30.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 110.17325, 109.657625, 110.8295, 108.392, 105.767, 108.532625, 108.2045, 104.642, 103.79825,
            103.79825, 105.345125, 102.017, 102.626375, 103.79825, 102.720125, 103.188875, 100.751375, 102.5795,
            101.595125, 103.142, 102.5795, 100.751375, 100.188875, 98.782625, 102.907625, 96.438875, 95.36075,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:32.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 149.18658,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:32.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            146.313875, 143.595125, 141.626375, 131.126375, 128.126375, 125.595125, 121.61075, 120.345125, 118.470125,
            112.938875, 110.501375, 111.29825, 104.54825, 104.126375, 105.251375, 102.063875, 100.79825, 99.67325,
            100.376375, 101.17325, 102.767, 101.876375, 100.282625, 99.392, 98.220125, 102.813875, 97.001375, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:14.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.02611,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:14.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.157625, 131.501375, 128.032625, 125.501375, 123.626375, 120.626375, 118.98575, 117.017, 124.142,
            125.17325, 111.532625, 104.595125, 103.751375, 108.67325, 104.501375, 105.063875, 103.845125, 101.688875,
            101.313875, 102.532625, 103.3295, 102.5795, 100.657625, 99.532625, 98.595125, 103.470125, 97.3295,
            95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:05.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.96085,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:05.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 117.626375, 114.345125, 112.470125, 112.04825, 110.688875, 109.98575, 107.73575, 105.11075,
            104.92325, 104.267, 107.595125, 113.267, 103.23575, 102.063875, 110.8295, 110.501375, 102.767, 103.23575,
            102.626375, 104.126375, 102.720125, 101.595125, 100.23575, 99.063875, 102.813875, 96.345125, 95.267,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:10.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.65072,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:10.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.11075, 104.54825, 104.688875, 106.892, 106.188875, 106.563875, 107.0795, 107.4545, 104.970125,
            104.407625, 103.095125, 103.7045, 102.157625, 101.8295, 101.407625, 101.92325, 101.36075, 100.42325,
            101.032625, 100.98575, 102.907625, 102.2045, 100.563875, 100.04825, 98.54825, 102.29825, 96.438875,
            95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:17.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.879074,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:17.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.470125, 111.5795, 108.017, 105.907625, 106.657625, 105.813875, 107.407625, 111.345125, 121.563875,
            110.4545, 106.79825, 104.313875, 101.782625, 103.79825, 102.86075, 103.3295, 102.11075, 100.98575,
            101.17325, 101.501375, 103.42325, 102.720125, 100.845125, 99.626375, 98.4545, 102.626375, 96.438875,
            95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:24.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.0117,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:24.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.8295, 124.188875, 118.42325, 116.501375, 114.813875, 112.79825, 110.220125, 109.563875, 104.8295,
            104.0795, 105.11075, 103.001375, 102.767, 102.720125, 103.517, 101.595125, 100.79825, 99.532625, 99.5795,
            101.220125, 102.157625, 102.907625, 100.23575, 99.532625, 98.313875, 102.2045, 96.345125, 95.17325,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:23.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.35612,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:01:23.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.345125, 123.5795, 123.29825, 123.2045, 120.392, 115.61075, 113.313875, 110.4545, 106.938875, 105.29825,
            103.61075, 102.345125, 101.267, 101.4545, 100.42325, 101.73575, 101.17325, 100.04825, 100.04825, 101.782625,
            103.3295, 102.2045, 100.42325, 99.5795, 97.845125, 101.313875, 96.157625, 95.220125,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:54.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.1848,
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:00:54.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.11075, 125.595125, 122.92325, 121.23575, 120.392, 115.7045, 111.767, 109.98575, 121.751375, 123.017,
            112.376375, 103.845125, 105.813875, 105.063875, 106.938875, 105.626375, 105.532625, 102.017, 101.220125,
            102.813875, 103.282625, 102.345125, 100.79825, 100.563875, 99.251375, 103.751375, 96.626375, 95.313875,
        ],
        latitude: 37.440579,
        longitude: -122.5334447,
    },
    {
        timestamp: '2025-08-29T23:02:43.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.5673,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:43.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.595125, 125.407625, 123.5795, 115.517, 112.845125, 113.4545, 112.470125, 110.220125, 106.517, 104.17325,
            102.67325, 101.17325, 98.642, 101.267, 102.438875, 103.001375, 100.79825, 99.017, 99.9545, 101.501375,
            104.0795, 102.86075, 100.61075, 100.142, 98.501375, 102.29825, 97.04825, 95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:03.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.58309,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:03.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.892, 119.501375, 117.532625, 114.392, 110.407625, 112.095125, 109.98575, 104.595125, 103.98575,
            104.032625, 102.907625, 103.517, 101.267, 109.563875, 103.657625, 106.23575, 109.04825, 103.657625,
            103.001375, 102.29825, 105.2045, 103.3295, 101.313875, 100.42325, 98.642, 102.626375, 96.017, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:33.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.479744,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:33.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.188875, 104.032625, 104.876375, 109.61075, 109.751375, 109.188875, 109.376375, 109.938875, 104.782625,
            103.095125, 102.392, 102.767, 101.8295, 112.657625, 100.892, 103.517, 105.67325, 103.517, 101.54825,
            102.017, 104.36075, 103.517, 102.11075, 100.42325, 98.876375, 103.095125, 96.48575, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:32.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.66599,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:32.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.126375, 122.54825, 119.970125, 115.563875, 113.0795, 111.392, 115.751375, 125.54825, 105.813875,
            104.92325, 105.29825, 103.563875, 102.392, 111.157625, 103.98575, 108.767, 108.438875, 103.04825,
            111.532625, 103.79825, 103.892, 102.9545, 100.517, 99.767, 97.892, 101.73575, 96.157625, 95.126375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:36.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.35938,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:36.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.61075, 119.032625, 115.79825, 112.142, 111.11075, 108.2045, 108.67325, 113.407625, 107.0795, 106.42325,
            108.438875, 104.36075, 102.813875, 103.001375, 102.5795, 117.345125, 103.61075, 101.73575, 120.392,
            106.470125, 108.157625, 104.595125, 102.5795, 101.17325, 98.92325, 103.23575, 96.392, 95.126375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:28.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.5778,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:28.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.67325, 136.04825, 131.501375, 130.517, 128.54825, 125.688875, 124.095125, 119.4545, 116.313875,
            112.98575, 109.142, 105.907625, 103.188875, 102.438875, 100.3295, 102.2045, 100.98575, 100.3295, 100.23575,
            101.73575, 103.517, 102.48575, 100.563875, 99.532625, 98.126375, 101.876375, 96.626375, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:09.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 146.5751,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:09.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            145.7045, 137.92325, 130.657625, 126.5795, 122.313875, 120.9545, 117.063875, 115.095125, 111.29825,
            110.4545, 107.407625, 104.501375, 101.54825, 101.688875, 103.376375, 103.79825, 105.532625, 103.517,
            103.470125, 102.017, 102.86075, 102.438875, 100.42325, 99.720125, 98.54825, 104.032625, 97.188875,
            95.407625,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:42.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.7771,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:42.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.61075, 131.688875, 128.501375, 124.7045, 123.813875, 121.376375, 116.642, 113.970125, 109.470125,
            106.3295, 104.032625, 100.98575, 99.9545, 100.79825, 100.61075, 100.3295, 100.282625, 98.4545, 100.61075,
            101.642, 103.845125, 102.813875, 100.470125, 99.9545, 98.688875, 102.720125, 97.517, 95.501375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:15.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.06798,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:15.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 118.04825, 116.970125, 114.29825, 113.032625, 115.61075, 112.3295, 106.892, 106.3295, 109.42325,
            107.36075, 103.7045, 101.313875, 100.892, 101.407625, 103.751375, 103.517, 101.4545, 99.48575, 101.032625,
            102.438875, 101.970125, 100.845125, 100.001375, 98.220125, 102.11075, 96.063875, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:18.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.62793,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:18.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.095125, 123.9545, 122.501375, 118.892, 118.04825, 114.157625, 109.98575, 109.376375, 105.67325,
            103.42325, 104.407625, 101.782625, 100.563875, 101.17325, 101.36075, 102.767, 102.532625, 101.876375,
            99.532625, 100.563875, 102.767, 102.251375, 100.61075, 99.907625, 98.876375, 103.563875, 97.23575, 95.4545,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:36.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.07081,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:36.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.017, 118.98575, 116.126375, 112.095125, 109.42325, 108.9545, 107.220125, 107.17325, 104.126375,
            103.470125, 103.23575, 100.61075, 101.220125, 110.267, 101.4545, 102.438875, 103.845125, 101.36075,
            100.751375, 101.92325, 104.17325, 103.517, 101.73575, 100.470125, 99.157625, 103.23575, 96.29825, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:16.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.1986,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:16.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.095125, 105.345125, 103.892, 108.2045, 108.5795, 106.517, 107.54825, 109.142, 105.9545, 103.938875,
            102.063875, 101.642, 100.563875, 100.517, 101.032625, 101.92325, 102.907625, 100.892, 99.345125, 100.751375,
            102.5795, 102.345125, 100.892, 100.142, 98.642, 102.532625, 96.2045, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:05.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.79899,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:05.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.61075, 105.767, 107.0795, 109.61075, 109.79825, 120.67325, 118.517, 108.29825, 106.938875, 104.73575,
            104.17325, 102.813875, 100.98575, 104.220125, 110.407625, 106.892, 106.282625, 105.392, 108.29825, 105.9545,
            104.595125, 103.751375, 101.313875, 100.23575, 98.73575, 102.438875, 96.11075, 95.126375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:11.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.90561,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:11.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.0795, 121.563875, 117.813875, 115.892, 112.892, 110.313875, 109.938875, 107.876375, 103.188875,
            102.67325, 102.626375, 102.157625, 101.8295, 110.36075, 109.188875, 101.970125, 104.267, 102.157625,
            103.7045, 102.86075, 102.767, 102.392, 100.79825, 99.392, 98.0795, 102.251375, 96.392, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:44.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.39264,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:44.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.501375, 131.92325, 128.17325, 125.032625, 121.61075, 121.001375, 116.220125, 112.23575, 109.79825,
            106.376375, 104.267, 103.517, 100.563875, 104.8295, 121.470125, 102.813875, 100.79825, 103.938875,
            112.42325, 107.688875, 104.92325, 107.92325, 102.29825, 100.04825, 98.876375, 103.23575, 96.392, 95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:10.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.57402,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:10.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.142, 128.73575, 126.063875, 121.095125, 119.595125, 117.626375, 115.42325, 111.48575, 109.517, 106.142,
            104.17325, 104.0795, 107.595125, 111.063875, 103.517, 107.4545, 107.032625, 103.892, 107.267, 103.23575,
            104.126375, 102.907625, 100.892, 99.907625, 98.642, 102.157625, 97.142, 95.4545,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:40.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.21553,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:40.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.54825, 124.095125, 121.7045, 117.532625, 113.267, 111.438875, 108.907625, 107.501375, 104.032625,
            103.142, 102.626375, 109.376375, 116.970125, 101.313875, 107.54825, 104.642, 102.392, 102.626375, 104.36075,
            103.470125, 107.220125, 104.267, 101.313875, 100.095125, 98.8295, 102.767, 96.67325, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:37.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.9655,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:37.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.063875, 113.642, 109.79825, 106.095125, 106.79825, 106.657625, 107.73575, 109.517, 106.188875,
            105.157625, 105.392, 103.04825, 102.251375, 102.9545, 102.5795, 104.032625, 102.017, 99.907625, 100.517,
            101.4545, 103.142, 102.767, 100.751375, 100.001375, 98.782625, 102.438875, 96.251375, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:35.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.70686,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:35.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.79825, 125.0795, 120.345125, 119.220125, 117.5795, 112.79825, 108.9545, 108.813875, 105.157625,
            102.86075, 102.11075, 104.73575, 106.7045, 111.532625, 105.251375, 107.313875, 104.688875, 101.876375,
            103.7045, 102.251375, 104.782625, 104.032625, 101.642, 100.04825, 99.11075, 102.767, 97.142, 95.407625,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:55.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.15517,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:55.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.98575, 126.11075, 120.48575, 117.67325, 114.392, 119.36075, 112.142, 109.282625, 113.970125, 105.438875,
            104.4545, 102.29825, 100.3295, 101.642, 101.642, 105.532625, 102.11075, 100.845125, 101.54825, 102.345125,
            103.282625, 103.61075, 100.470125, 99.9545, 98.54825, 102.392, 96.48575, 95.126375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:52.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.81688,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:52.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.892, 120.626375, 118.3295, 115.61075, 113.501375, 110.8295, 109.563875, 106.751375, 103.938875,
            103.751375, 102.063875, 101.92325, 99.86075, 100.892, 101.17325, 101.126375, 100.938875, 100.3295,
            100.563875, 101.501375, 103.657625, 103.845125, 100.892, 99.9545, 98.8295, 103.001375, 96.392, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:01.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.206375,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:01.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.251375, 114.48575, 109.563875, 106.98575, 106.751375, 107.220125, 108.063875, 104.876375, 106.23575,
            103.42325, 107.17325, 103.188875, 100.751375, 102.907625, 103.282625, 105.345125, 105.438875, 101.8295,
            102.67325, 102.251375, 104.267, 103.04825, 101.220125, 100.188875, 99.157625, 103.04825, 96.767, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:00.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.84538,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:00.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.29825, 116.36075, 112.892, 112.892, 112.142, 110.970125, 109.376375, 108.017, 106.470125, 107.876375,
            104.595125, 104.642, 101.54825, 103.938875, 104.73575, 104.4545, 104.267, 101.595125, 103.04825, 102.720125,
            103.845125, 102.720125, 101.126375, 100.470125, 99.063875, 103.04825, 97.04825, 95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:49.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.364105,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:49.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.392, 108.157625, 105.626375, 109.001375, 109.938875, 110.267, 108.86075, 108.813875, 103.79825,
            103.79825, 103.095125, 103.23575, 99.813875, 101.501375, 101.313875, 100.845125, 100.938875, 99.157625,
            99.67325, 100.79825, 102.67325, 103.001375, 100.563875, 99.9545, 98.595125, 102.5795, 96.11075, 95.0795,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:47.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.870895,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:47.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.11075, 115.001375, 112.98575, 109.282625, 106.938875, 107.17325, 107.407625, 106.938875, 103.04825,
            101.501375, 101.17325, 101.8295, 100.61075, 104.126375, 114.532625, 102.532625, 101.407625, 102.907625,
            102.11075, 103.657625, 105.626375, 105.11075, 103.282625, 100.095125, 98.54825, 102.251375, 96.063875,
            95.126375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:17.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.16878,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:17.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.563875, 130.563875, 125.595125, 121.98575, 119.220125, 115.517, 114.157625, 115.892, 116.54825,
            117.438875, 116.642, 109.376375, 107.0795, 103.142, 102.626375, 104.688875, 103.892, 101.782625, 100.892,
            101.032625, 103.23575, 102.5795, 100.845125, 100.142, 98.876375, 102.2045, 96.720125, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:51.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.746086,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:51.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.220125, 112.3295, 108.29825, 106.892, 108.438875, 110.4545, 109.470125, 109.7045, 110.032625, 105.86075,
            103.751375, 102.532625, 100.376375, 102.29825, 102.626375, 101.313875, 102.29825, 100.23575, 101.501375,
            101.8295, 103.188875, 103.517, 100.79825, 99.813875, 98.595125, 102.626375, 96.626375, 95.407625,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:25.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.33483,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:25.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.251375, 116.595125, 111.767, 110.73575, 121.3295, 117.9545, 107.032625, 111.907625, 104.54825,
            107.782625, 103.470125, 100.845125, 100.001375, 103.23575, 105.11075, 104.220125, 103.095125, 103.7045,
            101.313875, 102.157625, 103.42325, 102.767, 100.7045, 100.23575, 98.782625, 102.9545, 97.188875, 95.501375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:41.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.13232,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:41.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.642, 125.032625, 120.157625, 116.642, 117.345125, 114.063875, 110.032625, 107.73575, 104.642, 101.73575,
            101.782625, 104.876375, 107.220125, 100.61075, 99.907625, 100.7045, 100.79825, 101.0795, 102.29825,
            101.8295, 104.407625, 102.392, 100.7045, 99.86075, 98.642, 102.720125, 96.392, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:13.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.77761,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:13.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.48575, 102.67325, 103.61075, 107.73575, 109.23575, 108.438875, 109.001375, 108.2045, 103.98575,
            103.3295, 103.282625, 102.67325, 99.9545, 100.001375, 100.04825, 102.251375, 103.23575, 102.063875,
            100.42325, 101.4545, 102.720125, 102.5795, 100.7045, 99.9545, 98.267, 102.11075, 95.970125, 95.17325,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:24.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.02312,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:24.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            104.876375, 101.782625, 103.845125, 108.345125, 106.282625, 107.8295, 106.657625, 108.017, 104.0795,
            104.313875, 104.4545, 101.313875, 99.345125, 100.470125, 100.938875, 101.595125, 102.251375, 101.220125,
            100.142, 100.7045, 102.626375, 102.251375, 100.563875, 100.04825, 98.73575, 102.67325, 96.392, 95.407625,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:07.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.81144,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:07.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 109.61075, 105.907625, 107.642, 107.267, 107.4545, 109.3295, 106.376375, 103.892, 102.063875,
            103.7045, 103.3295, 101.220125, 102.720125, 104.17325, 103.79825, 104.595125, 103.845125, 105.11075,
            103.095125, 103.282625, 102.813875, 101.0795, 100.188875, 98.642, 102.29825, 96.11075, 95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:23.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.62872,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:23.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.970125, 104.8295, 103.095125, 108.251375, 109.657625, 107.501375, 108.063875, 109.23575, 105.48575,
            103.657625, 104.595125, 102.017, 98.73575, 100.23575, 114.2045, 103.845125, 103.563875, 106.7045, 102.2045,
            103.04825, 104.595125, 102.720125, 100.563875, 99.907625, 98.36075, 102.5795, 96.29825, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:06.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.19379,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:06.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.470125, 120.626375, 116.126375, 111.9545, 109.61075, 109.7045, 111.626375, 105.813875, 103.563875,
            103.470125, 103.892, 102.532625, 99.9545, 102.532625, 107.595125, 107.782625, 105.11075, 104.36075,
            113.17325, 103.095125, 104.782625, 103.61075, 100.845125, 99.813875, 98.642, 103.142, 96.2045, 95.17325,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:31.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.216,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:31.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.267, 113.73575, 110.501375, 105.813875, 105.767, 107.54825, 105.86075, 107.782625, 102.626375,
            101.73575, 100.61075, 100.001375, 99.157625, 99.907625, 100.04825, 101.126375, 101.8295, 100.845125,
            100.470125, 101.642, 103.42325, 102.2045, 100.61075, 99.86075, 98.4545, 102.438875, 96.48575, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:39.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.156136,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:39.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.376375, 109.282625, 106.79825, 109.188875, 111.813875, 109.657625, 113.126375, 120.720125, 106.04825,
            104.73575, 106.188875, 104.970125, 104.501375, 103.3295, 102.532625, 104.642, 103.892, 100.3295, 102.5795,
            102.9545, 104.220125, 103.095125, 100.892, 100.095125, 98.36075, 102.29825, 95.970125, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:48.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.94673,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:48.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.188875, 122.595125, 121.61075, 116.782625, 114.11075, 112.001375, 110.595125, 109.376375, 105.48575,
            102.5795, 102.720125, 102.392, 100.61075, 101.92325, 101.595125, 101.4545, 101.782625, 99.063875, 99.438875,
            101.36075, 102.813875, 102.86075, 100.517, 99.720125, 98.54825, 102.5795, 96.2045, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:58.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.63588,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:58.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.626375, 119.970125, 118.23575, 114.251375, 112.7045, 109.42325, 109.61075, 105.767, 108.063875,
            103.42325, 102.29825, 101.54825, 99.720125, 103.563875, 102.720125, 104.032625, 104.4545, 100.376375,
            102.813875, 103.376375, 103.7045, 103.563875, 101.17325, 100.04825, 98.688875, 102.767, 96.9545, 95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:34.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.62933,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:34.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.001375, 123.720125, 120.251375, 115.892, 112.7045, 110.501375, 108.626375, 109.142, 104.267, 102.532625,
            102.626375, 101.407625, 100.282625, 100.938875, 102.157625, 102.251375, 102.5795, 101.782625, 100.657625,
            101.92325, 103.892, 102.813875, 100.42325, 99.767, 99.2045, 102.5795, 96.9545, 95.54825,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:42.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.82661,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:42.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.017, 121.892, 117.29825, 112.892, 112.142, 112.470125, 109.42325, 110.73575, 117.11075, 104.17325,
            105.2045, 104.17325, 101.4545, 102.767, 102.2045, 103.751375, 102.392, 99.48575, 100.23575, 101.501375,
            102.532625, 103.001375, 100.376375, 99.392, 98.126375, 102.251375, 96.157625, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:44.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.13937,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:44.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.142, 127.42325, 124.095125, 122.032625, 117.720125, 118.7045, 116.54825, 112.3295, 108.907625,
            107.54825, 107.595125, 101.642, 100.3295, 101.032625, 101.970125, 102.345125, 101.407625, 98.8295, 99.48575,
            100.98575, 102.813875, 102.532625, 100.142, 99.251375, 98.407625, 102.063875, 96.5795, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:45.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.07753,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:45.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.017, 131.501375, 129.2045, 127.42325, 123.017, 120.392, 118.23575, 114.345125, 111.48575, 106.7045,
            103.7045, 104.0795, 101.8295, 103.657625, 104.267, 103.751375, 101.220125, 100.470125, 100.188875, 101.267,
            102.626375, 103.188875, 100.657625, 100.001375, 98.782625, 102.532625, 97.095125, 95.54825,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:41.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.04965,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:41.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.29825, 122.4545, 119.313875, 117.9545, 114.813875, 111.532625, 111.063875, 109.142, 104.501375,
            102.5795, 104.36075, 103.095125, 102.813875, 104.0795, 102.438875, 104.970125, 103.142, 100.23575, 100.7045,
            100.79825, 102.626375, 102.5795, 100.376375, 99.438875, 98.595125, 102.813875, 96.532625, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:32.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.38386,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:32.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.2045, 114.9545, 110.970125, 109.142, 106.7045, 108.767, 107.876375, 109.42325, 105.11075, 103.517,
            100.376375, 100.845125, 102.86075, 101.267, 100.563875, 106.282625, 104.313875, 102.11075, 101.267,
            102.86075, 103.79825, 102.813875, 101.126375, 100.095125, 98.688875, 102.626375, 96.532625, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:29.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.6909,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:29.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.845125, 121.938875, 120.29825, 118.282625, 121.04825, 116.4545, 110.642, 110.688875, 105.532625,
            108.720125, 102.438875, 100.98575, 100.7045, 105.11075, 101.126375, 102.9545, 104.54825, 101.4545,
            100.095125, 102.2045, 103.563875, 102.626375, 100.470125, 99.907625, 98.313875, 102.392, 96.48575, 95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:02.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.59416,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:02.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.73575, 120.813875, 118.845125, 115.42325, 113.17325, 114.392, 111.251375, 105.9545, 105.063875,
            103.04825, 103.7045, 103.470125, 101.313875, 103.142, 107.970125, 106.657625, 105.720125, 104.642,
            107.36075, 104.54825, 105.11075, 104.876375, 101.126375, 100.188875, 98.970125, 102.767, 96.813875,
            95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:19.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.86347,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:19.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.282625, 107.0795, 104.032625, 105.767, 112.657625, 114.5795, 106.095125, 107.4545, 105.813875,
            103.751375, 103.376375, 102.2045, 101.126375, 102.5795, 104.126375, 103.751375, 104.8295, 103.61075,
            102.063875, 102.29825, 103.282625, 103.04825, 100.98575, 100.001375, 99.532625, 102.67325, 98.126375,
            95.595125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:38.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.35002,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:38.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.642, 115.563875, 108.907625, 107.36075, 107.782625, 108.813875, 107.267, 108.438875, 105.626375,
            103.845125, 112.095125, 109.98575, 102.626375, 109.7045, 108.11075, 111.720125, 103.938875, 103.142,
            103.470125, 102.345125, 104.032625, 103.3295, 101.267, 100.470125, 99.063875, 102.813875, 96.720125,
            95.17325,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:50.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.31047,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:50.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.313875, 109.751375, 107.501375, 109.938875, 123.392, 118.61075, 108.720125, 124.188875, 115.188875,
            106.142, 102.9545, 101.782625, 99.626375, 103.751375, 103.98575, 104.267, 105.438875, 102.767, 105.67325,
            103.142, 104.032625, 103.42325, 101.032625, 100.04825, 98.73575, 102.532625, 96.29825, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:39.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.52107,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:39.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 124.517, 120.767, 116.595125, 113.8295, 111.392, 109.376375, 108.532625, 106.142, 102.345125,
            103.04825, 103.188875, 100.188875, 101.501375, 101.17325, 101.501375, 101.595125, 100.845125, 100.563875,
            101.970125, 103.938875, 102.720125, 100.61075, 100.001375, 98.642, 102.9545, 96.5795, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:14.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.03972,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:14.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.938875, 128.642, 125.73575, 122.8295, 120.2045, 117.29825, 113.782625, 111.9545, 111.29825, 105.017,
            104.688875, 102.251375, 100.095125, 101.17325, 101.4545, 103.751375, 105.11075, 102.11075, 101.0795,
            101.54825, 103.04825, 102.48575, 101.220125, 100.188875, 98.642, 103.42325, 96.67325, 95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:27.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.99818,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:27.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.563875, 128.54825, 126.86075, 123.345125, 121.892, 118.42325, 114.5795, 109.7045, 105.720125, 104.0795,
            102.345125, 101.4545, 100.517, 101.54825, 100.188875, 101.220125, 101.407625, 99.907625, 99.767, 101.36075,
            102.907625, 102.345125, 100.42325, 99.626375, 98.8295, 102.392, 97.188875, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:59.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.014,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:59.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.67325, 124.23575, 121.42325, 118.23575, 113.595125, 110.73575, 111.720125, 108.2045, 105.345125,
            102.29825, 103.376375, 101.876375, 99.907625, 105.017, 119.501375, 104.17325, 104.126375, 107.54825,
            108.251375, 106.095125, 105.063875, 104.126375, 101.782625, 100.563875, 98.970125, 102.720125, 96.67325,
            95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:22.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.69575,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:22.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.54825, 116.8295, 111.67325, 111.063875, 116.032625, 115.517, 106.376375, 108.017, 103.845125, 103.892,
            103.517, 100.892, 100.3295, 101.0795, 100.845125, 101.92325, 101.970125, 101.313875, 100.470125, 101.54825,
            103.095125, 103.142, 100.751375, 100.282625, 99.438875, 103.282625, 97.892, 95.4545,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:30.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.9376,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:30.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.001375, 124.001375, 121.657625, 119.032625, 113.688875, 111.345125, 109.657625, 108.157625, 105.907625,
            104.17325, 103.79825, 103.04825, 101.313875, 101.970125, 102.5795, 104.126375, 101.36075, 100.04825,
            99.9545, 101.126375, 102.86075, 101.8295, 100.282625, 99.392, 98.032625, 102.251375, 96.392, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:07.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.36615,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:07.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.563875, 122.782625, 119.36075, 115.98575, 119.0795, 115.98575, 111.767, 107.36075, 105.86075,
            108.626375, 108.532625, 105.2045, 103.376375, 106.42325, 105.29825, 105.017, 107.032625, 104.4545,
            107.73575, 103.657625, 103.23575, 102.626375, 101.17325, 100.142, 98.54825, 102.67325, 96.720125, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:38.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.68049,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:38.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.938875, 106.938875, 104.73575, 105.392, 110.407625, 107.92325, 108.438875, 113.92325, 106.79825,
            104.36075, 106.282625, 103.04825, 102.626375, 102.063875, 102.767, 104.876375, 102.9545, 100.23575,
            100.095125, 101.220125, 102.9545, 103.095125, 100.751375, 99.767, 98.501375, 102.813875, 96.11075, 95.17325,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:57.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.74112,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:57.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.8295, 106.142, 103.657625, 106.001375, 105.907625, 106.751375, 107.4545, 106.23575, 104.4545,
            104.126375, 102.11075, 101.688875, 101.17325, 102.720125, 104.267, 104.642, 103.095125, 100.892, 100.938875,
            102.2045, 103.517, 103.095125, 100.517, 99.767, 98.92325, 103.751375, 96.86075, 97.04825,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:26.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 153.18578,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:26.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            151.188875, 146.0795, 143.73575, 138.2045, 134.970125, 131.501375, 128.220125, 125.970125, 121.7045,
            118.61075, 116.313875, 113.4545, 112.892, 108.813875, 106.42325, 107.73575, 102.11075, 102.157625,
            109.376375, 105.720125, 105.251375, 103.095125, 100.845125, 99.720125, 98.501375, 102.48575, 97.3295,
            95.407625,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:53.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.85396,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:53.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.720125, 124.470125, 121.470125, 117.720125, 114.767, 114.11075, 111.86075, 110.313875, 122.267,
            121.563875, 118.23575, 111.48575, 106.3295, 104.36075, 104.313875, 106.3295, 106.188875, 105.626375,
            104.032625, 104.642, 103.98575, 103.7045, 100.845125, 100.04825, 98.92325, 102.9545, 96.767, 95.407625,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:35.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.40868,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:35.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.9545, 125.970125, 124.42325, 122.0795, 119.313875, 115.376375, 114.86075, 122.407625, 107.501375,
            107.267, 108.251375, 106.188875, 103.142, 103.938875, 101.782625, 102.86075, 102.392, 100.3295, 100.657625,
            101.220125, 103.095125, 102.720125, 100.376375, 99.86075, 98.54825, 102.532625, 96.017, 95.17325,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:56.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.67212,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:56.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.313875, 119.0795, 114.813875, 111.532625, 108.345125, 108.48575, 109.001375, 108.67325, 106.657625,
            105.532625, 101.642, 101.688875, 100.470125, 105.063875, 122.688875, 103.61075, 103.3295, 106.188875,
            110.126375, 107.501375, 104.970125, 105.5795, 106.938875, 100.470125, 98.8295, 102.767, 96.720125,
            95.407625,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:08.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.71176,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:08.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 123.9545, 115.938875, 112.61075, 113.782625, 119.54825, 113.8295, 109.142, 110.642, 110.126375,
            111.626375, 104.782625, 102.017, 103.376375, 104.267, 104.688875, 104.54825, 103.23575, 103.938875,
            102.251375, 103.42325, 102.813875, 100.79825, 100.095125, 98.407625, 102.157625, 96.345125, 95.17325,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:46.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 148.8078,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:46.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            147.11075, 140.126375, 137.782625, 134.876375, 133.470125, 130.79825, 128.032625, 126.2045, 122.970125,
            121.282625, 116.032625, 113.407625, 110.0795, 115.376375, 120.251375, 104.126375, 104.54825, 111.813875,
            121.563875, 105.11075, 105.532625, 109.657625, 103.563875, 101.313875, 98.36075, 103.23575, 96.251375,
            95.17325,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:54.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.35023,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:54.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.36075, 124.751375, 122.36075, 118.7045, 116.595125, 114.67325, 113.220125, 109.04825, 106.563875,
            106.04825, 104.0795, 101.8295, 100.61075, 100.376375, 99.392, 100.751375, 100.845125, 98.8295, 99.9545,
            100.892, 102.720125, 103.04825, 100.3295, 99.392, 98.220125, 101.92325, 96.345125, 95.54825,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:37.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.38148,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:37.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.42325, 111.29825, 108.251375, 110.782625, 110.267, 109.470125, 110.0795, 109.23575, 105.767, 104.92325,
            104.220125, 102.2045, 99.5795, 101.0795, 102.9545, 104.267, 101.642, 101.36075, 100.376375, 101.642,
            103.282625, 103.470125, 100.751375, 99.86075, 98.782625, 102.67325, 96.392, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:31.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.39702,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:31.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.595125, 130.517, 127.845125, 123.11075, 120.532625, 118.657625, 117.11075, 125.92325, 108.29825,
            107.92325, 106.04825, 103.845125, 103.61075, 102.907625, 101.92325, 104.782625, 101.876375, 100.751375,
            99.626375, 101.220125, 103.04825, 102.017, 100.470125, 99.720125, 98.17325, 102.017, 96.438875, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:33.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.47144,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:33.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.438875, 119.4545, 115.751375, 113.267, 110.54825, 108.813875, 110.032625, 108.86075, 106.001375,
            104.8295, 104.92325, 102.813875, 108.2045, 114.2045, 102.345125, 106.001375, 103.845125, 110.0795,
            107.032625, 101.595125, 103.61075, 102.813875, 100.470125, 99.813875, 98.36075, 102.063875, 96.29825,
            95.36075,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:34.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.52575,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:34.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.188875, 112.892, 110.876375, 111.345125, 110.313875, 109.61075, 109.001375, 108.345125, 106.470125,
            105.157625, 105.157625, 103.142, 101.970125, 101.595125, 102.11075, 102.2045, 101.501375, 99.438875,
            99.532625, 100.7045, 102.67325, 103.001375, 100.61075, 99.813875, 98.688875, 102.5795, 96.2045, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:30.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.93581,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:30.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.98575, 114.11075, 108.345125, 107.126375, 105.86075, 108.11075, 107.54825, 107.595125, 104.501375,
            103.563875, 102.11075, 101.032625, 103.845125, 104.501375, 101.126375, 101.8295, 101.032625, 100.892,
            100.845125, 101.688875, 103.517, 102.157625, 100.470125, 99.392, 98.313875, 101.73575, 96.017, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:43.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.15069,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:43.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.267, 115.517, 114.063875, 110.126375, 109.188875, 112.142, 107.73575, 114.11075, 117.86075, 105.626375,
            104.73575, 103.376375, 105.67325, 105.392, 106.188875, 104.267, 104.407625, 102.017, 110.782625, 106.282625,
            103.892, 103.98575, 101.032625, 99.907625, 98.73575, 102.907625, 96.392, 95.267,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:04.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.14153,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:04.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.29825, 117.626375, 115.61075, 112.845125, 108.9545, 109.79825, 112.79825, 107.501375, 106.470125,
            105.063875, 104.17325, 103.3295, 101.407625, 103.7045, 102.86075, 105.767, 105.720125, 103.42325, 103.04825,
            102.11075, 104.032625, 102.86075, 101.267, 99.86075, 99.11075, 103.3295, 96.626375, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:21.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.6368,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:21.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.3295, 126.063875, 124.751375, 123.251375, 122.313875, 118.7045, 112.376375, 110.267, 107.267,
            105.157625, 103.3295, 102.5795, 99.767, 100.657625, 108.67325, 105.5795, 101.595125, 101.267, 105.438875,
            104.17325, 103.095125, 102.86075, 100.845125, 100.001375, 99.2045, 104.032625, 97.3295, 95.313875,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:12.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.30373,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:12.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.767, 118.7045, 115.98575, 111.813875, 107.92325, 110.595125, 108.438875, 107.220125, 105.345125,
            104.032625, 102.626375, 101.970125, 100.3295, 100.376375, 100.563875, 101.92325, 103.938875, 101.8295,
            100.892, 101.595125, 102.86075, 102.157625, 100.7045, 100.23575, 98.595125, 102.251375, 96.48575, 95.220125,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:20.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.53072,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:02:20.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.188875, 127.142, 124.095125, 123.017, 122.0795, 121.001375, 116.642, 112.095125, 109.845125, 106.470125,
            104.313875, 102.251375, 100.282625, 110.782625, 119.688875, 103.04825, 104.73575, 105.532625, 109.42325,
            110.595125, 104.782625, 103.938875, 101.36075, 100.563875, 98.688875, 102.5795, 96.813875, 95.501375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:40.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.28107,
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:01:40.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.001375, 125.4545, 119.407625, 118.188875, 113.642, 109.42325, 109.657625, 109.42325, 105.017, 104.54825,
            105.29825, 108.48575, 114.438875, 113.688875, 113.0795, 106.657625, 107.313875, 104.220125, 110.220125,
            106.98575, 106.7045, 105.063875, 101.17325, 100.001375, 98.642, 102.907625, 96.29825, 95.126375,
        ],
        latitude: 37.4405878,
        longitude: -122.5334407,
    },
    {
        timestamp: '2025-08-29T23:03:12.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.91335,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:12.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.095125, 133.751375, 129.86075, 126.626375, 123.2045, 118.517, 116.501375, 115.657625, 111.767,
            106.751375, 107.220125, 107.642, 105.251375, 105.48575, 106.095125, 103.095125, 101.642, 99.767, 101.267,
            101.92325, 103.845125, 102.86075, 101.17325, 100.3295, 98.970125, 102.48575, 96.392, 95.17325,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:44.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.1451,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:44.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.626375, 122.876375, 118.376375, 116.54825, 112.657625, 110.876375, 108.5795, 108.720125, 104.501375,
            102.251375, 101.92325, 101.8295, 102.813875, 103.657625, 102.626375, 102.251375, 103.04825, 100.376375,
            101.220125, 101.642, 103.751375, 102.438875, 100.61075, 99.907625, 98.73575, 102.767, 96.5795, 95.17325,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:36.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.05571,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:36.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 113.54825, 108.532625, 107.54825, 107.4545, 108.5795, 105.767, 106.188875, 104.876375,
            101.876375, 103.3295, 101.595125, 100.517, 101.313875, 100.001375, 101.642, 101.92325, 100.188875,
            101.36075, 101.782625, 103.845125, 103.282625, 100.751375, 100.142, 99.157625, 103.188875, 97.142, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:46.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.810036,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:46.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.767, 114.2045, 111.29825, 111.11075, 109.98575, 109.095125, 109.751375, 109.3295, 104.501375, 102.86075,
            102.345125, 102.392, 101.8295, 103.892, 102.720125, 103.001375, 101.92325, 100.7045, 101.126375, 102.2045,
            104.970125, 102.720125, 100.751375, 100.282625, 98.782625, 102.438875, 96.438875, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:18.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.819534,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:18.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.501375, 119.4545, 116.73575, 115.282625, 113.876375, 110.032625, 109.23575, 109.095125, 105.11075,
            102.767, 102.767, 101.92325, 101.220125, 103.845125, 103.188875, 101.92325, 102.29825, 100.188875,
            99.813875, 101.36075, 103.095125, 102.251375, 100.751375, 100.04825, 98.595125, 102.532625, 96.392,
            95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:05.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.96257,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:05.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.892, 117.813875, 112.751375, 112.04825, 110.407625, 110.36075, 112.7045, 110.876375, 109.517,
            105.907625, 104.36075, 103.892, 101.032625, 103.563875, 101.876375, 103.79825, 102.67325, 100.61075,
            100.188875, 100.892, 103.3295, 102.720125, 100.751375, 100.095125, 98.782625, 102.5795, 96.626375, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:49.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.72217,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:49.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.345125, 123.86075, 122.92325, 119.54825, 115.42325, 111.392, 109.79825, 109.376375, 104.313875,
            102.438875, 100.3295, 100.79825, 100.095125, 102.392, 101.73575, 102.017, 102.767, 102.813875, 102.438875,
            101.92325, 104.54825, 103.142, 101.267, 100.23575, 98.8295, 102.67325, 96.48575, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:15.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.0321,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:15.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.48575, 115.142, 112.04825, 118.188875, 115.04825, 110.0795, 109.470125, 110.17325, 106.938875,
            103.095125, 102.86075, 103.376375, 101.0795, 102.157625, 102.5795, 101.407625, 100.04825, 100.376375,
            99.626375, 100.751375, 103.095125, 102.392, 100.3295, 100.188875, 98.92325, 102.48575, 97.001375, 95.4545,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:53.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.176605,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:53.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 116.8295, 110.92325, 112.188875, 110.032625, 107.126375, 107.407625, 109.42325, 104.17325,
            101.688875, 100.79825, 99.5795, 98.73575, 101.126375, 100.563875, 101.126375, 100.142, 99.9545, 101.54825,
            102.2045, 103.376375, 102.907625, 100.61075, 99.767, 98.313875, 102.157625, 96.157625, 95.126375,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:43.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.91855,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:43.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.657625, 108.626375, 108.157625, 108.9545, 108.626375, 109.04825, 108.48575, 110.126375, 105.392,
            104.0795, 102.532625, 102.2045, 101.36075, 103.04825, 101.501375, 102.767, 103.751375, 101.313875, 100.517,
            101.501375, 104.407625, 102.345125, 100.845125, 100.282625, 98.54825, 102.392, 96.29825, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:10.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.56303,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:10.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.751375, 127.7045, 126.67325, 123.2045, 121.892, 121.188875, 115.892, 115.938875, 110.54825, 106.938875,
            106.563875, 104.54825, 101.313875, 101.8295, 101.782625, 102.5795, 100.751375, 98.876375, 100.142,
            101.36075, 103.142, 102.48575, 100.563875, 99.5795, 98.126375, 101.92325, 96.251375, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:30.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.63875,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:30.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.0795, 130.517, 126.5795, 123.5795, 120.392, 120.9545, 119.73575, 114.392, 110.407625, 107.0795,
            104.36075, 101.595125, 100.04825, 100.282625, 99.67325, 100.845125, 102.017, 99.11075, 100.892, 101.73575,
            103.938875, 103.095125, 100.845125, 99.86075, 98.407625, 103.04825, 96.907625, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:45.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.02977,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:45.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.470125, 118.892, 116.73575, 115.142, 112.61075, 109.001375, 106.751375, 108.29825, 104.970125,
            102.157625, 102.157625, 103.282625, 100.938875, 103.517, 102.813875, 101.876375, 101.220125, 99.438875,
            101.0795, 101.688875, 103.42325, 102.157625, 100.7045, 99.9545, 98.407625, 102.626375, 96.2045, 95.126375,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:29.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.40083,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:29.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.751375, 127.61075, 123.532625, 120.345125, 119.0795, 114.720125, 112.282625, 113.313875, 109.470125,
            104.688875, 103.470125, 101.032625, 99.907625, 100.751375, 101.8295, 102.11075, 103.376375, 99.907625,
            100.7045, 101.407625, 103.79825, 103.095125, 100.79825, 99.907625, 98.595125, 102.5795, 96.86075, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:38.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.25008,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:38.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.595125, 123.907625, 120.813875, 118.188875, 117.86075, 117.29825, 111.720125, 111.29825, 107.8295,
            105.48575, 104.220125, 102.2045, 100.517, 102.11075, 101.313875, 101.17325, 101.407625, 99.626375, 100.517,
            102.017, 104.220125, 103.142, 100.563875, 100.001375, 98.782625, 102.2045, 96.392, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:14.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.413155,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:14.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.720125, 107.17325, 107.36075, 107.642, 107.36075, 106.938875, 106.98575, 109.563875, 105.2045, 103.892,
            105.345125, 104.267, 101.4545, 102.86075, 102.251375, 101.73575, 101.36075, 99.251375, 99.48575, 100.98575,
            102.532625, 102.345125, 100.470125, 99.720125, 98.73575, 102.157625, 97.7045, 95.407625,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:23.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.89346,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:23.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.4545, 127.04825, 124.188875, 120.67325, 118.3295, 115.845125, 112.61075, 109.751375, 106.938875,
            105.345125, 103.282625, 103.751375, 100.517, 101.876375, 103.938875, 101.4545, 100.3295, 99.438875,
            100.23575, 100.98575, 103.3295, 102.5795, 100.79825, 100.282625, 98.782625, 102.2045, 96.532625, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:26.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.04242,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:26.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.42325, 123.017, 120.767, 119.17325, 115.376375, 112.42325, 109.3295, 107.220125, 106.282625, 102.392,
            101.17325, 101.595125, 101.220125, 102.392, 102.907625, 103.142, 103.376375, 99.48575, 99.767, 100.892,
            103.282625, 102.157625, 100.517, 100.001375, 98.4545, 101.970125, 96.438875, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:50.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.44864,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:50.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.876375, 127.142, 125.8295, 123.345125, 119.970125, 117.157625, 114.48575, 111.157625, 108.157625,
            103.23575, 102.813875, 100.376375, 98.8295, 100.892, 101.595125, 101.54825, 101.595125, 101.782625,
            101.032625, 101.782625, 103.7045, 102.5795, 100.7045, 99.86075, 98.501375, 102.251375, 96.251375, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:52.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.67279,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:52.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.657625, 121.98575, 119.17325, 115.142, 112.61075, 109.7045, 109.563875, 108.5795, 103.42325, 102.11075,
            101.0795, 101.267, 99.907625, 101.642, 100.095125, 102.063875, 100.79825, 100.563875, 102.063875, 102.392,
            103.657625, 103.23575, 100.751375, 99.907625, 99.017, 102.532625, 96.345125, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:11.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.901276,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:11.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.73575, 115.42325, 117.017, 116.032625, 108.767, 110.92325, 110.92325, 109.376375, 104.73575, 103.3295,
            105.720125, 105.251375, 102.157625, 103.001375, 103.23575, 103.04825, 101.54825, 99.251375, 100.61075,
            102.017, 104.17325, 102.767, 100.892, 100.470125, 98.876375, 102.48575, 96.626375, 95.54825,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:19.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.645,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:19.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 126.392, 123.017, 119.970125, 120.438875, 121.095125, 113.501375, 114.063875, 107.313875,
            105.345125, 104.642, 104.126375, 101.407625, 103.001375, 102.29825, 103.42325, 102.345125, 100.892, 100.892,
            101.407625, 103.23575, 102.767, 100.938875, 100.282625, 99.2045, 103.470125, 97.282625, 95.54825,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:24.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.92296,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:24.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.595125, 113.267, 111.2045, 108.626375, 107.595125, 107.876375, 105.29825, 107.267, 104.407625,
            103.657625, 105.2045, 107.032625, 107.782625, 105.11075, 103.845125, 104.54825, 104.032625, 99.392,
            100.3295, 100.7045, 102.813875, 102.157625, 100.563875, 99.9545, 98.642, 102.5795, 96.48575, 95.17325,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:55.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.952835,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:55.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.501375, 107.0795, 108.345125, 109.095125, 106.61075, 106.04825, 107.970125, 111.017, 104.782625,
            103.61075, 101.642, 100.845125, 100.001375, 101.267, 100.79825, 101.0795, 101.876375, 99.48575, 100.61075,
            102.29825, 104.73575, 103.3295, 101.36075, 100.42325, 98.688875, 102.532625, 96.157625, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:54.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.11266,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:54.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.095125, 102.907625, 104.54825, 108.626375, 108.251375, 109.3295, 109.892, 107.313875, 106.188875,
            102.767, 103.751375, 102.720125, 99.9545, 103.938875, 101.17325, 101.92325, 100.3295, 99.48575, 100.04825,
            101.220125, 103.23575, 102.626375, 100.892, 100.188875, 98.970125, 103.42325, 96.532625, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:02.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.40286,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:02.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 117.29825, 112.7045, 112.938875, 110.642, 110.642, 110.407625, 108.813875, 106.23575, 105.11075,
            102.9545, 101.970125, 100.188875, 102.2045, 101.876375, 102.907625, 101.313875, 99.67325, 99.67325,
            101.595125, 103.470125, 102.813875, 101.126375, 100.188875, 99.017, 102.907625, 97.892, 95.4545,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:08.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.64163,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:08.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 127.001375, 123.626375, 121.376375, 119.032625, 117.392, 114.11075, 111.767, 107.782625,
            103.892, 104.267, 103.563875, 101.0795, 103.938875, 101.126375, 103.845125, 102.157625, 100.517, 100.61075,
            101.970125, 103.7045, 102.813875, 100.657625, 100.095125, 98.876375, 102.767, 96.2045, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:04.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.55493,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:04.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.5795, 120.157625, 117.5795, 113.313875, 110.595125, 110.126375, 111.86075, 109.04825, 106.142,
            104.501375, 104.407625, 103.3295, 101.876375, 103.376375, 101.595125, 102.720125, 102.345125, 101.73575,
            100.657625, 101.595125, 103.3295, 102.720125, 100.61075, 100.001375, 99.017, 102.767, 97.563875, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:55.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.28205,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:55.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.9545, 115.563875, 114.017, 110.501375, 107.8295, 111.29825, 109.98575, 106.470125, 105.907625,
            103.61075, 105.251375, 104.17325, 102.438875, 107.876375, 100.7045, 100.938875, 101.4545, 100.001375,
            99.907625, 101.876375, 103.517, 102.5795, 100.751375, 100.376375, 98.92325, 102.532625, 96.345125,
            95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:09.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.54869,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:09.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.23575, 128.032625, 126.29825, 123.48575, 118.98575, 115.470125, 115.470125, 111.157625, 107.313875,
            104.73575, 104.642, 102.86075, 102.720125, 104.17325, 100.79825, 101.595125, 100.376375, 98.688875,
            100.376375, 101.17325, 103.188875, 102.48575, 100.517, 99.907625, 98.407625, 102.11075, 96.251375,
            95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:32.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.66653,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:32.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.3295, 112.751375, 108.157625, 105.907625, 106.142, 107.4545, 105.67325, 108.2045, 104.688875, 103.04825,
            102.11075, 103.892, 100.188875, 99.67325, 100.142, 102.063875, 101.8295, 100.282625, 101.4545, 101.407625,
            104.4545, 103.04825, 100.79825, 100.04825, 98.54825, 102.626375, 97.04825, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:07.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.29478,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:07.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.92325, 122.876375, 122.876375, 124.657625, 118.79825, 117.907625, 116.36075, 112.095125, 108.532625,
            104.407625, 104.876375, 103.517, 101.73575, 103.61075, 102.063875, 104.126375, 102.29825, 101.501375,
            100.7045, 101.4545, 103.751375, 102.626375, 100.61075, 100.001375, 98.642, 102.626375, 96.9545, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:45.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.63832,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:45.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.407625, 129.345125, 127.3295, 123.48575, 120.2045, 117.532625, 113.595125, 111.063875, 107.782625,
            104.642, 102.29825, 100.563875, 99.392, 100.7045, 101.92325, 101.876375, 101.220125, 99.29825, 100.657625,
            101.407625, 103.470125, 102.9545, 100.517, 99.9545, 98.782625, 102.48575, 97.142, 95.407625,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:56.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.23007,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:56.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.04825, 117.438875, 115.517, 112.376375, 109.3295, 107.4545, 107.876375, 108.720125, 103.61075,
            105.063875, 104.876375, 101.8295, 100.470125, 101.267, 100.563875, 100.751375, 100.3295, 99.48575,
            100.23575, 101.595125, 104.73575, 102.813875, 100.79825, 99.907625, 98.4545, 102.626375, 96.251375,
            95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:59.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.44437,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:59.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.095125, 126.11075, 122.54825, 118.61075, 113.17325, 112.98575, 108.86075, 106.188875, 105.29825,
            104.36075, 102.86075, 102.251375, 103.23575, 102.532625, 100.23575, 101.8295, 100.3295, 99.9545, 99.86075,
            100.938875, 103.7045, 102.063875, 100.892, 99.907625, 98.220125, 102.2045, 96.251375, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:34.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.64255,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:34.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.657625, 131.782625, 130.98575, 128.36075, 127.42325, 124.23575, 121.657625, 119.407625, 115.188875,
            112.23575, 107.126375, 104.8295, 102.017, 101.032625, 99.86075, 100.470125, 101.688875, 99.345125,
            101.126375, 102.157625, 104.267, 103.517, 100.657625, 99.720125, 99.017, 102.48575, 97.095125, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:27.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.669624,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:27.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.157625, 116.688875, 115.095125, 113.4545, 110.970125, 109.04825, 107.407625, 108.017, 104.267,
            103.23575, 101.876375, 100.79825, 101.220125, 101.782625, 102.345125, 102.720125, 101.970125, 99.48575,
            100.095125, 101.4545, 103.188875, 102.767, 100.61075, 99.9545, 99.017, 102.813875, 97.376375, 95.407625,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:58.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.340324,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:58.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.970125, 117.907625, 112.61075, 110.642, 106.563875, 110.126375, 107.17325, 104.92325, 103.751375,
            101.501375, 102.48575, 103.751375, 103.3295, 103.001375, 102.017, 102.720125, 101.92325, 100.470125,
            101.313875, 101.970125, 104.032625, 103.04825, 101.17325, 100.470125, 99.345125, 103.188875, 97.04825,
            95.407625,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:46.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.01768,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:46.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.220125, 116.8295, 114.813875, 112.04825, 109.657625, 109.845125, 108.438875, 105.907625, 103.61075,
            101.92325, 102.251375, 101.126375, 99.2045, 100.892, 101.8295, 101.313875, 100.61075, 99.392, 100.517,
            101.4545, 103.892, 103.282625, 100.892, 100.142, 98.782625, 102.48575, 96.907625, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:40.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.61754,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:40.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.720125, 106.79825, 108.86075, 108.438875, 106.657625, 107.36075, 108.67325, 108.532625, 105.767,
            103.23575, 103.79825, 102.345125, 102.5795, 102.720125, 102.063875, 102.813875, 102.017, 99.532625,
            100.282625, 101.688875, 104.970125, 102.5795, 100.61075, 99.9545, 98.220125, 102.86075, 96.29825, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:49.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.91451,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:49.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.267, 118.98575, 114.532625, 113.36075, 117.86075, 116.595125, 110.73575, 109.095125, 105.9545, 105.2045,
            101.36075, 99.67325, 98.876375, 99.67325, 99.86075, 100.142, 99.157625, 98.54825, 100.188875, 100.892,
            103.188875, 102.29825, 100.657625, 99.86075, 98.73575, 102.813875, 96.345125, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:57.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.62949,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:57.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.282625, 115.517, 113.688875, 121.42325, 117.626375, 110.92325, 111.907625, 109.892, 105.86075,
            104.92325, 103.04825, 103.04825, 100.892, 101.54825, 100.657625, 102.438875, 102.907625, 99.907625,
            100.376375, 101.73575, 104.313875, 102.5795, 101.126375, 100.282625, 99.157625, 102.907625, 96.532625,
            95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:53.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.06665,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:53.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.095125, 109.04825, 108.345125, 108.720125, 106.095125, 106.376375, 105.86075, 108.9545, 103.938875,
            102.157625, 100.98575, 100.938875, 99.67325, 101.501375, 100.282625, 100.79825, 100.42325, 100.42325,
            101.407625, 102.9545, 104.407625, 103.23575, 100.79825, 99.86075, 98.267, 101.92325, 96.11075, 95.126375,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:25.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.74025,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:25.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.845125, 119.642, 118.470125, 116.17325, 112.98575, 111.157625, 108.532625, 109.001375, 103.98575,
            102.9545, 104.970125, 107.267, 103.892, 103.095125, 103.3295, 104.36075, 103.095125, 99.157625, 100.42325,
            100.98575, 103.517, 102.532625, 100.79825, 100.095125, 98.782625, 102.907625, 96.813875, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:13.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.113785,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:13.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.11075, 115.3295, 111.29825, 109.376375, 107.688875, 109.095125, 107.0795, 108.67325, 104.4545, 104.4545,
            106.095125, 107.36075, 104.501375, 103.04825, 103.42325, 102.86075, 101.407625, 99.345125, 99.48575,
            101.36075, 102.86075, 102.2045, 100.61075, 99.720125, 98.501375, 101.73575, 96.438875, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:56.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.69247,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:56.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.501375, 125.642, 124.23575, 120.626375, 118.095125, 116.0795, 113.54825, 112.892, 107.688875,
            105.720125, 104.876375, 101.688875, 99.5795, 101.0795, 100.3295, 100.282625, 101.73575, 99.29825, 99.5795,
            101.126375, 104.407625, 102.345125, 100.563875, 99.67325, 98.407625, 102.345125, 96.11075, 95.17325,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:41.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.59879,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:41.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.7045, 123.86075, 120.907625, 120.767, 118.23575, 114.767, 112.23575, 108.907625, 106.845125, 104.595125,
            103.845125, 101.595125, 102.720125, 104.54825, 103.282625, 103.3295, 103.517, 100.7045, 100.845125, 101.267,
            104.126375, 102.392, 100.657625, 99.767, 98.595125, 102.2045, 96.532625, 95.17325,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:52.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.87649,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:52.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.095125, 115.3295, 110.36075, 109.376375, 109.938875, 108.438875, 108.5795, 109.282625, 107.0795,
            103.657625, 103.470125, 101.54825, 99.157625, 102.063875, 99.392, 101.0795, 100.61075, 98.876375, 100.61075,
            100.7045, 103.095125, 102.11075, 100.657625, 99.9545, 98.4545, 103.142, 96.67325, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:03.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.814095,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:03.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.0795, 116.688875, 114.767, 117.720125, 111.86075, 110.876375, 111.438875, 108.67325, 107.688875,
            106.3295, 103.7045, 102.907625, 100.470125, 102.532625, 101.17325, 101.688875, 101.220125, 100.938875,
            100.001375, 101.642, 103.938875, 102.532625, 100.892, 100.095125, 98.92325, 102.9545, 97.376375, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:47.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.70831,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:47.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.73575, 124.7045, 123.626375, 119.501375, 114.017, 112.79825, 109.3295, 109.657625, 105.017, 111.48575,
            111.345125, 105.017, 108.11075, 100.282625, 100.563875, 101.17325, 101.17325, 98.876375, 100.3295, 100.7045,
            103.517, 101.92325, 100.188875, 99.86075, 98.36075, 102.392, 96.063875, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:33.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.99869,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:33.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.142, 122.92325, 120.438875, 118.04825, 115.98575, 112.04825, 108.767, 109.470125, 105.720125,
            103.751375, 102.017, 103.563875, 110.54825, 99.720125, 99.29825, 100.657625, 101.0795, 99.532625, 100.892,
            102.157625, 104.4545, 102.532625, 100.517, 99.86075, 98.501375, 102.5795, 96.438875, 95.407625,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:17.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.52135,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:17.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.267, 119.17325, 115.470125, 114.392, 111.29825, 108.251375, 111.392, 109.04825, 105.251375, 103.7045,
            104.782625, 104.688875, 107.17325, 106.23575, 104.313875, 103.001375, 102.48575, 101.4545, 100.517,
            101.782625, 103.23575, 102.67325, 101.032625, 100.282625, 98.92325, 103.001375, 96.813875, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:51.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.19775,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:51.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 123.063875, 118.23575, 115.376375, 112.751375, 108.9545, 110.267, 108.907625, 106.470125,
            102.532625, 101.73575, 99.813875, 98.313875, 101.220125, 100.79825, 101.407625, 100.98575, 100.938875,
            101.4545, 101.688875, 104.0795, 102.626375, 100.376375, 99.5795, 98.0795, 101.595125, 96.063875, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:48.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.38148,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:48.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.29825, 113.8295, 111.29825, 111.29825, 109.282625, 107.876375, 108.67325, 109.563875, 103.892,
            102.29825, 101.501375, 100.470125, 100.79825, 102.438875, 100.892, 101.876375, 103.095125, 102.063875,
            101.36075, 101.313875, 104.267, 102.29825, 100.98575, 100.282625, 98.36075, 102.345125, 96.11075, 95.126375,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:01.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.08902,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:01.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.3295, 120.532625, 116.126375, 115.563875, 112.7045, 110.313875, 110.032625, 109.517, 106.095125,
            104.407625, 103.79825, 102.392, 100.892, 102.626375, 101.220125, 104.0795, 101.501375, 100.42325, 99.720125,
            100.938875, 103.376375, 102.345125, 100.282625, 99.5795, 98.36075, 102.157625, 96.9545, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:21.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.66343,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:21.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.73575, 117.720125, 116.0795, 111.9545, 111.063875, 108.9545, 107.642, 107.220125, 105.392, 103.517,
            102.48575, 104.501375, 104.688875, 103.142, 101.267, 102.392, 101.267, 102.438875, 100.98575, 100.751375,
            103.376375, 102.438875, 100.98575, 100.001375, 98.501375, 103.001375, 96.251375, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:47.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.12478,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:47.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.42325, 112.04825, 111.720125, 109.7045, 108.86075, 107.313875, 107.126375, 107.126375, 103.470125,
            102.063875, 101.73575, 101.36075, 101.36075, 102.720125, 102.157625, 103.001375, 102.9545, 101.220125,
            101.54825, 102.392, 104.220125, 102.392, 100.751375, 100.3295, 98.782625, 102.392, 96.2045, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:57.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.13329,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:57.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.657625, 120.29825, 116.595125, 112.142, 111.29825, 109.42325, 109.470125, 107.313875, 105.907625,
            103.751375, 103.23575, 101.92325, 101.970125, 101.313875, 100.751375, 100.61075, 100.42325, 100.001375,
            101.0795, 101.595125, 103.751375, 103.142, 100.751375, 99.767, 98.8295, 103.282625, 97.001375, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:06.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.52828,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:06.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.79825, 117.720125, 113.970125, 112.142, 112.095125, 112.188875, 114.2045, 109.376375, 105.67325,
            103.892, 104.595125, 103.142, 101.642, 104.267, 102.392, 104.501375, 103.142, 102.5795, 101.0795, 101.642,
            104.313875, 103.001375, 101.17325, 100.751375, 99.48575, 103.517, 97.3295, 95.501375,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:58.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 146.23029,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:58.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.251375, 138.767, 135.251375, 131.876375, 132.532625, 127.282625, 124.376375, 121.98575, 119.220125,
            117.438875, 112.376375, 108.767, 105.063875, 102.813875, 101.313875, 101.267, 100.04825, 99.626375, 99.767,
            101.313875, 103.470125, 102.2045, 100.61075, 99.813875, 98.220125, 102.063875, 96.767, 95.407625,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:20.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.80702,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:20.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.17325, 126.157625, 125.407625, 120.67325, 119.407625, 118.001375, 112.751375, 110.126375, 107.642,
            105.251375, 103.98575, 102.767, 102.017, 102.063875, 101.4545, 103.98575, 102.345125, 101.8295, 101.407625,
            101.267, 103.095125, 102.29825, 100.845125, 100.188875, 98.876375, 102.813875, 96.767, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:28.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.0209,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:28.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.688875, 114.392, 111.9545, 109.98575, 108.5795, 109.470125, 106.470125, 108.017, 103.657625, 102.251375,
            102.29825, 100.751375, 99.392, 99.67325, 100.98575, 101.73575, 103.892, 100.470125, 100.751375, 101.313875,
            103.376375, 102.907625, 100.98575, 100.001375, 98.688875, 102.86075, 96.907625, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:39.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.2348,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:39.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.532625, 122.267, 119.032625, 119.032625, 116.407625, 110.0795, 108.438875, 108.29825, 105.86075,
            104.501375, 104.876375, 102.67325, 99.720125, 101.220125, 101.4545, 101.501375, 101.032625, 98.970125,
            100.61075, 101.36075, 107.688875, 103.095125, 100.61075, 100.3295, 98.642, 102.392, 96.532625, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:48.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.703445,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:48.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.282625, 104.642, 101.73575, 104.642, 106.938875, 109.142, 107.54825, 108.345125, 103.470125, 101.4545,
            101.17325, 99.9545, 98.8295, 99.907625, 99.626375, 100.79825, 100.376375, 98.92325, 100.142, 101.36075,
            103.7045, 103.04825, 101.126375, 100.376375, 98.688875, 102.9545, 96.438875, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:42.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.28967,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:42.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.470125, 123.392, 120.392, 118.563875, 115.892, 112.376375, 112.095125, 106.938875, 105.11075,
            102.813875, 102.345125, 102.48575, 102.720125, 103.42325, 102.626375, 103.04825, 103.98575, 101.8295,
            100.79825, 102.11075, 104.642, 102.720125, 100.61075, 100.001375, 98.642, 102.345125, 96.345125, 95.267,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:50.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.99095,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:50.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.157625, 113.8295, 112.188875, 108.5795, 106.142, 107.642, 106.23575, 106.470125, 103.563875, 101.501375,
            101.876375, 101.313875, 103.095125, 105.86075, 101.0795, 101.17325, 102.157625, 98.688875, 100.142,
            101.032625, 103.376375, 102.29825, 101.032625, 99.907625, 98.313875, 102.11075, 96.2045, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:16.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.88495,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:16.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.970125, 123.9545, 119.313875, 114.5795, 111.626375, 109.938875, 109.98575, 108.438875, 104.73575,
            103.470125, 103.42325, 103.376375, 102.907625, 106.04825, 103.142, 101.36075, 101.220125, 100.751375,
            100.42325, 101.032625, 103.001375, 102.532625, 100.61075, 100.04825, 98.642, 102.438875, 96.720125,
            95.407625,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:37.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.841156,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:37.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.157625, 118.563875, 113.501375, 114.063875, 112.3295, 108.626375, 108.2045, 109.42325, 105.626375,
            104.92325, 103.3295, 104.126375, 104.032625, 101.17325, 102.345125, 100.938875, 103.517, 100.23575,
            100.845125, 101.313875, 104.8295, 103.470125, 100.938875, 100.282625, 99.345125, 104.032625, 97.142,
            95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:51.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.26844,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:51.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.126375, 118.98575, 116.4545, 112.751375, 109.938875, 111.345125, 108.157625, 106.79825, 104.36075,
            102.063875, 105.5795, 102.532625, 101.782625, 105.907625, 99.11075, 100.142, 101.36075, 98.688875,
            99.626375, 100.845125, 103.7045, 102.5795, 100.7045, 99.767, 98.313875, 102.063875, 96.157625, 95.126375,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:53.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.8864,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:02:53.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.42325, 106.142, 105.2045, 110.501375, 114.48575, 109.79825, 109.04825, 111.438875, 105.11075, 101.642,
            102.626375, 102.345125, 100.282625, 102.345125, 100.376375, 101.220125, 101.73575, 98.8295, 99.29825,
            101.17325, 103.23575, 102.532625, 100.61075, 99.48575, 98.36075, 102.251375, 96.251375, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:00.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.30077,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:00.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.17325, 125.407625, 123.29825, 121.04825, 117.29825, 113.595125, 111.813875, 108.9545, 106.563875,
            104.54825, 104.642, 105.438875, 105.532625, 105.29825, 101.4545, 102.392, 102.157625, 100.61075, 100.845125,
            101.73575, 103.42325, 102.813875, 101.4545, 100.563875, 99.438875, 103.657625, 97.79825, 95.73575,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:22.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.266594,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:22.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.8295, 102.063875, 103.938875, 108.813875, 107.54825, 107.032625, 107.36075, 107.501375, 104.73575,
            103.657625, 102.438875, 100.79825, 99.767, 100.7045, 100.938875, 101.0795, 100.98575, 101.267, 100.845125,
            100.7045, 103.142, 102.5795, 100.892, 100.282625, 98.876375, 102.86075, 96.392, 95.17325,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:54.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.77863,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:54.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.2045, 115.001375, 114.392, 111.438875, 106.938875, 106.42325, 107.36075, 109.938875, 105.626375,
            104.36075, 102.251375, 100.892, 99.86075, 105.017, 106.095125, 101.73575, 101.4545, 100.23575, 101.17325,
            102.907625, 105.017, 103.470125, 101.782625, 100.42325, 98.782625, 102.907625, 96.392, 95.220125,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:31.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.889404,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:31.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.29825, 110.267, 106.892, 108.11075, 106.470125, 107.407625, 106.42325, 107.267, 104.595125, 103.845125,
            102.063875, 100.938875, 100.282625, 100.470125, 100.142, 101.267, 101.876375, 99.392, 101.126375,
            101.407625, 103.79825, 102.67325, 100.470125, 99.907625, 98.642, 102.251375, 97.001375, 95.313875,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:35.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.27776,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:35.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.220125, 128.267, 125.220125, 124.845125, 121.892, 118.517, 113.313875, 110.92325, 107.8295, 104.313875,
            103.001375, 101.782625, 99.251375, 99.813875, 99.063875, 101.73575, 102.2045, 99.86075, 102.48575,
            101.595125, 104.642, 103.938875, 100.751375, 99.9545, 99.11075, 102.626375, 96.813875, 95.36075,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:00.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.07686,
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:03:00.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.438875, 127.563875, 127.142, 122.92325, 119.032625, 115.7045, 112.517, 109.845125, 107.407625,
            104.220125, 104.0795, 103.23575, 102.251375, 104.0795, 101.92325, 103.23575, 102.626375, 100.282625,
            99.907625, 101.4545, 104.0795, 102.532625, 100.7045, 99.907625, 98.501375, 103.001375, 96.86075, 95.501375,
        ],
        latitude: 37.4405843,
        longitude: -122.5334157,
    },
    {
        timestamp: '2025-08-29T23:04:09.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.07612,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:09.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.095125, 113.032625, 111.813875, 109.892, 107.220125, 107.17325, 110.92325, 108.251375, 103.282625,
            102.720125, 101.54825, 100.938875, 99.157625, 99.29825, 99.345125, 98.970125, 98.313875, 98.17325,
            98.876375, 100.470125, 102.626375, 102.345125, 100.61075, 100.095125, 98.688875, 102.251375, 97.142,
            95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:12.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.4831,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:12.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.720125, 102.392, 103.751375, 108.767, 109.98575, 110.0795, 108.5795, 109.3295, 105.720125, 105.2045,
            103.04825, 101.8295, 100.7045, 101.8295, 103.892, 102.532625, 103.001375, 103.188875, 102.29825, 100.563875,
            102.5795, 103.095125, 101.17325, 99.67325, 98.54825, 102.392, 96.392, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:12.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.44449,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:12.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.23575, 122.220125, 116.92325, 114.345125, 114.438875, 111.626375, 112.188875, 110.595125, 104.595125,
            103.7045, 103.42325, 100.657625, 100.61075, 99.767, 99.720125, 99.626375, 99.767, 98.4545, 98.782625,
            100.98575, 102.67325, 102.345125, 101.032625, 99.86075, 98.688875, 102.251375, 97.188875, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:29.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.45468,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:29.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.142, 134.032625, 130.470125, 129.9545, 127.845125, 123.813875, 118.98575, 120.48575, 116.36075,
            113.54825, 107.0795, 103.79825, 101.73575, 101.501375, 101.54825, 102.2045, 103.142, 101.782625, 101.595125,
            102.157625, 103.892, 102.907625, 100.751375, 100.04825, 98.8295, 102.907625, 96.86075, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:22.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.083176,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:22.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.642, 107.126375, 107.782625, 108.9545, 109.42325, 108.063875, 109.142, 108.907625, 107.0795, 103.23575,
            102.532625, 101.0795, 100.001375, 99.9545, 101.267, 100.7045, 100.657625, 99.67325, 99.720125, 101.126375,
            103.04825, 102.438875, 100.98575, 100.282625, 98.688875, 102.813875, 96.392, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:34.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.34521,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:34.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.04825, 128.0795, 125.73575, 122.8295, 118.98575, 115.845125, 112.751375, 111.345125, 107.54825,
            111.11075, 107.54825, 101.970125, 102.626375, 101.032625, 103.142, 102.29825, 101.4545, 99.907625,
            100.095125, 101.0795, 102.813875, 103.188875, 100.79825, 99.907625, 99.345125, 102.9545, 96.767, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:45.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.78206,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:45.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.767, 128.032625, 126.67325, 125.4545, 122.501375, 121.79825, 117.2045, 112.845125, 109.42325,
            106.938875, 105.063875, 102.251375, 101.595125, 101.313875, 102.063875, 104.4545, 102.9545, 103.23575,
            101.782625, 102.438875, 103.23575, 101.8295, 100.42325, 99.5795, 98.501375, 103.04825, 97.001375, 97.282625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:31.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.707726,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:31.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.767, 115.3295, 111.017, 112.751375, 110.032625, 108.767, 108.48575, 109.892, 107.501375, 105.345125,
            105.063875, 102.813875, 101.782625, 101.407625, 100.376375, 102.251375, 100.845125, 100.751375, 100.04825,
            101.267, 103.517, 102.392, 100.376375, 99.767, 99.017, 102.767, 96.767, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:24.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.77257,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:24.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.92325, 125.220125, 122.92325, 119.220125, 116.267, 113.032625, 110.642, 108.67325, 105.86075,
            104.595125, 103.3295, 101.73575, 100.188875, 100.470125, 101.0795, 101.032625, 100.98575, 100.657625,
            101.595125, 101.407625, 103.7045, 102.813875, 100.7045, 99.767, 98.688875, 102.251375, 96.767, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:38.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.39453,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:38.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.032625, 122.92325, 120.67325, 116.92325, 114.626375, 112.188875, 110.54825, 109.23575, 105.2045,
            103.7045, 103.095125, 101.688875, 100.892, 102.017, 101.126375, 103.657625, 102.907625, 102.251375,
            101.126375, 101.970125, 103.376375, 103.3295, 100.938875, 99.67325, 98.8295, 102.720125, 96.5795, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:06.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.56812,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:06.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.251375, 120.767, 118.7045, 115.001375, 112.79825, 110.220125, 110.782625, 108.251375, 104.782625,
            103.188875, 102.48575, 100.938875, 99.86075, 100.657625, 99.2045, 99.157625, 98.970125, 98.501375,
            98.782625, 100.470125, 102.67325, 101.970125, 100.563875, 99.9545, 98.501375, 102.063875, 96.438875,
            95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:05.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.8369,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:05.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.282625, 111.345125, 108.063875, 106.470125, 105.11075, 107.126375, 107.36075, 109.23575, 104.92325,
            104.313875, 102.907625, 104.782625, 102.813875, 104.876375, 103.892, 104.032625, 105.9545, 103.938875,
            101.407625, 101.501375, 102.720125, 102.532625, 100.282625, 99.5795, 98.313875, 101.92325, 96.438875,
            95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:06.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.516785,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:06.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.36075, 118.001375, 115.657625, 111.2045, 109.188875, 107.407625, 108.626375, 109.42325, 105.767,
            104.407625, 103.7045, 104.642, 102.438875, 103.657625, 104.36075, 104.782625, 106.42325, 104.54825,
            101.220125, 101.642, 103.376375, 102.813875, 100.563875, 99.86075, 98.501375, 102.345125, 96.392, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:46.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.9221,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:46.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.938875, 124.563875, 122.54825, 119.267, 118.42325, 114.532625, 111.9545, 113.032625, 106.563875,
            103.938875, 104.54825, 102.67325, 100.79825, 101.220125, 101.313875, 103.61075, 102.767, 102.5795,
            101.73575, 102.438875, 103.845125, 102.626375, 100.563875, 99.626375, 98.501375, 102.48575, 96.532625,
            95.501375,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:01.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.27816,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:01.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.157625, 113.54825, 112.001375, 111.392, 110.73575, 109.517, 107.0795, 110.4545, 104.17325, 104.501375,
            104.032625, 103.095125, 100.376375, 101.501375, 100.938875, 102.29825, 99.813875, 99.345125, 99.017,
            100.892, 102.767, 102.017, 100.376375, 99.48575, 98.17325, 101.970125, 96.157625, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:01.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.34258,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:01.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.470125, 133.376375, 129.48575, 129.11075, 125.642, 125.032625, 120.532625, 115.470125, 112.79825,
            109.282625, 107.54825, 103.142, 101.54825, 102.907625, 101.313875, 103.42325, 103.657625, 103.001375,
            101.782625, 101.0795, 102.9545, 103.095125, 100.563875, 99.5795, 98.267, 102.345125, 96.345125, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:19.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.39424,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:19.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.392, 128.970125, 126.2045, 123.48575, 121.563875, 118.23575, 114.9545, 113.688875, 109.657625,
            106.563875, 105.392, 101.313875, 100.095125, 100.095125, 98.595125, 99.251375, 98.54825, 97.98575,
            98.688875, 100.563875, 102.29825, 101.970125, 100.376375, 99.813875, 99.063875, 102.720125, 96.5795,
            95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:51.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.87996,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:51.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.470125, 130.563875, 129.813875, 126.438875, 124.3295, 122.970125, 121.845125, 117.67325, 113.407625,
            110.126375, 106.98575, 104.54825, 103.845125, 105.063875, 107.407625, 106.04825, 103.563875, 102.5795,
            102.017, 102.626375, 103.79825, 102.767, 100.61075, 99.9545, 98.642, 103.095125, 96.9545, 95.595125,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:25.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.02478,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:25.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 123.017, 120.5795, 118.376375, 114.11075, 112.282625, 109.657625, 107.220125, 104.782625,
            102.29825, 102.063875, 102.063875, 100.517, 99.907625, 101.407625, 101.8295, 100.563875, 100.470125,
            101.313875, 101.0795, 103.04825, 102.392, 100.751375, 100.095125, 98.313875, 102.251375, 96.626375, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:02.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.123764,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:02.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.501375, 110.126375, 108.813875, 109.61075, 109.095125, 107.688875, 109.376375, 109.470125, 104.688875,
            103.98575, 103.517, 101.8295, 100.188875, 100.7045, 100.376375, 100.845125, 99.532625, 98.782625, 99.017,
            101.032625, 102.720125, 102.251375, 100.751375, 99.86075, 98.4545, 102.2045, 96.251375, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:08.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.341385,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:08.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.595125, 102.345125, 106.7045, 109.04825, 109.79825, 108.063875, 109.938875, 110.4545, 107.595125,
            104.782625, 102.438875, 101.313875, 98.501375, 100.188875, 100.563875, 99.626375, 99.157625, 98.220125,
            98.92325, 100.845125, 102.813875, 102.345125, 100.751375, 99.9545, 98.642, 103.7045, 96.626375, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:40.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.88793,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:40.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.657625, 106.98575, 105.626375, 106.61075, 107.407625, 109.142, 108.11075, 110.313875, 105.532625,
            104.17325, 104.36075, 102.67325, 101.126375, 101.970125, 101.4545, 103.61075, 104.642, 102.2045, 101.407625,
            101.642, 103.751375, 102.67325, 101.032625, 100.23575, 98.876375, 102.9545, 96.67325, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:58.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.38158,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:58.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.79825, 115.001375, 112.282625, 111.11075, 108.345125, 111.2045, 107.782625, 106.563875, 103.892,
            103.517, 102.5795, 102.2045, 100.42325, 102.67325, 102.2045, 103.517, 103.282625, 103.04825, 100.79825,
            101.876375, 103.282625, 102.5795, 100.42325, 99.767, 98.220125, 102.017, 96.345125, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:55.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.72109,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:55.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.501375, 112.657625, 109.938875, 109.095125, 107.8295, 109.142, 107.642, 109.563875, 104.73575,
            104.595125, 103.001375, 102.063875, 101.4545, 102.626375, 103.23575, 103.42325, 103.095125, 102.392,
            101.17325, 101.4545, 103.001375, 102.251375, 100.42325, 99.67325, 98.54825, 102.251375, 96.9545, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:10.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.43534,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:10.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.73575, 111.2045, 110.313875, 106.7045, 109.751375, 110.407625, 107.267, 106.751375, 103.142, 103.563875,
            102.438875, 102.438875, 101.4545, 102.813875, 103.3295, 103.188875, 103.7045, 103.892, 102.11075,
            101.782625, 102.813875, 102.67325, 100.938875, 99.86075, 98.642, 103.188875, 96.5795, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:23.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.20102,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:23.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.267, 125.595125, 121.845125, 120.9545, 115.751375, 114.907625, 109.23575, 108.157625, 106.563875,
            102.2045, 102.345125, 101.126375, 99.345125, 100.657625, 100.563875, 100.751375, 100.892, 99.345125,
            100.282625, 100.79825, 103.282625, 102.48575, 100.892, 100.001375, 98.92325, 102.345125, 96.767, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:05.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.01788,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:05.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.157625, 119.126375, 116.876375, 114.813875, 110.782625, 109.23575, 107.8295, 108.86075, 104.0795,
            102.86075, 101.73575, 100.892, 100.095125, 100.517, 100.7045, 100.470125, 99.626375, 99.67325, 99.720125,
            101.501375, 103.188875, 102.907625, 100.98575, 100.04825, 99.251375, 102.813875, 97.517, 95.642,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:03:59.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.51436,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:03:59.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.642, 123.438875, 123.532625, 118.282625, 118.751375, 115.282625, 112.98575, 110.267, 106.892, 105.2045,
            104.595125, 103.517, 100.23575, 101.73575, 102.063875, 101.688875, 100.188875, 99.532625, 99.5795,
            101.313875, 103.98575, 102.626375, 100.7045, 99.626375, 98.4545, 102.392, 96.48575, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:03.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.59363,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:03.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.61075, 125.36075, 120.438875, 116.032625, 113.17325, 111.063875, 111.017, 109.3295, 106.376375,
            105.345125, 103.563875, 101.0795, 101.36075, 103.563875, 101.0795, 103.282625, 103.938875, 101.782625,
            101.642, 101.032625, 102.48575, 102.532625, 100.657625, 99.86075, 98.4545, 102.626375, 96.86075, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:18.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.27022,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:18.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.267, 118.42325, 116.36075, 117.063875, 114.86075, 111.907625, 109.563875, 110.0795, 106.23575,
            103.470125, 102.767, 101.8295, 99.532625, 98.407625, 99.017, 100.61075, 98.782625, 98.501375, 98.642,
            100.79825, 102.67325, 102.2045, 100.7045, 100.282625, 98.92325, 102.86075, 96.813875, 95.501375,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:33.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.42856,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:33.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.282625, 122.782625, 122.688875, 118.892, 115.845125, 113.126375, 111.2045, 108.5795, 106.563875,
            106.23575, 104.970125, 103.3295, 102.813875, 102.392, 102.438875, 103.3295, 102.2045, 100.657625,
            100.095125, 101.4545, 103.23575, 102.5795, 100.751375, 99.9545, 99.251375, 102.532625, 97.563875, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:35.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.24915,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:35.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 125.8295, 122.0795, 120.907625, 118.470125, 115.938875, 112.095125, 110.876375, 107.8295,
            112.657625, 107.407625, 101.36075, 103.04825, 101.267, 102.345125, 102.626375, 101.0795, 100.095125,
            100.61075, 101.220125, 102.157625, 102.720125, 100.42325, 99.907625, 99.063875, 103.892, 97.095125,
            96.11075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:04.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.87886,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:04.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.563875, 122.73575, 120.29825, 116.876375, 111.5795, 108.438875, 107.501375, 109.142, 103.376375,
            101.4545, 102.67325, 101.313875, 100.470125, 100.7045, 99.720125, 100.188875, 99.11075, 98.220125,
            98.501375, 100.751375, 102.48575, 102.063875, 100.282625, 99.626375, 98.54825, 102.345125, 96.907625,
            95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:47.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.44964,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:47.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.5795, 113.876375, 111.48575, 109.04825, 106.04825, 108.063875, 109.04825, 110.032625, 103.517,
            104.17325, 103.938875, 101.688875, 100.23575, 101.267, 101.970125, 102.9545, 103.845125, 103.001375,
            102.157625, 101.92325, 103.61075, 102.813875, 100.61075, 100.188875, 98.73575, 102.063875, 96.767, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:59.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.42319,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:59.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.892, 106.001375, 107.642, 109.61075, 108.720125, 111.626375, 109.470125, 110.688875, 107.501375,
            106.001375, 104.876375, 101.642, 101.407625, 103.142, 101.54825, 103.657625, 103.61075, 103.845125,
            101.0795, 102.438875, 103.61075, 102.86075, 100.938875, 99.86075, 98.782625, 102.720125, 96.86075, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:30.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.77563,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:30.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.001375, 133.563875, 130.3295, 124.142, 122.4545, 120.29825, 115.79825, 114.157625, 112.563875, 108.767,
            106.188875, 102.720125, 101.313875, 101.267, 101.407625, 102.2045, 102.2045, 101.407625, 100.142,
            101.970125, 103.095125, 102.5795, 100.657625, 99.86075, 98.642, 102.29825, 96.392, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:56.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.82811,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:56.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.532625, 133.376375, 131.688875, 127.142, 125.220125, 123.86075, 119.782625, 116.313875, 115.751375,
            111.392, 107.407625, 104.501375, 101.782625, 103.282625, 102.48575, 104.17325, 103.23575, 103.376375,
            100.7045, 102.017, 103.23575, 102.345125, 101.032625, 100.04825, 99.251375, 103.42325, 98.17325, 95.876375,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:39.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.75778,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:39.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.4545, 120.438875, 117.157625, 112.42325, 110.4545, 109.23575, 108.720125, 108.5795, 105.29825,
            103.751375, 101.876375, 101.595125, 101.501375, 101.8295, 101.407625, 102.9545, 103.79825, 101.92325,
            101.970125, 101.54825, 103.563875, 102.29825, 100.657625, 100.04825, 98.642, 102.29825, 96.813875, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:08.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.2553,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:08.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 124.188875, 119.73575, 118.563875, 115.938875, 112.470125, 111.767, 111.67325, 106.938875,
            106.751375, 103.657625, 102.157625, 100.79825, 103.001375, 103.3295, 104.17325, 105.017, 105.017, 101.642,
            100.98575, 102.5795, 102.5795, 100.751375, 99.86075, 98.4545, 101.970125, 96.48575, 95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:10.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.82407,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:10.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.142, 122.876375, 120.438875, 118.42325, 116.126375, 111.720125, 112.376375, 112.517, 104.688875,
            102.2045, 103.376375, 100.751375, 99.392, 100.04825, 98.782625, 98.876375, 98.73575, 98.032625, 98.782625,
            101.032625, 102.720125, 102.251375, 100.282625, 99.813875, 98.407625, 102.48575, 96.67325, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:00.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.19336,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:00.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.73575, 129.345125, 128.267, 125.8295, 122.17325, 118.938875, 116.595125, 113.782625, 110.032625,
            106.657625, 104.970125, 103.376375, 99.9545, 101.17325, 100.42325, 101.36075, 99.438875, 99.017, 98.970125,
            101.126375, 103.563875, 102.5795, 100.563875, 99.720125, 98.54825, 102.2045, 96.438875, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:17.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.6592,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:17.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.67325, 103.142, 105.9545, 109.095125, 109.282625, 108.532625, 111.2045, 111.48575, 107.642, 105.11075,
            103.142, 101.220125, 99.626375, 99.86075, 98.970125, 100.142, 99.017, 98.54825, 98.92325, 100.517,
            102.438875, 101.970125, 100.470125, 99.532625, 98.595125, 102.157625, 96.48575, 95.54825,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:44.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.32858,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:44.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.3295, 131.688875, 125.595125, 121.751375, 118.04825, 118.095125, 115.938875, 112.79825, 109.04825,
            105.063875, 104.501375, 102.9545, 102.063875, 102.2045, 102.532625, 104.126375, 104.92325, 104.8295,
            101.876375, 102.2045, 103.376375, 102.392, 100.98575, 99.392, 98.032625, 102.5795, 96.532625, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:27.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.947235,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:27.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.392, 105.063875, 104.876375, 106.98575, 108.11075, 108.017, 107.595125, 107.032625, 105.438875,
            101.782625, 100.845125, 101.313875, 100.98575, 100.845125, 101.032625, 101.688875, 103.095125, 100.938875,
            101.970125, 101.8295, 104.595125, 103.001375, 101.17325, 100.095125, 98.688875, 102.813875, 96.532625,
            95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:09.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.65537,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:09.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.17325, 112.376375, 108.251375, 109.751375, 107.688875, 109.3295, 109.61075, 110.220125, 104.92325,
            104.876375, 103.095125, 102.063875, 101.36075, 102.11075, 102.626375, 103.657625, 103.938875, 103.938875,
            102.017, 101.54825, 102.907625, 102.157625, 100.751375, 99.9545, 98.73575, 102.720125, 96.438875, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:02.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.54566,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:02.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.845125, 110.36075, 105.2045, 105.11075, 105.157625, 107.54825, 106.42325, 107.126375, 104.688875,
            104.313875, 102.720125, 100.751375, 100.3295, 102.532625, 101.313875, 103.095125, 103.79825, 101.4545,
            101.36075, 101.36075, 102.907625, 102.86075, 100.282625, 99.29825, 98.220125, 101.501375, 96.392, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:50.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.26796,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:50.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.23575, 121.23575, 118.751375, 114.017, 110.501375, 109.42325, 111.438875, 110.595125, 105.345125,
            103.188875, 103.04825, 101.501375, 101.54825, 102.813875, 105.063875, 105.251375, 103.42325, 102.86075,
            102.532625, 102.86075, 103.61075, 103.282625, 100.98575, 100.188875, 99.29825, 103.04825, 97.517, 95.595125,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:07.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.37492,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:07.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.61075, 123.626375, 121.517, 116.876375, 115.7045, 112.3295, 109.7045, 108.251375, 103.142, 103.3295,
            101.0795, 100.095125, 99.017, 99.67325, 99.532625, 99.017, 99.017, 98.17325, 98.782625, 100.657625, 102.392,
            101.8295, 100.376375, 99.86075, 98.642, 102.5795, 96.67325, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:37.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.96037,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:37.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.142, 127.282625, 124.188875, 119.267, 117.251375, 116.92325, 111.86075, 108.767, 106.892, 114.532625,
            107.642, 102.720125, 103.001375, 102.392, 102.5795, 103.04825, 102.157625, 101.782625, 101.220125,
            102.11075, 103.142, 103.470125, 100.845125, 100.001375, 99.157625, 103.376375, 97.517, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:52.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.91727,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:52.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.313875, 118.04825, 117.767, 115.23575, 109.79825, 107.642, 109.282625, 108.251375, 105.392, 103.61075,
            101.8295, 102.157625, 101.8295, 102.48575, 103.04825, 103.470125, 103.376375, 101.876375, 101.501375,
            102.251375, 103.23575, 102.720125, 100.657625, 99.9545, 98.4545, 102.532625, 96.813875, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:11.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.03802,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:11.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.688875, 123.345125, 120.9545, 118.938875, 115.79825, 112.938875, 109.7045, 108.532625, 106.04825,
            104.313875, 102.9545, 102.9545, 102.017, 103.892, 104.54825, 103.845125, 104.313875, 103.98575, 102.9545,
            101.501375, 102.67325, 102.392, 100.79825, 99.907625, 98.54825, 102.157625, 96.48575, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:21.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.751816,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:21.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.86075, 108.063875, 106.282625, 108.017, 107.407625, 108.86075, 106.7045, 107.220125, 104.407625,
            102.720125, 101.595125, 100.98575, 99.438875, 100.282625, 99.345125, 100.282625, 99.532625, 98.642,
            99.157625, 100.657625, 102.767, 102.29825, 100.3295, 99.86075, 98.501375, 102.392, 96.48575, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:15.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.29959,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:15.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.376375, 122.92325, 121.563875, 118.892, 114.438875, 111.5795, 114.11075, 111.86075, 104.876375,
            104.92325, 103.79825, 100.282625, 99.11075, 99.86075, 98.876375, 99.11075, 98.782625, 98.407625, 98.688875,
            101.126375, 102.29825, 101.8295, 100.04825, 99.720125, 98.313875, 101.970125, 96.438875, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:20.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.32066,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:20.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 124.751375, 119.688875, 116.688875, 114.017, 118.188875, 111.11075, 110.501375, 107.92325,
            103.282625, 101.501375, 101.92325, 98.970125, 99.532625, 98.313875, 99.2045, 99.2045, 98.0795, 98.782625,
            100.563875, 102.392, 101.876375, 100.188875, 99.720125, 98.407625, 102.29825, 96.5795, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:32.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.10925,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:32.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.86075, 120.438875, 119.032625, 116.501375, 113.126375, 112.42325, 109.142, 109.517, 107.92325, 108.9545,
            104.126375, 104.267, 101.0795, 101.54825, 100.188875, 102.9545, 102.251375, 100.845125, 100.188875,
            101.17325, 102.767, 102.251375, 100.095125, 99.157625, 98.313875, 101.73575, 96.626375, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:49.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.83744,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:49.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.267, 119.876375, 118.04825, 114.48575, 111.907625, 111.063875, 111.392, 109.282625, 105.251375,
            104.220125, 103.23575, 101.501375, 100.3295, 101.642, 101.36075, 102.532625, 103.892, 102.2045, 101.92325,
            101.876375, 103.376375, 102.5795, 100.845125, 99.813875, 98.876375, 102.251375, 96.907625, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:36.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.50331,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:36.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.5795, 117.532625, 114.907625, 113.73575, 111.29825, 110.0795, 109.376375, 109.188875, 107.642, 114.9545,
            108.063875, 101.267, 103.61075, 101.876375, 104.17325, 102.9545, 101.126375, 100.142, 100.142, 101.267,
            102.392, 102.767, 100.61075, 100.04825, 98.876375, 102.532625, 96.720125, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:16.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.58641,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:16.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.8295, 111.11075, 109.751375, 110.126375, 109.79825, 109.142, 110.92325, 110.407625, 103.657625,
            103.98575, 103.001375, 100.61075, 97.7045, 99.532625, 98.267, 99.017, 97.7045, 97.98575, 98.642, 100.470125,
            102.29825, 101.73575, 99.86075, 99.532625, 98.313875, 102.157625, 96.345125, 95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:57.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.04036,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:57.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.017, 128.17325, 127.188875, 124.79825, 122.36075, 118.751375, 118.657625, 115.7045, 110.782625,
            105.813875, 105.345125, 102.063875, 101.501375, 102.86075, 102.063875, 103.376375, 103.3295, 102.907625,
            100.845125, 101.876375, 102.907625, 102.48575, 100.61075, 99.626375, 98.688875, 102.9545, 97.095125,
            95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:11.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.64568,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:11.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.2045, 130.61075, 128.688875, 123.907625, 121.3295, 120.063875, 118.001375, 114.157625, 110.36075,
            107.313875, 105.157625, 101.92325, 99.813875, 100.23575, 99.9545, 99.345125, 98.8295, 98.0795, 98.595125,
            100.376375, 102.345125, 102.29825, 101.032625, 100.23575, 98.73575, 103.517, 96.720125, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:43.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.71121,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:43.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.876375, 126.532625, 122.407625, 117.767, 116.4545, 113.17325, 109.845125, 111.11075, 106.188875,
            103.282625, 104.876375, 102.5795, 101.782625, 102.2045, 102.626375, 104.642, 105.438875, 104.970125,
            101.688875, 102.392, 103.282625, 102.532625, 100.938875, 100.04825, 98.642, 102.48575, 96.626375, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:26.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.69514,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:26.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.79825, 116.54825, 113.17325, 111.438875, 110.032625, 110.36075, 106.845125, 107.688875, 107.595125,
            103.517, 102.017, 101.595125, 100.470125, 100.61075, 101.407625, 101.595125, 102.392, 100.095125, 102.2045,
            101.73575, 104.8295, 102.438875, 100.517, 99.86075, 98.595125, 101.970125, 96.29825, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:54.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.66035,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:54.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.2045, 121.04825, 117.767, 113.92325, 111.9545, 111.67325, 109.282625, 113.501375, 108.438875, 106.7045,
            104.220125, 104.92325, 104.0795, 104.501375, 103.845125, 103.142, 103.61075, 101.92325, 101.782625,
            102.2045, 103.845125, 102.532625, 100.7045, 99.907625, 98.92325, 102.767, 97.42325, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:04.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.45778,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:04.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.188875, 125.501375, 122.36075, 119.267, 114.251375, 111.9545, 110.92325, 110.220125, 108.017, 105.5795,
            103.657625, 102.532625, 102.767, 104.313875, 102.626375, 104.17325, 104.4545, 103.142, 101.970125,
            101.032625, 102.9545, 102.626375, 100.376375, 99.532625, 98.313875, 102.2045, 97.3295, 95.595125,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:41.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.61249,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:41.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.79825, 126.907625, 125.36075, 119.876375, 118.61075, 113.267, 111.813875, 111.345125, 107.4545,
            106.657625, 104.407625, 103.7045, 101.688875, 102.813875, 101.501375, 104.313875, 104.8295, 103.04825,
            102.2045, 102.11075, 103.470125, 103.23575, 100.98575, 100.376375, 99.063875, 103.23575, 96.907625, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:14.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.25989,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:14.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.438875, 133.79825, 133.095125, 130.282625, 126.29825, 123.017, 120.392, 118.42325, 114.626375,
            112.61075, 109.563875, 103.892, 101.36075, 100.3295, 99.2045, 98.970125, 98.267, 97.7045, 98.17325,
            100.657625, 102.345125, 101.8295, 100.42325, 99.9545, 98.54825, 103.142, 96.767, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:03.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.98055,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:03.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.67325, 130.095125, 128.220125, 126.29825, 123.5795, 121.188875, 117.48575, 113.54825, 110.642,
            106.98575, 104.595125, 102.392, 100.282625, 101.36075, 100.376375, 100.938875, 98.970125, 98.407625,
            98.688875, 100.3295, 102.767, 101.688875, 100.376375, 99.67325, 98.407625, 103.42325, 96.438875, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:46.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.30644,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:46.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.7045, 127.04825, 123.626375, 120.9545, 118.517, 115.517, 114.017, 112.095125, 106.3295, 104.688875,
            104.92325, 102.392, 101.54825, 101.54825, 102.907625, 104.4545, 103.657625, 103.42325, 101.8295, 101.970125,
            103.7045, 102.67325, 100.61075, 99.720125, 98.876375, 102.251375, 96.907625, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:48.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.68832,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:48.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.688875, 126.2045, 122.970125, 120.9545, 116.688875, 112.04825, 112.001375, 110.54825, 105.2045, 103.517,
            104.782625, 101.54825, 100.517, 101.8295, 100.517, 102.67325, 103.142, 102.9545, 102.48575, 101.54825,
            103.7045, 102.767, 100.42325, 99.86075, 98.73575, 102.86075, 97.04825, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:42.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.3423,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:42.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.98575, 120.626375, 114.67325, 110.876375, 110.267, 109.563875, 107.0795, 110.4545, 104.73575,
            104.313875, 103.3295, 103.751375, 101.36075, 102.345125, 102.626375, 104.8295, 105.67325, 104.032625,
            102.2045, 102.251375, 103.42325, 102.813875, 100.938875, 100.42325, 98.595125, 102.767, 96.86075, 95.267,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:28.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.53209,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:28.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.251375, 103.142, 102.720125, 104.36075, 105.11075, 106.892, 104.0795, 104.92325, 104.4545, 102.017,
            99.9545, 101.313875, 99.813875, 100.751375, 101.0795, 103.001375, 103.001375, 101.782625, 103.142,
            101.92325, 104.17325, 102.767, 101.17325, 100.142, 98.642, 102.767, 96.392, 95.17325,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:13.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.42708,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:13.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.063875, 107.876375, 106.001375, 108.532625, 107.876375, 109.04825, 109.470125, 109.001375, 106.142,
            105.29825, 103.751375, 101.267, 101.313875, 102.345125, 103.470125, 103.001375, 104.267, 103.470125,
            103.3295, 101.501375, 103.23575, 102.720125, 101.0795, 100.095125, 98.876375, 102.626375, 96.48575,
            95.36075,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:13.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.6171,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:13.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.345125, 124.376375, 121.04825, 118.3295, 115.142, 113.782625, 114.017, 111.532625, 106.282625,
            104.73575, 103.188875, 100.001375, 99.86075, 99.48575, 101.220125, 99.86075, 98.17325, 97.751375, 98.36075,
            100.376375, 102.67325, 101.688875, 100.188875, 99.48575, 98.220125, 102.157625, 96.11075, 95.313875,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:00.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.44219,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:00.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.8295, 112.42325, 109.42325, 107.17325, 107.8295, 110.267, 106.42325, 107.17325, 105.532625, 104.4545,
            102.063875, 100.892, 100.42325, 102.392, 102.2045, 103.751375, 102.813875, 104.17325, 101.4545, 101.73575,
            103.517, 103.001375, 100.657625, 100.095125, 98.73575, 102.907625, 96.86075, 95.407625,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:07.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.87473,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:07.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.688875, 129.157625, 126.392, 124.751375, 122.642, 118.892, 115.376375, 113.501375, 109.188875,
            107.54825, 105.438875, 104.501375, 101.782625, 103.7045, 104.595125, 104.4545, 105.626375, 105.157625,
            101.642, 101.642, 103.61075, 103.23575, 100.892, 99.9545, 98.642, 102.392, 96.86075, 95.220125,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:53.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.10648,
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:04:53.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.001375, 127.7045, 124.7045, 121.938875, 119.126375, 116.688875, 112.98575, 111.063875, 108.11075,
            105.345125, 104.313875, 102.9545, 102.251375, 103.23575, 103.23575, 104.501375, 103.98575, 102.813875,
            101.876375, 102.9545, 104.407625, 103.517, 101.0795, 100.3295, 99.5795, 103.095125, 98.688875, 95.4545,
        ],
        latitude: 37.4405802,
        longitude: -122.5334173,
    },
    {
        timestamp: '2025-08-29T23:05:15.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.5372,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:15.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.313875, 124.188875, 118.470125, 114.11075, 112.517, 111.063875, 108.48575, 108.626375, 106.376375,
            105.48575, 105.11075, 101.73575, 100.142, 102.67325, 102.626375, 102.345125, 103.001375, 102.29825,
            103.7045, 102.063875, 102.48575, 102.392, 100.751375, 99.86075, 98.782625, 104.220125, 98.267, 96.720125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:31.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.08765,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:31.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.657625, 130.001375, 126.157625, 122.032625, 119.501375, 117.251375, 115.98575, 111.2045, 108.48575,
            106.04825, 103.095125, 101.876375, 101.970125, 102.48575, 103.04825, 103.938875, 104.4545, 101.267,
            100.98575, 101.642, 102.626375, 102.157625, 100.7045, 99.767, 98.501375, 102.67325, 96.626375, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:30.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.28767,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:30.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.7045, 130.563875, 126.392, 122.595125, 121.657625, 119.126375, 113.407625, 111.251375, 107.54825,
            106.517, 102.29825, 102.86075, 101.126375, 101.73575, 103.517, 104.782625, 105.2045, 101.8295, 101.54825,
            101.54825, 103.42325, 102.86075, 100.938875, 100.095125, 99.11075, 103.563875, 96.767, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:04.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.237625,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:04.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.720125, 114.017, 110.8295, 106.845125, 106.282625, 106.517, 105.626375, 106.04825, 104.73575,
            102.907625, 101.407625, 104.595125, 100.3295, 101.642, 102.907625, 103.188875, 104.220125, 103.095125,
            102.813875, 103.142, 103.42325, 102.438875, 100.751375, 100.04825, 98.73575, 103.04825, 96.532625, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:25.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.6652,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:25.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.126375, 121.3295, 116.126375, 113.92325, 113.313875, 110.73575, 107.876375, 107.876375, 104.970125,
            104.501375, 102.017, 101.688875, 99.67325, 101.267, 101.970125, 103.095125, 102.813875, 101.501375,
            100.563875, 100.470125, 102.5795, 102.5795, 100.61075, 99.48575, 98.407625, 102.017, 96.29825, 95.126375,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:21.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.10953,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:21.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.517, 122.501375, 120.2045, 116.782625, 115.563875, 115.04825, 110.595125, 110.73575, 108.767, 104.73575,
            106.657625, 100.845125, 99.767, 102.29825, 101.970125, 102.438875, 101.4545, 102.767, 103.04825, 103.095125,
            103.188875, 102.67325, 100.42325, 100.001375, 98.970125, 102.907625, 97.23575, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:11.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.41131,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:11.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 112.61075, 106.657625, 110.126375, 107.8295, 108.48575, 107.8295, 108.67325, 109.845125,
            104.032625, 103.892, 104.032625, 102.11075, 103.657625, 103.001375, 103.282625, 103.563875, 103.095125,
            102.063875, 101.782625, 103.282625, 103.23575, 100.845125, 100.23575, 99.017, 103.04825, 97.142, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:10.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.86067,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:10.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            106.845125, 100.892, 102.5795, 105.2045, 105.907625, 107.876375, 106.61075, 108.813875, 107.126375,
            106.657625, 105.48575, 105.5795, 103.001375, 103.517, 103.04825, 103.98575, 104.642, 102.907625, 101.313875,
            102.11075, 103.188875, 103.04825, 100.79825, 99.907625, 98.73575, 103.188875, 96.86075, 95.595125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:17.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.3848,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:17.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.892, 116.17325, 114.345125, 114.720125, 113.595125, 112.470125, 108.251375, 108.907625, 106.42325,
            104.642, 104.220125, 104.4545, 101.688875, 102.767, 102.720125, 102.251375, 102.345125, 101.970125,
            102.86075, 103.517, 104.267, 102.720125, 100.79825, 100.142, 99.063875, 103.142, 97.23575, 95.501375,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:06.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.19688,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:06.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.907625, 118.42325, 119.126375, 115.892, 112.657625, 110.032625, 110.220125, 110.782625, 107.595125,
            103.7045, 102.907625, 103.938875, 104.73575, 102.767, 102.438875, 103.938875, 102.907625, 102.438875,
            101.595125, 101.970125, 102.813875, 102.720125, 100.563875, 99.767, 98.501375, 102.11075, 96.626375,
            95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:27.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.18613,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:27.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.92325, 130.3295, 127.517, 123.720125, 120.67325, 117.063875, 113.220125, 113.4545, 106.751375,
            107.92325, 104.73575, 101.220125, 100.892, 101.313875, 101.126375, 101.642, 101.267, 100.845125, 99.720125,
            101.313875, 103.04825, 102.813875, 100.79825, 99.9545, 98.642, 102.345125, 96.767, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:45.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.38995,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:45.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.392, 123.767, 121.142, 115.751375, 115.470125, 111.11075, 110.126375, 108.438875, 106.7045, 103.517,
            104.126375, 102.626375, 101.642, 102.767, 102.9545, 103.23575, 103.61075, 102.5795, 101.688875, 102.5795,
            103.892, 103.142, 101.407625, 100.188875, 99.157625, 102.345125, 98.0795, 95.688875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:40.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.630554,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:40.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 116.782625, 116.0795, 114.251375, 111.2045, 107.501375, 107.54825, 105.720125, 103.938875,
            102.907625, 101.54825, 101.032625, 99.67325, 101.220125, 102.907625, 103.938875, 103.142, 102.5795, 101.642,
            101.642, 103.657625, 103.142, 100.563875, 100.188875, 98.595125, 102.907625, 96.2045, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:57.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.95555,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:57.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.876375, 102.720125, 105.345125, 110.4545, 110.313875, 108.907625, 109.04825, 110.267, 107.407625,
            105.11075, 103.751375, 102.2045, 102.392, 102.86075, 104.501375, 104.313875, 105.251375, 103.517, 101.36075,
            102.251375, 103.001375, 101.970125, 100.188875, 99.626375, 98.407625, 102.2045, 96.29825, 95.220125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:24.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.00807,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:24.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.642, 119.92325, 117.157625, 114.063875, 113.876375, 112.7045, 107.54825, 106.98575, 106.3295, 104.267,
            102.063875, 101.220125, 100.23575, 102.720125, 105.532625, 105.251375, 104.032625, 101.8295, 101.407625,
            101.4545, 103.095125, 103.095125, 101.032625, 99.907625, 98.642, 102.251375, 96.11075, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:39.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.824066,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:39.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.501375, 110.688875, 108.29825, 107.782625, 106.001375, 105.345125, 107.032625, 105.2045, 104.73575,
            103.98575, 102.626375, 103.142, 101.220125, 102.907625, 103.517, 104.876375, 104.501375, 102.767, 102.48575,
            101.595125, 103.845125, 103.61075, 100.657625, 100.188875, 98.642, 102.11075, 96.438875, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:26.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.71916,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:26.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.9545, 126.720125, 123.157625, 121.470125, 118.517, 114.29825, 112.657625, 111.907625, 107.970125,
            105.2045, 107.970125, 106.563875, 100.938875, 101.4545, 101.876375, 101.782625, 101.8295, 100.3295,
            100.42325, 101.220125, 103.188875, 102.48575, 100.845125, 99.86075, 98.8295, 103.001375, 97.142, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:20.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.81491,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:20.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.188875, 107.032625, 107.642, 108.251375, 108.345125, 110.17325, 107.688875, 107.267, 104.970125,
            103.7045, 102.67325, 102.157625, 101.17325, 103.470125, 102.29825, 103.04825, 104.688875, 103.517,
            101.595125, 101.595125, 102.813875, 102.532625, 100.470125, 99.813875, 98.4545, 102.29825, 96.67325,
            95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:16.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.915,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:16.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.688875, 123.5795, 120.345125, 117.438875, 115.095125, 112.23575, 110.92325, 109.42325, 105.67325,
            105.626375, 104.17325, 101.407625, 100.470125, 102.392, 102.063875, 102.86075, 102.392, 101.782625, 103.142,
            102.2045, 102.67325, 102.063875, 100.42325, 99.438875, 98.0795, 102.063875, 96.67325, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:46.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.643,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:46.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.54825, 132.48575, 128.126375, 126.017, 121.7045, 121.142, 118.79825, 114.907625, 111.392, 107.970125,
            104.595125, 103.188875, 101.17325, 101.54825, 102.2045, 102.017, 102.017, 101.36075, 102.9545, 101.8295,
            102.67325, 102.626375, 100.470125, 99.29825, 98.126375, 101.8295, 96.532625, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:19.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.16973,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:19.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.157625, 109.470125, 107.595125, 107.782625, 107.501375, 108.9545, 106.563875, 107.126375, 105.345125,
            104.54825, 103.3295, 100.845125, 100.938875, 103.188875, 103.517, 102.767, 104.54825, 103.095125, 100.517,
            102.2045, 103.42325, 102.48575, 100.751375, 99.907625, 98.501375, 102.48575, 96.157625, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:49.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.84746,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:49.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.7045, 111.767, 107.970125, 106.517, 104.36075, 106.142, 106.142, 105.720125, 104.126375, 102.48575,
            103.04825, 103.095125, 100.98575, 101.126375, 101.032625, 102.438875, 104.501375, 102.67325, 108.29825,
            101.876375, 105.29825, 103.892, 100.938875, 100.001375, 98.876375, 102.392, 96.67325, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:47.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.8901,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:47.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.407625, 126.438875, 124.751375, 121.751375, 118.23575, 115.3295, 112.657625, 112.142, 109.470125,
            105.11075, 104.501375, 102.907625, 101.220125, 101.782625, 102.67325, 101.8295, 103.04825, 101.501375,
            104.73575, 101.4545, 105.48575, 103.892, 100.61075, 99.392, 98.313875, 102.11075, 96.86075, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:22.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.18225,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:22.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.563875, 129.157625, 126.720125, 124.657625, 121.470125, 118.7045, 114.720125, 112.095125, 108.626375,
            105.345125, 103.845125, 101.54825, 100.001375, 99.813875, 99.767, 100.376375, 100.470125, 100.938875,
            101.688875, 101.73575, 103.42325, 102.438875, 100.563875, 100.095125, 98.970125, 103.001375, 96.813875,
            95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:02.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.3619,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:02.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.142, 123.907625, 123.345125, 119.032625, 113.876375, 114.813875, 112.517, 111.48575, 107.220125,
            104.313875, 102.532625, 100.938875, 113.642, 103.23575, 102.532625, 103.3295, 103.376375, 102.907625,
            106.470125, 103.79825, 103.892, 102.5795, 100.938875, 99.767, 98.54825, 102.11075, 96.86075, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:07.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.82032,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:07.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.313875, 120.29825, 118.188875, 114.29825, 109.751375, 106.845125, 107.407625, 108.017, 103.892,
            103.7045, 105.157625, 106.095125, 107.126375, 103.517, 103.001375, 103.79825, 103.188875, 101.8295,
            101.0795, 101.73575, 102.907625, 102.9545, 100.517, 99.48575, 98.54825, 102.11075, 96.67325, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:24.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.20657,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:24.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.86075, 122.313875, 116.92325, 115.04825, 113.313875, 112.563875, 109.3295, 112.282625, 110.032625,
            102.9545, 103.938875, 100.188875, 99.813875, 100.517, 100.563875, 102.29825, 101.126375, 100.3295,
            101.36075, 101.4545, 103.04825, 102.767, 100.657625, 99.813875, 98.782625, 102.86075, 97.376375, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:26.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.48551,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:26.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.3295, 116.17325, 114.29825, 112.142, 109.3295, 108.626375, 109.04825, 108.157625, 105.2045, 104.0795,
            100.61075, 102.392, 100.376375, 101.267, 102.345125, 102.5795, 102.907625, 102.063875, 101.17325,
            101.032625, 103.001375, 102.9545, 100.376375, 99.813875, 98.313875, 102.017, 96.48575, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:00.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.18962,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:00.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.845125, 121.98575, 120.813875, 118.23575, 114.86075, 111.438875, 108.767, 107.220125, 103.282625,
            103.61075, 102.626375, 101.267, 102.67325, 103.282625, 103.79825, 102.438875, 104.17325, 104.407625,
            103.142, 102.11075, 102.345125, 102.251375, 100.470125, 99.345125, 98.0795, 102.157625, 96.532625,
            95.220125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:18.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.42701,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:18.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.11075, 110.970125, 106.657625, 106.095125, 108.11075, 109.23575, 108.813875, 108.063875, 105.11075,
            104.642, 103.517, 103.845125, 101.970125, 103.845125, 103.42325, 103.376375, 104.0795, 103.79825,
            101.782625, 102.017, 103.42325, 102.9545, 101.267, 100.04825, 98.876375, 103.04825, 97.001375, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:54.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.7703,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:54.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.845125, 127.61075, 126.251375, 122.54825, 118.470125, 114.86075, 112.188875, 109.3295, 107.17325,
            105.29825, 104.220125, 102.907625, 101.407625, 103.282625, 101.54825, 103.563875, 106.42325, 103.98575,
            105.813875, 103.563875, 107.970125, 103.282625, 100.938875, 100.04825, 98.73575, 102.767, 97.04825, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:33.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.67798,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:33.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.04825, 127.845125, 126.11075, 124.04825, 123.438875, 118.79825, 115.751375, 114.532625, 110.267,
            108.157625, 102.86075, 102.48575, 100.7045, 103.61075, 102.345125, 104.0795, 104.688875, 102.438875,
            100.98575, 102.017, 102.907625, 102.720125, 100.42325, 99.48575, 98.501375, 102.2045, 97.001375, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:14.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.35344,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:14.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.001375, 122.126375, 118.7045, 114.813875, 114.5795, 111.48575, 108.251375, 108.767, 106.376375,
            104.501375, 103.42325, 101.4545, 100.7045, 101.407625, 102.86075, 102.532625, 103.61075, 103.095125,
            103.892, 102.251375, 103.3295, 102.5795, 101.267, 100.3295, 99.11075, 103.23575, 97.04825, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:28.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.37084,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:28.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.67325, 111.063875, 107.032625, 106.79825, 108.86075, 109.095125, 107.4545, 106.376375, 105.11075,
            104.126375, 103.845125, 100.470125, 104.595125, 100.04825, 100.04825, 102.67325, 100.751375, 100.61075,
            100.001375, 100.7045, 102.86075, 102.9545, 100.42325, 99.86075, 98.970125, 103.001375, 97.188875, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:18.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.5527,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:18.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.438875, 121.23575, 116.876375, 112.7045, 110.220125, 108.907625, 107.876375, 105.720125, 104.407625,
            111.9545, 105.11075, 99.86075, 102.532625, 101.595125, 102.48575, 101.407625, 104.126375, 101.970125,
            101.36075, 103.892, 104.73575, 102.907625, 100.657625, 100.001375, 99.11075, 102.907625, 97.04825, 95.17325,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:35.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.72438,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:35.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.54825, 130.095125, 125.73575, 122.501375, 119.032625, 116.032625, 113.54825, 111.532625, 108.532625,
            105.392, 102.2045, 102.532625, 100.376375, 102.907625, 102.767, 103.517, 104.17325, 101.595125, 101.54825,
            101.36075, 102.5795, 103.142, 100.23575, 99.438875, 98.407625, 101.92325, 96.813875, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:53.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.21011,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:53.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 114.11075, 109.470125, 105.251375, 105.532625, 106.3295, 105.86075, 107.501375, 105.767,
            103.98575, 103.751375, 101.876375, 102.720125, 101.970125, 101.267, 102.813875, 106.751375, 104.8295,
            103.142, 101.876375, 102.86075, 102.532625, 100.892, 99.86075, 98.220125, 102.251375, 96.67325, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:08.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.3489,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:08.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.7045, 126.11075, 124.188875, 120.532625, 117.9545, 113.8295, 110.267, 110.17325, 106.517, 115.04825,
            112.845125, 104.595125, 104.782625, 104.4545, 107.73575, 105.48575, 106.892, 103.095125, 102.157625,
            102.626375, 103.61075, 102.813875, 101.032625, 100.3295, 99.251375, 103.376375, 96.532625, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:13.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.9588,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:13.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.42325, 119.032625, 111.29825, 110.220125, 110.032625, 111.767, 108.251375, 109.142, 106.3295,
            123.626375, 104.688875, 105.063875, 111.157625, 104.73575, 104.8295, 108.813875, 105.392, 106.188875,
            107.17325, 104.220125, 104.0795, 102.86075, 101.220125, 100.376375, 99.11075, 103.7045, 97.282625, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:37.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.79737,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:37.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.8295, 113.407625, 110.54825, 112.142, 112.79825, 110.36075, 111.2045, 111.2045, 108.2045, 104.876375,
            102.813875, 102.438875, 100.42325, 102.9545, 102.532625, 103.845125, 104.407625, 101.782625, 101.313875,
            101.501375, 103.517, 103.657625, 100.657625, 99.67325, 98.782625, 102.438875, 96.5795, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:52.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.35852,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:52.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.7045, 128.73575, 127.892, 125.54825, 120.532625, 117.251375, 115.376375, 111.157625, 108.2045,
            105.063875, 103.845125, 102.813875, 103.23575, 102.9545, 101.126375, 103.04825, 106.79825, 103.376375,
            103.04825, 102.720125, 102.9545, 102.532625, 100.470125, 99.907625, 98.688875, 102.626375, 96.767,
            95.220125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:21.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.2982,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:21.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.11075, 125.032625, 119.032625, 113.970125, 112.98575, 111.438875, 108.532625, 109.23575, 106.282625,
            105.532625, 102.251375, 101.876375, 101.126375, 103.376375, 103.376375, 105.157625, 104.126375, 104.267,
            102.2045, 101.4545, 103.563875, 102.907625, 100.98575, 100.142, 99.017, 102.720125, 97.04825, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:29.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.40444,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:29.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.017, 114.9545, 113.8295, 111.345125, 109.23575, 107.73575, 104.688875, 105.813875, 104.313875,
            103.095125, 101.407625, 103.04825, 102.11075, 102.063875, 103.892, 103.892, 104.36075, 102.157625, 102.017,
            102.017, 103.61075, 103.001375, 100.61075, 100.04825, 98.595125, 102.29825, 96.438875, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:23.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.67873,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:23.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.595125, 121.142, 119.876375, 116.642, 114.9545, 112.142, 109.23575, 108.251375, 106.61075, 103.657625,
            102.907625, 102.063875, 101.54825, 103.7045, 105.532625, 105.29825, 104.876375, 103.376375, 101.782625,
            101.782625, 103.23575, 102.626375, 100.938875, 99.767, 98.501375, 102.438875, 96.67325, 95.220125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:12.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.345116,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:12.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.657625, 112.42325, 108.48575, 105.907625, 106.282625, 111.157625, 106.188875, 107.595125, 105.720125,
            105.017, 104.782625, 106.470125, 103.98575, 105.2045, 103.3295, 103.61075, 103.657625, 103.282625,
            103.001375, 102.392, 103.001375, 103.04825, 100.7045, 100.001375, 99.11075, 102.720125, 97.23575, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:34.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.12244,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:34.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.142, 134.642, 128.92325, 122.688875, 120.063875, 118.188875, 115.892, 112.188875, 110.220125, 107.36075,
            104.4545, 103.376375, 101.782625, 103.42325, 103.892, 103.751375, 104.8295, 101.688875, 101.126375,
            101.313875, 102.626375, 103.23575, 100.845125, 99.9545, 99.017, 103.04825, 97.095125, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:09.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.07928,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:09.445Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.3295, 109.7045, 107.782625, 106.938875, 106.751375, 106.376375, 105.392, 107.970125, 105.063875,
            123.017, 125.0795, 105.813875, 107.032625, 105.532625, 105.626375, 105.907625, 106.98575, 104.4545,
            104.782625, 103.142, 104.313875, 103.142, 101.220125, 100.517, 99.017, 103.188875, 97.04825, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:38.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.70305,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:38.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.42325, 128.501375, 125.220125, 123.2045, 121.04825, 118.376375, 114.251375, 110.267, 106.751375,
            103.79825, 102.157625, 101.73575, 100.892, 103.04825, 103.001375, 104.876375, 104.220125, 102.767, 101.0795,
            101.8295, 102.9545, 102.9545, 100.42325, 99.438875, 98.407625, 102.345125, 97.095125, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:19.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.6563,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:19.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.751375, 135.2045, 133.42325, 131.17325, 130.001375, 128.782625, 122.17325, 121.04825, 117.345125,
            112.79825, 110.782625, 105.720125, 103.79825, 102.438875, 103.23575, 103.142, 105.392, 104.688875,
            102.907625, 102.532625, 104.36075, 103.282625, 100.938875, 100.142, 99.11075, 102.9545, 97.376375,
            95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:58.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.90756,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:58.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.095125, 104.970125, 102.720125, 104.688875, 105.392, 106.188875, 105.063875, 106.282625, 105.11075,
            104.73575, 104.501375, 103.282625, 101.92325, 103.657625, 104.0795, 104.267, 105.5795, 104.220125, 101.642,
            101.54825, 102.813875, 102.5795, 100.751375, 100.04825, 98.642, 102.251375, 96.48575, 95.17325,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:36.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.20703,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:36.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.5795, 126.345125, 122.36075, 117.767, 118.517, 115.98575, 109.517, 107.688875, 105.345125, 104.688875,
            101.642, 102.48575, 100.04825, 103.23575, 102.9545, 104.782625, 105.063875, 101.642, 101.267, 101.970125,
            103.188875, 103.23575, 100.470125, 99.86075, 98.688875, 102.29825, 96.532625, 95.220125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:41.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.02278,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:41.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.8295, 107.688875, 107.032625, 109.892, 111.017, 109.376375, 109.3295, 110.782625, 107.970125,
            105.063875, 103.188875, 102.813875, 100.095125, 101.407625, 102.063875, 103.657625, 104.54825, 102.2045,
            101.220125, 101.782625, 104.126375, 106.376375, 101.032625, 100.282625, 98.8295, 102.767, 96.720125,
            95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:43.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.95331,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:43.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.4545, 121.845125, 117.438875, 113.970125, 108.251375, 108.157625, 105.86075, 105.67325, 105.392,
            104.267, 103.470125, 102.720125, 101.4545, 103.470125, 102.532625, 103.142, 103.282625, 102.392, 102.063875,
            102.532625, 103.470125, 102.532625, 100.7045, 100.04825, 98.501375, 102.9545, 96.438875, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:05.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.97046,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:05.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.267, 134.4545, 130.61075, 127.751375, 124.7045, 120.813875, 117.813875, 114.720125, 112.892, 109.7045,
            107.782625, 105.907625, 102.5795, 102.720125, 102.720125, 104.501375, 104.642, 103.095125, 102.29825,
            102.251375, 103.470125, 102.5795, 100.79825, 100.095125, 99.11075, 103.188875, 97.282625, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:16.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.5535,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:16.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.001375, 121.845125, 120.29825, 116.220125, 113.970125, 111.813875, 109.657625, 109.61075, 107.032625,
            104.54825, 104.0795, 103.42325, 101.876375, 103.751375, 103.7045, 103.001375, 103.42325, 101.73575,
            103.470125, 104.0795, 104.688875, 103.282625, 100.845125, 100.142, 99.251375, 103.001375, 97.892, 95.4545,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:14.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.45108,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:14.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.48575, 127.751375, 120.767, 117.720125, 114.392, 112.23575, 109.98575, 110.54825, 106.563875, 107.54825,
            104.4545, 104.267, 102.86075, 102.9545, 102.626375, 103.61075, 102.9545, 101.782625, 102.907625, 103.001375,
            103.001375, 102.438875, 100.42325, 99.626375, 98.73575, 102.813875, 97.095125, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:56.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.18936,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:56.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.86075, 117.48575, 117.11075, 114.626375, 111.345125, 107.970125, 106.470125, 107.642, 106.23575,
            104.17325, 103.095125, 102.720125, 102.720125, 103.001375, 104.73575, 104.407625, 106.79825, 104.970125,
            102.48575, 102.813875, 103.282625, 102.907625, 101.220125, 100.04825, 98.782625, 102.767, 96.392, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:51.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.006065,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:51.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 118.98575, 116.970125, 114.2045, 111.29825, 109.282625, 108.67325, 108.345125, 107.220125,
            104.0795, 102.626375, 102.767, 102.9545, 102.720125, 101.595125, 103.001375, 106.42325, 102.48575,
            102.251375, 102.907625, 103.657625, 103.188875, 101.126375, 100.42325, 99.251375, 103.657625, 97.188875,
            95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:15.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.86172,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:15.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.126375, 124.61075, 121.23575, 119.8295, 113.970125, 114.5795, 110.407625, 111.251375, 106.938875,
            104.595125, 105.2045, 106.7045, 102.67325, 103.517, 102.017, 103.23575, 102.5795, 101.73575, 102.767,
            103.23575, 103.188875, 102.86075, 100.7045, 99.626375, 98.73575, 102.5795, 97.42325, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:27.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.67895,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:27.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.907625, 109.42325, 106.98575, 109.04825, 109.563875, 110.17325, 108.157625, 108.67325, 105.063875,
            103.188875, 101.642, 101.688875, 101.642, 102.2045, 102.813875, 103.61075, 102.767, 101.8295, 101.313875,
            101.032625, 103.04825, 102.720125, 100.845125, 100.04825, 98.4545, 102.2045, 96.157625, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:20.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.09195,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:20.242Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 126.907625, 124.282625, 121.517, 120.48575, 118.79825, 116.032625, 110.032625, 122.313875,
            116.970125, 103.188875, 107.642, 100.04825, 105.720125, 103.892, 104.782625, 104.688875, 105.532625,
            105.532625, 103.61075, 103.7045, 103.142, 100.751375, 100.23575, 98.970125, 102.720125, 96.9545, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:25.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.52347,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:25.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.61075, 130.376375, 128.642, 125.4545, 122.407625, 118.095125, 116.313875, 114.532625, 111.345125,
            108.48575, 110.688875, 102.86075, 99.720125, 101.595125, 100.188875, 101.688875, 101.17325, 100.3295,
            99.9545, 101.17325, 102.626375, 102.345125, 100.42325, 99.720125, 98.595125, 102.157625, 96.86075,
            95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:23.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.92374,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:23.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.532625, 121.517, 121.23575, 118.23575, 115.001375, 111.67325, 109.98575, 117.251375, 117.017,
            104.501375, 104.54825, 100.61075, 100.61075, 102.017, 103.376375, 103.282625, 102.2045, 102.345125,
            102.48575, 102.532625, 103.79825, 103.563875, 100.845125, 100.04825, 99.2045, 103.04825, 97.657625,
            95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:50.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.4781,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:50.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.61075, 108.9545, 105.86075, 105.626375, 105.86075, 106.938875, 106.845125, 105.5795, 105.2045, 104.267,
            103.188875, 102.438875, 101.92325, 101.220125, 101.267, 102.67325, 105.67325, 102.392, 102.9545, 101.970125,
            109.938875, 103.282625, 100.657625, 100.001375, 99.11075, 102.907625, 96.9545, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:39.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.807,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:39.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.5795, 131.0795, 128.688875, 123.626375, 117.813875, 115.845125, 113.688875, 109.7045, 107.313875,
            104.876375, 102.392, 102.063875, 100.751375, 103.376375, 103.3295, 105.063875, 104.220125, 103.142, 102.017,
            102.2045, 103.188875, 102.5795, 100.7045, 100.04825, 99.11075, 102.48575, 96.813875, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:55.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.46237,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:55.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.845125, 127.517, 124.23575, 120.063875, 117.9545, 115.42325, 112.3295, 109.7045, 105.86075, 103.376375,
            103.3295, 102.67325, 101.970125, 102.86075, 103.282625, 103.563875, 106.7045, 104.876375, 102.251375,
            102.532625, 103.188875, 102.67325, 101.0795, 99.907625, 98.36075, 102.5795, 96.813875, 95.220125,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:48.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.0655,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:48.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 125.313875, 123.2045, 121.7045, 118.517, 117.626375, 113.54825, 111.67325, 106.98575, 105.2045,
            103.892, 102.5795, 100.142, 101.876375, 102.720125, 102.532625, 104.267, 101.267, 102.063875, 101.501375,
            103.938875, 103.376375, 100.470125, 99.626375, 98.407625, 102.251375, 96.907625, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:17.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.59564,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:17.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.782625, 121.98575, 119.17325, 116.220125, 114.720125, 113.220125, 109.7045, 109.657625, 106.470125,
            105.392, 104.313875, 103.470125, 101.032625, 103.04825, 104.220125, 104.220125, 104.73575, 102.438875,
            102.532625, 102.720125, 103.42325, 102.86075, 101.126375, 99.907625, 98.876375, 102.767, 97.142, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:59.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.15349,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:59.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.720125, 128.688875, 125.126375, 122.36075, 119.876375, 116.876375, 113.407625, 110.220125, 105.86075,
            104.407625, 103.563875, 102.345125, 102.813875, 103.892, 104.17325, 102.86075, 106.04825, 104.4545,
            105.532625, 102.9545, 104.126375, 106.095125, 101.032625, 99.720125, 98.36075, 102.626375, 96.345125,
            95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:03.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.436295,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:03.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.36075, 119.4545, 115.61075, 111.5795, 109.188875, 109.61075, 106.892, 108.063875, 103.42325, 101.970125,
            101.782625, 103.04825, 107.970125, 102.813875, 103.188875, 106.23575, 105.29825, 103.3295, 106.095125,
            103.563875, 103.845125, 102.720125, 100.3295, 99.813875, 98.032625, 101.595125, 96.251375, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:22.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.602875,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:22.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.501375, 120.063875, 115.517, 110.54825, 111.063875, 109.517, 108.11075, 108.29825, 105.2045, 103.938875,
            102.48575, 101.0795, 100.61075, 102.9545, 104.407625, 104.970125, 104.92325, 105.345125, 102.813875,
            102.251375, 103.563875, 102.48575, 100.79825, 99.907625, 98.73575, 102.345125, 96.67325, 95.407625,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:32.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.3768,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:32.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.2045, 135.67325, 132.9545, 131.642, 129.11075, 125.126375, 121.470125, 117.907625, 116.032625, 112.517,
            109.142, 106.79825, 102.48575, 103.3295, 103.61075, 104.126375, 104.4545, 100.98575, 101.407625, 101.688875,
            103.376375, 102.438875, 100.7045, 99.67325, 98.54825, 102.11075, 97.142, 95.36075,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:42.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.82804,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:42.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.563875, 112.188875, 110.595125, 112.657625, 110.54825, 108.86075, 110.17325, 109.98575, 106.470125,
            104.17325, 103.282625, 101.876375, 100.142, 103.095125, 102.017, 103.751375, 104.0795, 101.782625,
            100.845125, 102.063875, 103.23575, 102.67325, 100.79825, 99.86075, 98.54825, 102.5795, 96.29825, 95.267,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:28.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.536064,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:28.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 118.61075, 113.782625, 112.282625, 112.04825, 112.23575, 111.345125, 109.845125, 107.220125,
            104.642, 101.220125, 101.595125, 100.657625, 101.642, 102.11075, 103.751375, 102.532625, 101.17325,
            100.938875, 101.36075, 102.767, 102.345125, 100.61075, 100.142, 98.595125, 102.5795, 96.2045, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:44.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.302986,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:05:44.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.29825, 116.782625, 115.42325, 111.438875, 108.017, 108.720125, 106.517, 105.11075, 104.17325, 103.23575,
            104.313875, 102.626375, 101.595125, 102.29825, 102.813875, 103.188875, 103.42325, 105.392, 109.563875,
            102.67325, 105.251375, 103.3295, 101.313875, 100.095125, 99.2045, 102.438875, 96.9545, 95.501375,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:01.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.995,
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:06:01.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.563875, 127.470125, 121.657625, 117.86075, 116.73575, 112.517, 111.017, 109.3295, 106.79825, 103.61075,
            103.188875, 101.267, 101.032625, 102.438875, 102.392, 102.5795, 103.563875, 102.48575, 103.751375,
            102.626375, 102.86075, 102.626375, 100.892, 100.04825, 98.313875, 102.251375, 96.392, 95.313875,
        ],
        latitude: 37.440583,
        longitude: -122.5334143,
    },
    {
        timestamp: '2025-08-29T23:07:10.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.89781,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:10.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.313875, 134.688875, 130.751375, 123.626375, 121.142, 119.267, 117.48575, 115.657625, 111.063875,
            108.2045, 104.54825, 101.17325, 98.92325, 111.5795, 100.04825, 103.42325, 103.04825, 100.095125, 103.142,
            104.267, 103.657625, 103.376375, 101.267, 100.42325, 99.2045, 103.095125, 97.845125, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:15.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.05574,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:15.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.517, 133.751375, 128.8295, 124.001375, 122.17325, 120.29825, 118.188875, 113.313875, 113.642, 111.9545,
            104.642, 101.595125, 98.4545, 100.845125, 99.813875, 99.813875, 97.79825, 98.36075, 97.938875, 100.23575,
            101.970125, 101.267, 100.282625, 99.29825, 98.4545, 101.92325, 96.532625, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:33.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.03584,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:33.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.595125, 127.61075, 126.9545, 124.001375, 123.813875, 118.517, 115.7045, 111.767, 109.845125, 105.907625,
            103.892, 102.063875, 109.142, 98.92325, 97.61075, 107.407625, 98.501375, 102.438875, 109.142, 100.657625,
            103.517, 104.267, 103.938875, 100.470125, 99.532625, 102.767, 96.813875, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:33.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.60786,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:33.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.345125, 130.79825, 127.845125, 124.3295, 119.876375, 118.892, 114.157625, 112.470125, 111.157625,
            107.0795, 105.017, 102.9545, 100.001375, 99.532625, 98.688875, 99.017, 99.438875, 98.501375, 99.251375,
            101.970125, 103.563875, 103.3295, 100.470125, 99.9545, 99.438875, 103.001375, 96.9545, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:29.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.33684,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:29.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.11075, 119.126375, 116.8295, 115.3295, 110.92325, 109.938875, 107.032625, 106.376375, 106.938875,
            115.470125, 118.98575, 118.845125, 106.095125, 106.001375, 112.657625, 109.517, 106.845125, 106.845125,
            102.86075, 102.251375, 103.188875, 102.907625, 100.657625, 99.67325, 98.595125, 102.813875, 96.67325,
            95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:17.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.04405,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:17.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.376375, 126.438875, 123.907625, 119.501375, 119.032625, 115.517, 113.688875, 112.751375, 107.688875,
            105.9545, 103.188875, 100.657625, 98.54825, 99.907625, 114.438875, 107.876375, 100.42325, 106.470125,
            112.79825, 101.688875, 103.04825, 104.126375, 101.032625, 100.142, 98.876375, 103.04825, 96.86075,
            95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:38.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.91383,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:38.765Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.751375, 121.376375, 119.36075, 118.61075, 113.642, 110.032625, 109.3295, 106.938875, 104.501375,
            104.220125, 102.29825, 101.126375, 99.767, 112.79825, 97.470125, 98.126375, 97.892, 97.42325, 98.313875,
            100.79825, 102.2045, 102.2045, 100.3295, 99.813875, 98.313875, 103.095125, 96.48575, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:08.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.75102,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:08.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.86075, 130.563875, 127.845125, 121.938875, 118.376375, 116.970125, 115.470125, 111.9545, 107.688875,
            105.532625, 103.095125, 101.8295, 98.876375, 99.438875, 98.970125, 100.188875, 99.157625, 98.36075,
            99.157625, 101.407625, 102.48575, 102.251375, 100.79825, 99.720125, 98.73575, 102.626375, 97.563875,
            95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:14.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.11519,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:14.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.470125, 132.345125, 130.563875, 126.392, 123.67325, 119.407625, 116.642, 111.251375, 108.017,
            105.720125, 103.42325, 100.563875, 96.907625, 103.751375, 109.657625, 98.313875, 102.86075, 107.782625,
            108.063875, 100.42325, 102.11075, 103.23575, 100.61075, 99.720125, 98.313875, 102.017, 96.5795, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:44.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.84691,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:44.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.376375, 126.157625, 122.36075, 120.86075, 118.938875, 115.095125, 112.79825, 110.36075, 107.8295,
            106.61075, 102.063875, 101.220125, 99.5795, 99.438875, 97.7045, 99.48575, 99.063875, 98.688875, 99.063875,
            100.657625, 102.720125, 102.251375, 100.42325, 99.532625, 98.54825, 102.767, 96.767, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:33.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.54614,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:33.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.392, 119.92325, 115.61075, 112.563875, 110.032625, 108.626375, 107.782625, 108.532625, 118.61075,
            105.438875, 102.767, 101.17325, 98.8295, 100.04825, 99.532625, 98.688875, 99.157625, 100.04825, 100.001375,
            101.8295, 103.23575, 102.5795, 100.751375, 99.813875, 98.407625, 102.86075, 96.813875, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:25.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.07037,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:25.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.98575, 126.86075, 120.392, 115.751375, 111.48575, 113.267, 111.2045, 108.438875, 106.42325, 102.017,
            100.563875, 98.54825, 98.220125, 97.938875, 97.938875, 98.313875, 98.0795, 98.36075, 98.595125, 100.470125,
            102.251375, 102.063875, 100.98575, 99.767, 98.73575, 102.29825, 97.001375, 95.595125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:26.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.843506,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:26.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.017, 111.157625, 108.29825, 107.501375, 107.032625, 106.188875, 106.7045, 107.688875, 106.001375,
            102.157625, 105.767, 101.73575, 98.032625, 99.251375, 99.720125, 99.532625, 98.267, 99.017, 99.157625,
            100.79825, 102.345125, 101.73575, 100.3295, 99.438875, 98.407625, 102.017, 96.48575, 95.17325,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:41.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 144.38417,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:41.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.470125, 136.282625, 133.142, 130.79825, 130.563875, 127.376375, 123.532625, 121.23575, 121.376375,
            115.42325, 113.407625, 109.04825, 103.892, 103.517, 102.438875, 103.517, 100.938875, 99.48575, 98.876375,
            101.407625, 103.517, 103.001375, 100.938875, 100.563875, 99.392, 102.9545, 97.282625, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:04.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.51866,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:04.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.3295, 128.313875, 125.267, 122.407625, 120.11075, 117.392, 113.782625, 110.642, 109.563875, 104.54825,
            102.86075, 101.313875, 99.157625, 98.17325, 98.032625, 97.470125, 97.61075, 98.032625, 98.54825, 100.23575,
            102.29825, 102.251375, 100.42325, 99.626375, 98.4545, 102.157625, 96.392, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:11.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.71951,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:11.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.470125, 132.626375, 127.142, 124.563875, 120.438875, 119.73575, 117.67325, 113.73575, 108.157625,
            105.9545, 104.4545, 101.17325, 98.126375, 98.595125, 97.517, 99.392, 97.938875, 98.17325, 98.92325,
            100.470125, 102.251375, 101.92325, 100.376375, 99.48575, 98.4545, 102.063875, 97.04825, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:13.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.04523,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:13.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.688875, 121.79825, 118.3295, 115.42325, 113.220125, 110.4545, 109.892, 107.970125, 122.36075, 107.36075,
            102.532625, 98.8295, 96.813875, 97.98575, 113.032625, 105.907625, 107.313875, 103.470125, 107.92325,
            101.8295, 103.188875, 103.470125, 101.4545, 99.48575, 98.4545, 102.063875, 96.626375, 95.17325,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:30.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 146.17131,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:30.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            143.642, 140.0795, 137.313875, 132.157625, 126.907625, 124.142, 121.98575, 118.751375, 115.376375,
            112.61075, 109.517, 105.157625, 101.688875, 101.17325, 100.376375, 100.282625, 99.063875, 99.157625,
            99.251375, 100.282625, 102.345125, 102.2045, 100.188875, 99.532625, 98.642, 102.86075, 97.3295, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:29.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.14586,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:29.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.657625, 126.907625, 122.688875, 119.0795, 119.595125, 116.54825, 111.86075, 110.8295, 106.3295, 105.392,
            104.501375, 100.095125, 98.4545, 99.48575, 99.157625, 100.23575, 99.251375, 98.92325, 99.532625, 101.032625,
            102.626375, 102.2045, 100.3295, 99.67325, 98.782625, 102.5795, 97.470125, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:34.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.67989,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:34.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.98575, 127.98575, 124.79825, 120.2045, 117.392, 116.032625, 113.36075, 111.86075, 108.157625, 105.11075,
            102.392, 99.29825, 98.73575, 98.313875, 97.470125, 98.313875, 98.0795, 98.220125, 98.8295, 100.517,
            101.782625, 102.48575, 100.001375, 99.345125, 98.36075, 103.188875, 96.767, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:35.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.90751,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:35.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.282625, 108.392, 106.79825, 108.251375, 108.532625, 108.017, 108.063875, 106.892, 103.938875,
            101.782625, 102.767, 100.04825, 97.751375, 97.04825, 97.095125, 97.938875, 97.142, 97.04825, 98.313875,
            100.517, 102.438875, 102.720125, 100.563875, 99.86075, 98.782625, 102.532625, 96.48575, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:03.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.07079,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:03.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.001375, 127.470125, 124.657625, 121.42325, 120.11075, 117.251375, 113.73575, 110.501375, 110.313875,
            107.595125, 105.251375, 104.54825, 100.42325, 98.876375, 98.4545, 98.8295, 98.688875, 98.032625, 98.595125,
            101.17325, 102.5795, 102.2045, 100.563875, 99.67325, 98.688875, 102.392, 96.720125, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:01.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.01563,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:01.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.142, 115.563875, 113.595125, 110.970125, 106.61075, 106.142, 107.407625, 107.92325, 108.626375,
            104.688875, 104.501375, 101.4545, 99.67325, 99.5795, 98.501375, 98.4545, 98.36075, 98.4545, 99.11075,
            100.7045, 102.2045, 101.970125, 100.3295, 99.626375, 98.92325, 103.657625, 96.720125, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:57.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.700905,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:57.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.29825, 107.407625, 103.282625, 104.92325, 106.938875, 108.345125, 108.438875, 107.688875, 105.392,
            102.48575, 102.251375, 100.517, 106.79825, 98.92325, 98.8295, 99.063875, 101.92325, 99.720125, 102.767,
            103.04825, 102.907625, 102.720125, 100.892, 99.86075, 98.688875, 102.907625, 96.48575, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:28.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.25269,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:28.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.095125, 127.188875, 124.42325, 122.4545, 120.438875, 120.438875, 116.36075, 111.251375, 113.54825,
            111.157625, 104.688875, 102.532625, 97.892, 100.98575, 100.845125, 100.470125, 99.392, 98.73575, 99.392,
            101.220125, 102.626375, 102.48575, 101.0795, 100.188875, 98.876375, 103.142, 97.188875, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:50.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.74124,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:50.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.595125, 135.063875, 132.767, 130.98575, 127.23575, 123.251375, 120.017, 116.595125, 114.813875,
            109.657625, 108.9545, 105.532625, 109.845125, 104.782625, 102.017, 108.11075, 100.98575, 102.9545,
            104.17325, 100.892, 102.767, 102.251375, 101.126375, 100.657625, 98.642, 102.86075, 96.9545, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:58.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.79498,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:58.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.54825, 104.8295, 103.7045, 107.876375, 108.11075, 108.438875, 108.86075, 107.126375, 106.470125,
            104.501375, 103.188875, 101.4545, 98.501375, 99.345125, 98.688875, 98.8295, 98.73575, 98.54825, 99.157625,
            101.032625, 102.48575, 102.157625, 100.892, 100.001375, 98.92325, 102.86075, 97.188875, 95.501375,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:32.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.55383,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:32.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.767, 127.563875, 122.92325, 119.501375, 117.11075, 113.782625, 112.938875, 112.42325, 128.501375,
            105.907625, 103.892, 104.642, 99.532625, 101.36075, 99.29825, 98.407625, 99.5795, 98.54825, 99.063875,
            101.17325, 102.017, 101.73575, 100.095125, 99.438875, 98.36075, 101.970125, 96.767, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:18.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.46472,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:18.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.095125, 135.626375, 131.54825, 126.392, 123.157625, 121.3295, 118.095125, 114.626375, 112.61075,
            110.407625, 105.767, 103.142, 99.9545, 99.767, 100.23575, 101.0795, 100.42325, 99.48575, 99.251375,
            101.17325, 102.9545, 102.767, 100.61075, 99.86075, 98.688875, 102.813875, 97.517, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:19.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.73402,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:19.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.970125, 125.8295, 121.61075, 118.845125, 116.782625, 111.532625, 110.126375, 108.29825, 111.86075,
            118.42325, 104.313875, 100.42325, 100.23575, 99.626375, 100.657625, 101.54825, 99.063875, 98.4545,
            98.501375, 101.126375, 102.251375, 101.92325, 100.376375, 99.9545, 98.501375, 102.345125, 96.86075,
            95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:24.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.62999,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:24.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.751375, 126.86075, 124.3295, 122.407625, 119.267, 116.688875, 114.11075, 109.61075, 105.5795, 102.48575,
            100.657625, 98.8295, 97.938875, 97.42325, 97.751375, 97.98575, 98.17325, 98.126375, 98.501375, 100.3295,
            102.438875, 102.017, 100.42325, 99.813875, 98.688875, 102.157625, 96.438875, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:52.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.90877,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:52.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.2045, 131.36075, 127.42325, 124.98575, 122.54825, 121.001375, 117.157625, 115.563875, 123.063875,
            124.98575, 106.7045, 106.188875, 101.970125, 102.017, 103.79825, 103.282625, 101.782625, 101.0795,
            100.42325, 101.17325, 103.095125, 102.532625, 100.517, 99.907625, 98.782625, 103.04825, 97.095125,
            95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:43.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.97101,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:43.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.36075, 124.98575, 121.42325, 117.48575, 115.04825, 112.470125, 109.188875, 108.11075, 105.813875,
            104.126375, 103.001375, 107.126375, 106.7045, 102.67325, 99.251375, 101.032625, 101.595125, 102.720125,
            102.67325, 104.17325, 103.23575, 102.720125, 101.0795, 100.23575, 98.8295, 102.345125, 96.86075, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:47.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.1823,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:47.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.017, 126.813875, 123.9545, 120.720125, 117.907625, 116.36075, 114.438875, 111.767, 106.892, 104.642,
            102.392, 105.48575, 104.8295, 99.11075, 100.3295, 101.17325, 100.61075, 101.0795, 101.313875, 102.2045,
            102.532625, 102.626375, 101.0795, 99.813875, 98.4545, 102.29825, 96.767, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:09.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.03283,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:09.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.563875, 117.251375, 114.157625, 111.11075, 110.032625, 108.157625, 108.813875, 110.642, 123.063875,
            111.157625, 103.001375, 101.17325, 98.4545, 99.345125, 99.67325, 99.9545, 97.98575, 97.892, 98.501375,
            100.563875, 102.626375, 101.876375, 100.095125, 99.67325, 98.4545, 101.92325, 96.392, 95.17325,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:30.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.44308,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:30.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.813875, 127.657625, 125.501375, 125.313875, 122.17325, 119.313875, 112.79825, 111.157625, 107.642,
            106.001375, 104.36075, 101.782625, 99.67325, 99.532625, 99.251375, 99.532625, 98.642, 98.8295, 99.251375,
            101.0795, 102.48575, 102.251375, 100.563875, 99.67325, 98.4545, 102.392, 96.767, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:38.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.1939,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:38.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.29825, 107.642, 104.36075, 106.938875, 108.063875, 107.782625, 106.095125, 106.657625, 124.845125,
            114.251375, 100.42325, 103.095125, 99.813875, 102.532625, 102.157625, 102.157625, 100.142, 99.29825,
            99.2045, 101.032625, 103.376375, 103.517, 100.892, 99.907625, 98.782625, 102.2045, 96.813875, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:02.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.022255,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:02.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.095125, 119.876375, 116.267, 115.376375, 115.188875, 109.188875, 107.501375, 106.42325, 103.98575,
            102.9545, 102.345125, 100.376375, 98.267, 98.407625, 98.17325, 97.42325, 98.220125, 98.17325, 98.876375,
            100.517, 102.392, 101.970125, 100.42325, 99.720125, 98.501375, 102.29825, 96.813875, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:36.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.66223,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:36.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.688875, 132.345125, 129.720125, 126.157625, 121.470125, 118.845125, 114.767, 112.61075, 111.017,
            107.595125, 103.79825, 102.67325, 106.23575, 99.11075, 99.5795, 100.751375, 100.001375, 101.17325, 101.642,
            103.3295, 104.36075, 103.61075, 100.892, 100.04825, 99.017, 103.42325, 97.23575, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:22.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.56718,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:22.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.657625, 117.017, 112.751375, 110.501375, 108.063875, 106.563875, 107.8295, 106.79825, 104.407625,
            102.392, 100.98575, 98.782625, 107.032625, 108.157625, 109.657625, 110.501375, 103.188875, 103.845125,
            103.61075, 102.907625, 104.876375, 103.61075, 103.142, 99.9545, 98.8295, 102.813875, 96.720125, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:37.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.0063,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:37.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.5795, 120.67325, 118.938875, 115.938875, 112.095125, 109.892, 108.11075, 107.642, 104.92325, 102.48575,
            101.782625, 101.501375, 115.563875, 102.017, 98.73575, 108.29825, 100.938875, 98.595125, 100.845125,
            103.657625, 102.2045, 103.282625, 100.79825, 100.282625, 98.92325, 102.813875, 96.720125, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:27.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.83403,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:27.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.4545, 128.126375, 122.8295, 118.7045, 117.67325, 113.126375, 111.720125, 109.7045, 106.376375,
            104.501375, 101.17325, 99.157625, 97.98575, 98.220125, 98.17325, 98.54825, 97.657625, 97.938875, 98.642,
            100.79825, 102.157625, 101.92325, 100.7045, 99.5795, 98.54825, 102.9545, 96.813875, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:34.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.49992,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:34.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.470125, 127.657625, 127.563875, 124.938875, 120.017, 119.8295, 116.54825, 112.3295, 118.751375,
            126.11075, 103.282625, 100.7045, 106.282625, 100.938875, 106.845125, 107.4545, 99.720125, 100.79825,
            100.095125, 103.282625, 104.501375, 104.17325, 100.61075, 99.720125, 98.876375, 102.907625, 96.9545,
            95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:42.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 145.95792,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:42.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.5795, 137.36075, 133.7045, 131.642, 127.04825, 123.813875, 124.3295, 121.470125, 121.3295, 120.86075,
            111.626375, 108.907625, 106.563875, 106.892, 101.642, 106.563875, 104.313875, 102.017, 100.376375,
            101.688875, 102.5795, 102.532625, 100.61075, 99.907625, 98.970125, 102.720125, 96.67325, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:23.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.31807,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:23.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.657625, 120.392, 116.54825, 116.220125, 112.845125, 108.720125, 108.813875, 107.267, 103.892,
            101.782625, 100.751375, 97.04825, 101.92325, 109.892, 97.3295, 103.98575, 104.73575, 98.782625, 99.392,
            101.642, 102.767, 102.251375, 101.313875, 99.9545, 98.595125, 102.813875, 96.767, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:46.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.415,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:46.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.54825, 131.501375, 126.86075, 126.392, 125.54825, 122.4545, 117.9545, 114.767, 117.2045, 108.11075,
            105.48575, 107.595125, 104.8295, 99.767, 98.782625, 102.345125, 100.04825, 101.8295, 104.17325, 102.345125,
            103.04825, 103.04825, 101.642, 100.142, 99.017, 103.938875, 97.282625, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:42.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.43184,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:42.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.642, 116.970125, 114.345125, 111.345125, 107.4545, 107.642, 107.782625, 106.845125, 104.126375,
            102.9545, 101.313875, 105.720125, 113.407625, 100.095125, 100.517, 102.767, 101.126375, 101.0795,
            100.751375, 105.063875, 102.9545, 102.907625, 101.4545, 100.563875, 98.970125, 103.3295, 96.251375,
            95.17325,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:55.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.2987,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:55.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.970125, 127.188875, 126.251375, 124.7045, 120.48575, 117.392, 116.4545, 112.98575, 124.470125,
            115.376375, 102.626375, 105.48575, 100.98575, 104.313875, 101.782625, 103.79825, 99.48575, 101.4545,
            99.67325, 101.313875, 102.67325, 102.67325, 100.98575, 99.907625, 99.063875, 103.04825, 97.79825, 95.595125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:48.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.55464,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:48.707Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.282625, 118.188875, 119.688875, 115.61075, 110.36075, 110.032625, 110.17325, 107.876375, 122.688875,
            107.782625, 102.29825, 101.407625, 97.657625, 101.8295, 105.907625, 104.0795, 99.767, 99.626375, 99.392,
            101.126375, 102.29825, 101.92325, 100.563875, 99.532625, 98.501375, 102.345125, 97.001375, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:20.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.4288,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:20.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.392, 116.501375, 112.188875, 111.2045, 110.17325, 106.517, 107.267, 107.126375, 105.438875, 103.845125,
            100.470125, 99.157625, 97.892, 96.86075, 119.501375, 98.92325, 98.4545, 104.8295, 99.532625, 108.063875,
            104.876375, 102.29825, 103.470125, 100.376375, 98.595125, 102.2045, 96.907625, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:45.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.23024,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:45.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.876375, 122.0795, 119.782625, 117.532625, 111.438875, 107.407625, 107.8295, 109.376375, 127.04825,
            112.751375, 102.438875, 103.657625, 99.11075, 104.782625, 105.626375, 102.29825, 99.438875, 99.5795,
            99.813875, 101.126375, 102.48575, 102.017, 100.42325, 100.04825, 98.688875, 102.5795, 97.001375, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:31.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.31906,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:31.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.126375, 128.8295, 126.2045, 123.5795, 122.126375, 117.626375, 113.8295, 111.063875, 107.54825, 105.2045,
            104.4545, 102.532625, 100.001375, 101.17325, 100.23575, 100.470125, 100.095125, 100.095125, 99.720125,
            101.73575, 102.438875, 102.626375, 100.23575, 99.86075, 98.595125, 102.11075, 97.79825, 95.595125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:26.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.33044,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:26.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.3295, 128.4545, 122.970125, 120.157625, 116.220125, 113.54825, 111.67325, 108.5795, 106.938875,
            103.23575, 100.98575, 98.73575, 97.563875, 99.157625, 98.36075, 98.4545, 97.657625, 98.595125, 98.92325,
            101.0795, 102.345125, 102.2045, 100.98575, 99.9545, 98.92325, 102.9545, 96.720125, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:07.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.94797,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:07.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.782625, 133.79825, 128.501375, 124.7045, 120.5795, 118.282625, 116.032625, 114.063875, 110.267,
            107.4545, 104.688875, 101.0795, 99.5795, 99.626375, 99.767, 99.48575, 98.876375, 98.642, 99.017, 100.517,
            102.720125, 102.48575, 100.657625, 99.67325, 98.73575, 102.9545, 97.42325, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:32.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.79524,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:32.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.532625, 116.92325, 112.001375, 108.907625, 107.36075, 106.7045, 106.657625, 105.813875, 102.767,
            100.938875, 101.642, 100.23575, 111.2045, 98.407625, 97.938875, 111.2045, 98.267, 107.782625, 107.220125,
            101.032625, 106.04825, 105.9545, 105.11075, 101.126375, 99.157625, 103.188875, 96.532625, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:54.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.27368,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:54.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.626375, 114.67325, 110.876375, 108.017, 107.92325, 106.98575, 107.876375, 108.2045, 105.532625,
            102.345125, 101.688875, 100.563875, 102.67325, 99.532625, 99.626375, 101.876375, 99.29825, 98.36075, 99.017,
            100.7045, 102.5795, 102.063875, 100.376375, 99.67325, 98.407625, 101.970125, 96.86075, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:06.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.911095,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:06.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.501375, 110.595125, 107.313875, 107.876375, 107.970125, 107.92325, 108.438875, 105.720125, 105.251375,
            104.782625, 104.54825, 100.376375, 98.313875, 108.2045, 100.42325, 98.54825, 100.938875, 98.4545, 98.688875,
            100.845125, 102.29825, 102.67325, 101.220125, 99.86075, 98.8295, 102.532625, 96.532625, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:49.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.38184,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:49.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.126375, 125.688875, 123.11075, 118.7045, 117.48575, 115.04825, 112.282625, 111.11075, 127.98575,
            113.970125, 102.438875, 104.0795, 99.48575, 103.001375, 104.220125, 103.657625, 100.470125, 100.563875,
            100.001375, 101.17325, 102.392, 101.782625, 100.657625, 99.720125, 98.688875, 102.67325, 96.813875,
            95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:53.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.81696,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:53.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.720125, 120.11075, 116.407625, 114.767, 112.095125, 110.313875, 107.782625, 106.892, 116.36075,
            103.98575, 101.36075, 101.36075, 108.86075, 100.376375, 99.767, 105.2045, 101.4545, 102.438875, 102.813875,
            101.595125, 102.907625, 102.5795, 102.2045, 99.907625, 98.501375, 101.782625, 96.9545, 95.407625,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:41.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.43048,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:41.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.17325, 112.376375, 108.5795, 108.67325, 107.220125, 108.063875, 108.345125, 106.938875, 104.688875,
            102.438875, 101.032625, 105.626375, 106.142, 97.938875, 102.626375, 106.142, 98.501375, 100.517, 106.04825,
            100.892, 102.907625, 103.142, 101.032625, 100.142, 98.642, 102.5795, 96.532625, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:56.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.11147,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:56.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.017, 136.188875, 131.970125, 129.67325, 128.54825, 122.4545, 120.2045, 116.782625, 117.86075, 114.86075,
            108.48575, 105.063875, 104.313875, 101.0795, 103.188875, 102.86075, 101.407625, 101.032625, 105.532625,
            103.188875, 103.657625, 102.907625, 101.407625, 99.9545, 98.970125, 103.188875, 97.42325, 96.11075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:39.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.9341,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:39.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.751375, 116.8295, 115.892, 112.3295, 107.54825, 109.095125, 106.3295, 106.42325, 104.642, 102.626375,
            100.845125, 101.642, 108.2045, 99.86075, 100.42325, 100.845125, 100.61075, 102.157625, 104.595125,
            103.04825, 103.657625, 103.3295, 101.313875, 100.001375, 98.8295, 102.438875, 96.813875, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:05.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.709625,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:05.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.142, 109.42325, 106.095125, 106.98575, 106.23575, 106.845125, 107.032625, 105.720125, 122.642,
            122.54825, 110.876375, 105.67325, 105.392, 100.98575, 101.782625, 101.688875, 100.79825, 102.2045, 99.392,
            100.23575, 102.063875, 101.688875, 100.470125, 100.001375, 98.688875, 102.438875, 96.48575, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:16.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.5007,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:16.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.470125, 114.67325, 114.29825, 109.376375, 108.063875, 105.626375, 106.001375, 108.29825, 121.938875,
            120.345125, 104.17325, 104.595125, 100.470125, 103.001375, 104.36075, 100.23575, 99.251375, 99.626375,
            98.642, 100.892, 103.001375, 102.907625, 101.267, 100.142, 98.92325, 103.282625, 97.188875, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:39.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.842316,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:39.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.657625, 116.8295, 114.9545, 112.845125, 111.626375, 108.767, 109.42325, 107.032625, 104.73575,
            103.751375, 102.626375, 101.032625, 99.9545, 98.642, 98.4545, 99.532625, 98.0795, 98.4545, 98.782625,
            100.470125, 102.29825, 102.29825, 100.470125, 100.095125, 98.782625, 102.532625, 96.720125, 95.267,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:00.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.212494,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:00.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.001375, 107.73575, 104.220125, 105.392, 105.67325, 107.4545, 107.688875, 105.767, 103.188875, 102.2045,
            102.157625, 101.032625, 98.876375, 97.61075, 97.470125, 97.845125, 98.220125, 98.0795, 98.688875, 100.7045,
            102.157625, 101.8295, 100.61075, 99.907625, 98.595125, 102.157625, 96.532625, 95.17325,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:31.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.78593,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:31.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.017, 124.657625, 123.392, 119.642, 116.73575, 112.23575, 111.532625, 107.782625, 102.86075, 102.67325,
            101.970125, 100.04825, 102.11075, 99.2045, 97.938875, 102.9545, 97.892, 101.032625, 100.23575, 100.751375,
            102.532625, 102.11075, 100.61075, 99.767, 98.54825, 102.5795, 96.5795, 95.17325,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:36.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.1472,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:36.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.938875, 118.7045, 114.48575, 109.79825, 108.392, 107.92325, 104.8295, 106.751375, 103.282625,
            101.782625, 102.5795, 101.0795, 115.470125, 98.220125, 99.157625, 110.642, 102.392, 101.54825, 101.92325,
            105.5795, 103.095125, 103.517, 101.36075, 100.470125, 99.251375, 103.23575, 97.001375, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:35.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.385666,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:35.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.48575, 114.11075, 109.657625, 107.313875, 106.376375, 108.2045, 105.532625, 106.892, 124.142,
            119.595125, 102.392, 102.767, 100.657625, 100.79825, 101.267, 101.642, 99.67325, 100.095125, 99.48575,
            103.001375, 105.063875, 104.642, 100.845125, 99.86075, 98.92325, 102.813875, 96.813875, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:51.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.47958,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:51.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.188875, 118.517, 115.282625, 112.376375, 111.017, 110.032625, 107.92325, 106.42325, 105.5795,
            104.407625, 102.813875, 100.892, 98.876375, 100.095125, 101.970125, 101.267, 99.29825, 98.970125, 99.532625,
            100.892, 102.29825, 102.345125, 100.7045, 99.532625, 98.501375, 102.5795, 96.9545, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:37.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.73778,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:37.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.517, 122.313875, 119.407625, 116.126375, 113.032625, 110.688875, 109.23575, 108.626375, 108.5795,
            105.11075, 101.17325, 100.3295, 99.157625, 100.001375, 100.04825, 100.657625, 99.063875, 98.595125,
            99.251375, 102.767, 103.142, 103.376375, 100.517, 99.813875, 98.73575, 102.438875, 96.907625, 95.36075,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:40.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.58224,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:40.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.642, 130.23575, 130.376375, 127.282625, 121.3295, 120.48575, 119.313875, 114.9545, 112.188875, 106.892,
            104.501375, 103.938875, 102.9545, 100.42325, 100.751375, 101.642, 99.67325, 99.2045, 100.98575, 101.782625,
            104.032625, 103.282625, 101.17325, 99.9545, 98.595125, 102.392, 96.767, 95.220125,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:59.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.76979,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:06:59.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.3295, 113.17325, 111.67325, 108.9545, 104.595125, 106.282625, 107.17325, 105.9545, 103.892, 102.86075,
            102.157625, 100.98575, 98.267, 98.407625, 98.313875, 98.73575, 98.92325, 98.54825, 98.970125, 101.126375,
            102.532625, 102.29825, 100.42325, 100.142, 98.876375, 102.438875, 96.86075, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:40.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.768715,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:40.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 118.23575, 114.626375, 109.79825, 108.86075, 109.563875, 107.17325, 107.36075, 105.251375,
            101.92325, 101.876375, 101.17325, 108.5795, 98.220125, 98.642, 110.642, 98.267, 104.17325, 112.142,
            101.688875, 103.376375, 103.095125, 101.4545, 100.79825, 98.970125, 103.376375, 96.532625, 95.4545,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:12.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.22742,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:12.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.36075, 123.532625, 121.563875, 118.79825, 115.470125, 112.142, 110.313875, 110.54825, 125.595125,
            118.79825, 104.032625, 103.845125, 100.845125, 102.813875, 108.251375, 100.61075, 98.782625, 98.36075,
            98.642, 100.892, 102.11075, 102.2045, 100.188875, 99.67325, 98.36075, 101.782625, 96.438875, 95.313875,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:21.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.55291,
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:07:21.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.392, 109.04825, 106.376375, 107.313875, 107.595125, 106.42325, 106.61075, 107.0795, 104.17325,
            103.04825, 102.251375, 99.86075, 98.032625, 98.17325, 104.501375, 98.267, 98.17325, 99.532625, 98.970125,
            100.845125, 102.626375, 102.2045, 100.657625, 100.23575, 99.11075, 103.188875, 97.42325, 95.54825,
        ],
        latitude: 37.4405842,
        longitude: -122.533406,
    },
    {
        timestamp: '2025-08-29T23:08:02.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.1878,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:02.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.2045, 135.767, 132.67325, 130.04825, 125.876375, 125.0795, 121.7045, 118.98575, 114.9545, 109.892,
            108.48575, 105.720125, 101.8295, 99.063875, 98.126375, 97.7045, 96.86075, 97.188875, 98.267, 100.470125,
            102.2045, 102.063875, 100.751375, 100.095125, 98.782625, 102.438875, 96.626375, 95.407625,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:57.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.61459,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:57.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.9545, 113.0795, 109.517, 106.938875, 108.251375, 108.48575, 107.782625, 107.688875, 105.813875,
            103.001375, 100.282625, 98.17325, 97.938875, 98.267, 98.032625, 98.876375, 99.767, 98.36075, 98.54825,
            100.563875, 102.345125, 102.345125, 100.98575, 100.001375, 98.73575, 102.532625, 96.813875, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:38.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.095695,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:38.640Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.595125, 100.751375, 99.48575, 109.751375, 112.23575, 111.67325, 109.04825, 110.501375, 111.2045,
            104.4545, 100.79825, 100.188875, 98.92325, 98.688875, 101.501375, 99.251375, 97.657625, 99.48575, 99.157625,
            100.3295, 102.11075, 102.345125, 100.7045, 100.142, 98.876375, 102.438875, 96.720125, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:09.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.51016,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:09.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.267, 135.251375, 133.095125, 129.626375, 124.892, 124.23575, 122.267, 117.532625, 113.267, 113.4545,
            111.29825, 108.251375, 106.001375, 103.61075, 101.313875, 98.407625, 98.032625, 98.267, 98.73575, 101.0795,
            102.345125, 101.595125, 100.376375, 100.23575, 98.782625, 102.29825, 96.907625, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:46.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.06648,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:46.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            108.626375, 102.813875, 101.782625, 106.42325, 108.9545, 107.688875, 107.220125, 106.42325, 121.3295,
            103.188875, 107.36075, 101.0795, 100.79825, 101.17325, 101.4545, 101.595125, 101.8295, 102.017, 100.3295,
            100.892, 102.48575, 101.92325, 100.7045, 99.9545, 98.73575, 102.157625, 96.813875, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:42.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.18341,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:42.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.7045, 113.267, 110.54825, 109.282625, 110.642, 111.063875, 107.92325, 118.23575, 119.17325, 111.11075,
            105.438875, 102.345125, 100.751375, 100.001375, 99.017, 99.67325, 97.751375, 97.845125, 98.8295, 100.657625,
            102.67325, 102.48575, 100.938875, 100.188875, 99.063875, 103.23575, 96.48575, 95.17325,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:54.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.2678,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:54.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.642, 119.4545, 115.657625, 111.5795, 108.157625, 108.767, 106.517, 106.42325, 118.142, 116.313875,
            98.688875, 101.032625, 104.36075, 108.767, 102.2045, 102.29825, 101.267, 101.54825, 105.392, 103.563875,
            103.470125, 103.42325, 101.17325, 100.517, 98.782625, 102.251375, 96.29825, 95.220125,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:52.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.92587,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:52.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.98575, 127.892, 126.9545, 121.61075, 118.517, 114.9545, 112.188875, 109.79825, 107.54825, 104.4545,
            100.7045, 98.0795, 97.892, 97.7045, 98.501375, 98.267, 97.470125, 97.517, 97.938875, 100.470125, 102.626375,
            102.017, 100.79825, 100.282625, 98.92325, 103.42325, 97.001375, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:34.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 146.09479,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:34.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.017, 140.032625, 135.720125, 126.251375, 126.907625, 123.063875, 120.532625, 124.845125, 116.0795,
            117.626375, 107.54825, 106.892, 106.657625, 101.782625, 99.532625, 103.892, 97.938875, 98.0795, 98.595125,
            100.282625, 102.017, 103.001375, 100.563875, 99.67325, 98.4545, 102.720125, 96.9545, 95.642,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:43.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.5465,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:43.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.11075, 127.42325, 124.282625, 120.157625, 118.3295, 115.892, 113.642, 108.67325, 106.845125, 105.392,
            103.61075, 105.907625, 119.782625, 97.7045, 98.36075, 113.36075, 104.126375, 98.595125, 100.563875,
            110.73575, 104.220125, 104.4545, 103.517, 100.845125, 98.782625, 102.813875, 96.626375, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:30.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.848495,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:30.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.892, 111.5795, 108.063875, 110.595125, 109.751375, 109.42325, 108.157625, 112.751375, 112.23575,
            107.220125, 101.220125, 99.157625, 97.98575, 97.845125, 98.876375, 98.36075, 98.126375, 98.220125, 98.73575,
            100.61075, 102.392, 102.5795, 100.751375, 100.282625, 99.063875, 102.67325, 97.001375, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:26.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.74669,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:26.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.876375, 132.2045, 128.73575, 126.11075, 123.720125, 120.063875, 118.42325, 115.376375, 111.9545,
            107.92325, 105.532625, 101.220125, 99.438875, 99.438875, 98.970125, 98.688875, 98.126375, 98.313875,
            99.063875, 101.0795, 102.29825, 102.626375, 101.0795, 100.188875, 99.017, 102.392, 97.23575, 95.501375,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:32.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.12846,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:32.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.282625, 121.79825, 116.92325, 111.9545, 112.845125, 111.345125, 106.845125, 106.04825, 105.5795,
            102.767, 102.251375, 98.595125, 99.29825, 100.98575, 99.345125, 99.813875, 98.642, 98.73575, 99.720125,
            101.0795, 103.04825, 102.48575, 101.0795, 100.376375, 99.063875, 102.907625, 97.188875, 95.407625,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:31.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.66973,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:31.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.220125, 104.501375, 103.845125, 105.251375, 106.282625, 108.345125, 104.73575, 107.501375, 104.032625,
            101.595125, 99.157625, 97.938875, 96.86075, 96.392, 96.86075, 98.032625, 97.142, 97.751375, 98.876375,
            100.938875, 102.438875, 102.345125, 100.892, 100.188875, 98.73575, 102.67325, 96.251375, 95.17325,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:44.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.88379,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:44.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.657625, 134.267, 131.595125, 129.48575, 128.313875, 123.063875, 122.501375, 118.001375, 114.48575,
            111.345125, 107.54825, 102.67325, 101.73575, 97.7045, 97.517, 98.032625, 97.095125, 97.188875, 97.98575,
            100.142, 102.063875, 101.92325, 100.3295, 99.767, 98.313875, 102.11075, 96.251375, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:53.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.7067,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:53.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.001375, 126.907625, 125.267, 122.032625, 117.720125, 117.345125, 113.73575, 111.017, 124.79825,
            123.9545, 107.73575, 105.017, 102.67325, 106.7045, 108.48575, 105.438875, 100.04825, 98.782625, 99.392,
            100.892, 102.2045, 101.876375, 100.563875, 99.86075, 98.501375, 102.017, 96.438875, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:27.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.30429,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:27.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.251375, 121.376375, 116.688875, 112.3295, 110.782625, 110.032625, 107.782625, 105.392, 104.73575,
            102.11075, 100.563875, 98.782625, 97.938875, 98.73575, 98.267, 99.2045, 98.032625, 99.017, 99.017,
            101.220125, 102.86075, 102.720125, 100.563875, 99.86075, 98.970125, 102.5795, 97.657625, 95.4545,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:51.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.48764,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:51.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.17325, 123.767, 118.3295, 115.282625, 112.7045, 110.126375, 112.470125, 111.813875, 109.095125,
            114.11075, 109.751375, 102.438875, 100.98575, 100.04825, 99.157625, 98.126375, 97.98575, 98.54825,
            98.876375, 100.938875, 102.5795, 102.5795, 100.470125, 99.67325, 98.595125, 102.767, 97.7045, 95.4545,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:25.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 146.36234,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:25.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.86075, 139.376375, 133.938875, 127.938875, 125.17325, 124.142, 122.313875, 116.267, 116.313875,
            111.86075, 109.751375, 105.720125, 102.017, 99.907625, 99.48575, 98.54825, 98.688875, 98.688875, 99.11075,
            100.657625, 102.063875, 101.4545, 100.001375, 99.48575, 98.4545, 102.29825, 96.813875, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:46.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.9363,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:46.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.8295, 119.407625, 115.938875, 113.970125, 111.86075, 112.79825, 106.04825, 109.282625, 107.92325,
            103.79825, 99.532625, 97.751375, 107.313875, 106.517, 99.438875, 103.98575, 99.532625, 99.720125,
            105.720125, 102.532625, 103.517, 102.907625, 100.7045, 100.282625, 98.782625, 102.86075, 96.626375,
            95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:12.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.40009,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:12.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.9545, 128.54825, 126.345125, 122.267, 119.267, 116.126375, 111.063875, 108.48575, 107.032625,
            103.001375, 100.282625, 108.157625, 104.8295, 99.29825, 97.98575, 98.501375, 98.501375, 98.4545, 98.92325,
            101.313875, 102.251375, 102.157625, 100.376375, 99.86075, 98.688875, 102.5795, 97.3295, 95.407625,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:19.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.34715,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:19.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.220125, 130.142, 124.563875, 119.4545, 118.095125, 114.813875, 111.813875, 108.626375, 107.0795,
            102.345125, 100.188875, 107.267, 108.9545, 99.767, 98.4545, 98.92325, 101.92325, 99.67325, 100.470125,
            101.032625, 102.392, 102.157625, 100.61075, 99.813875, 98.501375, 103.23575, 96.813875, 95.407625,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:37.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.42026,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:37.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            106.23575, 101.36075, 102.5795, 108.11075, 107.54825, 109.42325, 108.438875, 111.11075, 106.001375, 101.642,
            99.157625, 98.36075, 97.23575, 98.032625, 98.126375, 97.845125, 96.9545, 97.3295, 98.642, 100.61075,
            102.017, 102.9545, 100.892, 99.532625, 98.73575, 102.532625, 96.532625, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:44.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.99732,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:44.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.2045, 110.8295, 107.0795, 106.7045, 106.79825, 111.48575, 106.142, 106.657625, 105.767, 103.563875,
            102.345125, 98.73575, 98.313875, 100.3295, 98.407625, 99.11075, 97.61075, 97.892, 99.2045, 100.470125,
            102.29825, 101.8295, 100.517, 100.188875, 98.4545, 102.9545, 96.626375, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:20.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.6759,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:20.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.438875, 126.157625, 123.157625, 117.9545, 114.9545, 115.938875, 110.642, 109.61075, 108.017, 121.42325,
            115.142, 100.657625, 102.532625, 101.92325, 103.98575, 101.126375, 100.3295, 98.8295, 100.938875,
            101.313875, 102.532625, 102.29825, 100.751375, 99.9545, 98.970125, 102.29825, 97.001375, 95.4545,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:59.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.29147,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:59.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.7045, 115.79825, 112.142, 109.188875, 109.23575, 107.267, 107.407625, 106.98575, 103.095125, 117.720125,
            114.345125, 113.407625, 117.392, 105.392, 102.813875, 107.0795, 102.767, 101.032625, 101.54825, 102.251375,
            102.907625, 102.48575, 100.3295, 99.767, 98.267, 102.11075, 96.907625, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:22.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.7298,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:22.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.720125, 109.751375, 105.767, 105.157625, 105.345125, 109.657625, 104.688875, 105.5795, 102.907625,
            101.4545, 102.2045, 105.017, 99.532625, 97.3295, 99.063875, 98.407625, 98.970125, 98.4545, 100.001375,
            100.657625, 102.017, 102.11075, 100.61075, 99.813875, 98.876375, 102.392, 96.86075, 95.126375,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:40.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.36797,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:40.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.42325, 109.517, 107.220125, 108.29825, 108.767, 111.86075, 107.688875, 107.17325, 104.032625,
            101.313875, 99.251375, 97.751375, 96.392, 97.657625, 97.751375, 98.0795, 97.282625, 97.470125, 98.8295,
            100.188875, 101.970125, 101.54825, 100.7045, 100.142, 98.688875, 102.626375, 96.392, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:33.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.10697,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:33.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.0795, 118.470125, 113.4545, 114.2045, 112.61075, 112.001375, 109.751375, 107.876375, 105.345125,
            103.563875, 101.876375, 98.501375, 97.938875, 98.642, 98.313875, 98.220125, 97.376375, 97.470125, 99.063875,
            100.938875, 102.392, 102.67325, 100.79825, 100.095125, 99.2045, 102.813875, 96.67325, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:55.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.43931,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:55.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.23575, 106.845125, 105.251375, 108.11075, 107.17325, 110.407625, 108.813875, 108.063875, 105.438875,
            101.642, 100.563875, 98.4545, 103.42325, 99.2045, 98.501375, 100.470125, 100.470125, 98.73575, 103.3295,
            101.17325, 102.9545, 102.67325, 100.657625, 100.142, 98.876375, 102.29825, 96.767, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:56.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.84809,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:56.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.54825, 113.73575, 112.001375, 106.282625, 102.9545, 105.392, 104.4545, 103.938875, 104.8295, 100.3295,
            98.73575, 98.17325, 97.657625, 98.126375, 98.501375, 99.720125, 99.11075, 98.4545, 98.782625, 100.657625,
            102.48575, 102.5795, 100.845125, 100.095125, 99.2045, 104.126375, 97.188875, 95.54825,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:45.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.35425,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:45.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.845125, 119.642, 117.438875, 114.86075, 110.73575, 109.142, 109.892, 107.876375, 106.188875, 102.9545,
            103.42325, 100.3295, 100.98575, 99.86075, 98.73575, 99.017, 97.001375, 97.61075, 98.4545, 100.563875,
            102.392, 101.876375, 100.42325, 99.813875, 98.595125, 102.017, 96.48575, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:51.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.41219,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:51.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.9545, 119.0795, 116.267, 111.29825, 109.563875, 108.157625, 105.9545, 105.157625, 103.095125, 101.36075,
            100.142, 101.688875, 107.595125, 98.407625, 100.845125, 102.48575, 101.642, 100.23575, 102.5795, 101.17325,
            102.345125, 102.157625, 100.42325, 100.095125, 98.501375, 102.251375, 96.5795, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:29.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.48723,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:29.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.29825, 118.001375, 114.157625, 110.267, 108.5795, 106.282625, 106.3295, 106.04825, 103.892, 100.892,
            102.438875, 98.313875, 96.9545, 99.2045, 98.54825, 98.313875, 97.188875, 97.376375, 98.595125, 100.79825,
            102.345125, 101.970125, 100.563875, 100.001375, 98.313875, 102.438875, 96.626375, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:23.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.17191,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:23.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.001375, 105.2045, 101.4545, 105.392, 105.86075, 109.282625, 106.7045, 109.79825, 123.813875, 119.642,
            106.563875, 105.813875, 101.970125, 103.376375, 105.720125, 101.92325, 100.845125, 99.063875, 99.67325,
            101.17325, 103.04825, 102.48575, 100.470125, 99.813875, 98.73575, 102.5795, 96.48575, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:58.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.175476,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:58.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.376375, 116.17325, 113.688875, 110.876375, 109.470125, 107.782625, 104.267, 104.126375, 113.0795,
            117.48575, 101.220125, 102.063875, 100.001375, 98.642, 96.907625, 97.23575, 97.376375, 98.220125, 98.54825,
            100.517, 102.67325, 102.29825, 101.313875, 100.3295, 98.876375, 103.3295, 96.67325, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:01.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.66966,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:01.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.220125, 127.3295, 123.767, 119.36075, 118.3295, 114.063875, 111.720125, 108.813875, 104.032625,
            103.282625, 101.92325, 101.73575, 98.4545, 98.642, 98.73575, 98.4545, 97.3295, 98.267, 98.595125, 100.98575,
            102.626375, 101.8295, 100.142, 99.9545, 98.92325, 102.251375, 96.67325, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:55.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 150.87685,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:55.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            148.3295, 143.970125, 141.2045, 136.657625, 136.61075, 135.29825, 132.720125, 128.876375, 127.376375,
            122.8295, 119.92325, 115.892, 112.563875, 107.688875, 103.42325, 101.782625, 99.626375, 98.73575, 99.017,
            101.032625, 102.532625, 102.29825, 100.98575, 100.095125, 99.392, 103.376375, 97.657625, 95.4545,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:19.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.36661,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:19.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.720125, 124.563875, 123.626375, 120.063875, 117.813875, 114.48575, 111.251375, 109.001375, 107.4545,
            111.11075, 113.17325, 103.61075, 99.532625, 100.61075, 101.73575, 99.67325, 98.407625, 98.36075, 98.92325,
            101.0795, 102.9545, 102.345125, 100.657625, 99.9545, 98.876375, 103.282625, 97.376375, 95.501375,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:18.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.4033,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:18.027Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.345125, 120.2045, 116.4545, 116.17325, 112.001375, 111.532625, 107.267, 106.751375, 104.0795,
            103.188875, 101.126375, 99.063875, 107.688875, 105.67325, 98.0795, 98.595125, 98.782625, 100.892, 100.42325,
            100.61075, 102.2045, 102.063875, 100.892, 100.095125, 98.688875, 102.48575, 96.438875, 95.220125,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:10.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.35017,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:10.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.04825, 130.845125, 127.563875, 125.126375, 123.5795, 124.095125, 121.095125, 115.376375, 113.17325,
            109.142, 103.938875, 101.4545, 99.157625, 98.970125, 98.876375, 98.267, 98.36075, 97.938875, 98.782625,
            101.4545, 102.48575, 101.970125, 100.657625, 100.095125, 98.970125, 103.3295, 97.04825, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:08.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.17448,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:08.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.98575, 123.063875, 119.4545, 115.188875, 112.751375, 110.313875, 109.938875, 109.282625, 109.470125,
            106.470125, 109.3295, 103.095125, 100.79825, 101.4545, 99.392, 98.407625, 98.407625, 98.92325, 99.157625,
            100.657625, 102.251375, 101.970125, 100.845125, 100.001375, 98.8295, 102.767, 96.86075, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:56.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.04657,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:56.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 125.782625, 122.407625, 117.67325, 115.142, 113.0795, 111.720125, 108.67325, 104.595125,
            103.845125, 100.751375, 99.251375, 100.470125, 97.470125, 97.3295, 96.626375, 97.23575, 97.7045, 98.267,
            100.7045, 102.2045, 102.017, 100.563875, 99.907625, 98.501375, 102.438875, 97.23575, 95.407625,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:04.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.48788,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:04.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.376375, 112.3295, 107.54825, 104.36075, 106.376375, 108.767, 108.251375, 108.345125, 104.0795,
            102.29825, 101.0795, 99.9545, 99.392, 97.79825, 97.095125, 97.657625, 97.23575, 97.845125, 99.017, 101.267,
            102.626375, 102.11075, 100.3295, 99.813875, 98.54825, 102.532625, 96.48575, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:52.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.4287,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:52.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.782625, 128.220125, 124.095125, 124.23575, 120.157625, 115.563875, 114.29825, 109.142, 106.517,
            105.48575, 103.7045, 99.532625, 100.61075, 97.517, 97.563875, 97.001375, 97.3295, 97.23575, 98.0795,
            101.0795, 102.017, 102.017, 100.188875, 100.001375, 98.595125, 102.720125, 96.67325, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:36.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.513565,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:36.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 118.751375, 114.767, 109.938875, 109.188875, 111.017, 106.79825, 105.48575, 104.407625, 102.017,
            100.282625, 98.4545, 97.470125, 96.86075, 98.36075, 98.36075, 97.001375, 97.61075, 98.92325, 101.501375,
            102.157625, 102.813875, 100.79825, 100.188875, 98.92325, 102.626375, 96.813875, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:15.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.58792,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:15.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.501375, 126.29825, 123.345125, 120.11075, 116.17325, 113.642, 109.563875, 106.563875, 104.407625,
            101.17325, 98.595125, 111.86075, 105.392, 97.61075, 104.032625, 101.032625, 106.657625, 99.907625,
            104.92325, 101.970125, 103.095125, 102.907625, 101.36075, 100.563875, 98.876375, 103.001375, 96.86075,
            95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:48.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.91342,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:48.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.438875, 118.04825, 114.86075, 112.7045, 111.063875, 109.470125, 107.54825, 107.54825, 105.251375,
            103.42325, 103.7045, 100.470125, 99.251375, 97.892, 97.7045, 97.845125, 97.3295, 97.517, 98.36075,
            100.42325, 102.532625, 102.5795, 100.517, 99.720125, 98.54825, 102.251375, 96.767, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:49.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.81157,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:49.437Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.032625, 128.032625, 124.61075, 120.813875, 119.220125, 115.470125, 113.73575, 110.73575, 117.063875,
            111.11075, 100.938875, 98.73575, 98.17325, 98.8295, 101.595125, 100.04825, 98.407625, 97.001375, 98.313875,
            100.61075, 102.2045, 102.11075, 100.657625, 99.86075, 98.4545, 102.813875, 96.5795, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:39.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.11628,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:39.621Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.86075, 104.970125, 101.970125, 105.532625, 106.470125, 112.376375, 107.032625, 106.79825, 105.767,
            101.688875, 99.626375, 101.220125, 102.86075, 103.095125, 101.4545, 100.845125, 98.126375, 97.892,
            99.813875, 100.751375, 102.5795, 102.2045, 100.563875, 100.001375, 98.642, 102.48575, 96.67325, 95.17325,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:49.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.90432,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:49.562Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.938875, 113.220125, 107.688875, 104.313875, 105.813875, 106.470125, 110.0795, 114.48575, 104.313875,
            118.376375, 118.04825, 104.8295, 100.938875, 99.532625, 99.345125, 98.313875, 98.220125, 99.720125,
            99.251375, 100.892, 102.720125, 102.48575, 100.79825, 100.142, 98.642, 102.626375, 96.532625, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:54.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.18619,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:54.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.001375, 132.017, 130.23575, 126.063875, 124.376375, 124.23575, 118.7045, 116.4545, 111.86075,
            109.095125, 105.86075, 119.92325, 126.438875, 102.720125, 103.23575, 110.17325, 107.501375, 99.251375,
            103.142, 103.23575, 102.86075, 102.720125, 100.892, 100.23575, 99.11075, 102.251375, 96.907625, 95.407625,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:28.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.08656,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:28.824Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.501375, 122.0795, 118.517, 113.92325, 111.720125, 107.876375, 107.92325, 108.017, 104.970125, 102.5795,
            103.142, 97.517, 97.563875, 98.92325, 98.4545, 97.657625, 97.142, 96.626375, 98.267, 100.470125, 102.157625,
            101.782625, 100.376375, 99.86075, 98.313875, 102.11075, 96.392, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:06.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.02864,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:06.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.23575, 124.095125, 120.017, 116.36075, 115.938875, 113.313875, 112.938875, 111.5795, 110.267, 103.517,
            110.92325, 102.345125, 99.626375, 100.657625, 102.157625, 100.3295, 98.313875, 99.157625, 99.438875,
            101.17325, 102.720125, 101.92325, 100.42325, 99.813875, 98.73575, 102.86075, 96.67325, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:45.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.66772,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:45.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.79825, 121.470125, 117.063875, 114.5795, 112.517, 113.36075, 109.3295, 110.642, 113.642, 102.813875,
            101.032625, 98.876375, 100.98575, 99.438875, 100.79825, 101.688875, 99.626375, 99.345125, 99.720125,
            100.7045, 102.29825, 101.782625, 100.563875, 99.86075, 98.595125, 102.720125, 96.5795, 95.220125,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:05.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.97451,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:05.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.626375, 107.8295, 106.42325, 107.54825, 108.063875, 108.5795, 107.688875, 109.517, 107.032625, 103.517,
            100.98575, 101.970125, 98.782625, 99.29825, 99.063875, 98.688875, 98.313875, 98.4545, 99.29825, 101.407625,
            102.29825, 101.970125, 100.845125, 100.282625, 98.876375, 102.5795, 96.626375, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:50.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.23332,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:50.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.595125, 132.017, 126.11075, 120.626375, 117.157625, 115.42325, 115.3295, 114.48575, 106.470125,
            124.79825, 114.86075, 111.017, 102.813875, 102.86075, 102.11075, 99.438875, 101.688875, 100.657625, 99.767,
            100.98575, 102.720125, 101.92325, 100.188875, 99.532625, 98.8295, 103.04825, 96.626375, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:03.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.11096,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:03.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.767, 121.892, 119.92325, 117.157625, 115.79825, 113.782625, 116.876375, 119.970125, 107.970125,
            107.92325, 108.157625, 101.8295, 99.345125, 100.42325, 99.86075, 98.595125, 99.29825, 98.4545, 98.92325,
            101.17325, 102.2045, 101.92325, 100.282625, 99.720125, 98.313875, 102.017, 96.767, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:47.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 145.42372,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:47.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.42325, 136.142, 136.98575, 136.376375, 132.626375, 128.782625, 129.438875, 123.767, 120.907625,
            116.782625, 112.42325, 112.98575, 108.67325, 101.642, 104.267, 103.095125, 101.220125, 100.282625,
            104.220125, 103.095125, 103.04825, 102.86075, 101.17325, 100.23575, 98.688875, 103.001375, 96.5795,
            95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:57.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.20882,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:57.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.938875, 116.032625, 111.813875, 110.4545, 108.345125, 106.3295, 106.42325, 104.36075, 103.001375,
            124.376375, 119.36075, 122.73575, 111.157625, 105.767, 107.92325, 103.845125, 105.063875, 103.98575,
            101.220125, 101.642, 102.720125, 102.392, 100.79825, 99.626375, 98.17325, 101.595125, 96.438875, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:17.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.35162,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:17.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.563875, 122.782625, 119.595125, 114.345125, 114.532625, 112.845125, 108.29825, 107.36075, 116.73575,
            118.892, 102.063875, 99.345125, 99.86075, 100.42325, 102.345125, 100.001375, 100.657625, 98.4545, 99.720125,
            101.267, 102.67325, 102.626375, 100.79825, 100.095125, 99.11075, 103.282625, 96.9545, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:48.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 148.54974,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:48.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            146.36075, 141.907625, 139.282625, 133.657625, 129.5795, 127.470125, 124.7045, 120.67325, 118.892, 116.267,
            111.907625, 106.79825, 104.4545, 101.54825, 99.2045, 98.313875, 98.688875, 98.313875, 98.54825, 101.0795,
            102.532625, 101.970125, 100.563875, 99.767, 98.54825, 103.470125, 97.095125, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:41.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.187325,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:41.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.42325, 110.313875, 104.92325, 104.642, 108.345125, 110.970125, 105.532625, 105.5795, 101.313875,
            100.563875, 100.892, 98.032625, 96.11075, 97.04825, 97.42325, 97.7045, 97.3295, 97.61075, 98.36075,
            100.563875, 102.438875, 102.48575, 100.7045, 100.282625, 98.73575, 102.813875, 96.813875, 95.220125,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:35.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.65402,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:35.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.92325, 129.251375, 125.17325, 120.67325, 117.157625, 118.3295, 116.0795, 113.313875, 112.188875,
            106.376375, 101.595125, 105.157625, 106.79825, 105.017, 99.017, 102.438875, 100.845125, 98.876375,
            102.720125, 104.0795, 101.970125, 103.04825, 100.79825, 99.767, 98.8295, 102.5795, 96.67325, 95.17325,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:43.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.20161,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:43.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.595125, 116.92325, 114.251375, 110.970125, 111.438875, 113.4545, 104.54825, 104.92325, 103.563875,
            101.17325, 99.29825, 97.657625, 97.188875, 97.79825, 97.517, 97.938875, 97.001375, 97.7045, 99.063875,
            100.657625, 101.876375, 101.970125, 100.376375, 100.04825, 98.970125, 102.767, 96.67325, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:21.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.50851,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:21.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.67325, 126.9545, 123.157625, 120.11075, 118.517, 115.376375, 112.188875, 107.8295, 105.063875,
            101.54825, 100.517, 108.017, 109.470125, 99.392, 101.407625, 101.220125, 102.767, 99.67325, 102.67325,
            101.92325, 102.532625, 102.720125, 100.61075, 99.626375, 98.4545, 102.11075, 96.86075, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:07.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.2651,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:07.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.5795, 111.532625, 108.2045, 107.313875, 106.98575, 107.642, 113.36075, 108.017, 109.563875, 111.767,
            103.142, 103.657625, 100.23575, 101.970125, 102.438875, 98.8295, 99.813875, 99.438875, 98.688875, 101.0795,
            102.063875, 102.29825, 100.61075, 99.86075, 98.876375, 102.2045, 96.86075, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:47.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.88062,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:47.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.67325, 125.17325, 120.017, 116.642, 115.095125, 113.17325, 108.29825, 114.48575, 127.61075, 117.157625,
            108.392, 106.282625, 104.688875, 103.470125, 101.032625, 101.92325, 102.86075, 102.2045, 99.017, 100.7045,
            102.626375, 102.2045, 100.517, 99.767, 98.313875, 102.29825, 96.67325, 95.36075,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:53.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.00801,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:07:53.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.5795, 122.126375, 119.876375, 114.532625, 111.907625, 109.470125, 106.845125, 104.4545, 102.157625,
            102.767, 101.642, 100.188875, 101.54825, 96.9545, 97.3295, 97.23575, 97.04825, 97.142, 98.54825, 100.23575,
            101.8295, 101.4545, 100.517, 100.001375, 98.595125, 102.392, 96.392, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:00.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.17374,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:00.359Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.907625, 121.42325, 118.142, 116.313875, 114.5795, 112.892, 109.23575, 109.845125, 106.142, 101.73575,
            101.313875, 101.220125, 99.907625, 97.98575, 97.98575, 97.7045, 97.470125, 97.517, 98.688875, 100.3295,
            102.2045, 102.017, 100.892, 100.282625, 98.642, 103.04825, 96.626375, 95.220125,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:14.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.86665,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:14.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.501375, 126.813875, 123.11075, 119.36075, 118.470125, 113.92325, 109.892, 109.188875, 114.29825,
            119.73575, 102.157625, 98.8295, 97.98575, 99.392, 98.876375, 98.73575, 98.17325, 98.642, 99.017, 100.657625,
            102.392, 102.29825, 100.282625, 100.001375, 98.8295, 102.720125, 97.04825, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:50.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.60704,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:50.417Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.970125, 118.892, 113.642, 111.345125, 110.782625, 108.157625, 107.642, 107.688875, 122.17325, 106.517,
            100.61075, 97.938875, 101.313875, 98.220125, 98.4545, 97.61075, 97.79825, 98.17325, 98.782625, 100.61075,
            102.157625, 101.642, 100.42325, 99.67325, 98.220125, 101.970125, 96.345125, 95.17325,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:11.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.13245,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:11.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.157625, 107.970125, 104.267, 108.017, 106.42325, 109.188875, 109.79825, 107.92325, 110.8295, 102.5795,
            100.23575, 99.86075, 101.73575, 100.7045, 99.67325, 100.04825, 98.267, 98.595125, 99.5795, 101.126375,
            102.626375, 102.48575, 100.7045, 99.907625, 99.017, 102.48575, 97.282625, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:16.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.0553,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:16.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.17325, 120.438875, 119.126375, 116.4545, 112.142, 110.73575, 110.876375, 109.376375, 106.517, 104.642,
            102.017, 98.407625, 97.282625, 97.98575, 97.470125, 98.688875, 97.892, 97.376375, 98.92325, 100.845125,
            102.48575, 102.063875, 100.23575, 100.095125, 98.595125, 102.86075, 96.626375, 95.267,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:24.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.42628,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:24.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.8295, 130.61075, 126.2045, 121.517, 119.876375, 119.782625, 114.67325, 112.142, 128.267, 117.345125,
            103.142, 103.98575, 98.126375, 97.892, 104.36075, 100.04825, 99.157625, 98.73575, 99.392, 100.938875,
            102.345125, 102.063875, 100.845125, 99.907625, 98.92325, 103.188875, 97.095125, 95.313875,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:13.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.43459,
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:08:13.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.61075, 133.845125, 131.220125, 126.017, 125.0795, 120.907625, 119.407625, 115.751375, 111.720125,
            110.782625, 109.3295, 102.29825, 99.2045, 99.720125, 99.063875, 98.92325, 98.8295, 97.892, 99.438875,
            101.313875, 102.48575, 102.392, 100.517, 99.9545, 98.876375, 103.04825, 97.563875, 95.4545,
        ],
        latitude: 37.4405838,
        longitude: -122.5333985,
    },
    {
        timestamp: '2025-08-29T23:09:20.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.53221,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:20.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.142, 119.17325, 115.751375, 113.73575, 108.86075, 109.845125, 108.5795, 105.532625, 102.907625,
            100.188875, 99.907625, 98.4545, 98.642, 98.032625, 97.845125, 99.29825, 98.126375, 97.7045, 98.407625,
            99.9545, 102.063875, 101.501375, 100.142, 99.392, 98.642, 101.970125, 96.5795, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:11.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.34906,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:11.890Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.17325, 120.626375, 117.532625, 114.5795, 113.642, 113.126375, 111.626375, 110.4545, 107.032625,
            103.657625, 104.642, 123.438875, 98.032625, 98.970125, 109.188875, 99.767, 103.23575, 108.5795, 100.751375,
            100.938875, 102.251375, 101.313875, 100.42325, 99.626375, 98.267, 101.876375, 96.626375, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:51.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.58493,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:51.277Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 119.0795, 114.767, 111.392, 107.876375, 112.04825, 107.313875, 107.501375, 104.267, 102.11075,
            99.813875, 98.688875, 97.751375, 98.220125, 108.251375, 99.532625, 97.657625, 99.907625, 98.8295, 100.98575,
            101.876375, 101.970125, 100.23575, 99.67325, 98.54825, 102.2045, 96.720125, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:36.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.74124,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:36.554Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.407625, 129.017, 126.017, 122.8295, 124.188875, 122.220125, 117.345125, 114.438875, 111.345125, 108.767,
            108.251375, 103.3295, 99.626375, 99.392, 112.001375, 99.438875, 98.36075, 99.251375, 100.188875, 103.188875,
            102.29825, 102.720125, 100.845125, 100.142, 99.438875, 103.188875, 97.095125, 95.4545,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:02.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.16837,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:02.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.5795, 127.892, 125.313875, 121.563875, 118.188875, 116.8295, 112.845125, 109.938875, 118.563875,
            118.892, 115.938875, 114.438875, 102.67325, 100.188875, 99.67325, 100.142, 100.517, 99.063875, 100.3295,
            101.032625, 102.29825, 102.532625, 100.42325, 99.86075, 98.595125, 101.92325, 97.095125, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:45.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.903336,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:45.386Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.67325, 113.4545, 109.23575, 108.29825, 106.188875, 109.42325, 105.9545, 104.595125, 102.9545,
            101.126375, 101.220125, 98.126375, 97.751375, 99.063875, 99.017, 99.67325, 99.67325, 98.54825, 99.29825,
            101.4545, 102.251375, 102.5795, 100.376375, 100.001375, 98.970125, 102.5795, 97.3295, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:12.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.06364,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:12.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.438875, 107.126375, 102.86075, 104.407625, 103.98575, 108.2045, 105.345125, 116.126375, 129.48575,
            112.04825, 102.767, 103.001375, 96.86075, 99.67325, 101.595125, 101.407625, 98.595125, 97.61075, 98.8295,
            100.470125, 102.251375, 101.313875, 100.142, 99.626375, 98.407625, 101.782625, 96.157625, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:06.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.05495,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:06.000Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.79825, 131.970125, 129.157625, 125.501375, 122.4545, 122.313875, 115.23575, 113.92325, 110.032625,
            106.188875, 105.29825, 116.313875, 105.907625, 99.063875, 112.142, 100.61075, 107.4545, 101.8295, 100.98575,
            102.767, 102.438875, 102.017, 100.282625, 100.376375, 99.2045, 104.407625, 98.17325, 95.501375,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:07.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.66125,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:07.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.11075, 136.188875, 134.4545, 131.17325, 128.36075, 128.54825, 125.032625, 122.782625, 120.11075,
            114.017, 107.54825, 104.313875, 102.9545, 99.5795, 99.251375, 99.345125, 98.876375, 97.657625, 98.782625,
            101.0795, 102.438875, 101.92325, 99.767, 99.626375, 98.407625, 102.157625, 97.3295, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:18.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.65717,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:18.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.42325, 120.67325, 115.845125, 111.720125, 109.517, 108.392, 105.532625, 112.376375, 129.11075,
            123.907625, 106.42325, 103.001375, 99.67325, 102.438875, 101.8295, 102.48575, 99.67325, 97.845125,
            98.876375, 100.892, 101.73575, 101.73575, 100.188875, 99.345125, 98.54825, 101.8295, 96.67325, 95.17325,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:15.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.53851,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:15.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.876375, 119.36075, 115.142, 111.48575, 107.126375, 108.626375, 106.42325, 108.67325, 120.48575,
            110.92325, 100.095125, 104.782625, 99.720125, 103.001375, 113.126375, 104.688875, 100.7045, 100.095125,
            100.892, 103.563875, 102.67325, 102.392, 101.0795, 100.376375, 99.157625, 103.095125, 97.142, 95.54825,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:38.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.66243,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:38.515Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.782625, 133.657625, 132.532625, 130.98575, 126.86075, 122.126375, 121.892, 123.67325, 115.42325,
            111.767, 108.48575, 108.392, 101.688875, 99.86075, 100.42325, 101.267, 99.720125, 101.032625, 99.532625,
            100.892, 102.2045, 102.392, 100.376375, 99.767, 98.54825, 102.345125, 96.9545, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:39.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.07442,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:39.496Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.782625, 130.188875, 124.845125, 124.376375, 122.220125, 121.42325, 114.626375, 112.376375, 108.720125,
            104.267, 104.501375, 102.157625, 99.11075, 98.407625, 117.813875, 101.36075, 99.438875, 105.86075, 108.017,
            105.907625, 105.29825, 102.626375, 101.501375, 99.767, 98.267, 102.532625, 96.626375, 95.17325,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:27.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.35324,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:27.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.813875, 118.470125, 115.7045, 112.42325, 110.688875, 111.345125, 109.142, 109.142, 107.313875,
            102.157625, 101.0795, 97.892, 97.095125, 100.376375, 99.251375, 100.188875, 98.970125, 98.032625, 99.2045,
            100.657625, 102.251375, 101.876375, 100.282625, 99.767, 98.73575, 102.626375, 96.5795, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:58.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.4666,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:58.148Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.001375, 128.126375, 125.17325, 122.0795, 121.845125, 117.86075, 113.595125, 117.392, 113.970125,
            116.313875, 107.17325, 105.11075, 102.813875, 99.907625, 98.92325, 101.36075, 100.001375, 99.67325,
            99.720125, 100.79825, 101.4545, 101.595125, 100.470125, 99.720125, 98.17325, 101.876375, 96.345125,
            95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:50.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.737976,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:50.296Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.626375, 108.063875, 103.563875, 104.876375, 107.8295, 111.345125, 106.892, 114.2045, 104.642, 104.54825,
            102.67325, 108.67325, 103.42325, 99.907625, 111.626375, 100.845125, 99.813875, 105.438875, 108.392,
            103.04825, 103.470125, 102.767, 101.407625, 100.001375, 98.73575, 103.23575, 97.282625, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:01.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.9666,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:01.093Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.142, 132.063875, 128.92325, 128.73575, 126.626375, 123.2045, 122.688875, 120.157625, 112.095125,
            119.220125, 117.813875, 109.23575, 102.767, 102.813875, 99.813875, 106.657625, 98.501375, 100.142, 102.392,
            102.063875, 102.157625, 101.595125, 100.095125, 99.345125, 98.126375, 101.501375, 95.970125, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:06.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.41173,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:06.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.61075, 127.001375, 123.438875, 121.938875, 121.470125, 117.438875, 116.032625, 111.720125, 109.845125,
            106.095125, 103.751375, 100.79825, 105.48575, 98.8295, 99.2045, 110.54825, 99.29825, 99.11075, 105.48575,
            102.063875, 103.188875, 103.892, 100.98575, 99.720125, 98.92325, 103.3295, 97.376375, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:47.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.31533,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:47.351Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.126375, 105.438875, 103.095125, 107.782625, 108.017, 112.938875, 109.563875, 109.095125, 106.095125,
            103.04825, 101.501375, 99.29825, 96.345125, 98.642, 114.626375, 99.720125, 98.782625, 103.61075, 99.9545,
            106.938875, 104.8295, 103.142, 102.626375, 99.907625, 98.595125, 103.470125, 96.767, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:33.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.76058,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:33.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.751375, 116.73575, 114.251375, 110.688875, 108.86075, 112.282625, 108.813875, 107.4545, 104.220125,
            103.3295, 104.54825, 103.04825, 100.61075, 99.532625, 99.251375, 99.907625, 99.67325, 98.782625, 99.157625,
            100.892, 102.2045, 102.345125, 100.282625, 99.626375, 99.157625, 102.9545, 97.3295, 95.4545,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:44.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.28099,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:44.406Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.251375, 116.0795, 113.267, 112.376375, 109.657625, 110.313875, 106.095125, 104.642, 102.2045,
            100.095125, 101.782625, 97.3295, 96.438875, 98.92325, 98.501375, 99.720125, 100.470125, 98.595125,
            99.063875, 101.267, 101.970125, 101.642, 100.517, 99.48575, 98.688875, 102.438875, 96.5795, 95.4545,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:07.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.286476,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:07.964Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.657625, 118.282625, 116.73575, 113.501375, 110.220125, 113.4545, 107.595125, 105.251375, 101.642,
            101.782625, 102.5795, 116.4545, 100.517, 98.313875, 102.813875, 97.751375, 98.17325, 97.845125, 99.251375,
            100.61075, 101.73575, 101.4545, 100.001375, 99.720125, 98.54825, 102.017, 96.157625, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:42.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.52538,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:42.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.720125, 125.220125, 120.532625, 117.767, 116.407625, 113.36075, 115.04825, 124.470125, 113.642,
            115.7045, 103.657625, 104.92325, 97.563875, 99.767, 102.438875, 99.251375, 99.157625, 99.438875, 99.063875,
            100.470125, 101.688875, 101.595125, 99.86075, 99.438875, 98.313875, 101.92325, 97.23575, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:04.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.92513,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:04.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 127.282625, 125.8295, 121.938875, 119.782625, 113.73575, 110.17325, 112.892, 130.751375,
            122.595125, 104.267, 107.642, 103.98575, 106.42325, 107.220125, 104.73575, 102.157625, 99.86075, 101.0795,
            101.36075, 102.438875, 102.11075, 100.563875, 99.767, 98.595125, 102.392, 96.86075, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:28.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.30061,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:28.699Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.220125, 103.42325, 102.907625, 107.0795, 107.407625, 109.61075, 107.126375, 106.42325, 103.751375,
            101.126375, 104.8295, 98.54825, 97.751375, 99.48575, 99.157625, 99.86075, 99.157625, 98.688875, 98.876375,
            101.0795, 102.2045, 102.5795, 100.845125, 100.04825, 99.017, 102.9545, 97.095125, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:08:59.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.62656,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:08:59.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.04825, 114.767, 110.54825, 108.907625, 111.157625, 110.032625, 118.04825, 126.9545, 120.9545,
            110.876375, 104.313875, 105.9545, 100.98575, 99.67325, 98.126375, 98.501375, 97.7045, 97.563875, 98.126375,
            100.095125, 102.11075, 101.8295, 100.892, 99.9545, 98.595125, 102.2045, 96.157625, 95.126375,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:08.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 144.79224,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:08.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            141.48575, 137.267, 136.563875, 134.8295, 130.142, 130.79825, 126.5795, 121.98575, 122.032625, 119.407625,
            115.188875, 112.04825, 105.251375, 102.5795, 100.845125, 99.9545, 99.017, 98.220125, 98.4545, 100.657625,
            102.392, 101.782625, 100.23575, 99.813875, 98.876375, 102.48575, 97.188875, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:17.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.326866,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:17.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.563875, 113.8295, 110.970125, 109.04825, 109.517, 109.188875, 107.54825, 107.17325, 108.67325, 103.142,
            101.642, 97.657625, 97.98575, 98.92325, 99.063875, 99.813875, 98.8295, 98.17325, 98.8295, 100.98575,
            101.970125, 101.8295, 100.3295, 99.532625, 98.4545, 101.688875, 97.188875, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:21.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.9821,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:21.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.54825, 125.8295, 123.86075, 117.67325, 115.7045, 114.720125, 110.595125, 111.48575, 125.126375,
            121.470125, 103.095125, 103.23575, 102.251375, 104.407625, 105.392, 105.157625, 100.845125, 98.876375,
            99.345125, 100.938875, 102.29825, 102.392, 100.563875, 100.001375, 98.688875, 102.532625, 97.188875,
            95.54825,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:09.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.69008,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:09.925Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.42325, 122.313875, 119.595125, 116.73575, 112.751375, 112.001375, 106.095125, 106.42325, 104.0795,
            103.001375, 103.142, 101.4545, 107.876375, 97.142, 98.17325, 98.0795, 97.61075, 97.938875, 98.407625,
            100.938875, 102.063875, 101.876375, 100.001375, 99.2045, 98.0795, 101.313875, 96.438875, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:10.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.74113,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:10.906Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.642, 123.017, 120.063875, 119.032625, 117.48575, 114.67325, 108.532625, 107.54825, 105.11075, 102.2045,
            102.720125, 127.517, 118.001375, 100.563875, 111.29825, 105.017, 106.470125, 101.642, 100.188875, 100.79825,
            102.157625, 101.54825, 100.142, 99.29825, 98.126375, 101.876375, 96.5795, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:02.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.93899,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:02.074Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.001375, 110.0795, 105.86075, 106.751375, 106.98575, 117.345125, 116.501375, 106.657625, 116.501375,
            116.970125, 103.79825, 108.9545, 100.563875, 97.79825, 101.267, 102.345125, 98.876375, 99.2045, 101.032625,
            100.98575, 101.782625, 101.595125, 100.188875, 99.392, 98.0795, 101.54825, 96.48575, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:29.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.04344,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:29.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.532625, 121.142, 118.892, 114.720125, 113.220125, 112.79825, 115.001375, 113.73575, 105.157625,
            99.532625, 98.782625, 96.29825, 97.892, 98.595125, 99.438875, 99.720125, 100.142, 98.032625, 98.782625,
            100.3295, 101.876375, 101.595125, 100.188875, 99.251375, 98.17325, 101.595125, 96.345125, 95.17325,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:41.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.57229,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:41.460Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.001375, 114.48575, 111.017, 109.23575, 105.813875, 111.5795, 107.17325, 106.095125, 103.892, 101.782625,
            106.517, 100.188875, 98.688875, 99.017, 98.595125, 99.2045, 99.29825, 97.657625, 98.970125, 101.032625,
            102.29825, 102.2045, 100.563875, 99.720125, 98.54825, 102.86075, 97.563875, 95.688875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:11.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.89327,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:11.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.032625, 113.0795, 108.157625, 106.563875, 106.42325, 108.532625, 106.517, 107.501375, 107.36075,
            101.313875, 99.86075, 97.42325, 97.23575, 97.3295, 97.095125, 97.282625, 96.907625, 97.657625, 98.54825,
            100.376375, 101.92325, 101.642, 100.470125, 99.67325, 98.688875, 102.345125, 96.251375, 95.17325,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:30.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.83957,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:30.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.188875, 123.157625, 118.938875, 116.8295, 115.23575, 112.751375, 120.720125, 124.79825, 116.17325,
            107.54825, 106.938875, 101.642, 104.0795, 102.907625, 101.267, 100.98575, 100.938875, 98.688875, 99.345125,
            101.032625, 102.063875, 101.688875, 100.3295, 99.5795, 98.688875, 101.970125, 96.532625, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:53.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.5013,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:53.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.36075, 135.017, 132.017, 128.970125, 125.970125, 127.563875, 122.782625, 120.9545, 116.267, 111.392,
            108.9545, 106.3295, 103.001375, 100.517, 99.626375, 99.86075, 100.7045, 98.407625, 99.5795, 101.0795,
            102.438875, 102.626375, 100.61075, 99.907625, 98.782625, 103.517, 97.095125, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:37.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.13765,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:37.535Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.501375, 116.407625, 113.032625, 111.626375, 109.142, 111.9545, 109.42325, 109.282625, 106.42325,
            103.98575, 106.3295, 101.313875, 99.532625, 100.001375, 98.688875, 100.376375, 100.892, 98.0795, 98.970125,
            101.0795, 101.970125, 102.626375, 100.23575, 99.86075, 98.782625, 102.626375, 96.720125, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:35.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.22867,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:35.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.7045, 122.970125, 120.532625, 117.392, 116.782625, 111.907625, 118.892, 120.720125, 114.86075, 108.2045,
            109.563875, 101.876375, 100.657625, 105.907625, 115.938875, 100.517, 100.79825, 104.17325, 105.5795,
            103.23575, 104.0795, 103.142, 100.938875, 99.86075, 98.642, 102.017, 96.86075, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:08.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.30733,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:08.945Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.2045, 131.36075, 130.142, 126.157625, 124.04825, 122.595125, 121.142, 115.892, 110.970125, 108.157625,
            106.095125, 103.7045, 99.5795, 98.54825, 97.001375, 97.61075, 96.907625, 97.470125, 98.36075, 100.42325,
            101.876375, 101.0795, 99.9545, 99.67325, 98.220125, 102.157625, 96.2045, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:05.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.50421,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:05.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.813875, 128.36075, 126.345125, 121.845125, 120.345125, 118.3295, 115.095125, 112.751375, 116.92325,
            115.095125, 103.563875, 102.2045, 113.313875, 99.86075, 101.36075, 111.11075, 98.8295, 100.42325,
            109.001375, 101.595125, 103.095125, 103.04825, 100.657625, 99.86075, 98.36075, 102.532625, 96.86075,
            95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:59.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.54416,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:59.128Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.970125, 130.845125, 126.251375, 124.938875, 122.595125, 120.251375, 118.095125, 122.17325, 122.501375,
            117.532625, 111.720125, 108.063875, 101.595125, 100.657625, 98.92325, 99.11075, 98.782625, 99.2045,
            99.157625, 100.563875, 102.11075, 102.017, 100.095125, 99.48575, 98.032625, 101.92325, 96.29825, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:00.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.470024,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:00.234Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.04825, 102.813875, 102.86075, 106.470125, 106.42325, 106.61075, 107.220125, 107.36075, 103.470125,
            101.126375, 103.7045, 97.470125, 95.876375, 96.9545, 97.142, 97.7045, 97.845125, 97.79825, 98.876375,
            100.892, 101.876375, 101.8295, 100.517, 99.813875, 98.501375, 102.017, 96.392, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:43.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.69241,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:43.425Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.67325, 127.517, 127.3295, 124.892, 122.220125, 121.04825, 116.8295, 112.892, 108.157625, 104.8295,
            103.751375, 98.642, 96.157625, 97.845125, 117.017, 105.29825, 98.220125, 101.8295, 102.5795, 103.7045,
            102.29825, 102.11075, 101.876375, 99.86075, 98.876375, 102.2045, 96.720125, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:46.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.10185,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:46.371Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.782625, 112.517, 108.063875, 109.98575, 109.23575, 111.532625, 114.67325, 119.876375, 106.095125,
            110.313875, 111.438875, 101.032625, 99.157625, 98.17325, 98.17325, 100.001375, 99.017, 98.688875, 99.29825,
            101.17325, 102.48575, 101.688875, 100.04825, 99.720125, 98.54825, 102.251375, 96.720125, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:06.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.34557,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:06.980Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.782625, 126.11075, 124.79825, 121.470125, 116.313875, 114.5795, 110.876375, 111.48575, 107.642,
            105.626375, 105.86075, 128.642, 122.688875, 99.157625, 112.42325, 101.688875, 106.61075, 101.73575,
            102.11075, 102.720125, 102.063875, 101.8295, 100.470125, 99.720125, 98.73575, 102.392, 96.438875, 95.0795,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:04.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.974915,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:04.039Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.017, 104.782625, 101.73575, 104.313875, 107.126375, 110.688875, 105.626375, 104.688875, 103.61075,
            101.970125, 103.188875, 98.4545, 97.188875, 97.282625, 97.517, 98.782625, 97.282625, 97.376375, 98.501375,
            100.188875, 101.8295, 101.313875, 99.86075, 99.017, 97.845125, 101.876375, 96.29825, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:23.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.97986,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:23.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.892, 121.7045, 119.126375, 116.876375, 113.688875, 112.517, 108.720125, 106.61075, 105.2045, 101.876375,
            102.392, 106.79825, 110.8295, 98.782625, 107.595125, 106.142, 101.642, 100.563875, 101.032625, 101.782625,
            102.29825, 101.4545, 100.376375, 99.67325, 98.642, 103.001375, 96.48575, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:24.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.12692,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:24.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.2045, 132.813875, 130.095125, 125.0795, 122.876375, 120.532625, 117.29825, 114.907625, 110.313875,
            106.142, 105.017, 101.8295, 100.095125, 98.970125, 98.313875, 98.642, 99.11075, 98.73575, 99.11075, 101.267,
            102.532625, 102.251375, 100.470125, 99.767, 98.782625, 102.532625, 96.720125, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:26.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.94406,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:26.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.392, 124.61075, 122.36075, 118.892, 115.188875, 114.767, 112.095125, 109.04825, 105.9545, 102.438875,
            100.98575, 98.642, 97.095125, 115.001375, 103.04825, 108.251375, 107.267, 99.063875, 105.720125, 102.157625,
            103.23575, 102.5795, 100.79825, 99.813875, 98.54825, 101.970125, 96.48575, 95.4545,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:16.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.62714,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:16.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.9545, 114.767, 109.61075, 109.282625, 107.36075, 108.063875, 109.61075, 110.407625, 106.563875,
            104.54825, 102.86075, 112.3295, 114.907625, 100.04825, 108.5795, 105.907625, 101.220125, 102.67325,
            105.11075, 101.876375, 102.438875, 102.345125, 100.517, 99.438875, 98.4545, 102.017, 97.001375, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:09.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.5202,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:09.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.73575, 126.48575, 123.86075, 120.767, 119.595125, 115.7045, 111.5795, 112.517, 130.188875, 115.845125,
            103.001375, 102.86075, 98.54825, 103.42325, 102.157625, 99.813875, 99.438875, 98.595125, 99.720125,
            101.54825, 102.67325, 102.2045, 100.3295, 99.720125, 98.688875, 102.11075, 97.001375, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:03.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.69652,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:03.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.032625, 124.98575, 120.767, 117.11075, 116.032625, 113.782625, 112.095125, 108.11075, 104.54825,
            101.4545, 100.23575, 98.220125, 97.376375, 97.61075, 97.517, 98.0795, 98.126375, 97.892, 99.063875,
            100.751375, 101.92325, 101.407625, 100.04825, 99.438875, 98.501375, 102.157625, 96.907625, 95.4545,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:25.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.2911,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:25.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.11075, 124.42325, 122.54825, 119.782625, 118.7045, 114.626375, 111.9545, 115.188875, 127.3295,
            116.782625, 105.017, 106.845125, 102.29825, 104.126375, 100.001375, 99.813875, 99.063875, 98.407625, 99.017,
            100.892, 102.345125, 102.345125, 100.517, 99.813875, 98.73575, 102.392, 96.9545, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:56.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.35395,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:56.183Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.36075, 101.876375, 100.845125, 104.0795, 106.188875, 110.595125, 106.095125, 106.657625, 102.063875,
            100.98575, 102.67325, 97.98575, 96.532625, 98.501375, 98.501375, 100.001375, 98.688875, 97.42325, 98.876375,
            100.376375, 101.4545, 101.36075, 100.23575, 99.907625, 98.313875, 102.11075, 96.767, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:14.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 147.5027,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:14.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.720125, 140.782625, 139.845125, 135.251375, 127.61075, 124.938875, 122.876375, 123.67325, 123.438875,
            117.532625, 113.4545, 110.313875, 104.36075, 102.813875, 101.220125, 100.23575, 99.67325, 97.98575,
            99.063875, 100.892, 102.251375, 101.92325, 100.42325, 99.532625, 98.407625, 102.392, 96.813875, 95.54825,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:55.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.09966,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:55.203Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.48575, 109.3295, 105.720125, 107.501375, 106.61075, 110.92325, 107.501375, 108.2045, 104.73575, 102.767,
            105.813875, 98.17325, 97.095125, 104.501375, 100.470125, 99.720125, 101.54825, 98.17325, 100.61075,
            101.36075, 101.8295, 101.54825, 100.142, 99.29825, 98.17325, 101.782625, 96.5795, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:22.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.07764,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:22.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.23575, 131.8295, 130.3295, 127.845125, 125.36075, 120.813875, 118.001375, 114.2045, 118.657625,
            110.313875, 106.61075, 103.7045, 103.892, 99.9545, 105.5795, 101.54825, 105.907625, 98.4545, 102.392,
            105.251375, 102.813875, 102.063875, 100.7045, 100.095125, 98.876375, 102.11075, 96.720125, 95.17325,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:10.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.42844,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:10.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.29825, 115.517, 108.813875, 107.642, 108.157625, 110.220125, 108.438875, 106.7045, 105.392, 102.063875,
            100.517, 110.220125, 106.001375, 98.032625, 112.3295, 106.79825, 99.29825, 100.7045, 101.970125, 102.157625,
            102.9545, 102.720125, 100.3295, 99.767, 98.501375, 102.2045, 96.86075, 95.4545,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:31.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.67678,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:31.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.61075, 118.7045, 115.79825, 112.188875, 109.095125, 110.4545, 106.282625, 105.251375, 102.5795,
            100.751375, 102.345125, 99.345125, 97.98575, 98.126375, 99.67325, 99.11075, 99.251375, 98.73575, 98.876375,
            100.892, 101.970125, 101.92325, 100.23575, 99.720125, 98.688875, 102.157625, 97.04825, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:08:58.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.23112,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:08:58.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.642, 122.126375, 119.126375, 113.54825, 111.67325, 109.61075, 116.970125, 123.720125, 102.86075,
            99.345125, 100.282625, 97.79825, 97.282625, 97.892, 97.79825, 99.017, 99.67325, 98.0795, 98.595125,
            100.7045, 102.29825, 102.157625, 100.61075, 99.907625, 98.92325, 103.001375, 96.767, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:13.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 148.23952,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:13.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            145.23575, 141.48575, 140.595125, 136.470125, 132.48575, 128.54825, 124.845125, 124.657625, 119.8295,
            115.845125, 115.517, 110.688875, 111.063875, 104.688875, 102.767, 102.532625, 99.86075, 98.54825,
            104.407625, 101.407625, 102.11075, 102.29825, 100.470125, 100.188875, 99.345125, 103.7045, 98.313875,
            95.688875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:52.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.91243,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:52.257Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.642, 131.267, 129.063875, 128.126375, 127.657625, 124.470125, 122.92325, 118.79825, 113.642, 111.063875,
            106.79825, 104.876375, 103.23575, 100.001375, 98.782625, 99.813875, 98.267, 98.313875, 98.92325, 100.938875,
            102.392, 101.73575, 100.938875, 99.9545, 98.54825, 102.48575, 97.04825, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:57.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.379265,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:57.167Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.642, 102.438875, 103.142, 108.157625, 108.251375, 110.642, 106.470125, 108.345125, 105.67325, 103.98575,
            102.11075, 98.642, 96.626375, 98.267, 99.157625, 99.767, 98.54825, 98.032625, 99.063875, 100.563875,
            102.11075, 101.92325, 100.23575, 99.532625, 98.8295, 102.2045, 96.86075, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:12.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.58325,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:12.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 109.563875, 106.04825, 109.23575, 108.251375, 110.54825, 106.657625, 106.892, 113.4545,
            102.157625, 102.251375, 104.126375, 106.095125, 99.48575, 102.67325, 104.970125, 100.23575, 97.751375,
            105.48575, 102.532625, 102.67325, 101.970125, 101.4545, 100.142, 98.642, 102.063875, 96.720125, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:32.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.12124,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:32.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.54825, 108.48575, 107.36075, 108.345125, 107.17325, 111.626375, 108.9545, 108.392, 106.04825, 103.7045,
            108.345125, 114.063875, 108.2045, 105.063875, 101.782625, 101.17325, 100.845125, 98.688875, 99.438875,
            100.938875, 102.5795, 101.73575, 100.23575, 99.720125, 98.313875, 102.438875, 96.720125, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:05.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.12013,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:05.019Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.0795, 125.407625, 123.767, 118.470125, 115.517, 114.626375, 113.73575, 105.767, 102.767, 102.86075,
            104.267, 99.67325, 100.282625, 97.98575, 97.79825, 98.032625, 97.845125, 97.938875, 98.126375, 100.470125,
            101.73575, 101.407625, 100.23575, 99.5795, 98.4545, 101.92325, 96.767, 95.501375,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:01.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.73935,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:01.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.2045, 131.36075, 127.04825, 122.407625, 120.29825, 118.376375, 114.017, 111.438875, 124.751375,
            122.54825, 115.517, 109.657625, 99.86075, 100.001375, 100.3295, 100.3295, 98.970125, 98.267, 99.67325,
            101.17325, 102.532625, 101.970125, 100.657625, 99.767, 98.407625, 102.251375, 96.813875, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:54.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.15782,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:54.222Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.23575, 124.563875, 121.7045, 117.9545, 114.720125, 112.04825, 110.54825, 106.04825, 103.61075, 101.642,
            102.5795, 98.4545, 97.7045, 104.313875, 104.17325, 101.642, 102.2045, 101.126375, 103.470125, 104.0795,
            103.142, 102.2045, 100.938875, 99.67325, 98.501375, 101.54825, 96.67325, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:48.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.288925,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:48.332Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.720125, 104.220125, 102.626375, 106.188875, 106.517, 113.032625, 108.907625, 109.470125, 104.4545,
            101.642, 99.532625, 97.04825, 95.92325, 96.48575, 101.313875, 98.595125, 98.4545, 98.313875, 98.876375,
            100.79825, 101.876375, 101.73575, 100.61075, 99.907625, 98.642, 102.017, 96.5795, 95.220125,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:19.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.06953,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:19.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.688875, 124.751375, 119.876375, 116.970125, 113.642, 111.532625, 108.48575, 109.7045, 110.267,
            102.157625, 100.79825, 101.313875, 106.98575, 99.438875, 109.751375, 106.61075, 101.126375, 97.938875,
            106.98575, 103.23575, 102.86075, 102.251375, 100.517, 99.86075, 98.73575, 102.392, 96.9545, 95.313875,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:40.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.19956,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:40.480Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.4545, 118.42325, 115.188875, 111.345125, 109.751375, 111.767, 106.282625, 103.563875, 103.657625,
            101.595125, 106.79825, 101.501375, 101.0795, 100.98575, 101.313875, 100.563875, 98.970125, 98.36075,
            98.73575, 100.79825, 101.8295, 101.8295, 100.282625, 99.532625, 98.267, 101.92325, 96.5795, 95.17325,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:03.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.03536,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:03.054Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.767, 116.17325, 113.267, 108.48575, 106.657625, 118.376375, 115.42325, 105.813875, 121.61075, 115.61075,
            108.11075, 100.563875, 100.751375, 100.282625, 100.517, 99.251375, 98.126375, 98.220125, 99.392, 100.845125,
            101.876375, 101.126375, 100.188875, 99.48575, 98.407625, 101.407625, 96.392, 95.267,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:00.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.21938,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:10:00.109Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            140.54825, 133.892, 131.17325, 128.8295, 124.7045, 122.876375, 122.876375, 117.392, 113.688875, 111.345125,
            109.3295, 104.73575, 99.720125, 98.4545, 97.61075, 97.98575, 96.67325, 97.3295, 98.688875, 101.032625,
            101.782625, 101.126375, 99.9545, 99.5795, 98.36075, 102.29825, 96.5795, 95.407625,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:34.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.98848,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:34.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.095125, 111.392, 108.2045, 110.4545, 109.892, 110.032625, 121.142, 117.11075, 118.79825, 103.751375,
            106.04825, 100.188875, 100.517, 99.2045, 100.79825, 101.267, 98.642, 97.98575, 99.11075, 100.517,
            101.688875, 102.813875, 100.376375, 99.720125, 98.970125, 102.2045, 96.67325, 95.36075,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:49.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.906364,
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:09:49.312Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 116.92325, 113.595125, 111.11075, 111.157625, 113.595125, 110.54825, 117.720125, 104.595125,
            104.267, 98.688875, 104.54825, 101.876375, 99.5795, 100.376375, 100.563875, 99.67325, 100.3295, 100.282625,
            101.267, 102.67325, 102.532625, 100.470125, 100.001375, 99.157625, 103.563875, 97.751375, 95.4545,
        ],
        latitude: 37.4405815,
        longitude: -122.5333942,
    },
    {
        timestamp: '2025-08-29T23:11:26.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 145.70192,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:26.488Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.438875, 137.267, 132.767, 129.5795, 127.23575, 125.595125, 121.892, 119.8295, 117.48575, 112.61075,
            109.98575, 106.845125, 102.532625, 100.657625, 99.907625, 100.79825, 100.376375, 98.782625, 100.42325,
            101.970125, 102.29825, 102.017, 100.7045, 99.813875, 99.017, 104.92325, 97.7045, 95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:22.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.08246,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:22.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.532625, 128.4545, 125.54825, 123.438875, 120.813875, 117.86075, 113.73575, 111.251375, 109.142,
            106.04825, 104.032625, 101.970125, 97.845125, 100.517, 99.157625, 102.2045, 100.23575, 98.92325, 102.392,
            103.282625, 101.970125, 102.11075, 100.095125, 99.345125, 98.313875, 101.642, 96.5795, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:11.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 153.64139,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:11.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            151.3295, 146.595125, 145.188875, 140.126375, 135.345125, 130.282625, 130.188875, 126.48575, 123.720125,
            121.376375, 118.001375, 115.282625, 110.92325, 106.3295, 103.282625, 102.626375, 99.767, 99.2045, 99.813875,
            101.501375, 101.970125, 102.11075, 100.470125, 99.157625, 98.36075, 102.157625, 97.04825, 95.92325,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:16.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.318184,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:16.671Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.001375, 114.438875, 110.92325, 108.29825, 107.17325, 107.642, 105.9545, 106.095125, 105.67325,
            101.688875, 102.813875, 100.938875, 98.688875, 98.8295, 98.17325, 98.688875, 98.220125, 97.79825, 98.73575,
            101.407625, 102.251375, 102.157625, 99.907625, 99.251375, 98.688875, 101.782625, 96.720125, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:18.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.70816,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:18.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.017, 121.892, 119.220125, 114.438875, 114.345125, 111.86075, 107.17325, 106.61075, 105.017, 103.23575,
            102.813875, 102.063875, 98.876375, 101.876375, 98.313875, 99.29825, 98.36075, 98.501375, 99.9545, 101.8295,
            102.11075, 101.8295, 99.907625, 99.9545, 98.595125, 101.970125, 96.48575, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:40.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.558304,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:40.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.157625, 103.938875, 100.04825, 102.11075, 103.79825, 108.438875, 103.751375, 103.892, 102.11075,
            108.157625, 108.48575, 103.517, 115.845125, 109.42325, 99.767, 101.642, 100.23575, 103.470125, 100.938875,
            101.032625, 102.017, 101.407625, 100.563875, 100.23575, 98.73575, 102.67325, 96.157625, 95.17325,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:36.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.941475,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:36.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.54825, 116.92325, 112.61075, 109.61075, 109.001375, 110.92325, 105.9545, 105.907625, 104.407625,
            102.251375, 106.282625, 103.563875, 97.98575, 98.876375, 99.5795, 100.142, 98.642, 98.0795, 99.67325,
            101.126375, 102.157625, 103.001375, 100.892, 100.142, 98.92325, 103.04825, 96.720125, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:59.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.33897,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:59.984Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.517, 123.720125, 121.7045, 117.813875, 117.392, 116.407625, 108.626375, 108.813875, 106.61075,
            103.376375, 100.938875, 100.517, 105.251375, 100.001375, 99.5795, 100.79825, 100.7045, 99.907625,
            100.938875, 102.720125, 102.532625, 101.970125, 100.282625, 99.67325, 98.73575, 102.67325, 96.767,
            95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:35.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.29828,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:35.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.5795, 120.392, 115.563875, 111.907625, 111.438875, 110.032625, 105.345125, 105.626375, 103.188875,
            107.126375, 105.720125, 101.595125, 99.86075, 100.282625, 99.5795, 101.313875, 99.67325, 98.267, 99.157625,
            100.42325, 102.345125, 102.438875, 100.3295, 99.67325, 98.4545, 102.2045, 96.251375, 95.17325,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:38.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.06537,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:38.390Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.892, 134.407625, 131.501375, 130.142, 126.767, 124.517, 122.36075, 119.73575, 116.17325, 112.938875,
            109.938875, 106.001375, 109.563875, 100.142, 100.3295, 101.642, 100.3295, 100.42325, 106.376375, 101.782625,
            102.626375, 102.9545, 100.470125, 100.23575, 99.063875, 103.282625, 97.04825, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:20.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.1883,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:20.722Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.157625, 115.42325, 112.04825, 108.48575, 107.126375, 108.907625, 106.376375, 106.517, 104.501375,
            100.61075, 99.11075, 102.438875, 103.470125, 103.376375, 97.845125, 98.970125, 99.438875, 99.251375,
            101.220125, 101.032625, 101.73575, 101.876375, 100.282625, 99.720125, 98.4545, 102.532625, 96.532625,
            95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:50.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.08718,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:50.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.188875, 103.282625, 101.220125, 103.563875, 104.876375, 108.2045, 105.86075, 105.67325, 103.42325,
            100.7045, 99.907625, 98.220125, 96.9545, 98.032625, 98.0795, 99.345125, 98.126375, 97.61075, 99.438875,
            101.407625, 102.626375, 101.92325, 100.563875, 99.767, 98.688875, 102.345125, 96.626375, 95.407625,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:41.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.95448,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:41.335Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 109.282625, 105.11075, 106.23575, 105.86075, 108.157625, 106.282625, 106.657625, 105.48575,
            101.642, 102.86075, 99.9545, 116.73575, 109.61075, 99.5795, 99.5795, 100.3295, 102.720125, 102.063875,
            101.92325, 101.688875, 101.876375, 100.657625, 100.517, 98.8295, 102.2045, 96.251375, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:15.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.55931,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:15.691Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.282625, 122.4545, 119.407625, 116.970125, 112.563875, 108.532625, 106.188875, 105.438875, 103.3295,
            102.720125, 103.188875, 101.688875, 98.220125, 98.595125, 98.220125, 99.11075, 99.345125, 98.501375,
            99.67325, 102.017, 102.157625, 102.017, 100.3295, 99.532625, 98.688875, 101.782625, 96.5795, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:25.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.530205,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:25.503Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.845125, 118.23575, 114.063875, 110.876375, 108.157625, 108.063875, 106.001375, 105.86075, 105.063875,
            100.7045, 99.063875, 97.142, 96.345125, 97.142, 97.79825, 100.3295, 98.36075, 97.470125, 99.720125,
            101.220125, 102.017, 101.501375, 100.001375, 99.345125, 98.220125, 101.4545, 96.251375, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:15.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.20831,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:15.816Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.563875, 127.23575, 124.3295, 119.220125, 118.3295, 116.313875, 113.267, 109.23575, 105.767, 104.17325,
            100.517, 99.67325, 97.142, 97.517, 97.188875, 97.517, 96.86075, 97.61075, 97.938875, 100.3295, 101.595125,
            101.688875, 100.563875, 99.5795, 98.4545, 102.438875, 96.5795, 95.4545,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:00.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.65984,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:00.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 127.470125, 123.720125, 119.8295, 118.938875, 116.4545, 115.095125, 113.267, 107.4545,
            104.36075, 102.017, 98.501375, 98.032625, 99.251375, 99.157625, 99.86075, 99.063875, 99.157625, 99.392,
            101.688875, 102.767, 102.017, 100.001375, 100.04825, 98.970125, 103.188875, 96.907625, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:13.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.38284,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:13.726Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.282625, 130.892, 128.407625, 125.501375, 121.98575, 119.032625, 117.438875, 115.282625, 110.73575,
            107.92325, 105.626375, 103.188875, 100.376375, 98.73575, 99.017, 98.970125, 98.36075, 98.407625, 99.017,
            100.657625, 101.92325, 102.017, 100.3295, 99.48575, 98.782625, 102.5795, 97.188875, 95.407625,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:16.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.4516,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:16.796Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.92325, 130.142, 128.688875, 124.79825, 123.29825, 119.688875, 114.438875, 111.9545, 108.157625,
            106.938875, 104.595125, 100.188875, 97.7045, 98.54825, 97.845125, 98.92325, 97.563875, 98.0795, 98.54825,
            101.220125, 101.92325, 101.92325, 100.04825, 99.532625, 98.313875, 101.8295, 96.907625, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:10.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.99051,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:10.781Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.42325, 128.688875, 126.532625, 122.970125, 121.188875, 116.688875, 119.688875, 118.563875, 112.095125,
            108.720125, 102.907625, 99.48575, 98.73575, 98.4545, 98.407625, 99.345125, 98.688875, 98.688875, 100.376375,
            100.938875, 101.92325, 101.876375, 100.517, 99.9545, 99.2045, 102.720125, 97.845125, 95.54825,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:51.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.916145,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:51.152Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.98575, 118.79825, 115.142, 112.04825, 110.970125, 110.688875, 105.9545, 106.376375, 101.876375,
            100.282625, 99.345125, 98.267, 97.657625, 98.032625, 97.79825, 99.157625, 98.4545, 98.126375, 99.2045,
            101.782625, 102.48575, 101.73575, 100.751375, 99.813875, 98.970125, 102.907625, 96.251375, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:29.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.67211,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:29.558Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.3295, 106.04825, 104.92325, 106.142, 109.04825, 116.8295, 108.251375, 107.595125, 117.392, 103.845125,
            109.23575, 102.86075, 101.4545, 102.720125, 102.86075, 104.126375, 100.98575, 99.438875, 99.86075,
            100.98575, 102.017, 101.8295, 100.376375, 99.813875, 98.407625, 102.11075, 96.626375, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:58.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.57329,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:58.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.767, 126.907625, 124.188875, 120.48575, 116.17325, 114.626375, 109.470125, 107.4545, 103.98575,
            105.063875, 103.470125, 99.157625, 98.126375, 100.3295, 99.767, 100.23575, 99.67325, 98.782625, 99.48575,
            101.595125, 102.907625, 102.29825, 100.001375, 99.907625, 98.970125, 102.626375, 97.095125, 95.407625,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:34.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.03772,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:34.464Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.54825, 116.970125, 113.54825, 110.876375, 108.438875, 110.501375, 107.032625, 106.61075, 105.017,
            102.626375, 105.67325, 100.7045, 98.032625, 101.267, 99.720125, 100.001375, 101.17325, 98.595125, 99.29825,
            100.751375, 101.970125, 102.907625, 100.61075, 99.67325, 98.688875, 102.251375, 96.720125, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:57.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.44239,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:57.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.938875, 119.876375, 118.376375, 112.892, 110.501375, 112.282625, 106.001375, 103.376375, 102.720125,
            105.11075, 104.54825, 97.7045, 97.751375, 98.782625, 98.407625, 100.001375, 98.36075, 98.4545, 98.8295,
            101.220125, 102.532625, 102.017, 100.188875, 99.48575, 98.501375, 101.595125, 96.86075, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:37.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.02222,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:37.410Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.032625, 118.3295, 113.642, 112.188875, 110.4545, 110.595125, 107.407625, 107.126375, 105.157625,
            102.345125, 103.376375, 98.8295, 111.813875, 103.657625, 98.970125, 101.970125, 98.970125, 99.017,
            106.751375, 101.17325, 101.92325, 102.767, 100.657625, 99.720125, 98.407625, 102.345125, 96.345125,
            95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:54.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.4486,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:54.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.98575, 108.86075, 105.2045, 106.7045, 107.267, 111.86075, 105.438875, 105.48575, 106.001375, 104.313875,
            102.392, 99.29825, 98.73575, 100.095125, 100.470125, 101.8295, 100.23575, 99.626375, 100.376375, 102.345125,
            102.67325, 102.532625, 100.7045, 100.001375, 99.2045, 102.438875, 97.657625, 95.501375,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:26.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.47062,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:26.613Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.517, 103.23575, 101.73575, 103.751375, 105.251375, 108.392, 106.470125, 105.9545, 103.282625, 101.0795,
            104.4545, 100.3295, 98.032625, 97.23575, 98.032625, 99.532625, 98.642, 98.032625, 99.813875, 101.36075,
            102.2045, 102.29825, 100.517, 100.095125, 98.4545, 102.157625, 96.532625, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:01.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.55779,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:01.949Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.17325, 119.4545, 116.970125, 114.767, 112.3295, 113.54825, 108.11075, 104.8295, 103.376375, 102.48575,
            100.657625, 99.438875, 98.313875, 99.767, 99.813875, 101.501375, 99.86075, 100.142, 99.626375, 101.36075,
            103.142, 102.767, 100.142, 100.04825, 98.688875, 102.345125, 97.23575, 95.17325,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:39.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.993004,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:39.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.86075, 115.470125, 112.751375, 111.017, 110.688875, 110.595125, 108.5795, 106.517, 104.220125,
            104.54825, 103.845125, 104.267, 101.17325, 101.595125, 100.563875, 99.5795, 98.501375, 98.126375, 99.9545,
            100.79825, 102.392, 101.4545, 100.282625, 99.907625, 98.595125, 102.2045, 96.29825, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:44.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.9118,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:44.281Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.23575, 121.23575, 119.220125, 118.845125, 115.79825, 115.095125, 110.267, 106.7045, 103.657625,
            101.17325, 103.282625, 104.407625, 114.11075, 109.938875, 100.7045, 101.4545, 102.5795, 108.626375,
            107.595125, 102.767, 102.720125, 101.782625, 100.42325, 99.720125, 98.36075, 102.2045, 96.2045, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:31.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.217636,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:31.519Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.032625, 110.407625, 107.595125, 106.001375, 104.970125, 111.157625, 106.42325, 104.782625, 102.29825,
            100.376375, 103.188875, 99.438875, 97.095125, 99.157625, 99.063875, 100.001375, 99.392, 98.0795, 99.251375,
            101.0795, 101.782625, 102.11075, 100.23575, 99.86075, 98.4545, 101.8295, 96.626375, 95.4545,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:23.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.42892,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:23.542Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.188875, 126.017, 121.517, 116.688875, 115.376375, 114.063875, 110.407625, 107.267, 106.282625,
            101.688875, 100.79825, 98.970125, 97.470125, 98.8295, 98.54825, 100.657625, 100.142, 98.8295, 101.8295,
            102.392, 102.11075, 101.8295, 100.376375, 99.626375, 98.407625, 102.251375, 96.157625, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:43.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.98633,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:43.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.267, 121.938875, 117.767, 114.532625, 110.688875, 113.73575, 110.0795, 108.345125, 104.642, 103.470125,
            105.5795, 99.251375, 103.04825, 102.5795, 100.23575, 102.392, 100.188875, 99.2045, 100.563875, 101.267,
            102.48575, 102.063875, 100.42325, 99.813875, 98.642, 101.782625, 96.67325, 95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:17.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.77368,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:17.777Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.767, 127.7045, 124.001375, 119.126375, 117.017, 115.095125, 111.063875, 109.517, 105.907625, 105.063875,
            102.063875, 117.67325, 98.876375, 98.220125, 97.7045, 98.4545, 97.751375, 100.282625, 100.188875, 105.29825,
            101.782625, 101.595125, 100.23575, 99.29825, 98.17325, 101.642, 96.438875, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:32.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.914734,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:32.500Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.501375, 115.751375, 111.907625, 107.4545, 108.29825, 110.595125, 114.017, 107.032625, 104.595125,
            104.73575, 102.157625, 99.438875, 98.8295, 99.626375, 101.17325, 100.04825, 101.0795, 99.626375, 99.67325,
            101.0795, 102.345125, 101.92325, 100.095125, 99.532625, 98.267, 102.063875, 96.29825, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:05.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.457726,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:05.875Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.3295, 106.7045, 105.5795, 108.345125, 108.392, 111.2045, 105.907625, 107.688875, 106.7045, 104.36075,
            102.2045, 98.92325, 97.845125, 101.876375, 99.11075, 99.626375, 99.017, 97.79825, 99.2045, 101.17325,
            102.29825, 102.29825, 100.563875, 99.626375, 98.688875, 102.5795, 97.3295, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:30.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.37065,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:30.539Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.063875, 128.642, 124.04825, 117.063875, 115.282625, 112.845125, 109.98575, 106.845125, 105.157625,
            103.42325, 100.98575, 99.2045, 97.376375, 98.032625, 97.751375, 99.063875, 98.267, 98.36075, 99.9545,
            100.98575, 102.392, 102.11075, 100.657625, 100.188875, 98.501375, 102.2045, 96.67325, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:14.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.54482,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:14.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.657625, 124.751375, 123.157625, 112.095125, 114.5795, 114.063875, 111.345125, 106.563875, 104.73575,
            103.98575, 101.267, 109.61075, 103.517, 96.48575, 106.61075, 99.29825, 102.907625, 101.4545, 101.501375,
            102.345125, 101.970125, 102.48575, 100.42325, 99.626375, 98.4545, 102.392, 96.438875, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:53.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.98087,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:53.113Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.67325, 125.313875, 120.017, 118.001375, 114.9545, 116.876375, 110.220125, 108.438875, 109.845125,
            112.751375, 105.48575, 98.876375, 100.142, 99.532625, 99.67325, 100.7045, 99.907625, 98.0795, 100.095125,
            102.017, 102.2045, 101.970125, 100.142, 99.438875, 98.407625, 101.782625, 96.813875, 95.4545,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:14.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.52728,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:14.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.813875, 121.61075, 120.017, 117.67325, 115.376375, 115.892, 109.79825, 107.970125, 104.642, 102.720125,
            103.7045, 101.313875, 97.79825, 98.782625, 99.017, 99.2045, 98.688875, 98.54825, 100.188875, 101.407625,
            102.2045, 101.8295, 100.282625, 99.532625, 98.876375, 102.11075, 97.095125, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:13.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.481026,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:13.851Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.892, 107.501375, 103.61075, 102.9545, 104.501375, 108.532625, 105.157625, 105.392, 101.4545, 100.470125,
            100.3295, 101.501375, 104.8295, 97.563875, 97.657625, 103.001375, 101.220125, 97.79825, 101.8295,
            101.501375, 102.251375, 102.063875, 100.23575, 99.48575, 98.501375, 102.157625, 96.532625, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:23.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.05923,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:23.667Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.126375, 118.7045, 114.720125, 111.532625, 110.267, 110.688875, 108.438875, 109.3295, 109.188875,
            102.11075, 100.470125, 98.501375, 96.907625, 100.563875, 98.54825, 99.720125, 97.79825, 97.79825, 98.54825,
            101.220125, 102.2045, 102.063875, 100.376375, 99.67325, 98.501375, 101.688875, 96.392, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:19.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.00137,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:19.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.7045, 108.767, 105.767, 108.767, 106.61075, 107.313875, 107.54825, 106.376375, 105.86075, 102.907625,
            101.54825, 101.36075, 98.688875, 98.642, 97.845125, 99.157625, 99.063875, 99.907625, 99.345125, 101.36075,
            102.11075, 101.970125, 100.3295, 99.86075, 98.595125, 102.392, 96.626375, 95.126375,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:45.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.87885,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:45.261Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.126375, 119.688875, 118.845125, 115.188875, 112.282625, 114.2045, 107.032625, 105.48575, 102.720125,
            101.126375, 102.017, 99.157625, 102.157625, 108.9545, 101.36075, 101.313875, 102.9545, 99.67325, 103.282625,
            103.470125, 102.251375, 101.876375, 100.3295, 99.767, 98.4545, 102.063875, 96.767, 95.407625,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:09.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.39261,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:09.800Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.220125, 101.8295, 101.501375, 103.142, 106.61075, 110.73575, 104.407625, 105.86075, 103.470125, 101.642,
            99.392, 98.17325, 101.36075, 98.267, 98.688875, 98.970125, 98.313875, 99.438875, 99.626375, 100.657625,
            102.345125, 102.251375, 100.7045, 100.282625, 98.8295, 102.720125, 97.095125, 95.407625,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:06.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.47373,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:06.855Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.438875, 107.73575, 104.36075, 106.001375, 109.282625, 112.3295, 105.11075, 105.9545, 104.17325,
            101.876375, 100.42325, 97.98575, 100.282625, 100.470125, 99.907625, 106.001375, 104.4545, 99.9545,
            109.001375, 106.61075, 102.29825, 102.345125, 100.938875, 100.282625, 98.876375, 102.251375, 96.767,
            95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:17.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.03822,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:17.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.3295, 120.907625, 117.438875, 114.438875, 111.11075, 109.845125, 107.032625, 105.532625, 103.79825,
            102.063875, 103.751375, 101.501375, 98.501375, 99.907625, 97.892, 100.188875, 98.4545, 98.032625, 99.813875,
            101.54825, 101.92325, 101.688875, 100.001375, 99.86075, 98.54825, 102.063875, 96.532625, 95.4545,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:20.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.96718,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:20.597Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.11075, 105.345125, 104.0795, 105.626375, 105.157625, 105.532625, 105.11075, 106.470125, 104.782625,
            102.86075, 103.751375, 100.79825, 98.642, 98.970125, 97.517, 100.470125, 99.392, 100.563875, 101.032625,
            102.48575, 102.767, 102.063875, 100.7045, 99.767, 98.36075, 102.29825, 96.392, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:03.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.74387,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:03.910Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.67325, 112.938875, 108.5795, 104.92325, 107.36075, 111.063875, 107.4545, 106.142, 103.470125,
            103.095125, 101.0795, 101.0795, 105.251375, 104.876375, 100.470125, 101.407625, 101.595125, 103.142,
            103.845125, 102.251375, 102.813875, 102.907625, 100.751375, 100.095125, 98.970125, 102.813875, 97.23575,
            95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:27.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.38194,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:27.593Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.001375, 116.876375, 115.563875, 114.813875, 111.48575, 111.2045, 110.126375, 108.9545, 104.8295,
            103.61075, 102.5795, 100.095125, 96.532625, 97.7045, 97.563875, 99.29825, 99.063875, 97.517, 100.04825,
            101.267, 102.29825, 102.017, 100.845125, 99.86075, 98.54825, 102.2045, 96.48575, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:24.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.990074,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:24.523Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.376375, 116.54825, 112.938875, 109.23575, 108.345125, 109.61075, 108.67325, 106.938875, 105.157625,
            102.251375, 100.04825, 97.188875, 96.2045, 97.657625, 98.126375, 100.188875, 99.392, 98.126375, 100.517,
            102.2045, 102.251375, 101.92325, 100.563875, 99.720125, 98.267, 101.876375, 96.063875, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:12.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.35252,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:12.871Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.48575, 130.845125, 122.73575, 115.517, 114.5795, 116.17325, 112.04825, 110.126375, 106.376375,
            104.688875, 101.970125, 102.017, 97.23575, 97.61075, 97.563875, 98.92325, 97.23575, 97.892, 99.017,
            100.7045, 101.73575, 101.36075, 100.282625, 99.392, 98.220125, 102.48575, 96.345125, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:19.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.042244,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:19.742Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.657625, 115.142, 111.063875, 109.98575, 109.751375, 110.501375, 107.8295, 107.032625, 103.282625,
            102.532625, 100.095125, 99.86075, 98.92325, 97.563875, 97.751375, 98.782625, 96.392, 98.220125, 98.595125,
            100.61075, 102.392, 101.970125, 100.282625, 99.907625, 98.4545, 102.017, 96.11075, 95.126375,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:08.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.5547,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:08.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.970125, 120.907625, 117.767, 116.595125, 113.642, 113.267, 109.61075, 108.86075, 105.626375, 103.470125,
            100.845125, 100.751375, 107.032625, 101.4545, 100.42325, 100.001375, 99.907625, 101.970125, 100.751375,
            102.9545, 102.67325, 103.095125, 100.3295, 99.720125, 98.501375, 102.251375, 96.813875, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:55.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.98383,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:55.078Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.73575, 124.23575, 118.563875, 117.2045, 115.938875, 114.813875, 110.267, 107.782625, 104.688875,
            101.4545, 100.001375, 98.17325, 96.907625, 98.4545, 99.767, 99.48575, 98.36075, 98.032625, 99.392,
            101.032625, 101.970125, 101.8295, 100.142, 99.532625, 98.407625, 102.29825, 97.001375, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:24.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.43913,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:24.652Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.767, 104.92325, 102.251375, 106.376375, 107.501375, 109.7045, 107.032625, 108.157625, 104.36075,
            100.657625, 99.017, 108.9545, 115.61075, 99.063875, 103.657625, 106.095125, 111.345125, 107.407625,
            104.36075, 102.392, 102.157625, 101.876375, 100.42325, 100.188875, 98.642, 102.9545, 96.67325, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:48.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.51147,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:48.207Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.892, 126.157625, 124.42325, 120.626375, 119.032625, 116.126375, 112.657625, 110.220125, 107.313875,
            103.142, 102.9545, 101.501375, 113.126375, 109.7045, 100.04825, 101.267, 102.29825, 103.001375, 106.095125,
            102.157625, 102.67325, 102.29825, 100.892, 99.9545, 98.688875, 102.251375, 96.29825, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:56.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.475746,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:56.058Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.79825, 112.79825, 108.813875, 109.376375, 109.188875, 112.142, 105.5795, 105.67325, 108.2045,
            118.657625, 115.42325, 104.407625, 104.8295, 101.782625, 101.4545, 101.126375, 100.751375, 99.345125,
            99.345125, 100.751375, 102.063875, 101.876375, 100.23575, 99.251375, 98.36075, 102.063875, 96.813875,
            95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:47.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.65602,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:47.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.17325, 123.813875, 120.767, 117.11075, 114.5795, 113.313875, 108.392, 107.126375, 104.267, 101.8295,
            100.095125, 102.767, 107.688875, 107.4545, 99.017, 99.907625, 99.9545, 100.142, 101.313875, 101.126375,
            102.2045, 101.407625, 100.001375, 99.345125, 98.220125, 101.73575, 96.438875, 95.17325,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:59.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.63191,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:59.003Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.063875, 129.345125, 127.7045, 123.67325, 122.313875, 118.892, 115.23575, 112.470125, 109.04825,
            106.282625, 102.532625, 101.782625, 110.501375, 110.876375, 99.720125, 104.17325, 101.36075, 101.0795,
            110.688875, 103.001375, 102.626375, 101.8295, 100.563875, 100.001375, 98.876375, 102.5795, 96.626375,
            95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:42.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.49982,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:42.316Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.188875, 125.4545, 123.345125, 117.532625, 115.04825, 115.142, 111.345125, 108.626375, 105.2045,
            101.595125, 101.92325, 99.392, 99.438875, 100.04825, 100.188875, 100.79825, 99.251375, 98.0795, 99.767,
            101.407625, 102.345125, 102.11075, 100.79825, 100.142, 99.2045, 103.04825, 96.86075, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:21.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.58998,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:21.578Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.3295, 136.04825, 131.54825, 123.392, 117.48575, 116.032625, 114.5795, 112.188875, 110.313875,
            105.813875, 103.657625, 102.157625, 97.79825, 99.063875, 98.267, 101.313875, 99.29825, 99.48575, 103.7045,
            103.938875, 102.720125, 102.345125, 100.517, 99.907625, 98.501375, 103.657625, 96.392, 95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:21.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.086365,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:21.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.5795, 114.157625, 109.892, 109.04825, 107.126375, 107.642, 106.282625, 105.48575, 107.73575, 100.563875,
            99.392, 100.142, 99.767, 103.845125, 98.642, 100.3295, 98.267, 98.595125, 100.001375, 101.4545, 102.345125,
            102.29825, 100.3295, 99.9545, 98.8295, 102.2045, 96.720125, 95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:22.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.54271,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:22.687Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.345125, 124.04825, 120.767, 118.517, 113.782625, 114.157625, 110.36075, 109.282625, 108.438875,
            101.688875, 98.501375, 109.3295, 111.017, 99.67325, 104.642, 105.392, 99.251375, 99.626375, 104.782625,
            102.29825, 102.626375, 101.92325, 100.376375, 99.5795, 98.642, 102.48575, 96.345125, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:25.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.46307,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:25.632Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.938875, 120.767, 115.470125, 112.845125, 109.3295, 110.36075, 106.938875, 105.626375, 105.29825,
            101.970125, 109.892, 123.907625, 102.48575, 100.657625, 109.892, 99.626375, 101.126375, 102.5795, 100.517,
            101.8295, 102.251375, 102.11075, 100.3295, 99.86075, 98.4545, 102.29825, 96.720125, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:02.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.96571,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:02.929Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.36075, 112.04825, 109.470125, 109.517, 109.98575, 111.438875, 107.032625, 105.392, 105.11075,
            101.595125, 101.642, 98.782625, 102.063875, 117.392, 109.61075, 100.7045, 107.501375, 103.79825, 103.188875,
            105.720125, 102.720125, 102.157625, 100.7045, 100.23575, 98.642, 102.720125, 96.720125, 95.17325,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:46.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.26726,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:46.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.5795, 123.626375, 119.36075, 114.5795, 113.220125, 114.438875, 107.970125, 107.407625, 103.7045,
            103.282625, 101.782625, 99.813875, 103.61075, 100.938875, 99.67325, 100.657625, 99.86075, 98.92325, 99.9545,
            101.501375, 102.251375, 101.595125, 100.142, 99.67325, 98.4545, 102.345125, 96.9545, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:52.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.4423,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:52.132Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.642, 120.9545, 114.251375, 111.9545, 123.907625, 122.17325, 108.813875, 115.095125, 111.86075, 104.642,
            103.282625, 99.11075, 99.767, 104.36075, 104.4545, 103.845125, 102.29825, 101.313875, 102.11075, 102.063875,
            102.48575, 101.8295, 100.470125, 99.767, 98.4545, 101.782625, 96.720125, 95.407625,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:49.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.777,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:49.187Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            112.845125, 106.563875, 104.17325, 107.126375, 106.376375, 111.017, 106.42325, 106.376375, 103.657625,
            102.720125, 102.438875, 99.063875, 102.2045, 109.001375, 102.9545, 102.063875, 103.61075, 100.376375,
            105.251375, 101.782625, 102.720125, 102.438875, 101.032625, 100.23575, 98.970125, 102.9545, 96.86075,
            95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:33.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.68588,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:33.484Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.251375, 124.892, 120.251375, 117.438875, 115.751375, 112.751375, 117.48575, 111.063875, 106.3295,
            113.92325, 103.142, 102.86075, 103.61075, 100.517, 108.5795, 104.267, 104.4545, 100.657625, 100.282625,
            101.407625, 102.626375, 103.001375, 100.79825, 100.470125, 99.017, 102.345125, 96.907625, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:12.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.53967,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:12.746Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.376375, 121.563875, 119.407625, 115.79825, 114.063875, 114.017, 108.9545, 106.3295, 104.688875,
            101.126375, 102.157625, 100.188875, 97.563875, 98.313875, 96.9545, 99.813875, 98.54825, 97.845125,
            98.876375, 101.267, 102.11075, 102.251375, 100.42325, 99.29825, 98.220125, 102.11075, 96.626375, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:28.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.38556,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:28.574Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.626375, 130.23575, 128.313875, 126.532625, 121.98575, 118.751375, 116.501375, 113.876375, 110.126375,
            105.11075, 103.98575, 101.17325, 98.220125, 99.907625, 100.845125, 100.376375, 99.063875, 98.17325,
            99.813875, 101.0795, 101.8295, 102.157625, 100.657625, 99.86075, 98.73575, 102.767, 96.48575, 95.220125,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:07.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.97634,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:07.835Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.876375, 108.017, 105.017, 107.642, 107.501375, 111.9545, 106.001375, 106.563875, 104.8295, 104.36075,
            103.001375, 97.61075, 113.595125, 107.73575, 99.017, 100.938875, 98.407625, 105.345125, 102.017, 102.720125,
            102.017, 102.157625, 102.017, 100.095125, 98.4545, 101.8295, 96.5795, 95.36075,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:04.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.79885,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:11:04.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.563875, 111.2045, 107.970125, 108.157625, 109.095125, 110.642, 107.17325, 107.73575, 104.642, 103.3295,
            99.86075, 99.11075, 100.517, 99.345125, 98.876375, 100.3295, 99.157625, 98.970125, 99.017, 100.892,
            101.73575, 101.92325, 100.142, 99.720125, 98.17325, 102.532625, 96.767, 95.267,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:18.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.28277,
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:10:18.761Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.42325, 113.4545, 109.04825, 106.04825, 108.626375, 112.282625, 104.782625, 104.782625, 103.23575,
            106.23575, 103.938875, 119.313875, 108.392, 99.907625, 99.532625, 100.376375, 100.282625, 99.767, 112.23575,
            103.61075, 102.157625, 103.142, 100.470125, 99.720125, 98.73575, 102.2045, 97.04825, 95.313875,
        ],
        latitude: 37.4405797,
        longitude: -122.5333943,
    },
    {
        timestamp: '2025-08-29T23:12:03.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.181694,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:03.785Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.313875, 118.751375, 114.720125, 112.095125, 110.220125, 112.7045, 105.48575, 105.767, 105.813875,
            102.251375, 105.67325, 97.892, 96.813875, 98.313875, 97.376375, 99.532625, 100.04825, 97.376375, 99.9545,
            101.595125, 102.5795, 102.11075, 100.517, 99.907625, 98.407625, 102.813875, 96.67325, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:55.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.035805,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:55.933Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.157625, 108.392, 104.4545, 106.657625, 107.642, 113.407625, 106.7045, 108.251375, 105.626375, 102.9545,
            101.8295, 97.892, 96.11075, 98.688875, 97.517, 98.220125, 98.642, 97.563875, 98.595125, 101.17325,
            101.92325, 101.73575, 100.376375, 99.392, 98.126375, 101.54825, 96.5795, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:11.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.91936,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:11.636Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.61075, 122.642, 119.73575, 116.4545, 113.8295, 113.595125, 108.2045, 106.563875, 106.23575, 102.11075,
            101.688875, 98.73575, 97.892, 99.251375, 99.345125, 99.67325, 100.23575, 98.267, 101.36075, 102.345125,
            102.626375, 102.2045, 100.04825, 99.626375, 98.4545, 101.642, 96.767, 95.501375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:14.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.18794,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:14.582Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.04825, 109.001375, 108.017, 107.970125, 109.845125, 115.42325, 107.17325, 106.188875, 103.938875,
            102.392, 102.29825, 102.017, 99.11075, 99.157625, 99.345125, 99.345125, 99.392, 98.501375, 100.282625,
            103.142, 102.907625, 102.907625, 101.0795, 100.188875, 98.642, 102.392, 96.532625, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:52.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.38297,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:52.988Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.376375, 117.063875, 112.892, 108.9545, 110.17325, 115.938875, 104.642, 105.017, 104.36075, 104.876375,
            104.8295, 99.157625, 98.032625, 100.79825, 100.142, 100.61075, 100.001375, 98.0795, 101.032625, 101.782625,
            102.767, 102.392, 100.61075, 99.67325, 98.73575, 101.970125, 96.720125, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:12.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.24678,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:12.617Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.9545, 121.095125, 119.688875, 115.517, 112.563875, 114.063875, 109.563875, 108.392, 104.8295, 104.267,
            104.267, 100.938875, 99.48575, 99.063875, 98.92325, 100.751375, 99.907625, 99.063875, 101.501375,
            102.907625, 103.04825, 102.813875, 100.563875, 99.9545, 99.063875, 102.392, 97.3295, 95.501375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:35.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.10581,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:35.320Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.688875, 114.48575, 112.001375, 107.642, 107.876375, 113.4545, 106.845125, 106.938875, 105.2045,
            102.67325, 102.017, 97.751375, 97.517, 97.751375, 98.8295, 99.9545, 100.61075, 98.8295, 100.61075,
            101.501375, 101.782625, 103.04825, 100.42325, 99.86075, 98.92325, 102.157625, 96.532625, 95.126375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:04.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.16849,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:04.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.938875, 127.61075, 126.5795, 121.61075, 116.782625, 119.220125, 113.126375, 111.2045, 108.345125,
            103.892, 103.61075, 99.063875, 97.470125, 97.938875, 98.8295, 99.626375, 99.907625, 98.032625, 99.345125,
            101.876375, 102.392, 102.251375, 100.470125, 99.86075, 98.54825, 102.767, 97.23575, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:38.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.31517,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:38.265Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.142, 125.8295, 125.73575, 122.407625, 118.23575, 118.095125, 112.23575, 109.142, 106.282625, 101.73575,
            101.407625, 99.48575, 97.188875, 98.970125, 98.54825, 99.767, 99.157625, 98.36075, 99.813875, 101.782625,
            102.2045, 103.04825, 100.845125, 100.095125, 99.532625, 103.188875, 96.813875, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:41.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.45157,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:41.210Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.61075, 128.267, 120.67325, 118.938875, 114.157625, 116.0795, 110.267, 108.86075, 107.970125, 102.157625,
            102.626375, 97.751375, 97.142, 100.001375, 98.970125, 99.813875, 101.688875, 98.267, 100.938875, 102.11075,
            102.2045, 102.438875, 100.79825, 100.376375, 99.017, 102.86075, 96.813875, 95.17325,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:36.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.6797,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:36.300Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.8295, 116.642, 114.767, 114.532625, 111.907625, 113.17325, 108.67325, 107.4545, 105.48575, 102.251375,
            101.970125, 98.267, 96.48575, 97.3295, 98.8295, 100.095125, 99.9545, 98.220125, 100.517, 101.876375,
            102.48575, 102.9545, 100.892, 100.23575, 99.157625, 102.907625, 97.142, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:08.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.00054,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:08.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.813875, 105.9545, 102.767, 103.892, 107.0795, 113.4545, 104.92325, 106.188875, 104.267, 101.36075,
            102.017, 97.61075, 96.767, 100.23575, 98.36075, 98.313875, 98.126375, 97.751375, 100.3295, 101.8295,
            102.2045, 102.017, 100.517, 99.5795, 98.54825, 102.345125, 96.532625, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:28.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.56981,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:28.324Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.313875, 118.98575, 117.438875, 115.142, 112.7045, 109.42325, 107.876375, 107.970125, 106.79825,
            103.095125, 100.98575, 98.17325, 96.720125, 97.845125, 98.595125, 100.470125, 99.9545, 98.595125, 99.251375,
            101.876375, 102.5795, 102.345125, 100.517, 99.86075, 98.126375, 102.11075, 96.532625, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:51.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.32237,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:51.023Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.845125, 126.86075, 122.8295, 121.04825, 117.626375, 118.470125, 111.48575, 109.142, 108.29825,
            103.376375, 102.063875, 98.36075, 96.626375, 98.313875, 99.67325, 100.001375, 99.438875, 98.0795,
            101.220125, 101.73575, 102.2045, 101.92325, 100.188875, 99.438875, 98.407625, 102.532625, 96.5795,
            95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:31.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.641846,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:31.394Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.017, 113.36075, 108.2045, 107.595125, 106.845125, 110.4545, 107.54825, 105.813875, 103.98575, 101.642,
            103.938875, 99.29825, 97.376375, 99.392, 99.813875, 100.376375, 99.9545, 98.36075, 99.767, 102.11075,
            102.48575, 102.11075, 100.7045, 100.04825, 98.4545, 102.532625, 96.392, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:42.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.8686,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:42.191Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.251375, 126.017, 122.73575, 117.532625, 115.61075, 115.657625, 110.595125, 108.345125, 105.907625,
            100.657625, 100.892, 97.517, 97.282625, 98.126375, 99.345125, 99.063875, 98.876375, 98.032625, 99.67325,
            102.063875, 102.063875, 101.8295, 100.376375, 99.48575, 98.36075, 102.29825, 97.79825, 95.876375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:30.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.66816,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:30.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.3295, 118.98575, 115.79825, 112.142, 109.657625, 112.188875, 107.54825, 106.517, 104.313875, 101.267,
            103.79825, 98.642, 97.892, 99.251375, 99.392, 101.267, 100.98575, 98.8295, 100.04825, 102.017, 102.392,
            102.157625, 100.563875, 99.626375, 98.642, 101.595125, 96.29825, 95.0795,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:46.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.82259,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:46.117Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.267, 124.095125, 120.2045, 118.3295, 117.157625, 116.73575, 111.157625, 108.5795, 107.4545, 102.392,
            102.017, 97.892, 97.517, 98.688875, 99.86075, 100.188875, 100.657625, 98.642, 101.595125, 104.313875,
            102.5795, 102.48575, 100.188875, 99.86075, 98.73575, 102.017, 96.67325, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:57.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.19831,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:57.894Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.845125, 109.657625, 106.470125, 106.23575, 106.563875, 112.188875, 103.7045, 103.892, 104.501375,
            101.8295, 103.04825, 98.126375, 96.063875, 98.876375, 99.392, 100.563875, 99.392, 98.36075, 99.48575,
            101.54825, 102.29825, 102.017, 100.470125, 99.67325, 98.501375, 101.970125, 96.813875, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:07.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.80379,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:07.710Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.9545, 114.907625, 110.970125, 108.532625, 109.282625, 113.36075, 106.751375, 107.73575, 106.142,
            103.98575, 103.7045, 98.782625, 96.720125, 98.407625, 97.470125, 98.92325, 97.79825, 97.42325, 101.267,
            101.220125, 102.29825, 101.36075, 100.563875, 99.67325, 98.313875, 101.688875, 96.29825, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:45.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 147.96437,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:45.136Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            146.501375, 139.751375, 136.001375, 132.251375, 130.79825, 128.032625, 126.67325, 124.23575, 120.392,
            118.23575, 112.095125, 110.36075, 104.032625, 101.73575, 101.36075, 100.79825, 100.892, 99.29825,
            101.032625, 102.29825, 102.813875, 103.142, 100.79825, 99.907625, 98.970125, 103.282625, 97.751375,
            95.501375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:10.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.79086,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:10.656Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.720125, 125.267, 119.17325, 114.392, 113.267, 112.79825, 109.188875, 107.220125, 104.313875, 102.11075,
            101.126375, 99.532625, 98.267, 99.67325, 98.73575, 99.157625, 98.782625, 98.0795, 99.9545, 102.438875,
            102.29825, 102.063875, 100.095125, 99.48575, 98.407625, 103.470125, 96.86075, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:56.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.11273,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:56.914Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.267, 117.438875, 115.61075, 109.98575, 106.938875, 112.3295, 106.892, 106.095125, 103.98575, 101.17325,
            103.563875, 98.220125, 97.61075, 100.282625, 99.5795, 100.23575, 99.626375, 98.36075, 99.86075, 101.220125,
            102.157625, 102.157625, 100.7045, 100.04825, 98.876375, 102.720125, 96.813875, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:25.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.37124,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:25.378Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.4545, 113.73575, 109.751375, 107.0795, 106.42325, 108.9545, 105.251375, 104.8295, 106.001375,
            104.501375, 103.657625, 100.23575, 98.4545, 98.92325, 99.767, 100.23575, 100.751375, 98.8295, 101.0795,
            102.532625, 102.720125, 102.5795, 100.79825, 99.438875, 98.642, 102.157625, 96.48575, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:54.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.4876,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:54.953Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.36075, 110.970125, 105.67325, 106.845125, 109.657625, 115.188875, 106.04825, 106.188875, 104.642,
            101.126375, 99.907625, 98.0795, 95.642, 97.845125, 97.3295, 98.267, 97.892, 97.7045, 99.11075, 101.220125,
            101.73575, 101.8295, 100.42325, 99.392, 98.642, 102.11075, 96.720125, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:31.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.09094,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:31.269Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.36075, 128.970125, 128.782625, 127.376375, 121.79825, 118.376375, 115.98575, 109.657625, 107.782625,
            105.157625, 100.892, 98.267, 98.642, 99.5795, 98.73575, 99.48575, 100.04825, 99.438875, 99.532625,
            102.626375, 102.767, 102.157625, 100.517, 99.86075, 98.876375, 102.86075, 98.313875, 95.688875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:23.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.3436,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:23.414Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.0795, 126.532625, 122.0795, 120.063875, 116.126375, 116.313875, 113.73575, 109.657625, 109.282625,
            104.54825, 103.470125, 101.407625, 98.54825, 101.0795, 101.126375, 101.501375, 102.063875, 100.517,
            100.79825, 102.017, 103.142, 103.095125, 100.79825, 100.001375, 99.017, 102.251375, 96.48575, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:24.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.69308,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:24.398Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.126375, 109.470125, 105.626375, 107.0795, 107.876375, 109.98575, 106.282625, 107.8295, 107.313875,
            103.517, 104.501375, 103.095125, 100.001375, 100.376375, 100.23575, 101.0795, 101.595125, 100.376375,
            100.79825, 102.11075, 102.67325, 103.04825, 100.938875, 99.86075, 98.970125, 103.517, 97.282625, 95.54825,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:26.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.795654,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:26.363Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.767, 105.9545, 105.11075, 106.751375, 106.751375, 107.17325, 107.782625, 106.892, 105.017, 105.392,
            104.595125, 98.407625, 97.98575, 100.23575, 98.595125, 101.032625, 101.36075, 98.73575, 101.407625,
            102.48575, 102.345125, 102.392, 100.845125, 100.001375, 98.595125, 102.2045, 96.67325, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:27.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.10881,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:27.343Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            109.376375, 104.032625, 101.54825, 106.23575, 106.142, 105.5795, 106.095125, 106.61075, 105.063875,
            107.17325, 105.626375, 98.4545, 97.3295, 101.36075, 98.642, 102.392, 100.892, 98.73575, 100.142, 103.001375,
            102.626375, 102.86075, 100.470125, 99.9545, 98.73575, 102.720125, 97.04825, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:32.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.75748,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:32.250Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.845125, 130.751375, 129.720125, 130.61075, 128.126375, 125.17325, 122.970125, 118.23575, 117.626375,
            110.8295, 110.267, 104.36075, 99.48575, 100.001375, 98.8295, 98.782625, 98.73575, 98.688875, 98.8295,
            101.876375, 102.345125, 101.8295, 100.470125, 99.767, 98.8295, 103.517, 96.626375, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:48.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.73715,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:48.082Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.92325, 110.595125, 107.782625, 107.126375, 106.98575, 116.501375, 105.720125, 104.36075, 105.9545,
            99.813875, 99.532625, 97.3295, 96.67325, 98.0795, 98.36075, 99.251375, 98.126375, 98.220125, 100.657625,
            101.36075, 102.017, 102.67325, 100.188875, 99.063875, 98.17325, 102.017, 96.767, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:00.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.073074,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:00.839Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.017, 113.8295, 109.79825, 105.392, 107.92325, 114.29825, 107.4545, 105.767, 105.626375, 102.017,
            99.86075, 98.126375, 96.813875, 98.126375, 99.157625, 101.642, 98.54825, 98.0795, 99.532625, 101.54825,
            102.48575, 101.92325, 100.282625, 99.9545, 98.54825, 103.001375, 97.142, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:44.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.359535,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:44.156Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.7045, 111.720125, 107.4545, 104.36075, 107.73575, 116.220125, 105.11075, 103.79825, 104.501375,
            99.48575, 98.4545, 97.938875, 97.657625, 98.36075, 99.67325, 99.392, 100.04825, 99.251375, 99.813875,
            101.92325, 102.438875, 102.813875, 100.3295, 99.626375, 98.36075, 102.063875, 97.3295, 95.876375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:33.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.77527,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:33.355Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.438875, 127.657625, 125.313875, 121.845125, 119.501375, 116.126375, 111.063875, 108.532625, 104.4545,
            103.001375, 102.813875, 98.54825, 97.095125, 98.73575, 99.251375, 99.86075, 99.2045, 97.845125, 100.04825,
            101.4545, 102.29825, 102.48575, 100.23575, 99.720125, 98.92325, 102.907625, 96.86075, 95.126375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:32.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.240585,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:32.375Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.86075, 115.563875, 109.98575, 109.23575, 106.98575, 106.04825, 104.642, 103.938875, 103.470125,
            100.3295, 100.7045, 97.376375, 97.001375, 100.3295, 98.313875, 98.876375, 99.2045, 97.79825, 99.5795,
            101.73575, 102.438875, 101.782625, 100.142, 99.767, 98.595125, 101.92325, 96.48575, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:27.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.24521,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:27.468Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.407625, 131.54825, 128.8295, 125.876375, 122.642, 118.188875, 114.11075, 111.29825, 109.7045, 106.142,
            100.892, 99.11075, 98.642, 99.813875, 99.86075, 100.282625, 100.751375, 99.29825, 100.001375, 101.642,
            102.157625, 101.688875, 100.095125, 99.345125, 98.407625, 101.688875, 96.907625, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:39.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.5598,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:39.121Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.595125, 112.98575, 108.532625, 104.8295, 106.892, 113.92325, 105.626375, 104.501375, 106.845125,
            100.188875, 100.563875, 98.0795, 96.767, 97.3295, 100.42325, 99.720125, 98.17325, 98.313875, 100.98575,
            102.67325, 101.782625, 102.345125, 100.188875, 99.9545, 98.17325, 100.98575, 96.345125, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:37.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.48976,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:37.285Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.157625, 127.23575, 123.626375, 122.782625, 120.626375, 117.438875, 112.892, 107.4545, 104.642, 102.767,
            101.595125, 98.688875, 96.9545, 97.376375, 98.407625, 100.04825, 100.188875, 97.845125, 100.517, 102.017,
            101.876375, 102.86075, 100.42325, 99.907625, 98.73575, 102.2045, 96.67325, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:16.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 144.09639,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:16.546Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.142, 137.4545, 133.7045, 127.657625, 125.642, 123.907625, 118.7045, 118.142, 114.2045, 109.001375,
            106.657625, 103.61075, 100.7045, 99.438875, 99.251375, 101.313875, 100.188875, 98.642, 99.907625,
            102.438875, 103.04825, 103.3295, 100.892, 100.142, 99.063875, 103.751375, 96.9545, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:49.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.6574,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:49.062Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.876375, 116.970125, 114.767, 112.98575, 111.5795, 114.5795, 106.61075, 105.157625, 105.5795, 101.36075,
            101.501375, 96.907625, 96.767, 99.392, 98.407625, 99.767, 98.313875, 98.642, 100.845125, 102.720125,
            103.376375, 102.813875, 100.470125, 99.532625, 98.032625, 101.782625, 96.438875, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:41.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.25306,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:41.085Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.157625, 115.517, 113.8295, 111.392, 111.251375, 115.657625, 107.54825, 107.92325, 106.470125,
            102.345125, 101.595125, 98.407625, 97.23575, 101.126375, 99.67325, 100.845125, 101.17325, 98.595125,
            101.4545, 103.3295, 102.720125, 103.282625, 100.938875, 99.813875, 98.501375, 101.501375, 96.907625,
            95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:39.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.12391,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:39.246Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.142, 111.767, 106.61075, 107.032625, 107.126375, 115.563875, 106.892, 105.532625, 104.92325, 101.220125,
            100.563875, 98.782625, 98.032625, 98.313875, 99.017, 99.767, 100.282625, 98.688875, 100.657625, 102.532625,
            102.86075, 102.29825, 100.79825, 100.42325, 99.29825, 102.626375, 96.907625, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:59.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.11028,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:59.859Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.04825, 124.42325, 122.0795, 118.188875, 115.79825, 114.345125, 111.017, 108.017, 107.595125, 102.5795,
            101.595125, 98.642, 97.095125, 99.2045, 99.67325, 100.845125, 98.642, 98.36075, 100.517, 102.438875,
            102.251375, 102.063875, 100.470125, 99.767, 98.642, 102.251375, 96.767, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:33.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.86884,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:33.230Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.517, 128.54825, 126.2045, 123.2045, 121.7045, 117.907625, 114.626375, 109.42325, 106.04825, 104.642,
            101.92325, 98.642, 97.095125, 100.188875, 98.032625, 99.67325, 99.2045, 98.92325, 99.157625, 102.532625,
            102.626375, 102.48575, 100.517, 99.438875, 98.36075, 101.92325, 96.532625, 95.4545,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:05.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.52176,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:05.750Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.36075, 112.657625, 108.345125, 109.563875, 108.907625, 112.657625, 106.61075, 105.907625, 106.657625,
            102.2045, 102.9545, 98.36075, 96.392, 97.376375, 98.17325, 98.595125, 98.36075, 97.61075, 99.86075, 101.642,
            102.2045, 102.29825, 100.657625, 99.813875, 98.267, 101.688875, 96.345125, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:19.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.2181,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:19.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.782625, 118.001375, 117.438875, 113.970125, 113.688875, 114.017, 108.157625, 107.032625, 105.392,
            101.54825, 100.7045, 101.642, 99.017, 102.392, 98.0795, 100.376375, 99.907625, 99.438875, 100.563875,
            101.8295, 102.86075, 102.48575, 100.657625, 99.626375, 98.4545, 101.782625, 96.767, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:21.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.13073,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:21.453Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.845125, 118.376375, 115.845125, 114.157625, 112.095125, 114.2045, 107.876375, 107.032625, 105.86075,
            101.595125, 101.595125, 100.42325, 99.2045, 99.063875, 98.4545, 99.532625, 99.813875, 98.876375, 100.001375,
            102.907625, 102.48575, 102.11075, 100.517, 99.626375, 98.267, 102.29825, 96.532625, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:29.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.21825,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:29.429Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.907625, 122.407625, 119.501375, 114.11075, 110.642, 112.282625, 106.657625, 104.501375, 103.98575,
            100.657625, 99.251375, 98.267, 97.095125, 97.892, 97.7045, 99.532625, 99.392, 97.98575, 99.813875,
            101.032625, 102.2045, 101.642, 100.282625, 99.720125, 98.595125, 101.782625, 96.438875, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:17.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 150.67876,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:17.527Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            147.813875, 145.3295, 142.7045, 132.251375, 129.2045, 128.032625, 123.767, 122.17325, 118.42325, 116.0795,
            112.282625, 110.642, 105.251375, 102.907625, 100.751375, 100.23575, 99.9545, 99.720125, 100.657625,
            101.92325, 102.5795, 102.5795, 100.563875, 99.9545, 98.688875, 104.642, 98.501375, 96.767,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:29.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.6407,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:29.304Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.345125, 125.0795, 120.2045, 118.751375, 116.032625, 112.7045, 109.470125, 106.61075, 105.29825,
            102.626375, 100.188875, 97.095125, 97.095125, 97.095125, 98.36075, 99.532625, 98.501375, 99.9545, 99.157625,
            101.642, 102.767, 102.251375, 100.657625, 100.04825, 98.782625, 102.29825, 96.67325, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:01.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.84143,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:01.820Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.23575, 118.845125, 116.595125, 113.126375, 110.595125, 113.876375, 109.470125, 108.438875, 106.095125,
            102.345125, 102.017, 98.4545, 96.9545, 98.126375, 98.595125, 100.42325, 97.98575, 98.0795, 100.001375,
            102.11075, 102.29825, 101.782625, 100.517, 100.188875, 98.595125, 102.11075, 96.48575, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:35.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.61861,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:35.195Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.86075, 103.938875, 101.970125, 105.392, 106.563875, 109.7045, 106.282625, 105.626375, 105.48575,
            107.032625, 103.001375, 97.563875, 96.626375, 101.407625, 98.220125, 99.5795, 100.376375, 98.032625,
            99.11075, 101.642, 102.063875, 103.188875, 100.98575, 100.188875, 99.11075, 102.907625, 96.532625,
            95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:06.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.31517,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:06.730Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.157625, 104.642, 103.3295, 106.376375, 108.345125, 113.8295, 104.92325, 106.751375, 105.251375, 103.892,
            105.157625, 98.126375, 95.642, 98.126375, 98.126375, 98.8295, 99.5795, 97.42325, 99.5795, 101.220125,
            102.2045, 101.92325, 100.563875, 99.813875, 98.501375, 101.73575, 96.251375, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:30.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 117.54502,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:30.289Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.063875, 105.157625, 102.017, 104.54825, 105.907625, 105.767, 105.11075, 104.17325, 104.407625,
            103.23575, 101.17325, 97.563875, 95.92325, 100.04825, 98.126375, 99.5795, 99.392, 98.126375, 99.063875,
            101.501375, 103.095125, 102.438875, 100.79825, 99.720125, 98.688875, 102.813875, 96.392, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:15.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.068596,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:15.566Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.032625, 116.407625, 113.126375, 110.8295, 110.220125, 115.563875, 107.4545, 106.7045, 104.970125,
            102.767, 102.626375, 101.688875, 98.92325, 99.67325, 99.9545, 100.845125, 100.79825, 99.11075, 100.563875,
            102.67325, 103.188875, 103.7045, 101.36075, 100.563875, 99.438875, 103.751375, 97.938875, 95.595125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:37.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 148.2338,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:37.160Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            146.126375, 141.063875, 138.86075, 133.892, 131.17325, 128.032625, 125.876375, 122.688875, 119.642,
            114.532625, 112.23575, 107.0795, 103.845125, 101.313875, 100.095125, 99.9545, 98.54825, 98.032625,
            100.938875, 102.438875, 102.29825, 102.813875, 100.61075, 100.42325, 99.063875, 103.376375, 96.67325,
            95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:28.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.052414,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:28.449Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.61075, 108.2045, 105.67325, 107.92325, 107.8295, 110.4545, 107.642, 106.61075, 104.642, 101.782625,
            100.001375, 97.563875, 96.86075, 99.29825, 98.8295, 100.3295, 97.892, 98.36075, 100.142, 101.36075, 102.017,
            101.73575, 99.86075, 99.48575, 98.17325, 101.8295, 96.2045, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:02.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.57866,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:02.804Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.313875, 104.54825, 101.595125, 104.970125, 107.407625, 112.7045, 105.9545, 104.92325, 104.688875,
            102.907625, 103.61075, 98.267, 96.2045, 96.720125, 98.032625, 98.876375, 99.29825, 98.032625, 99.720125,
            102.67325, 102.345125, 102.017, 100.3295, 99.626375, 98.220125, 101.92325, 96.251375, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:40.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 119.534134,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:40.226Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.92325, 104.126375, 104.73575, 107.313875, 107.970125, 114.767, 104.4545, 106.188875, 105.720125,
            100.376375, 99.907625, 97.657625, 96.48575, 96.9545, 98.8295, 99.157625, 101.970125, 98.54825, 101.220125,
            102.392, 102.251375, 102.063875, 100.751375, 100.42325, 98.642, 102.907625, 96.626375, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:58.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.69913,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:58.878Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.0795, 109.79825, 105.767, 106.3295, 106.188875, 112.61075, 107.92325, 107.36075, 105.532625, 102.063875,
            104.4545, 98.36075, 96.813875, 98.220125, 99.5795, 100.42325, 99.438875, 98.688875, 99.813875, 101.36075,
            102.767, 102.86075, 100.98575, 100.001375, 98.92325, 102.532625, 97.04825, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:52.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.88632,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:52.007Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.751375, 122.032625, 119.876375, 114.720125, 112.517, 116.4545, 107.17325, 105.345125, 104.501375,
            101.36075, 102.017, 97.61075, 96.11075, 97.282625, 99.2045, 99.9545, 99.29825, 97.98575, 100.563875,
            101.54825, 102.251375, 101.8295, 100.001375, 99.29825, 98.126375, 101.595125, 96.438875, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:38.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.94191,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:38.140Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.98575, 134.782625, 130.376375, 129.11075, 126.392, 121.282625, 117.86075, 118.751375, 111.67325,
            110.407625, 108.29825, 102.626375, 98.970125, 98.267, 100.188875, 100.376375, 99.2045, 98.407625, 100.98575,
            102.67325, 102.438875, 102.86075, 100.751375, 99.813875, 98.4545, 102.48575, 96.86075, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:53.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.98537,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:53.968Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.48575, 108.157625, 107.36075, 110.267, 110.73575, 115.563875, 105.767, 105.345125, 105.438875, 99.392,
            97.376375, 97.142, 97.001375, 96.9545, 97.938875, 98.407625, 98.4545, 97.61075, 99.720125, 101.17325,
            102.345125, 102.157625, 100.470125, 99.48575, 98.501375, 101.92325, 96.626375, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:50.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.0142,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:50.042Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            114.907625, 108.9545, 105.11075, 110.267, 109.04825, 114.813875, 107.032625, 107.4545, 108.2045, 101.73575,
            101.876375, 98.220125, 95.267, 99.017, 97.892, 99.11075, 98.92325, 97.79825, 99.767, 102.063875, 102.251375,
            102.063875, 99.813875, 99.2045, 98.126375, 101.36075, 96.251375, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:47.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.94101,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:47.097Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            135.907625, 130.517, 128.126375, 124.517, 120.767, 119.17325, 114.251375, 109.79825, 108.907625, 104.220125,
            103.517, 99.86075, 98.501375, 98.313875, 98.8295, 100.04825, 99.29825, 98.36075, 101.36075, 102.063875,
            102.626375, 101.92325, 100.282625, 99.720125, 98.17325, 102.720125, 96.86075, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:13.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.307846,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:13.601Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.11075, 116.595125, 112.376375, 106.61075, 107.73575, 114.017, 106.142, 105.157625, 103.79825,
            104.876375, 104.688875, 100.376375, 98.595125, 100.376375, 98.73575, 100.657625, 98.876375, 99.017,
            101.970125, 104.92325, 102.720125, 102.720125, 100.751375, 100.04825, 98.501375, 102.48575, 96.626375,
            95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:09.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.93333,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:09.675Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.657625, 123.017, 118.61075, 116.4545, 113.501375, 113.36075, 108.48575, 106.282625, 105.345125,
            103.470125, 102.5795, 99.345125, 97.98575, 99.345125, 98.126375, 99.626375, 99.48575, 98.688875, 101.688875,
            102.063875, 102.11075, 102.063875, 100.563875, 99.86075, 98.782625, 102.345125, 97.001375, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:36.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.72228,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:36.175Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.001375, 107.73575, 105.48575, 108.9545, 109.61075, 112.751375, 107.642, 106.657625, 106.892, 103.001375,
            100.98575, 98.407625, 97.188875, 100.470125, 100.282625, 102.392, 99.345125, 99.251375, 100.938875,
            103.3295, 103.188875, 103.892, 101.220125, 100.657625, 99.907625, 105.345125, 97.3295, 95.642,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:43.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.4963,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:43.171Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.48575, 120.67325, 117.2045, 112.001375, 109.470125, 115.79825, 106.23575, 105.67325, 105.86075,
            101.032625, 99.438875, 97.517, 96.157625, 97.470125, 99.11075, 100.376375, 99.86075, 97.98575, 100.470125,
            102.063875, 102.5795, 102.063875, 100.7045, 99.907625, 98.36075, 101.407625, 96.67325, 95.36075,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:40.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.11438,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:40.101Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.29825, 129.720125, 122.73575, 120.063875, 117.720125, 117.017, 113.220125, 109.23575, 109.001375,
            103.563875, 102.392, 97.845125, 97.23575, 103.188875, 99.017, 98.782625, 100.282625, 99.063875, 102.063875,
            103.751375, 102.017, 101.970125, 100.470125, 99.5795, 98.642, 103.376375, 96.86075, 95.126375,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:34.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.251495,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:34.214Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.61075, 117.907625, 115.3295, 117.67325, 113.688875, 111.392, 111.251375, 110.0795, 104.73575, 106.3295,
            102.813875, 97.98575, 97.142, 101.4545, 97.7045, 100.751375, 99.345125, 98.501375, 99.5795, 102.5795,
            102.157625, 103.376375, 100.142, 99.767, 99.11075, 102.2045, 96.532625, 95.313875,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:34.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.19083,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:11:34.339Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.032625, 119.17325, 116.782625, 111.11075, 109.892, 113.126375, 107.782625, 104.220125, 102.9545,
            101.73575, 101.4545, 98.17325, 97.188875, 98.92325, 98.782625, 99.86075, 100.04825, 99.11075, 100.892,
            101.970125, 102.438875, 103.188875, 100.517, 99.9545, 99.29825, 102.86075, 97.657625, 96.017,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:20.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 126.661705,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:20.472Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            124.517, 117.392, 114.67325, 112.3295, 111.813875, 114.5795, 106.98575, 106.517, 105.157625, 101.92325,
            101.876375, 101.73575, 99.626375, 102.86075, 98.220125, 99.626375, 99.157625, 99.626375, 99.720125,
            101.407625, 102.767, 101.970125, 100.79825, 99.907625, 98.876375, 103.845125, 96.9545, 95.267,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:18.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.45706,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:18.507Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.688875, 125.876375, 122.0795, 118.23575, 115.282625, 116.220125, 111.392, 109.142, 107.0795, 104.501375,
            102.251375, 101.73575, 98.8295, 100.563875, 98.17325, 100.23575, 99.86075, 99.532625, 100.938875,
            102.438875, 103.095125, 102.86075, 100.61075, 99.907625, 98.36075, 102.157625, 96.438875, 95.407625,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:22.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.18243,
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:22.433Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.92325, 130.001375, 127.79825, 123.626375, 120.438875, 120.157625, 113.501375, 111.907625, 109.282625,
            105.438875, 103.3295, 102.907625, 99.626375, 100.001375, 98.4545, 100.61075, 101.642, 100.657625, 100.42325,
            102.626375, 102.767, 103.04825, 100.845125, 99.907625, 98.54825, 102.2045, 96.438875, 95.220125,
        ],
        latitude: 37.440576,
        longitude: -122.5334047,
    },
    {
        timestamp: '2025-08-29T23:12:55.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.98466,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:55.808Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.595125, 120.392, 117.251375, 114.29825, 110.0795, 113.782625, 107.313875, 107.876375, 107.688875,
            103.04825, 104.267, 98.0795, 96.48575, 98.595125, 98.8295, 102.11075, 101.876375, 99.9545, 102.48575,
            103.892, 102.907625, 102.5795, 101.0795, 100.61075, 98.970125, 102.48575, 96.11075, 95.126375,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:13.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.448654,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:13.476Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.017, 117.157625, 112.517, 108.720125, 108.9545, 114.48575, 105.626375, 105.438875, 104.970125,
            104.36075, 102.063875, 98.73575, 96.720125, 100.282625, 100.188875, 102.345125, 101.36075, 99.86075,
            103.517, 104.782625, 103.517, 103.61075, 101.220125, 100.04825, 98.4545, 101.73575, 96.438875, 95.220125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:10.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.05254,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:10.531Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.438875, 125.36075, 122.36075, 119.782625, 117.48575, 118.04825, 112.23575, 108.345125, 106.001375,
            104.126375, 103.095125, 99.720125, 97.7045, 101.54825, 100.892, 102.48575, 103.470125, 99.392, 104.970125,
            105.626375, 103.517, 103.98575, 101.36075, 100.188875, 98.4545, 101.970125, 96.345125, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:44.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.246994,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:44.031Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.251375, 114.9545, 110.4545, 106.376375, 108.29825, 112.7045, 105.157625, 104.782625, 105.392, 100.517,
            99.157625, 99.017, 98.407625, 102.48575, 100.892, 101.876375, 100.657625, 99.11075, 102.532625, 102.392,
            103.001375, 102.86075, 100.61075, 100.188875, 99.532625, 102.720125, 97.938875, 95.54825,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:50.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.27742,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:50.773Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.642, 107.782625, 103.657625, 108.11075, 112.142, 119.313875, 107.876375, 109.563875, 109.61075,
            105.2045, 105.063875, 100.04825, 97.563875, 101.313875, 102.48575, 105.767, 104.313875, 102.626375,
            106.7045, 109.563875, 105.9545, 106.98575, 102.438875, 101.36075, 99.251375, 102.392, 96.5795, 95.17325,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:55.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.26383,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:55.683Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.2045, 114.063875, 109.892, 107.501375, 111.438875, 116.126375, 108.532625, 108.9545, 112.23575,
            106.98575, 102.392, 98.642, 98.876375, 102.017, 101.782625, 102.5795, 102.063875, 104.501375, 103.142,
            105.720125, 104.73575, 104.220125, 101.642, 100.376375, 98.595125, 101.876375, 96.5795, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:04.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.74228,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:04.644Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.938875, 124.42325, 121.3295, 118.892, 116.642, 116.876375, 109.845125, 107.17325, 104.36075, 103.42325,
            102.86075, 100.095125, 99.2045, 99.767, 103.04825, 104.126375, 103.376375, 101.595125, 107.501375,
            106.23575, 104.501375, 103.98575, 101.17325, 100.470125, 99.2045, 102.720125, 97.188875, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:54.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.13307,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:54.828Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.017, 120.017, 116.73575, 113.782625, 111.11075, 113.92325, 108.813875, 106.79825, 106.188875, 101.642,
            102.720125, 98.407625, 96.5795, 99.67325, 99.813875, 100.892, 101.4545, 99.29825, 103.517, 104.92325,
            103.282625, 103.61075, 101.220125, 100.42325, 98.782625, 102.392, 96.532625, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:53.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.04489,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:53.718Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.0795, 119.407625, 115.892, 112.98575, 114.767, 119.032625, 105.767, 105.626375, 108.626375, 106.563875,
            104.220125, 98.54825, 98.54825, 104.642, 103.3295, 105.532625, 104.8295, 104.4545, 105.29825, 107.4545,
            106.095125, 104.54825, 101.595125, 100.563875, 98.92325, 102.11075, 96.720125, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:45.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.62236,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:45.867Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.220125, 129.9545, 126.9545, 122.54825, 119.92325, 118.938875, 114.907625, 112.79825, 112.892, 105.5795,
            103.657625, 99.86075, 97.845125, 99.767, 101.8295, 103.42325, 102.48575, 101.4545, 105.11075, 108.67325,
            105.720125, 106.657625, 102.345125, 100.938875, 98.970125, 102.251375, 96.9545, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:16.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.51549,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:16.421Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.48575, 132.5795, 130.79825, 126.907625, 124.845125, 122.782625, 119.8295, 116.8295, 113.970125,
            109.751375, 106.470125, 102.157625, 99.626375, 99.345125, 99.86075, 101.17325, 102.251375, 99.48575,
            103.376375, 103.142, 103.23575, 103.142, 101.267, 100.142, 98.782625, 102.251375, 97.095125, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:35.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.90065,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:35.070Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.267, 124.892, 120.345125, 118.470125, 115.470125, 114.9545, 108.9545, 106.892, 108.86075, 104.407625,
            107.54825, 99.532625, 97.7045, 100.04825, 100.79825, 103.563875, 104.267, 101.8295, 104.73575, 106.095125,
            103.751375, 105.017, 101.54825, 100.7045, 99.29825, 102.86075, 96.438875, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:38.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.35545,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:38.015Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.032625, 116.595125, 114.5795, 109.376375, 108.2045, 115.98575, 106.79825, 104.8295, 110.220125,
            101.4545, 105.345125, 100.04825, 98.4545, 100.98575, 101.0795, 103.188875, 102.9545, 101.782625, 102.9545,
            108.345125, 104.313875, 104.73575, 102.11075, 101.36075, 99.767, 102.907625, 96.907625, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:07.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.9044,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:07.585Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            113.595125, 107.501375, 103.79825, 105.907625, 108.063875, 116.032625, 106.892, 105.907625, 104.8295,
            102.532625, 105.438875, 99.2045, 98.4545, 99.392, 101.92325, 102.157625, 102.157625, 100.142, 103.517,
            104.407625, 104.17325, 104.54825, 101.126375, 100.563875, 99.2045, 102.720125, 96.86075, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:03.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 141.43182,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:03.660Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            138.532625, 134.876375, 132.48575, 129.29825, 126.9545, 123.9545, 122.220125, 119.4545, 114.2045,
            109.657625, 108.48575, 104.782625, 101.0795, 100.892, 102.720125, 103.04825, 103.517, 100.79825, 106.095125,
            107.36075, 104.032625, 104.595125, 101.126375, 100.61075, 98.92325, 102.48575, 97.142, 95.54825,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:44.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.65416,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:44.886Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.0795, 120.67325, 115.892, 113.970125, 112.563875, 114.532625, 106.657625, 106.3295, 108.017, 104.970125,
            103.376375, 98.970125, 97.42325, 100.751375, 100.470125, 103.517, 103.938875, 100.98575, 103.7045, 108.9545,
            105.29825, 105.720125, 102.5795, 101.126375, 98.876375, 102.2045, 96.438875, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:39.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.082924,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:39.976Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.142, 113.032625, 108.532625, 106.98575, 107.688875, 116.0795, 106.3295, 105.345125, 108.29825,
            103.376375, 103.04825, 97.98575, 96.48575, 99.157625, 100.42325, 101.688875, 102.9545, 100.79825, 104.73575,
            106.79825, 105.532625, 104.782625, 102.017, 101.267, 99.5795, 102.9545, 96.767, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:43.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.51442,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:43.902Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.3295, 115.470125, 112.79825, 109.188875, 109.001375, 114.017, 105.2045, 105.48575, 106.938875, 103.3295,
            104.313875, 99.063875, 97.61075, 101.970125, 101.688875, 104.782625, 105.48575, 101.54825, 106.376375,
            107.407625, 105.017, 105.251375, 102.2045, 100.751375, 98.4545, 101.688875, 96.29825, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:33.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.58575,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:33.105Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.642, 123.11075, 119.73575, 113.970125, 113.970125, 112.142, 109.142, 107.642, 104.8295, 103.7045,
            107.4545, 99.9545, 97.61075, 98.8295, 100.517, 101.267, 102.017, 99.720125, 103.001375, 105.11075,
            103.98575, 103.657625, 101.17325, 100.376375, 98.92325, 101.876375, 96.5795, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:12.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.3126,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:12.492Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.98575, 129.345125, 129.11075, 124.61075, 118.938875, 116.876375, 112.095125, 108.157625, 105.392,
            103.938875, 101.876375, 98.501375, 96.9545, 99.48575, 101.220125, 102.11075, 102.2045, 99.017, 103.282625,
            104.642, 103.23575, 103.657625, 101.267, 99.86075, 98.220125, 101.73575, 96.626375, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:52.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.31572,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:52.863Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            104.595125, 101.032625, 102.2045, 104.8295, 105.813875, 118.938875, 108.48575, 105.392, 109.095125, 101.267,
            99.532625, 98.17325, 97.04825, 98.4545, 100.938875, 103.188875, 104.782625, 100.001375, 102.532625,
            103.7045, 103.001375, 102.9545, 100.938875, 100.61075, 99.11075, 103.3295, 96.9545, 95.595125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:48.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.91791,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:48.937Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.688875, 118.470125, 116.407625, 111.626375, 111.9545, 112.42325, 108.11075, 109.142, 106.04825,
            103.79825, 100.98575, 97.751375, 97.517, 100.892, 100.282625, 101.595125, 100.376375, 101.36075, 101.313875,
            103.657625, 103.845125, 102.67325, 101.032625, 100.095125, 98.595125, 102.345125, 96.532625, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:58.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.905815,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:58.753Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.063875, 117.157625, 115.751375, 108.48575, 109.282625, 117.86075, 107.92325, 107.642, 106.42325,
            101.313875, 102.5795, 99.251375, 97.517, 98.17325, 100.095125, 103.142, 101.407625, 100.23575, 102.2045,
            104.17325, 103.42325, 103.001375, 101.688875, 101.36075, 99.11075, 102.251375, 96.532625, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:42.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.69546,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:42.066Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.267, 113.220125, 109.79825, 105.720125, 107.73575, 114.907625, 105.5795, 105.67325, 105.626375,
            101.032625, 100.751375, 98.595125, 96.017, 99.767, 98.73575, 99.392, 98.92325, 97.751375, 101.407625,
            102.48575, 102.907625, 102.48575, 100.657625, 99.720125, 98.17325, 101.73575, 96.345125, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:01.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 140.30734,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:01.695Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.376375, 131.73575, 125.313875, 118.892, 116.92325, 116.595125, 113.267, 110.313875, 105.9545, 103.23575,
            101.970125, 99.86075, 97.188875, 98.688875, 100.79825, 103.845125, 102.2045, 100.42325, 105.251375,
            106.001375, 104.17325, 105.157625, 101.313875, 100.282625, 98.8295, 102.720125, 96.767, 95.126375,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:45.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.83004,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:45.992Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.86075, 115.61075, 110.595125, 107.970125, 109.7045, 112.563875, 107.313875, 108.2045, 106.04825,
            101.642, 99.2045, 98.0795, 96.67325, 102.48575, 99.017, 100.376375, 100.517, 99.86075, 99.9545, 102.907625,
            103.42325, 102.720125, 100.751375, 100.142, 99.29825, 103.001375, 96.9545, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:31.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 137.14871,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:31.144Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.142, 128.595125, 122.36075, 116.8295, 114.813875, 115.42325, 110.642, 110.220125, 107.54825, 103.470125,
            107.876375, 99.251375, 98.8295, 101.501375, 101.782625, 103.095125, 102.720125, 100.470125, 105.438875,
            105.9545, 104.407625, 103.563875, 101.73575, 100.3295, 98.642, 102.157625, 96.345125, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:54.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 146.89775,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:54.703Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            144.86075, 139.001375, 137.267, 133.04825, 130.845125, 129.017, 126.767, 123.720125, 122.220125, 118.3295,
            113.595125, 110.73575, 107.313875, 105.532625, 103.7045, 103.563875, 102.392, 106.845125, 104.4545,
            107.4545, 106.3295, 104.688875, 101.92325, 100.751375, 99.345125, 103.095125, 97.563875, 95.595125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:28.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.417496,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:28.199Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.0795, 115.563875, 111.438875, 108.907625, 107.642, 110.970125, 107.54825, 106.470125, 104.970125,
            101.0795, 101.688875, 99.345125, 97.282625, 99.345125, 100.470125, 102.063875, 103.61075, 99.392, 101.8295,
            105.063875, 103.61075, 103.470125, 101.36075, 100.517, 98.8295, 102.2045, 96.157625, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:25.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 124.926704,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:25.253Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.7045, 115.938875, 113.220125, 109.98575, 108.157625, 111.438875, 108.392, 107.501375, 105.86075,
            103.563875, 113.313875, 100.892, 97.751375, 101.36075, 103.517, 103.751375, 105.9545, 100.7045, 104.0795,
            107.313875, 104.36075, 103.98575, 101.267, 100.517, 99.11075, 102.813875, 96.48575, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:51.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.61287,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:51.882Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            107.36075, 101.54825, 101.595125, 104.407625, 106.095125, 113.54825, 104.501375, 103.845125, 107.688875,
            101.36075, 100.517, 98.501375, 97.04825, 99.532625, 99.767, 102.392, 101.92325, 99.017, 102.29825, 103.142,
            103.42325, 103.751375, 101.032625, 100.470125, 98.8295, 102.626375, 96.5795, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:15.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.9403,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:15.441Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.220125, 127.376375, 126.29825, 125.73575, 123.5795, 120.157625, 116.54825, 113.92325, 110.73575,
            107.92325, 104.970125, 100.79825, 99.2045, 102.29825, 100.892, 102.67325, 102.48575, 99.86075, 103.42325,
            104.17325, 103.3295, 103.657625, 101.220125, 100.470125, 98.782625, 101.92325, 96.767, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:20.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.4945,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:20.347Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.032625, 122.73575, 120.9545, 117.532625, 115.04825, 114.626375, 110.92325, 110.17325, 106.517,
            103.563875, 101.8295, 99.907625, 98.126375, 99.345125, 101.642, 101.876375, 103.79825, 100.142, 102.345125,
            105.48575, 103.095125, 103.376375, 101.17325, 99.907625, 98.595125, 102.017, 97.04825, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:53.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.02368,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:53.843Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            111.157625, 104.595125, 103.657625, 106.751375, 107.36075, 115.376375, 106.282625, 105.345125, 107.642,
            101.407625, 101.0795, 97.3295, 96.813875, 100.42325, 99.29825, 102.767, 102.345125, 99.017, 101.73575,
            104.313875, 102.86075, 103.42325, 101.126375, 100.61075, 98.876375, 102.438875, 96.438875, 95.595125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:29.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.99135,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:29.179Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.11075, 113.17325, 107.8295, 106.79825, 106.938875, 111.48575, 105.532625, 104.688875, 104.73575,
            102.11075, 109.04825, 99.438875, 98.642, 101.17325, 100.79825, 103.001375, 104.970125, 99.48575, 103.470125,
            104.876375, 104.126375, 104.220125, 101.876375, 100.79825, 99.11075, 102.48575, 96.29825, 95.17325,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:51.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 143.15845,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:51.757Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            142.142, 134.8295, 128.17325, 122.8295, 121.79825, 121.845125, 115.188875, 112.42325, 111.251375, 108.9545,
            109.61075, 100.98575, 97.23575, 103.42325, 101.782625, 106.142, 103.751375, 102.251375, 109.282625,
            109.001375, 105.5795, 105.438875, 102.9545, 101.4545, 99.017, 103.188875, 96.626375, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:41.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 139.9151,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:41.941Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            137.36075, 132.67325, 130.282625, 127.142, 126.29825, 124.3295, 120.626375, 117.5795, 112.376375, 107.17325,
            105.345125, 99.626375, 97.7045, 98.595125, 100.42325, 102.345125, 102.5795, 99.720125, 105.345125,
            107.220125, 104.688875, 104.501375, 102.438875, 101.17325, 98.970125, 102.392, 96.251375, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:36.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.70102,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:36.050Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.4545, 126.907625, 121.376375, 120.532625, 119.032625, 115.751375, 115.376375, 110.92325, 109.3295,
            104.313875, 102.767, 99.251375, 97.7045, 99.9545, 101.642, 101.54825, 102.9545, 101.4545, 103.282625,
            106.3295, 104.782625, 105.2045, 102.11075, 100.938875, 99.532625, 103.517, 97.42325, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:43.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.756905,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:43.046Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.251375, 112.470125, 107.032625, 104.8295, 106.563875, 113.73575, 103.845125, 104.73575, 105.29825,
            101.407625, 99.907625, 98.17325, 96.5795, 99.86075, 99.767, 100.188875, 99.907625, 97.61075, 100.98575,
            102.5795, 102.767, 102.438875, 100.845125, 100.282625, 98.4545, 101.92325, 96.29825, 95.220125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:18.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.6107,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:18.382Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.251375, 125.126375, 125.220125, 121.938875, 118.98575, 115.095125, 111.29825, 109.188875, 105.063875,
            103.845125, 103.98575, 98.970125, 96.392, 100.79825, 104.126375, 104.0795, 105.438875, 99.86075, 103.04825,
            105.11075, 102.67325, 103.188875, 100.98575, 100.095125, 98.501375, 101.876375, 96.767, 95.688875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:46.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.78113,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:46.847Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.688875, 129.532625, 126.392, 123.157625, 121.142, 117.767, 115.04825, 109.845125, 110.54825, 104.642,
            104.032625, 100.142, 98.876375, 101.8295, 102.907625, 103.282625, 103.23575, 100.938875, 105.626375,
            107.4545, 105.251375, 105.48575, 101.73575, 100.751375, 99.063875, 102.532625, 97.282625, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:00.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 133.48077,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:00.714Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            131.17325, 125.782625, 122.782625, 120.532625, 119.54825, 118.42325, 114.29825, 110.92325, 106.282625,
            104.876375, 104.36075, 100.188875, 99.017, 99.345125, 101.782625, 102.86075, 106.04825, 99.720125, 103.517,
            105.626375, 104.032625, 104.126375, 101.642, 100.376375, 99.063875, 102.48575, 97.517, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:27.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.70029,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:27.218Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.720125, 122.220125, 121.095125, 115.892, 114.5795, 115.188875, 110.032625, 107.407625, 105.017, 103.892,
            111.157625, 100.79825, 97.23575, 99.813875, 102.157625, 105.29825, 107.595125, 101.970125, 103.3295,
            106.188875, 104.73575, 104.17325, 101.970125, 100.563875, 98.595125, 102.5795, 97.563875, 96.157625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:11.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.37476,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:11.511Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.04825, 131.54825, 127.845125, 125.407625, 123.29825, 121.563875, 116.313875, 113.970125, 110.73575,
            106.23575, 103.892, 99.532625, 97.42325, 98.17325, 101.36075, 102.5795, 103.095125, 99.532625, 103.470125,
            105.67325, 103.61075, 103.845125, 101.4545, 100.517, 98.8295, 102.813875, 96.48575, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:02.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.2273,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:02.679Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.11075, 126.48575, 124.563875, 121.470125, 117.67325, 115.751375, 110.0795, 109.001375, 105.532625,
            103.095125, 102.5795, 99.48575, 96.9545, 98.970125, 102.626375, 103.845125, 103.3295, 100.61075, 104.313875,
            106.470125, 103.938875, 104.688875, 101.220125, 100.23575, 98.36075, 102.251375, 96.5795, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:06.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 122.443695,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:06.605Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            117.5795, 113.032625, 110.54825, 108.251375, 108.251375, 115.3295, 107.54825, 105.720125, 105.157625,
            102.720125, 102.720125, 98.8295, 97.7045, 98.313875, 100.188875, 102.67325, 101.688875, 99.48575,
            102.813875, 105.392, 103.61075, 103.845125, 101.032625, 100.376375, 98.688875, 102.063875, 96.626375,
            95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:38.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.50466,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:38.996Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.54825, 116.970125, 113.92325, 110.782625, 108.720125, 115.001375, 105.11075, 104.73575, 108.063875,
            103.42325, 106.517, 98.73575, 97.188875, 101.126375, 100.7045, 102.532625, 103.657625, 102.67325,
            103.938875, 106.7045, 105.532625, 105.251375, 102.29825, 101.36075, 99.767, 102.907625, 96.720125, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:05.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.76924,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:05.625Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.73575, 111.48575, 109.376375, 105.2045, 105.29825, 114.251375, 105.67325, 104.73575, 103.563875,
            104.407625, 107.220125, 98.970125, 97.376375, 99.813875, 102.392, 106.04825, 102.907625, 100.751375,
            104.73575, 106.142, 104.501375, 104.36075, 101.595125, 100.517, 99.017, 103.188875, 96.67325, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:24.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.60996,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:24.273Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.532625, 116.36075, 112.04825, 109.142, 106.79825, 111.720125, 105.767, 106.563875, 103.938875, 103.517,
            108.2045, 100.001375, 98.126375, 101.032625, 102.438875, 103.42325, 106.142, 100.938875, 104.267, 107.36075,
            103.98575, 104.54825, 101.970125, 100.845125, 98.782625, 101.8295, 96.5795, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:09.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.68546,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:09.550Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.3295, 123.767, 123.48575, 116.970125, 115.892, 115.3295, 108.626375, 107.876375, 107.032625, 104.642,
            105.48575, 98.17325, 96.86075, 97.517, 100.376375, 101.642, 101.313875, 100.142, 103.188875, 104.642,
            103.563875, 103.142, 101.220125, 100.3295, 98.54825, 102.017, 96.2045, 95.17325,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:19.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.24461,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:19.367Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.876375, 127.563875, 123.2045, 121.892, 118.563875, 118.42325, 112.845125, 109.3295, 105.9545,
            104.126375, 104.876375, 99.5795, 96.767, 101.970125, 101.4545, 102.157625, 103.98575, 99.813875, 102.907625,
            105.251375, 103.23575, 103.23575, 101.407625, 100.376375, 98.595125, 102.9545, 96.907625, 95.220125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:32.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 118.71231,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:32.125Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            110.032625, 103.657625, 102.48575, 104.407625, 104.970125, 110.220125, 106.23575, 106.282625, 105.9545,
            102.345125, 106.938875, 100.563875, 97.04825, 99.9545, 100.188875, 100.845125, 102.720125, 99.720125,
            103.61075, 106.04825, 104.36075, 103.61075, 101.595125, 100.657625, 98.642, 101.782625, 96.720125, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:49.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 142.01723,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:49.917Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            139.095125, 134.876375, 133.61075, 130.98575, 127.3295, 123.251375, 124.095125, 118.282625, 115.42325,
            113.73575, 108.392, 105.5795, 101.126375, 103.845125, 100.376375, 102.720125, 100.23575, 100.938875,
            101.92325, 103.42325, 103.095125, 103.001375, 101.126375, 100.04825, 98.8295, 102.67325, 97.938875,
            95.595125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:47.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.2149,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:47.832Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            128.126375, 124.751375, 122.8295, 117.907625, 114.767, 114.813875, 108.626375, 106.563875, 107.313875,
            104.642, 102.720125, 100.657625, 97.892, 100.892, 102.813875, 102.438875, 102.626375, 100.938875, 103.3295,
            111.532625, 105.157625, 105.2045, 102.017, 100.892, 98.688875, 102.063875, 96.626375, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:42.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 130.50114,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:42.921Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            127.563875, 123.29825, 121.563875, 118.095125, 114.9545, 116.220125, 110.032625, 106.470125, 106.23575,
            103.61075, 105.813875, 99.86075, 98.032625, 100.001375, 102.017, 103.23575, 103.751375, 101.54825,
            105.438875, 108.017, 104.876375, 104.8295, 102.29825, 101.0795, 98.8295, 101.782625, 96.532625, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:46.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.8454,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:46.972Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.407625, 110.17325, 108.29825, 106.657625, 107.688875, 111.251375, 104.970125, 105.438875, 104.595125,
            102.67325, 101.595125, 98.782625, 97.470125, 104.407625, 99.813875, 101.8295, 102.907625, 101.032625,
            102.063875, 103.751375, 103.517, 102.907625, 100.98575, 100.517, 99.157625, 102.9545, 96.626375, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:49.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.24223,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:49.792Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.2045, 127.188875, 123.11075, 119.8295, 116.267, 118.04825, 110.642, 108.2045, 109.188875, 103.470125,
            102.907625, 99.907625, 98.970125, 100.142, 102.29825, 103.938875, 104.595125, 102.438875, 104.642,
            108.063875, 105.438875, 104.642, 102.251375, 100.7045, 99.157625, 102.29825, 96.907625, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:56.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 120.5193,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:56.789Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            115.892, 107.970125, 102.438875, 102.157625, 104.313875, 114.29825, 104.54825, 104.8295, 106.657625,
            100.7045, 101.0795, 97.751375, 96.67325, 98.267, 100.3295, 102.438875, 102.813875, 99.67325, 102.2045,
            104.54825, 102.813875, 103.001375, 100.98575, 100.517, 98.8295, 102.767, 96.438875, 95.0795,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:37.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.55498,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:37.035Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.23575, 126.29825, 120.251375, 118.657625, 116.782625, 116.407625, 109.188875, 108.626375, 109.376375,
            100.376375, 100.517, 99.11075, 96.532625, 98.313875, 99.9545, 102.251375, 102.251375, 100.376375, 102.392,
            105.157625, 103.79825, 104.4545, 102.063875, 100.98575, 99.626375, 102.67325, 97.095125, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:26.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.02145,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:26.238Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.595125, 120.532625, 118.42325, 112.751375, 109.42325, 110.782625, 106.7045, 106.98575, 104.267,
            102.532625, 106.376375, 99.438875, 98.73575, 99.907625, 102.11075, 103.563875, 106.142, 101.876375,
            104.313875, 106.563875, 104.313875, 104.220125, 101.8295, 100.79825, 99.11075, 102.29825, 96.345125,
            95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:22.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.52665,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:22.308Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.595125, 117.86075, 114.2045, 111.48575, 110.501375, 112.61075, 107.0795, 107.0795, 105.5795, 102.438875,
            106.470125, 97.61075, 97.7045, 101.407625, 100.845125, 102.017, 101.36075, 100.61075, 102.907625, 106.04825,
            103.470125, 103.79825, 101.36075, 100.61075, 98.92325, 102.2045, 96.67325, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:59.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.91757,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:59.734Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.376375, 123.48575, 119.642, 116.36075, 111.392, 116.595125, 108.48575, 106.61075, 106.188875,
            102.907625, 104.92325, 98.876375, 97.282625, 98.92325, 100.563875, 101.642, 104.032625, 101.54825,
            103.845125, 105.5795, 104.0795, 104.032625, 101.36075, 100.938875, 98.876375, 102.67325, 96.5795, 95.220125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:08.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.20031,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:08.570Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            122.407625, 116.36075, 112.563875, 107.220125, 110.032625, 115.23575, 106.42325, 106.98575, 105.5795,
            104.313875, 107.0795, 98.688875, 98.0795, 99.11075, 100.938875, 102.29825, 102.9545, 100.376375, 104.4545,
            105.251375, 104.4545, 104.876375, 101.876375, 100.7045, 98.73575, 102.48575, 96.438875, 95.407625,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:48.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.37479,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:48.812Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            119.0795, 111.345125, 107.73575, 108.9545, 110.970125, 116.688875, 105.767, 105.720125, 108.251375,
            102.626375, 101.313875, 98.313875, 100.04825, 100.04825, 101.688875, 103.282625, 103.98575, 101.313875,
            104.126375, 109.001375, 104.782625, 104.782625, 102.11075, 100.79825, 99.157625, 101.782625, 96.5795,
            95.126375,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:40.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 128.21788,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:40.960Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.017, 119.126375, 115.892, 114.767, 110.642, 116.313875, 108.48575, 108.345125, 108.907625, 103.095125,
            103.938875, 99.345125, 98.73575, 101.126375, 101.970125, 102.720125, 103.188875, 100.892, 105.157625,
            107.642, 105.392, 105.017, 102.626375, 101.54825, 99.907625, 103.095125, 97.563875, 95.642,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:30.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.50137,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:30.164Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            123.29825, 116.220125, 110.313875, 108.063875, 108.532625, 113.688875, 109.3295, 109.3295, 107.4545,
            102.251375, 103.751375, 98.220125, 97.657625, 98.688875, 101.313875, 102.345125, 101.501375, 100.3295,
            103.142, 106.188875, 103.61075, 103.79825, 101.407625, 100.517, 99.345125, 103.563875, 96.5795, 95.501375,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:50.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 132.49173,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:50.898Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            130.79825, 124.282625, 120.5795, 119.0795, 115.42325, 113.73575, 111.532625, 109.470125, 105.907625,
            103.517, 101.220125, 99.017, 98.267, 101.73575, 99.907625, 102.86075, 100.23575, 100.845125, 101.876375,
            102.720125, 102.813875, 103.142, 100.61075, 99.86075, 98.54825, 102.251375, 96.438875, 95.220125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:23.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 127.74496,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:23.292Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            125.688875, 120.251375, 114.9545, 112.188875, 111.48575, 112.188875, 107.267, 104.92325, 103.845125,
            100.892, 100.470125, 98.8295, 98.032625, 98.501375, 102.532625, 102.251375, 105.251375, 100.142, 103.751375,
            105.9545, 103.42325, 103.7045, 102.017, 100.61075, 98.73575, 102.11075, 96.720125, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:47.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.3597,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:47.957Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.907625, 128.595125, 125.92325, 122.313875, 119.0795, 117.063875, 112.376375, 109.282625, 108.532625,
            105.157625, 102.157625, 99.438875, 97.470125, 104.313875, 102.532625, 103.79825, 105.345125, 102.345125,
            102.017, 104.032625, 103.142, 102.767, 100.845125, 100.188875, 99.392, 102.720125, 96.907625, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:34.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.58189,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:34.089Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            118.142, 111.67325, 107.313875, 105.532625, 105.157625, 109.04825, 105.907625, 106.282625, 104.970125,
            103.61075, 107.36075, 100.61075, 97.42325, 98.782625, 100.142, 100.751375, 101.126375, 101.032625, 103.142,
            105.5795, 104.032625, 104.313875, 101.407625, 100.470125, 99.29825, 103.751375, 97.188875, 95.4545,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:45.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 123.89601,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:45.011Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            120.720125, 114.2045, 110.501375, 111.438875, 111.392, 113.17325, 108.532625, 108.392, 107.0795, 102.9545,
            100.657625, 97.892, 96.626375, 101.4545, 99.392, 100.563875, 99.9545, 100.142, 100.938875, 102.626375,
            103.188875, 102.438875, 100.517, 99.9545, 98.876375, 102.48575, 96.907625, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:17.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 135.95598,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:17.402Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            134.642, 126.767, 123.251375, 122.407625, 118.42325, 115.142, 112.892, 110.407625, 108.017, 104.8295,
            103.04825, 100.61075, 99.11075, 100.517, 101.782625, 102.626375, 102.017, 100.470125, 103.563875, 104.4545,
            103.376375, 104.0795, 101.17325, 100.095125, 98.54825, 101.8295, 96.48575, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:57.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.58382,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:12:57.769Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.67325, 124.470125, 120.67325, 112.7045, 110.313875, 116.595125, 108.767, 105.438875, 104.642,
            100.470125, 103.376375, 98.501375, 96.626375, 97.79825, 100.938875, 102.86075, 104.595125, 99.907625,
            102.345125, 104.54825, 102.767, 103.142, 101.8295, 100.938875, 98.92325, 102.86075, 96.5795, 95.267,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:14.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 121.33535,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:14.457Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            116.8295, 109.3295, 105.720125, 105.345125, 108.907625, 114.11075, 107.17325, 106.142, 104.73575,
            103.470125, 102.392, 97.98575, 96.626375, 101.970125, 100.751375, 101.54825, 102.063875, 100.61075,
            103.095125, 104.36075, 102.813875, 103.282625, 101.032625, 100.142, 98.73575, 102.017, 96.5795, 95.220125,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:21.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 131.07301,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:21.328Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            129.345125, 123.48575, 119.220125, 114.438875, 112.282625, 112.892, 109.7045, 107.267, 104.876375,
            103.001375, 107.0795, 97.7045, 97.001375, 100.7045, 101.970125, 102.532625, 102.767, 99.907625, 102.767,
            105.48575, 103.095125, 104.0795, 101.501375, 100.517, 98.73575, 102.86075, 96.438875, 95.313875,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:52.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.98454,
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        timestamp: '2025-08-29T23:13:52.738Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.813875, 127.282625, 124.517, 120.86075, 119.032625, 121.095125, 111.11075, 108.720125, 108.532625,
            108.017, 108.532625, 101.220125, 98.4545, 104.267, 103.517, 107.0795, 104.4545, 103.42325, 108.532625,
            110.8295, 106.188875, 104.876375, 102.2045, 100.938875, 98.876375, 103.095125, 97.001375, 95.36075,
        ],
        latitude: 37.4405818,
        longitude: -122.5334147,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b22a048219017c185aa50518190719016310011519016311185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 125.642, 122.642, 118.892, 116.642, 113.642, 112.142, 110.642, 109.892, 110.642, 106.892,
                104.642, 103.142, 100.142, 99.392, 98.642, 98.642, 98.642, 98.642, 100.142, 102.392, 101.642, 100.892,
                100.142, 100.892, 106.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                118.892, 112.892, 109.142, 107.642, 107.642, 106.142, 106.142, 106.142, 102.392, 100.142, 99.392,
                97.892, 97.892, 97.142, 96.392, 96.392, 95.642, 96.392, 97.892, 100.142, 101.642, 101.642, 100.142,
                99.392, 97.892, 101.642, 96.392, 94.892,
            ],
            '50th_percentile': [
                124.892, 118.892, 115.142, 112.142, 110.642, 108.392, 107.642, 107.642, 103.892, 101.642, 100.142,
                99.392, 98.642, 98.642, 97.142, 97.142, 96.392, 97.142, 97.892, 100.142, 102.392, 101.642, 100.142,
                99.392, 98.642, 102.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 124.892, 121.142, 118.142, 115.892, 112.892, 110.642, 109.892, 106.142, 103.892, 101.642,
                100.892, 100.142, 100.142, 98.642, 98.642, 97.892, 97.892, 98.642, 100.142, 102.392, 102.392, 100.892,
                100.142, 98.642, 102.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 136.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b2310d8219017c185aa4051855071901271519012711185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                133.892, 128.642, 126.392, 122.642, 119.642, 117.392, 115.142, 113.642, 114.392, 111.392, 106.892,
                106.892, 106.142, 103.142, 105.392, 103.142, 102.392, 100.892, 103.142, 102.392, 103.142, 102.392,
                100.892, 100.142, 98.642, 102.392, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                120.392, 114.392, 110.642, 109.142, 109.142, 109.892, 107.642, 106.892, 104.642, 103.142, 102.392,
                100.142, 98.642, 99.392, 99.392, 100.142, 99.392, 98.642, 99.392, 100.892, 102.392, 102.392, 100.142,
                99.392, 98.642, 102.392, 96.392, 95.642,
            ],
            '50th_percentile': [
                127.142, 121.142, 118.142, 115.142, 112.892, 112.892, 109.892, 109.142, 106.142, 104.642, 103.142,
                101.642, 100.892, 100.892, 100.892, 101.642, 100.892, 100.142, 100.892, 101.642, 103.142, 102.392,
                100.892, 100.142, 98.642, 102.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                132.392, 127.142, 124.142, 120.392, 118.142, 116.642, 113.642, 111.392, 109.142, 106.892, 105.392,
                103.892, 103.142, 103.142, 103.142, 103.142, 103.142, 101.642, 102.392, 102.392, 103.142, 103.142,
                100.892, 100.142, 98.642, 103.142, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        timestamp: '2025-08-29T23:13:56.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 129.39587,
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:13:56.664Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            126.392, 121.517, 118.98575, 117.392, 115.095125, 117.9545, 108.2045, 107.54825, 110.782625, 103.376375,
            102.345125, 99.9545, 98.126375, 103.3295, 104.0795, 104.36075, 103.23575, 100.470125, 106.001375, 107.267,
            105.67325, 106.04825, 101.876375, 101.126375, 99.251375, 102.626375, 96.720125, 95.501375,
        ],
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:13:57.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 134.53125,
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:13:57.648Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            133.3295, 126.017, 118.892, 116.126375, 114.767, 117.48575, 112.7045, 107.876375, 110.642, 106.001375,
            104.220125, 100.7045, 97.892, 100.938875, 102.720125, 103.657625, 103.04825, 101.782625, 109.095125,
            107.970125, 106.04825, 105.392, 102.392, 101.313875, 99.017, 102.438875, 96.532625, 95.407625,
        ],
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:14:00.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 125.19136,
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:14:00.589Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            121.376375, 115.188875, 111.2045, 110.782625, 110.688875, 115.142, 107.642, 109.095125, 108.86075,
            107.92325, 111.392, 101.92325, 99.345125, 104.92325, 103.892, 105.532625, 104.220125, 102.86075, 107.876375,
            110.36075, 106.845125, 106.938875, 101.876375, 100.79825, 98.92325, 102.48575, 96.626375, 95.267,
        ],
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:13:58.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 138.53128,
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:13:58.628Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            136.04825, 130.938875, 130.142, 125.267, 122.92325, 121.938875, 117.438875, 114.251375, 111.9545,
            107.126375, 105.532625, 100.42325, 98.782625, 100.470125, 101.782625, 101.73575, 101.970125, 100.79825,
            107.17325, 108.626375, 106.142, 105.720125, 102.626375, 101.17325, 99.017, 102.29825, 95.92325, 95.126375,
        ],
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:13:59.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_reading',
        value: 136.05049,
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
    {
        timestamp: '2025-08-29T23:13:59.609Z',
        units: 'dB re µPa²',
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        sensorPosition: null,
        sensorConfigurations: null,
        unit_type: 'sound_pressure_level_array',
        data_type_name: 'bm_borealis_band_spls_reading',
        value: [
            132.532625, 129.532625, 128.595125, 124.79825, 121.376375, 119.970125, 113.17325, 109.657625, 107.0795,
            105.907625, 107.688875, 101.032625, 98.407625, 100.376375, 101.73575, 102.438875, 102.11075, 100.79825,
            104.688875, 107.407625, 105.9545, 105.157625, 102.11075, 100.7045, 98.73575, 102.532625, 97.001375,
            95.407625,
        ],
        latitude: 37.4405758,
        longitude: -122.5334243,
    },
];
